export const Questions = {
  questions: [
    {
      acRate: 55.52337249227447,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1",
      paidOnly: false,
      title: "Two Sum",
      titleSlug: "two-sum",
    },
    {
      acRate: 45.9172777185881,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2",
      paidOnly: false,
      title: "Add Two Numbers",
      titleSlug: "add-two-numbers",
    },
    {
      acRate: 36.69869045434196,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3",
      paidOnly: false,
      title: "Longest Substring Without Repeating Characters",
      titleSlug: "longest-substring-without-repeating-characters",
    },
    {
      acRate: 43.46100386281233,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "4",
      paidOnly: false,
      title: "Median of Two Sorted Arrays",
      titleSlug: "median-of-two-sorted-arrays",
    },
    {
      acRate: 35.63030641615235,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "5",
      paidOnly: false,
      title: "Longest Palindromic Substring",
      titleSlug: "longest-palindromic-substring",
    },
    {
      acRate: 51.29753964005362,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "6",
      paidOnly: false,
      title: "Zigzag Conversion",
      titleSlug: "zigzag-conversion",
    },
    {
      acRate: 30.125361582359663,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "7",
      paidOnly: false,
      title: "Reverse Integer",
      titleSlug: "reverse-integer",
    },
    {
      acRate: 19.01419398871952,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "8",
      paidOnly: false,
      title: "String to Integer (atoi)",
      titleSlug: "string-to-integer-atoi",
    },
    {
      acRate: 59.020464311371825,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "9",
      paidOnly: false,
      title: "Palindrome Number",
      titleSlug: "palindrome-number",
    },
    {
      acRate: 29.170061399161746,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "10",
      paidOnly: false,
      title: "Regular Expression Matching",
      titleSlug: "regular-expression-matching",
    },
    {
      acRate: 57.56160621923356,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "11",
      paidOnly: false,
      title: "Container With Most Water",
      titleSlug: "container-with-most-water",
    },
    {
      acRate: 68.30495748533504,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "12",
      paidOnly: false,
      title: "Integer to Roman",
      titleSlug: "integer-to-roman",
    },
    {
      acRate: 64.59920990507652,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "13",
      paidOnly: false,
      title: "Roman to Integer",
      titleSlug: "roman-to-integer",
    },
    {
      acRate: 45.252936344547365,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "14",
      paidOnly: false,
      title: "Longest Common Prefix",
      titleSlug: "longest-common-prefix",
    },
    {
      acRate: 36.82270759041979,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "15",
      paidOnly: false,
      title: "3Sum",
      titleSlug: "3sum",
    },
    {
      acRate: 46.78730885568652,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "16",
      paidOnly: false,
      title: "3Sum Closest",
      titleSlug: "3sum-closest",
    },
    {
      acRate: 63.57525557070086,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "17",
      paidOnly: false,
      title: "Letter Combinations of a Phone Number",
      titleSlug: "letter-combinations-of-a-phone-number",
    },
    {
      acRate: 37.96242973789024,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "18",
      paidOnly: false,
      title: "4Sum",
      titleSlug: "4sum",
    },
    {
      acRate: 48.610371721794365,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "19",
      paidOnly: false,
      title: "Remove Nth Node From End of List",
      titleSlug: "remove-nth-node-from-end-of-list",
    },
    {
      acRate: 42.147643022575394,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "20",
      paidOnly: false,
      title: "Valid Parentheses",
      titleSlug: "valid-parentheses",
    },
    {
      acRate: 66.63712462489494,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "21",
      paidOnly: false,
      title: "Merge Two Sorted Lists",
      titleSlug: "merge-two-sorted-lists",
    },
    {
      acRate: 76.8968818005161,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "22",
      paidOnly: false,
      title: "Generate Parentheses",
      titleSlug: "generate-parentheses",
    },
    {
      acRate: 56.41423995927307,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "23",
      paidOnly: false,
      title: "Merge k Sorted Lists",
      titleSlug: "merge-k-sorted-lists",
    },
    {
      acRate: 66.9309906302103,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "24",
      paidOnly: false,
      title: "Swap Nodes in Pairs",
      titleSlug: "swap-nodes-in-pairs",
    },
    {
      acRate: 62.65068310018197,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "25",
      paidOnly: false,
      title: "Reverse Nodes in k-Group",
      titleSlug: "reverse-nodes-in-k-group",
    },
    {
      acRate: 60.02547311429289,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "26",
      paidOnly: false,
      title: "Remove Duplicates from Sorted Array",
      titleSlug: "remove-duplicates-from-sorted-array",
    },
    {
      acRate: 59.82240569411472,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "27",
      paidOnly: false,
      title: "Remove Element",
      titleSlug: "remove-element",
    },
    {
      acRate: 44.77771966168195,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "28",
      paidOnly: false,
      title: "Find the Index of the First Occurrence in a String",
      titleSlug: "find-the-index-of-the-first-occurrence-in-a-string",
    },
    {
      acRate: 18.307670521856867,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "29",
      paidOnly: false,
      title: "Divide Two Integers",
      titleSlug: "divide-two-integers",
    },
    {
      acRate: 32.93877464121743,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "30",
      paidOnly: false,
      title: "Substring with Concatenation of All Words",
      titleSlug: "substring-with-concatenation-of-all-words",
    },
    {
      acRate: 42.77047280380362,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "31",
      paidOnly: false,
      title: "Next Permutation",
      titleSlug: "next-permutation",
    },
    {
      acRate: 36.089969236976145,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "32",
      paidOnly: false,
      title: "Longest Valid Parentheses",
      titleSlug: "longest-valid-parentheses",
    },
    {
      acRate: 42.6353830727677,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "33",
      paidOnly: false,
      title: "Search in Rotated Sorted Array",
      titleSlug: "search-in-rotated-sorted-array",
    },
    {
      acRate: 46.55005172675155,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "34",
      paidOnly: false,
      title: "Find First and Last Position of Element in Sorted Array",
      titleSlug: "find-first-and-last-position-of-element-in-sorted-array",
    },
    {
      acRate: 48.74100997251312,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "35",
      paidOnly: false,
      title: "Search Insert Position",
      titleSlug: "search-insert-position",
    },
    {
      acRate: 62.04642906396649,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "36",
      paidOnly: false,
      title: "Valid Sudoku",
      titleSlug: "valid-sudoku",
    },
    {
      acRate: 63.744650992549765,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "37",
      paidOnly: false,
      title: "Sudoku Solver",
      titleSlug: "sudoku-solver",
    },
    {
      acRate: 60.2115363375029,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "38",
      paidOnly: false,
      title: "Count and Say",
      titleSlug: "count-and-say",
    },
    {
      acRate: 74.37379260763423,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "39",
      paidOnly: false,
      title: "Combination Sum",
      titleSlug: "combination-sum",
    },
    {
      acRate: 57.47011115235215,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "40",
      paidOnly: false,
      title: "Combination Sum II",
      titleSlug: "combination-sum-ii",
    },
    {
      acRate: 40.92324094477801,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "41",
      paidOnly: false,
      title: "First Missing Positive",
      titleSlug: "first-missing-positive",
    },
    {
      acRate: 64.78660753108154,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "42",
      paidOnly: false,
      title: "Trapping Rain Water",
      titleSlug: "trapping-rain-water",
    },
    {
      acRate: 42.138262338706966,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "43",
      paidOnly: false,
      title: "Multiply Strings",
      titleSlug: "multiply-strings",
    },
    {
      acRate: 29.672355557199882,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "44",
      paidOnly: false,
      title: "Wildcard Matching",
      titleSlug: "wildcard-matching",
    },
    {
      acRate: 41.34468080956816,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "45",
      paidOnly: false,
      title: "Jump Game II",
      titleSlug: "jump-game-ii",
    },
    {
      acRate: 80.46864366434737,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "46",
      paidOnly: false,
      title: "Permutations",
      titleSlug: "permutations",
    },
    {
      acRate: 61.36440319830692,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "47",
      paidOnly: false,
      title: "Permutations II",
      titleSlug: "permutations-ii",
    },
    {
      acRate: 77.60008711843041,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "48",
      paidOnly: false,
      title: "Rotate Image",
      titleSlug: "rotate-image",
    },
    {
      acRate: 70.7057614486439,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "49",
      paidOnly: false,
      title: "Group Anagrams",
      titleSlug: "group-anagrams",
    },
    {
      acRate: 36.84081881447348,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "50",
      paidOnly: false,
      title: "Pow(x, n)",
      titleSlug: "powx-n",
    },
    {
      acRate: 72.33678294241274,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "51",
      paidOnly: false,
      title: "N-Queens",
      titleSlug: "n-queens",
    },
    {
      acRate: 76.46447336920227,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "52",
      paidOnly: false,
      title: "N-Queens II",
      titleSlug: "n-queens-ii",
    },
    {
      acRate: 51.96222162890983,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "53",
      paidOnly: false,
      title: "Maximum Subarray",
      titleSlug: "maximum-subarray",
    },
    {
      acRate: 53.5479188358312,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "54",
      paidOnly: false,
      title: "Spiral Matrix",
      titleSlug: "spiral-matrix",
    },
    {
      acRate: 39.31558196001194,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "55",
      paidOnly: false,
      title: "Jump Game",
      titleSlug: "jump-game",
    },
    {
      acRate: 49.1766535232815,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "56",
      paidOnly: false,
      title: "Merge Intervals",
      titleSlug: "merge-intervals",
    },
    {
      acRate: 43.257318477329214,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "57",
      paidOnly: false,
      title: "Insert Interval",
      titleSlug: "insert-interval",
    },
    {
      acRate: 56.007125495743615,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "58",
      paidOnly: false,
      title: "Length of Last Word",
      titleSlug: "length-of-last-word",
    },
    {
      acRate: 73.26770501048246,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "59",
      paidOnly: false,
      title: "Spiral Matrix II",
      titleSlug: "spiral-matrix-ii",
    },
    {
      acRate: 49.64703409867073,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "60",
      paidOnly: false,
      title: "Permutation Sequence",
      titleSlug: "permutation-sequence",
    },
    {
      acRate: 39.75225582534321,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "61",
      paidOnly: false,
      title: "Rotate List",
      titleSlug: "rotate-list",
    },
    {
      acRate: 65.63053504650905,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "62",
      paidOnly: false,
      title: "Unique Paths",
      titleSlug: "unique-paths",
    },
    {
      acRate: 42.993702574424034,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "63",
      paidOnly: false,
      title: "Unique Paths II",
      titleSlug: "unique-paths-ii",
    },
    {
      acRate: 66.22953975991892,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "64",
      paidOnly: false,
      title: "Minimum Path Sum",
      titleSlug: "minimum-path-sum",
    },
    {
      acRate: 21.398441104105796,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "65",
      paidOnly: false,
      title: "Valid Number",
      titleSlug: "valid-number",
    },
    {
      acRate: 47.37095122056502,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "66",
      paidOnly: false,
      title: "Plus One",
      titleSlug: "plus-one",
    },
    {
      acRate: 55.50905096690021,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "67",
      paidOnly: false,
      title: "Add Binary",
      titleSlug: "add-binary",
    },
    {
      acRate: 47.78500479900003,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "68",
      paidOnly: false,
      title: "Text Justification",
      titleSlug: "text-justification",
    },
    {
      acRate: 40.25412293757874,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "69",
      paidOnly: false,
      title: "Sqrt(x)",
      titleSlug: "sqrtx",
    },
    {
      acRate: 53.4723739172832,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "70",
      paidOnly: false,
      title: "Climbing Stairs",
      titleSlug: "climbing-stairs",
    },
    {
      acRate: 47.40561992147104,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "71",
      paidOnly: false,
      title: "Simplify Path",
      titleSlug: "simplify-path",
    },
    {
      acRate: 58.55656563414252,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "72",
      paidOnly: false,
      title: "Edit Distance",
      titleSlug: "edit-distance",
    },
    {
      acRate: 59.47001567880322,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "73",
      paidOnly: false,
      title: "Set Matrix Zeroes",
      titleSlug: "set-matrix-zeroes",
    },
    {
      acRate: 52.072328894042165,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "74",
      paidOnly: false,
      title: "Search a 2D Matrix",
      titleSlug: "search-a-2d-matrix",
    },
    {
      acRate: 66.81223990137924,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "75",
      paidOnly: false,
      title: "Sort Colors",
      titleSlug: "sort-colors",
    },
    {
      acRate: 45.07799256523155,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "76",
      paidOnly: false,
      title: "Minimum Window Substring",
      titleSlug: "minimum-window-substring",
    },
    {
      acRate: 72.66039112936043,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "77",
      paidOnly: false,
      title: "Combinations",
      titleSlug: "combinations",
    },
    {
      acRate: 80.62067453607924,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "78",
      paidOnly: false,
      title: "Subsets",
      titleSlug: "subsets",
    },
    {
      acRate: 45.007906798274114,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "79",
      paidOnly: false,
      title: "Word Search",
      titleSlug: "word-search",
    },
    {
      acRate: 62.67692249702756,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "80",
      paidOnly: false,
      title: "Remove Duplicates from Sorted Array II",
      titleSlug: "remove-duplicates-from-sorted-array-ii",
    },
    {
      acRate: 38.7712516829836,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "81",
      paidOnly: false,
      title: "Search in Rotated Sorted Array II",
      titleSlug: "search-in-rotated-sorted-array-ii",
    },
    {
      acRate: 49.65951896021173,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "82",
      paidOnly: false,
      title: "Remove Duplicates from Sorted List II",
      titleSlug: "remove-duplicates-from-sorted-list-ii",
    },
    {
      acRate: 54.677772027077886,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "83",
      paidOnly: false,
      title: "Remove Duplicates from Sorted List",
      titleSlug: "remove-duplicates-from-sorted-list",
    },
    {
      acRate: 47.04777565026605,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "84",
      paidOnly: false,
      title: "Largest Rectangle in Histogram",
      titleSlug: "largest-rectangle-in-histogram",
    },
    {
      acRate: 53.33133381892969,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "85",
      paidOnly: false,
      title: "Maximal Rectangle",
      titleSlug: "maximal-rectangle",
    },
    {
      acRate: 58.73525836101625,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "86",
      paidOnly: false,
      title: "Partition List",
      titleSlug: "partition-list",
    },
    {
      acRate: 42.01668415829341,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "87",
      paidOnly: false,
      title: "Scramble String",
      titleSlug: "scramble-string",
    },
    {
      acRate: 52.65980714135979,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "88",
      paidOnly: false,
      title: "Merge Sorted Array",
      titleSlug: "merge-sorted-array",
    },
    {
      acRate: 61.61056561827536,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "89",
      paidOnly: false,
      title: "Gray Code",
      titleSlug: "gray-code",
    },
    {
      acRate: 59.24788833192506,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "90",
      paidOnly: false,
      title: "Subsets II",
      titleSlug: "subsets-ii",
    },
    {
      acRate: 36.36846650906225,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "91",
      paidOnly: false,
      title: "Decode Ways",
      titleSlug: "decode-ways",
    },
    {
      acRate: 49.40389860221653,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "92",
      paidOnly: false,
      title: "Reverse Linked List II",
      titleSlug: "reverse-linked-list-ii",
    },
    {
      acRate: 52.849819104006514,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "93",
      paidOnly: false,
      title: "Restore IP Addresses",
      titleSlug: "restore-ip-addresses",
    },
    {
      acRate: 78.35576006009971,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "94",
      paidOnly: false,
      title: "Binary Tree Inorder Traversal",
      titleSlug: "binary-tree-inorder-traversal",
    },
    {
      acRate: 60.16095413859269,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "95",
      paidOnly: false,
      title: "Unique Binary Search Trees II",
      titleSlug: "unique-binary-search-trees-ii",
    },
    {
      acRate: 62.3312148076115,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "96",
      paidOnly: false,
      title: "Unique Binary Search Trees",
      titleSlug: "unique-binary-search-trees",
    },
    {
      acRate: 41.99931633334133,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "97",
      paidOnly: false,
      title: "Interleaving String",
      titleSlug: "interleaving-string",
    },
    {
      acRate: 34.228030312954715,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "98",
      paidOnly: false,
      title: "Validate Binary Search Tree",
      titleSlug: "validate-binary-search-tree",
    },
    {
      acRate: 55.942950832625485,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "99",
      paidOnly: false,
      title: "Recover Binary Search Tree",
      titleSlug: "recover-binary-search-tree",
    },
    {
      acRate: 64.85258854127042,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "100",
      paidOnly: false,
      title: "Same Tree",
      titleSlug: "same-tree",
    },
    {
      acRate: 59.02667456475888,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "101",
      paidOnly: false,
      title: "Symmetric Tree",
      titleSlug: "symmetric-tree",
    },
    {
      acRate: 70.28566792659335,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "102",
      paidOnly: false,
      title: "Binary Tree Level Order Traversal",
      titleSlug: "binary-tree-level-order-traversal",
    },
    {
      acRate: 61.408694519549336,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "103",
      paidOnly: false,
      title: "Binary Tree Zigzag Level Order Traversal",
      titleSlug: "binary-tree-zigzag-level-order-traversal",
    },
    {
      acRate: 76.99121577166488,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "104",
      paidOnly: false,
      title: "Maximum Depth of Binary Tree",
      titleSlug: "maximum-depth-of-binary-tree",
    },
    {
      acRate: 66.5522240749104,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "105",
      paidOnly: false,
      title: "Construct Binary Tree from Preorder and Inorder Traversal",
      titleSlug: "construct-binary-tree-from-preorder-and-inorder-traversal",
    },
    {
      acRate: 65.70641690101564,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "106",
      paidOnly: false,
      title: "Construct Binary Tree from Inorder and Postorder Traversal",
      titleSlug: "construct-binary-tree-from-inorder-and-postorder-traversal",
    },
    {
      acRate: 65.7648231460253,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "107",
      paidOnly: false,
      title: "Binary Tree Level Order Traversal II",
      titleSlug: "binary-tree-level-order-traversal-ii",
    },
    {
      acRate: 73.88701840719304,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "108",
      paidOnly: false,
      title: "Convert Sorted Array to Binary Search Tree",
      titleSlug: "convert-sorted-array-to-binary-search-tree",
    },
    {
      acRate: 64.245642337833,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "109",
      paidOnly: false,
      title: "Convert Sorted List to Binary Search Tree",
      titleSlug: "convert-sorted-list-to-binary-search-tree",
    },
    {
      acRate: 55.04064308204114,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "110",
      paidOnly: false,
      title: "Balanced Binary Tree",
      titleSlug: "balanced-binary-tree",
    },
    {
      acRate: 50.406591952935756,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "111",
      paidOnly: false,
      title: "Minimum Depth of Binary Tree",
      titleSlug: "minimum-depth-of-binary-tree",
    },
    {
      acRate: 52.77191919073035,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "112",
      paidOnly: false,
      title: "Path Sum",
      titleSlug: "path-sum",
    },
    {
      acRate: 60.300895193169325,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "113",
      paidOnly: false,
      title: "Path Sum II",
      titleSlug: "path-sum-ii",
    },
    {
      acRate: 68.18513953411193,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "114",
      paidOnly: false,
      title: "Flatten Binary Tree to Linked List",
      titleSlug: "flatten-binary-tree-to-linked-list",
    },
    {
      acRate: 49.82810808173498,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "115",
      paidOnly: false,
      title: "Distinct Subsequences",
      titleSlug: "distinct-subsequences",
    },
    {
      acRate: 65.21870700160646,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "116",
      paidOnly: false,
      title: "Populating Next Right Pointers in Each Node",
      titleSlug: "populating-next-right-pointers-in-each-node",
    },
    {
      acRate: 55.32365652849464,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "117",
      paidOnly: false,
      title: "Populating Next Right Pointers in Each Node II",
      titleSlug: "populating-next-right-pointers-in-each-node-ii",
    },
    {
      acRate: 76.78064681749355,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "118",
      paidOnly: false,
      title: "Pascal's Triangle",
      titleSlug: "pascals-triangle",
    },
    {
      acRate: 65.76862053377533,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "119",
      paidOnly: false,
      title: "Pascal's Triangle II",
      titleSlug: "pascals-triangle-ii",
    },
    {
      acRate: 58.99049460443698,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "120",
      paidOnly: false,
      title: "Triangle",
      titleSlug: "triangle",
    },
    {
      acRate: 55.04890660389402,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "121",
      paidOnly: false,
      title: "Best Time to Buy and Sell Stock",
      titleSlug: "best-time-to-buy-and-sell-stock",
    },
    {
      acRate: 69.24624267207095,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "122",
      paidOnly: false,
      title: "Best Time to Buy and Sell Stock II",
      titleSlug: "best-time-to-buy-and-sell-stock-ii",
    },
    {
      acRate: 50.70346914296974,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "123",
      paidOnly: false,
      title: "Best Time to Buy and Sell Stock III",
      titleSlug: "best-time-to-buy-and-sell-stock-iii",
    },
    {
      acRate: 41.11004203571569,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "124",
      paidOnly: false,
      title: "Binary Tree Maximum Path Sum",
      titleSlug: "binary-tree-maximum-path-sum",
    },
    {
      acRate: 50.6421132756116,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "125",
      paidOnly: false,
      title: "Valid Palindrome",
      titleSlug: "valid-palindrome",
    },
    {
      acRate: 27.153799575335302,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "126",
      paidOnly: false,
      title: "Word Ladder II",
      titleSlug: "word-ladder-ii",
    },
    {
      acRate: 42.4273510590781,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "127",
      paidOnly: false,
      title: "Word Ladder",
      titleSlug: "word-ladder",
    },
    {
      acRate: 47.07791595151944,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "128",
      paidOnly: false,
      title: "Longest Consecutive Sequence",
      titleSlug: "longest-consecutive-sequence",
    },
    {
      acRate: 68.32279180194654,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "129",
      paidOnly: false,
      title: "Sum Root to Leaf Numbers",
      titleSlug: "sum-root-to-leaf-numbers",
    },
    {
      acRate: 42.53649069944632,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "130",
      paidOnly: false,
      title: "Surrounded Regions",
      titleSlug: "surrounded-regions",
    },
    {
      acRate: 71.79748611486492,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "131",
      paidOnly: false,
      title: "Palindrome Partitioning",
      titleSlug: "palindrome-partitioning",
    },
    {
      acRate: 35.08077821142518,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "132",
      paidOnly: false,
      title: "Palindrome Partitioning II",
      titleSlug: "palindrome-partitioning-ii",
    },
    {
      acRate: 61.91850942417294,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "133",
      paidOnly: false,
      title: "Clone Graph",
      titleSlug: "clone-graph",
    },
    {
      acRate: 46.21487919863612,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "134",
      paidOnly: false,
      title: "Gas Station",
      titleSlug: "gas-station",
    },
    {
      acRate: 44.64571217208903,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "135",
      paidOnly: false,
      title: "Candy",
      titleSlug: "candy",
    },
    {
      acRate: 75.71611807053633,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "136",
      paidOnly: false,
      title: "Single Number",
      titleSlug: "single-number",
    },
    {
      acRate: 65.0069009164274,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "137",
      paidOnly: false,
      title: "Single Number II",
      titleSlug: "single-number-ii",
    },
    {
      acRate: 60.132516289771274,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "138",
      paidOnly: false,
      title: "Copy List with Random Pointer",
      titleSlug: "copy-list-with-random-pointer",
    },
    {
      acRate: 48.12125066383242,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "139",
      paidOnly: false,
      title: "Word Break",
      titleSlug: "word-break",
    },
    {
      acRate: 53.368331040529284,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "140",
      paidOnly: false,
      title: "Word Break II",
      titleSlug: "word-break-ii",
    },
    {
      acRate: 52.34074658799208,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "141",
      paidOnly: false,
      title: "Linked List Cycle",
      titleSlug: "linked-list-cycle",
    },
    {
      acRate: 54.515907062174826,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "142",
      paidOnly: false,
      title: "Linked List Cycle II",
      titleSlug: "linked-list-cycle-ii",
    },
    {
      acRate: 62.147520784058244,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "143",
      paidOnly: false,
      title: "Reorder List",
      titleSlug: "reorder-list",
    },
    {
      acRate: 72.85221103577713,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "144",
      paidOnly: false,
      title: "Binary Tree Preorder Traversal",
      titleSlug: "binary-tree-preorder-traversal",
    },
    {
      acRate: 75.39009087584053,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "145",
      paidOnly: false,
      title: "Binary Tree Postorder Traversal",
      titleSlug: "binary-tree-postorder-traversal",
    },
    {
      acRate: 44.91463112756093,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "146",
      paidOnly: false,
      title: "LRU Cache",
      titleSlug: "lru-cache",
    },
    {
      acRate: 56.200703347531125,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "147",
      paidOnly: false,
      title: "Insertion Sort List",
      titleSlug: "insertion-sort-list",
    },
    {
      acRate: 61.41458298382337,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "148",
      paidOnly: false,
      title: "Sort List",
      titleSlug: "sort-list",
    },
    {
      acRate: 28.76355503768159,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "149",
      paidOnly: false,
      title: "Max Points on a Line",
      titleSlug: "max-points-on-a-line",
    },
    {
      acRate: 54.606864749223675,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "150",
      paidOnly: false,
      title: "Evaluate Reverse Polish Notation",
      titleSlug: "evaluate-reverse-polish-notation",
    },
    {
      acRate: 51.23862158430654,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "151",
      paidOnly: false,
      title: "Reverse Words in a String",
      titleSlug: "reverse-words-in-a-string",
    },
    {
      acRate: 34.76903206856037,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "152",
      paidOnly: false,
      title: "Maximum Product Subarray",
      titleSlug: "maximum-product-subarray",
    },
    {
      acRate: 52.44524173756094,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "153",
      paidOnly: false,
      title: "Find Minimum in Rotated Sorted Array",
      titleSlug: "find-minimum-in-rotated-sorted-array",
    },
    {
      acRate: 44.078746502103996,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "154",
      paidOnly: false,
      title: "Find Minimum in Rotated Sorted Array II",
      titleSlug: "find-minimum-in-rotated-sorted-array-ii",
    },
    {
      acRate: 56.21774135895012,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "155",
      paidOnly: false,
      title: "Min Stack",
      titleSlug: "min-stack",
    },
    {
      acRate: 64.38856800285915,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "156",
      paidOnly: true,
      title: "Binary Tree Upside Down",
      titleSlug: "binary-tree-upside-down",
    },
    {
      acRate: 42.186022728458575,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "157",
      paidOnly: true,
      title: "Read N Characters Given Read4",
      titleSlug: "read-n-characters-given-read4",
    },
    {
      acRate: 42.837205447169225,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "158",
      paidOnly: true,
      title: "Read N Characters Given read4 II - Call Multiple Times",
      titleSlug: "read-n-characters-given-read4-ii-call-multiple-times",
    },
    {
      acRate: 56.27371949637847,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "159",
      paidOnly: true,
      title: "Longest Substring with At Most Two Distinct Characters",
      titleSlug: "longest-substring-with-at-most-two-distinct-characters",
    },
    {
      acRate: 60.761071779639884,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "160",
      paidOnly: false,
      title: "Intersection of Two Linked Lists",
      titleSlug: "intersection-of-two-linked-lists",
    },
    {
      acRate: 34.46147986491115,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "161",
      paidOnly: true,
      title: "One Edit Distance",
      titleSlug: "one-edit-distance",
    },
    {
      acRate: 46.459174843262325,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "162",
      paidOnly: false,
      title: "Find Peak Element",
      titleSlug: "find-peak-element",
    },
    {
      acRate: 35.158667645358975,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "163",
      paidOnly: true,
      title: "Missing Ranges",
      titleSlug: "missing-ranges",
    },
    {
      acRate: 49.06083010558758,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "164",
      paidOnly: false,
      title: "Maximum Gap",
      titleSlug: "maximum-gap",
    },
    {
      acRate: 42.182673419978926,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "165",
      paidOnly: false,
      title: "Compare Version Numbers",
      titleSlug: "compare-version-numbers",
    },
    {
      acRate: 26.10014628524904,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "166",
      paidOnly: false,
      title: "Fraction to Recurring Decimal",
      titleSlug: "fraction-to-recurring-decimal",
    },
    {
      acRate: 63.19457808225817,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "167",
      paidOnly: false,
      title: "Two Sum II - Input Array Is Sorted",
      titleSlug: "two-sum-ii-input-array-is-sorted",
    },
    {
      acRate: 43.26165021920273,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "168",
      paidOnly: false,
      title: "Excel Sheet Column Title",
      titleSlug: "excel-sheet-column-title",
    },
    {
      acRate: 65.64277554379056,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "169",
      paidOnly: false,
      title: "Majority Element",
      titleSlug: "majority-element",
    },
    {
      acRate: 38.639304904538704,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "170",
      paidOnly: true,
      title: "Two Sum III - Data structure design",
      titleSlug: "two-sum-iii-data-structure-design",
    },
    {
      acRate: 65.5487215938787,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "171",
      paidOnly: false,
      title: "Excel Sheet Column Number",
      titleSlug: "excel-sheet-column-number",
    },
    {
      acRate: 44.69480899142093,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "172",
      paidOnly: false,
      title: "Factorial Trailing Zeroes",
      titleSlug: "factorial-trailing-zeroes",
    },
    {
      acRate: 74.59997524848082,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "173",
      paidOnly: false,
      title: "Binary Search Tree Iterator",
      titleSlug: "binary-search-tree-iterator",
    },
    {
      acRate: 39.345992047927766,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "174",
      paidOnly: false,
      title: "Dungeon Game",
      titleSlug: "dungeon-game",
    },
    {
      acRate: 77.89078308548663,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "175",
      paidOnly: false,
      title: "Combine Two Tables",
      titleSlug: "combine-two-tables",
    },
    {
      acRate: 43.49284778800197,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "176",
      paidOnly: false,
      title: "Second Highest Salary",
      titleSlug: "second-highest-salary",
    },
    {
      acRate: 37.90317649217049,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "177",
      paidOnly: false,
      title: "Nth Highest Salary",
      titleSlug: "nth-highest-salary",
    },
    {
      acRate: 64.98766983218943,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "178",
      paidOnly: false,
      title: "Rank Scores",
      titleSlug: "rank-scores",
    },
    {
      acRate: 41.100751754604374,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "179",
      paidOnly: false,
      title: "Largest Number",
      titleSlug: "largest-number",
    },
    {
      acRate: 45.83726293732486,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "180",
      paidOnly: false,
      title: "Consecutive Numbers",
      titleSlug: "consecutive-numbers",
    },
    {
      acRate: 71.34409780310035,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "181",
      paidOnly: false,
      title: "Employees Earning More Than Their Managers",
      titleSlug: "employees-earning-more-than-their-managers",
    },
    {
      acRate: 72.29496492127566,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "182",
      paidOnly: false,
      title: "Duplicate Emails",
      titleSlug: "duplicate-emails",
    },
    {
      acRate: 70.53313504681026,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "183",
      paidOnly: false,
      title: "Customers Who Never Order",
      titleSlug: "customers-who-never-order",
    },
    {
      acRate: 54.40843626046965,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "184",
      paidOnly: false,
      title: "Department Highest Salary",
      titleSlug: "department-highest-salary",
    },
    {
      acRate: 57.406161226284944,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "185",
      paidOnly: false,
      title: "Department Top Three Salaries",
      titleSlug: "department-top-three-salaries",
    },
    {
      acRate: 55.95521569386636,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "186",
      paidOnly: true,
      title: "Reverse Words in a String II",
      titleSlug: "reverse-words-in-a-string-ii",
    },
    {
      acRate: 51.07367449110309,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "187",
      paidOnly: false,
      title: "Repeated DNA Sequences",
      titleSlug: "repeated-dna-sequences",
    },
    {
      acRate: 46.59879412964638,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "188",
      paidOnly: false,
      title: "Best Time to Buy and Sell Stock IV",
      titleSlug: "best-time-to-buy-and-sell-stock-iv",
    },
    {
      acRate: 42.789921607212854,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "189",
      paidOnly: false,
      title: "Rotate Array",
      titleSlug: "rotate-array",
    },
    {
      acRate: 62.811628848318016,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "190",
      paidOnly: false,
      title: "Reverse Bits",
      titleSlug: "reverse-bits",
    },
    {
      acRate: 74.21152493409284,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "191",
      paidOnly: false,
      title: "Number of 1 Bits",
      titleSlug: "number-of-1-bits",
    },
    {
      acRate: 27.087754064149554,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "192",
      paidOnly: false,
      title: "Word Frequency",
      titleSlug: "word-frequency",
    },
    {
      acRate: 27.265983364865548,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "193",
      paidOnly: false,
      title: "Valid Phone Numbers",
      titleSlug: "valid-phone-numbers",
    },
    {
      acRate: 28.2727336538799,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "194",
      paidOnly: false,
      title: "Transpose File",
      titleSlug: "transpose-file",
    },
    {
      acRate: 34.408570424631925,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "195",
      paidOnly: false,
      title: "Tenth Line",
      titleSlug: "tenth-line",
    },
    {
      acRate: 64.11818092155566,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "196",
      paidOnly: false,
      title: "Delete Duplicate Emails",
      titleSlug: "delete-duplicate-emails",
    },
    {
      acRate: 50.053454952433206,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "197",
      paidOnly: false,
      title: "Rising Temperature",
      titleSlug: "rising-temperature",
    },
    {
      acRate: 52.178514593804934,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "198",
      paidOnly: false,
      title: "House Robber",
      titleSlug: "house-robber",
    },
    {
      acRate: 66.53584289841899,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "199",
      paidOnly: false,
      title: "Binary Tree Right Side View",
      titleSlug: "binary-tree-right-side-view",
    },
    {
      acRate: 62.048087288168055,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "200",
      paidOnly: false,
      title: "Number of Islands",
      titleSlug: "number-of-islands",
    },
    {
      acRate: 47.63002002740592,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "201",
      paidOnly: false,
      title: "Bitwise AND of Numbers Range",
      titleSlug: "bitwise-and-of-numbers-range",
    },
    {
      acRate: 57.87442812046968,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "202",
      paidOnly: false,
      title: "Happy Number",
      titleSlug: "happy-number",
    },
    {
      acRate: 51.6218050803422,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "203",
      paidOnly: false,
      title: "Remove Linked List Elements",
      titleSlug: "remove-linked-list-elements",
    },
    {
      acRate: 34.620969195578446,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "204",
      paidOnly: false,
      title: "Count Primes",
      titleSlug: "count-primes",
    },
    {
      acRate: 46.67204953446812,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "205",
      paidOnly: false,
      title: "Isomorphic Strings",
      titleSlug: "isomorphic-strings",
    },
    {
      acRate: 78.99115775560767,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "206",
      paidOnly: false,
      title: "Reverse Linked List",
      titleSlug: "reverse-linked-list",
    },
    {
      acRate: 48.923892366334634,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "207",
      paidOnly: false,
      title: "Course Schedule",
      titleSlug: "course-schedule",
    },
    {
      acRate: 67.68037862362776,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "208",
      paidOnly: false,
      title: "Implement Trie (Prefix Tree)",
      titleSlug: "implement-trie-prefix-tree",
    },
    {
      acRate: 49.12943871313732,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "209",
      paidOnly: false,
      title: "Minimum Size Subarray Sum",
      titleSlug: "minimum-size-subarray-sum",
    },
    {
      acRate: 53.103306404381115,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "210",
      paidOnly: false,
      title: "Course Schedule II",
      titleSlug: "course-schedule-ii",
    },
    {
      acRate: 46.860569678332155,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "211",
      paidOnly: false,
      title: "Design Add and Search Words Data Structure",
      titleSlug: "design-add-and-search-words-data-structure",
    },
    {
      acRate: 37.18947364911243,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "212",
      paidOnly: false,
      title: "Word Search II",
      titleSlug: "word-search-ii",
    },
    {
      acRate: 43.38840507522913,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "213",
      paidOnly: false,
      title: "House Robber II",
      titleSlug: "house-robber-ii",
    },
    {
      acRate: 40.539534316778,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "214",
      paidOnly: false,
      title: "Shortest Palindrome",
      titleSlug: "shortest-palindrome",
    },
    {
      acRate: 67.82518999668076,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "215",
      paidOnly: false,
      title: "Kth Largest Element in an Array",
      titleSlug: "kth-largest-element-in-an-array",
    },
    {
      acRate: 71.6681046089255,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "216",
      paidOnly: false,
      title: "Combination Sum III",
      titleSlug: "combination-sum-iii",
    },
    {
      acRate: 63.062824491953606,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "217",
      paidOnly: false,
      title: "Contains Duplicate",
      titleSlug: "contains-duplicate",
    },
    {
      acRate: 43.83540908984579,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "218",
      paidOnly: false,
      title: "The Skyline Problem",
      titleSlug: "the-skyline-problem",
    },
    {
      acRate: 48.73614849255997,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "219",
      paidOnly: false,
      title: "Contains Duplicate II",
      titleSlug: "contains-duplicate-ii",
    },
    {
      acRate: 23.541743751892092,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "220",
      paidOnly: false,
      title: "Contains Duplicate III",
      titleSlug: "contains-duplicate-iii",
    },
    {
      acRate: 48.5393679306528,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "221",
      paidOnly: false,
      title: "Maximal Square",
      titleSlug: "maximal-square",
    },
    {
      acRate: 69.54528670225834,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "222",
      paidOnly: false,
      title: "Count Complete Tree Nodes",
      titleSlug: "count-complete-tree-nodes",
    },
    {
      acRate: 47.21534984231706,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "223",
      paidOnly: false,
      title: "Rectangle Area",
      titleSlug: "rectangle-area",
    },
    {
      acRate: 45.33467902480579,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "224",
      paidOnly: false,
      title: "Basic Calculator",
      titleSlug: "basic-calculator",
    },
    {
      acRate: 66.97900560157505,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "225",
      paidOnly: false,
      title: "Implement Stack using Queues",
      titleSlug: "implement-stack-using-queues",
    },
    {
      acRate: 78.86089097897217,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "226",
      paidOnly: false,
      title: "Invert Binary Tree",
      titleSlug: "invert-binary-tree",
    },
    {
      acRate: 45.61001162266024,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "227",
      paidOnly: false,
      title: "Basic Calculator II",
      titleSlug: "basic-calculator-ii",
    },
    {
      acRate: 52.878332575665155,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "228",
      paidOnly: false,
      title: "Summary Ranges",
      titleSlug: "summary-ranges",
    },
    {
      acRate: 54.08015656421392,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "229",
      paidOnly: false,
      title: "Majority Element II",
      titleSlug: "majority-element-ii",
    },
    {
      acRate: 75.08135614122993,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "230",
      paidOnly: false,
      title: "Kth Smallest Element in a BST",
      titleSlug: "kth-smallest-element-in-a-bst",
    },
    {
      acRate: 48.316049781979174,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "231",
      paidOnly: false,
      title: "Power of Two",
      titleSlug: "power-of-two",
    },
    {
      acRate: 67.85969459718181,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "232",
      paidOnly: false,
      title: "Implement Queue using Stacks",
      titleSlug: "implement-queue-using-stacks",
    },
    {
      acRate: 35.84034368878753,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "233",
      paidOnly: false,
      title: "Number of Digit One",
      titleSlug: "number-of-digit-one",
    },
    {
      acRate: 55.57173292053017,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "234",
      paidOnly: false,
      title: "Palindrome Linked List",
      titleSlug: "palindrome-linked-list",
    },
    {
      acRate: 67.95920823602091,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "235",
      paidOnly: false,
      title: "Lowest Common Ancestor of a Binary Search Tree",
      titleSlug: "lowest-common-ancestor-of-a-binary-search-tree",
    },
    {
      acRate: 66.33511283120873,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "236",
      paidOnly: false,
      title: "Lowest Common Ancestor of a Binary Tree",
      titleSlug: "lowest-common-ancestor-of-a-binary-tree",
    },
    {
      acRate: 82.05636112842456,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "237",
      paidOnly: false,
      title: "Delete Node in a Linked List",
      titleSlug: "delete-node-in-a-linked-list",
    },
    {
      acRate: 67.60495789134062,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "238",
      paidOnly: false,
      title: "Product of Array Except Self",
      titleSlug: "product-of-array-except-self",
    },
    {
      acRate: 47.4532959671787,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "239",
      paidOnly: false,
      title: "Sliding Window Maximum",
      titleSlug: "sliding-window-maximum",
    },
    {
      acRate: 54.94195375682571,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "240",
      paidOnly: false,
      title: "Search a 2D Matrix II",
      titleSlug: "search-a-2d-matrix-ii",
    },
    {
      acRate: 72.25177936315765,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "241",
      paidOnly: false,
      title: "Different Ways to Add Parentheses",
      titleSlug: "different-ways-to-add-parentheses",
    },
    {
      acRate: 66.45569611289706,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "242",
      paidOnly: false,
      title: "Valid Anagram",
      titleSlug: "valid-anagram",
    },
    {
      acRate: 65.90951135448358,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "243",
      paidOnly: true,
      title: "Shortest Word Distance",
      titleSlug: "shortest-word-distance",
    },
    {
      acRate: 62.06719404374127,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "244",
      paidOnly: true,
      title: "Shortest Word Distance II",
      titleSlug: "shortest-word-distance-ii",
    },
    {
      acRate: 59.0388387865641,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "245",
      paidOnly: true,
      title: "Shortest Word Distance III",
      titleSlug: "shortest-word-distance-iii",
    },
    {
      acRate: 47.59179173047473,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "246",
      paidOnly: true,
      title: "Strobogrammatic Number",
      titleSlug: "strobogrammatic-number",
    },
    {
      acRate: 53.126638337794205,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "247",
      paidOnly: true,
      title: "Strobogrammatic Number II",
      titleSlug: "strobogrammatic-number-ii",
    },
    {
      acRate: 42.40594048249518,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "248",
      paidOnly: true,
      title: "Strobogrammatic Number III",
      titleSlug: "strobogrammatic-number-iii",
    },
    {
      acRate: 67.25375322083273,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "249",
      paidOnly: true,
      title: "Group Shifted Strings",
      titleSlug: "group-shifted-strings",
    },
    {
      acRate: 57.12102390888663,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "250",
      paidOnly: true,
      title: "Count Univalue Subtrees",
      titleSlug: "count-univalue-subtrees",
    },
    {
      acRate: 50.08607539769013,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "251",
      paidOnly: true,
      title: "Flatten 2D Vector",
      titleSlug: "flatten-2d-vector",
    },
    {
      acRate: 58.88996191806722,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "252",
      paidOnly: true,
      title: "Meeting Rooms",
      titleSlug: "meeting-rooms",
    },
    {
      acRate: 52.071436513175364,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "253",
      paidOnly: true,
      title: "Meeting Rooms II",
      titleSlug: "meeting-rooms-ii",
    },
    {
      acRate: 50.20308063940022,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "254",
      paidOnly: true,
      title: "Factor Combinations",
      titleSlug: "factor-combinations",
    },
    {
      acRate: 50.778792609333856,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "255",
      paidOnly: true,
      title: "Verify Preorder Sequence in Binary Search Tree",
      titleSlug: "verify-preorder-sequence-in-binary-search-tree",
    },
    {
      acRate: 63.63223672373466,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "256",
      paidOnly: true,
      title: "Paint House",
      titleSlug: "paint-house",
    },
    {
      acRate: 66.24742944229025,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "257",
      paidOnly: false,
      title: "Binary Tree Paths",
      titleSlug: "binary-tree-paths",
    },
    {
      acRate: 67.79565589147923,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "258",
      paidOnly: false,
      title: "Add Digits",
      titleSlug: "add-digits",
    },
    {
      acRate: 50.96666396503675,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "259",
      paidOnly: true,
      title: "3Sum Smaller",
      titleSlug: "3sum-smaller",
    },
    {
      acRate: 70.67325585358373,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "260",
      paidOnly: false,
      title: "Single Number III",
      titleSlug: "single-number-iii",
    },
    {
      acRate: 49.23400977921611,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "261",
      paidOnly: true,
      title: "Graph Valid Tree",
      titleSlug: "graph-valid-tree",
    },
    {
      acRate: 37.08257052150925,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "262",
      paidOnly: false,
      title: "Trips and Users",
      titleSlug: "trips-and-users",
    },
    {
      acRate: 42.293234979684954,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "263",
      paidOnly: false,
      title: "Ugly Number",
      titleSlug: "ugly-number",
    },
    {
      acRate: 49.214748629564205,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "264",
      paidOnly: false,
      title: "Ugly Number II",
      titleSlug: "ugly-number-ii",
    },
    {
      acRate: 56.28604763337882,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "265",
      paidOnly: true,
      title: "Paint House II",
      titleSlug: "paint-house-ii",
    },
    {
      acRate: 68.46838124054463,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "266",
      paidOnly: true,
      title: "Palindrome Permutation",
      titleSlug: "palindrome-permutation",
    },
    {
      acRate: 42.093722268342255,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "267",
      paidOnly: true,
      title: "Palindrome Permutation II",
      titleSlug: "palindrome-permutation-ii",
    },
    {
      acRate: 69.76842656086801,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "268",
      paidOnly: false,
      title: "Missing Number",
      titleSlug: "missing-number",
    },
    {
      acRate: 36.58792550438009,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "269",
      paidOnly: true,
      title: "Alien Dictionary",
      titleSlug: "alien-dictionary",
    },
    {
      acRate: 49.90691294498615,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "270",
      paidOnly: true,
      title: "Closest Binary Search Tree Value",
      titleSlug: "closest-binary-search-tree-value",
    },
    {
      acRate: 49.41357802169537,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "271",
      paidOnly: true,
      title: "Encode and Decode Strings",
      titleSlug: "encode-and-decode-strings",
    },
    {
      acRate: 60.18101654196949,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "272",
      paidOnly: true,
      title: "Closest Binary Search Tree Value II",
      titleSlug: "closest-binary-search-tree-value-ii",
    },
    {
      acRate: 34.30587644049223,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "273",
      paidOnly: false,
      title: "Integer to English Words",
      titleSlug: "integer-to-english-words",
    },
    {
      acRate: 40.154467950026074,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "274",
      paidOnly: false,
      title: "H-Index",
      titleSlug: "h-index",
    },
    {
      acRate: 38.77699965558526,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "275",
      paidOnly: false,
      title: "H-Index II",
      titleSlug: "h-index-ii",
    },
    {
      acRate: 47.64681172160032,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "276",
      paidOnly: true,
      title: "Paint Fence",
      titleSlug: "paint-fence",
    },
    {
      acRate: 48.36408150954052,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "277",
      paidOnly: true,
      title: "Find the Celebrity",
      titleSlug: "find-the-celebrity",
    },
    {
      acRate: 45.776432033277366,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "278",
      paidOnly: false,
      title: "First Bad Version",
      titleSlug: "first-bad-version",
    },
    {
      acRate: 55.57470391740055,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "279",
      paidOnly: false,
      title: "Perfect Squares",
      titleSlug: "perfect-squares",
    },
    {
      acRate: 68.16516397859118,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "280",
      paidOnly: true,
      title: "Wiggle Sort",
      titleSlug: "wiggle-sort",
    },
    {
      acRate: 65.55680369561651,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "281",
      paidOnly: true,
      title: "Zigzag Iterator",
      titleSlug: "zigzag-iterator",
    },
    {
      acRate: 41.4506732489372,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "282",
      paidOnly: false,
      title: "Expression Add Operators",
      titleSlug: "expression-add-operators",
    },
    {
      acRate: 62.71242622660248,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "283",
      paidOnly: false,
      title: "Move Zeroes",
      titleSlug: "move-zeroes",
    },
    {
      acRate: 60.23844490678415,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "284",
      paidOnly: false,
      title: "Peeking Iterator",
      titleSlug: "peeking-iterator",
    },
    {
      acRate: 50.60218592347554,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "285",
      paidOnly: true,
      title: "Inorder Successor in BST",
      titleSlug: "inorder-successor-in-bst",
    },
    {
      acRate: 62.81088074285448,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "286",
      paidOnly: true,
      title: "Walls and Gates",
      titleSlug: "walls-and-gates",
    },
    {
      acRate: 62.617434678436915,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "287",
      paidOnly: false,
      title: "Find the Duplicate Number",
      titleSlug: "find-the-duplicate-number",
    },
    {
      acRate: 26.986005368855746,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "288",
      paidOnly: true,
      title: "Unique Word Abbreviation",
      titleSlug: "unique-word-abbreviation",
    },
    {
      acRate: 71.22525520346636,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "289",
      paidOnly: false,
      title: "Game of Life",
      titleSlug: "game-of-life",
    },
    {
      acRate: 42.97248117924697,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "290",
      paidOnly: false,
      title: "Word Pattern",
      titleSlug: "word-pattern",
    },
    {
      acRate: 48.58440266944634,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "291",
      paidOnly: true,
      title: "Word Pattern II",
      titleSlug: "word-pattern-ii",
    },
    {
      acRate: 58.00605442767265,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "292",
      paidOnly: false,
      title: "Nim Game",
      titleSlug: "nim-game",
    },
    {
      acRate: 64.87107178439352,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "293",
      paidOnly: true,
      title: "Flip Game",
      titleSlug: "flip-game",
    },
    {
      acRate: 52.209768608391315,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "294",
      paidOnly: true,
      title: "Flip Game II",
      titleSlug: "flip-game-ii",
    },
    {
      acRate: 53.10305968836984,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "295",
      paidOnly: false,
      title: "Find Median from Data Stream",
      titleSlug: "find-median-from-data-stream",
    },
    {
      acRate: 61.24156383531009,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "296",
      paidOnly: true,
      title: "Best Meeting Point",
      titleSlug: "best-meeting-point",
    },
    {
      acRate: 58.70553356273361,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "297",
      paidOnly: false,
      title: "Serialize and Deserialize Binary Tree",
      titleSlug: "serialize-and-deserialize-binary-tree",
    },
    {
      acRate: 54.06600127887904,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "298",
      paidOnly: true,
      title: "Binary Tree Longest Consecutive Sequence",
      titleSlug: "binary-tree-longest-consecutive-sequence",
    },
    {
      acRate: 51.254074343171254,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "299",
      paidOnly: false,
      title: "Bulls and Cows",
      titleSlug: "bulls-and-cows",
    },
    {
      acRate: 57.53394297725415,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "300",
      paidOnly: false,
      title: "Longest Increasing Subsequence",
      titleSlug: "longest-increasing-subsequence",
    },
    {
      acRate: 49.09942333136395,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "301",
      paidOnly: false,
      title: "Remove Invalid Parentheses",
      titleSlug: "remove-invalid-parentheses",
    },
    {
      acRate: 60.56540802303514,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "302",
      paidOnly: true,
      title: "Smallest Rectangle Enclosing Black Pixels",
      titleSlug: "smallest-rectangle-enclosing-black-pixels",
    },
    {
      acRate: 67.9917606501964,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "303",
      paidOnly: false,
      title: "Range Sum Query - Immutable",
      titleSlug: "range-sum-query-immutable",
    },
    {
      acRate: 56.29625529548038,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "304",
      paidOnly: false,
      title: "Range Sum Query 2D - Immutable",
      titleSlug: "range-sum-query-2d-immutable",
    },
    {
      acRate: 40.07953237135158,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "305",
      paidOnly: true,
      title: "Number of Islands II",
      titleSlug: "number-of-islands-ii",
    },
    {
      acRate: 32.43916050590367,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "306",
      paidOnly: false,
      title: "Additive Number",
      titleSlug: "additive-number",
    },
    {
      acRate: 41.6351736601282,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "307",
      paidOnly: false,
      title: "Range Sum Query - Mutable",
      titleSlug: "range-sum-query-mutable",
    },
    {
      acRate: 44.822892068342824,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "308",
      paidOnly: true,
      title: "Range Sum Query 2D - Mutable",
      titleSlug: "range-sum-query-2d-mutable",
    },
    {
      acRate: 60.108087499404284,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "309",
      paidOnly: false,
      title: "Best Time to Buy and Sell Stock with Cooldown",
      titleSlug: "best-time-to-buy-and-sell-stock-with-cooldown",
    },
    {
      acRate: 41.94226533290927,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "310",
      paidOnly: false,
      title: "Minimum Height Trees",
      titleSlug: "minimum-height-trees",
    },
    {
      acRate: 68.87074937494441,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "311",
      paidOnly: true,
      title: "Sparse Matrix Multiplication",
      titleSlug: "sparse-matrix-multiplication",
    },
    {
      acRate: 60.976810637772246,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "312",
      paidOnly: false,
      title: "Burst Balloons",
      titleSlug: "burst-balloons",
    },
    {
      acRate: 45.41721790968647,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "313",
      paidOnly: false,
      title: "Super Ugly Number",
      titleSlug: "super-ugly-number",
    },
    {
      acRate: 56.96308644713288,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "314",
      paidOnly: true,
      title: "Binary Tree Vertical Order Traversal",
      titleSlug: "binary-tree-vertical-order-traversal",
    },
    {
      acRate: 42.81186427479876,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "315",
      paidOnly: false,
      title: "Count of Smaller Numbers After Self",
      titleSlug: "count-of-smaller-numbers-after-self",
    },
    {
      acRate: 51.171374205476305,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "316",
      paidOnly: false,
      title: "Remove Duplicate Letters",
      titleSlug: "remove-duplicate-letters",
    },
    {
      acRate: 44.23813579680709,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "317",
      paidOnly: true,
      title: "Shortest Distance from All Buildings",
      titleSlug: "shortest-distance-from-all-buildings",
    },
    {
      acRate: 60.47542711524666,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "318",
      paidOnly: false,
      title: "Maximum Product of Word Lengths",
      titleSlug: "maximum-product-of-word-lengths",
    },
    {
      acRate: 53.942608349799656,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "319",
      paidOnly: false,
      title: "Bulb Switcher",
      titleSlug: "bulb-switcher",
    },
    {
      acRate: 60.00469799201341,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "320",
      paidOnly: true,
      title: "Generalized Abbreviation",
      titleSlug: "generalized-abbreviation",
    },
    {
      acRate: 32.20855561694458,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "321",
      paidOnly: false,
      title: "Create Maximum Number",
      titleSlug: "create-maximum-number",
    },
    {
      acRate: 46.213364160656376,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "322",
      paidOnly: false,
      title: "Coin Change",
      titleSlug: "coin-change",
    },
    {
      acRate: 64.08594536820607,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "323",
      paidOnly: true,
      title: "Number of Connected Components in an Undirected Graph",
      titleSlug: "number-of-connected-components-in-an-undirected-graph",
    },
    {
      acRate: 35.49939711810516,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "324",
      paidOnly: false,
      title: "Wiggle Sort II",
      titleSlug: "wiggle-sort-ii",
    },
    {
      acRate: 50.57811958238625,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "325",
      paidOnly: true,
      title: "Maximum Size Subarray Sum Equals k",
      titleSlug: "maximum-size-subarray-sum-equals-k",
    },
    {
      acRate: 47.86811102946405,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "326",
      paidOnly: false,
      title: "Power of Three",
      titleSlug: "power-of-three",
    },
    {
      acRate: 36.880969280386516,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "327",
      paidOnly: false,
      title: "Count of Range Sum",
      titleSlug: "count-of-range-sum",
    },
    {
      acRate: 61.94271848305352,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "328",
      paidOnly: false,
      title: "Odd Even Linked List",
      titleSlug: "odd-even-linked-list",
    },
    {
      acRate: 55.16682127465036,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "329",
      paidOnly: false,
      title: "Longest Increasing Path in a Matrix",
      titleSlug: "longest-increasing-path-in-a-matrix",
    },
    {
      acRate: 53.43195868420383,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "330",
      paidOnly: false,
      title: "Patching Array",
      titleSlug: "patching-array",
    },
    {
      acRate: 46.050693488363706,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "331",
      paidOnly: false,
      title: "Verify Preorder Serialization of a Binary Tree",
      titleSlug: "verify-preorder-serialization-of-a-binary-tree",
    },
    {
      acRate: 43.51579052497164,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "332",
      paidOnly: false,
      title: "Reconstruct Itinerary",
      titleSlug: "reconstruct-itinerary",
    },
    {
      acRate: 45.25767860267862,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "333",
      paidOnly: true,
      title: "Largest BST Subtree",
      titleSlug: "largest-bst-subtree",
    },
    {
      acRate: 39.13898959536648,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "334",
      paidOnly: false,
      title: "Increasing Triplet Subsequence",
      titleSlug: "increasing-triplet-subsequence",
    },
    {
      acRate: 31.870910769477785,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "335",
      paidOnly: false,
      title: "Self Crossing",
      titleSlug: "self-crossing",
    },
    {
      acRate: 36.146276044366125,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "336",
      paidOnly: false,
      title: "Palindrome Pairs",
      titleSlug: "palindrome-pairs",
    },
    {
      acRate: 54.84615878846976,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "337",
      paidOnly: false,
      title: "House Robber III",
      titleSlug: "house-robber-iii",
    },
    {
      acRate: 79.58975432046374,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "338",
      paidOnly: false,
      title: "Counting Bits",
      titleSlug: "counting-bits",
    },
    {
      acRate: 85.44097189379485,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "339",
      paidOnly: true,
      title: "Nested List Weight Sum",
      titleSlug: "nested-list-weight-sum",
    },
    {
      acRate: 49.41688104057423,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "340",
      paidOnly: true,
      title: "Longest Substring with At Most K Distinct Characters",
      titleSlug: "longest-substring-with-at-most-k-distinct-characters",
    },
    {
      acRate: 65.16141361291045,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "341",
      paidOnly: false,
      title: "Flatten Nested List Iterator",
      titleSlug: "flatten-nested-list-iterator",
    },
    {
      acRate: 49.321139317746564,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "342",
      paidOnly: false,
      title: "Power of Four",
      titleSlug: "power-of-four",
    },
    {
      acRate: 61.049591875327444,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "343",
      paidOnly: false,
      title: "Integer Break",
      titleSlug: "integer-break",
    },
    {
      acRate: 79.64523282717302,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "344",
      paidOnly: false,
      title: "Reverse String",
      titleSlug: "reverse-string",
    },
    {
      acRate: 57.757848776769,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "345",
      paidOnly: false,
      title: "Reverse Vowels of a String",
      titleSlug: "reverse-vowels-of-a-string",
    },
    {
      acRate: 79.84660336011687,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "346",
      paidOnly: true,
      title: "Moving Average from Data Stream",
      titleSlug: "moving-average-from-data-stream",
    },
    {
      acRate: 64.37169052783803,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "347",
      paidOnly: false,
      title: "Top K Frequent Elements",
      titleSlug: "top-k-frequent-elements",
    },
    {
      acRate: 58.5533610712479,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "348",
      paidOnly: true,
      title: "Design Tic-Tac-Toe",
      titleSlug: "design-tic-tac-toe",
    },
    {
      acRate: 76.28879386182997,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "349",
      paidOnly: false,
      title: "Intersection of Two Arrays",
      titleSlug: "intersection-of-two-arrays",
    },
    {
      acRate: 58.98988497304972,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "350",
      paidOnly: false,
      title: "Intersection of Two Arrays II",
      titleSlug: "intersection-of-two-arrays-ii",
    },
    {
      acRate: 53.29358809236121,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "351",
      paidOnly: true,
      title: "Android Unlock Patterns",
      titleSlug: "android-unlock-patterns",
    },
    {
      acRate: 59.44985443228592,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "352",
      paidOnly: false,
      title: "Data Stream as Disjoint Intervals",
      titleSlug: "data-stream-as-disjoint-intervals",
    },
    {
      acRate: 39.56614850944979,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "353",
      paidOnly: true,
      title: "Design Snake Game",
      titleSlug: "design-snake-game",
    },
    {
      acRate: 37.282765001204496,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "354",
      paidOnly: false,
      title: "Russian Doll Envelopes",
      titleSlug: "russian-doll-envelopes",
    },
    {
      acRate: 42.35323593903439,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "355",
      paidOnly: false,
      title: "Design Twitter",
      titleSlug: "design-twitter",
    },
    {
      acRate: 35.946456434261314,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "356",
      paidOnly: true,
      title: "Line Reflection",
      titleSlug: "line-reflection",
    },
    {
      acRate: 54.20950282626292,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "357",
      paidOnly: false,
      title: "Count Numbers with Unique Digits",
      titleSlug: "count-numbers-with-unique-digits",
    },
    {
      acRate: 39.3280643575823,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "358",
      paidOnly: true,
      title: "Rearrange String k Distance Apart",
      titleSlug: "rearrange-string-k-distance-apart",
    },
    {
      acRate: 76.51833306412534,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "359",
      paidOnly: true,
      title: "Logger Rate Limiter",
      titleSlug: "logger-rate-limiter",
    },
    {
      acRate: 56.96508454773166,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "360",
      paidOnly: true,
      title: "Sort Transformed Array",
      titleSlug: "sort-transformed-array",
    },
    {
      acRate: 52.059678183284475,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "361",
      paidOnly: true,
      title: "Bomb Enemy",
      titleSlug: "bomb-enemy",
    },
    {
      acRate: 69.12193019823069,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "362",
      paidOnly: true,
      title: "Design Hit Counter",
      titleSlug: "design-hit-counter",
    },
    {
      acRate: 44.60254494528837,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "363",
      paidOnly: false,
      title: "Max Sum of Rectangle No Larger Than K",
      titleSlug: "max-sum-of-rectangle-no-larger-than-k",
    },
    {
      acRate: 65.40190273206198,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "364",
      paidOnly: true,
      title: "Nested List Weight Sum II",
      titleSlug: "nested-list-weight-sum-ii",
    },
    {
      acRate: 42.87846325377214,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "365",
      paidOnly: false,
      title: "Water and Jug Problem",
      titleSlug: "water-and-jug-problem",
    },
    {
      acRate: 81.0378788994067,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "366",
      paidOnly: true,
      title: "Find Leaves of Binary Tree",
      titleSlug: "find-leaves-of-binary-tree",
    },
    {
      acRate: 44.131990685394484,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "367",
      paidOnly: false,
      title: "Valid Perfect Square",
      titleSlug: "valid-perfect-square",
    },
    {
      acRate: 48.74633015420369,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "368",
      paidOnly: false,
      title: "Largest Divisible Subset",
      titleSlug: "largest-divisible-subset",
    },
    {
      acRate: 61.141500969581195,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "369",
      paidOnly: true,
      title: "Plus One Linked List",
      titleSlug: "plus-one-linked-list",
    },
    {
      acRate: 72.24990195081563,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "370",
      paidOnly: true,
      title: "Range Addition",
      titleSlug: "range-addition",
    },
    {
      acRate: 53.470691215865386,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "371",
      paidOnly: false,
      title: "Sum of Two Integers",
      titleSlug: "sum-of-two-integers",
    },
    {
      acRate: 35.422927759973064,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "372",
      paidOnly: false,
      title: "Super Pow",
      titleSlug: "super-pow",
    },
    {
      acRate: 40.611064964588614,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "373",
      paidOnly: false,
      title: "Find K Pairs with Smallest Sums",
      titleSlug: "find-k-pairs-with-smallest-sums",
    },
    {
      acRate: 55.566507308689005,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "374",
      paidOnly: false,
      title: "Guess Number Higher or Lower",
      titleSlug: "guess-number-higher-or-lower",
    },
    {
      acRate: 50.94086503626437,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "375",
      paidOnly: false,
      title: "Guess Number Higher or Lower II",
      titleSlug: "guess-number-higher-or-lower-ii",
    },
    {
      acRate: 48.81077618057856,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "376",
      paidOnly: false,
      title: "Wiggle Subsequence",
      titleSlug: "wiggle-subsequence",
    },
    {
      acRate: 54.60713519410126,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "377",
      paidOnly: false,
      title: "Combination Sum IV",
      titleSlug: "combination-sum-iv",
    },
    {
      acRate: 63.42963663369989,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "378",
      paidOnly: false,
      title: "Kth Smallest Element in a Sorted Matrix",
      titleSlug: "kth-smallest-element-in-a-sorted-matrix",
    },
    {
      acRate: 52.29507467335044,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "379",
      paidOnly: true,
      title: "Design Phone Directory",
      titleSlug: "design-phone-directory",
    },
    {
      acRate: 54.92122648702892,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "380",
      paidOnly: false,
      title: "Insert Delete GetRandom O(1)",
      titleSlug: "insert-delete-getrandom-o1",
    },
    {
      acRate: 35.712617459919024,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "381",
      paidOnly: false,
      title: "Insert Delete GetRandom O(1) - Duplicates allowed",
      titleSlug: "insert-delete-getrandom-o1-duplicates-allowed",
    },
    {
      acRate: 63.89729339833179,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "382",
      paidOnly: false,
      title: "Linked List Random Node",
      titleSlug: "linked-list-random-node",
    },
    {
      acRate: 64.30297021747344,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "383",
      paidOnly: false,
      title: "Ransom Note",
      titleSlug: "ransom-note",
    },
    {
      acRate: 58.95069378629923,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "384",
      paidOnly: false,
      title: "Shuffle an Array",
      titleSlug: "shuffle-an-array",
    },
    {
      acRate: 39.960575891409036,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "385",
      paidOnly: false,
      title: "Mini Parser",
      titleSlug: "mini-parser",
    },
    {
      acRate: 73.08429512754914,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "386",
      paidOnly: false,
      title: "Lexicographical Numbers",
      titleSlug: "lexicographical-numbers",
    },
    {
      acRate: 63.508199125601664,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "387",
      paidOnly: false,
      title: "First Unique Character in a String",
      titleSlug: "first-unique-character-in-a-string",
    },
    {
      acRate: 48.27196488708187,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "388",
      paidOnly: false,
      title: "Longest Absolute File Path",
      titleSlug: "longest-absolute-file-path",
    },
    {
      acRate: 59.695600596348164,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "389",
      paidOnly: false,
      title: "Find the Difference",
      titleSlug: "find-the-difference",
    },
    {
      acRate: 44.72944249532638,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "390",
      paidOnly: false,
      title: "Elimination Game",
      titleSlug: "elimination-game",
    },
    {
      acRate: 35.01565217391304,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "391",
      paidOnly: false,
      title: "Perfect Rectangle",
      titleSlug: "perfect-rectangle",
    },
    {
      acRate: 48.3123961452147,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "392",
      paidOnly: false,
      title: "Is Subsequence",
      titleSlug: "is-subsequence",
    },
    {
      acRate: 45.4787418144564,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "393",
      paidOnly: false,
      title: "UTF-8 Validation",
      titleSlug: "utf-8-validation",
    },
    {
      acRate: 60.959952408322934,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "394",
      paidOnly: false,
      title: "Decode String",
      titleSlug: "decode-string",
    },
    {
      acRate: 45.39845344967419,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "395",
      paidOnly: false,
      title: "Longest Substring with At Least K Repeating Characters",
      titleSlug: "longest-substring-with-at-least-k-repeating-characters",
    },
    {
      acRate: 43.85278311975413,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "396",
      paidOnly: false,
      title: "Rotate Function",
      titleSlug: "rotate-function",
    },
    {
      acRate: 36.425085081465994,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "397",
      paidOnly: false,
      title: "Integer Replacement",
      titleSlug: "integer-replacement",
    },
    {
      acRate: 64.4429511539531,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "398",
      paidOnly: false,
      title: "Random Pick Index",
      titleSlug: "random-pick-index",
    },
    {
      acRate: 62.97658909107149,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "399",
      paidOnly: false,
      title: "Evaluate Division",
      titleSlug: "evaluate-division",
    },
    {
      acRate: 35.56767940972663,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "400",
      paidOnly: false,
      title: "Nth Digit",
      titleSlug: "nth-digit",
    },
    {
      acRate: 56.33928082754092,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "401",
      paidOnly: false,
      title: "Binary Watch",
      titleSlug: "binary-watch",
    },
    {
      acRate: 34.71258193012977,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "402",
      paidOnly: false,
      title: "Remove K Digits",
      titleSlug: "remove-k-digits",
    },
    {
      acRate: 46.48332317775191,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "403",
      paidOnly: false,
      title: "Frog Jump",
      titleSlug: "frog-jump",
    },
    {
      acRate: 61.54204194333048,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "404",
      paidOnly: false,
      title: "Sum of Left Leaves",
      titleSlug: "sum-of-left-leaves",
    },
    {
      acRate: 50.663266635213475,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "405",
      paidOnly: false,
      title: "Convert a Number to Hexadecimal",
      titleSlug: "convert-a-number-to-hexadecimal",
    },
    {
      acRate: 74.0971220298784,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "406",
      paidOnly: false,
      title: "Queue Reconstruction by Height",
      titleSlug: "queue-reconstruction-by-height",
    },
    {
      acRate: 58.75463711203789,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "407",
      paidOnly: false,
      title: "Trapping Rain Water II",
      titleSlug: "trapping-rain-water-ii",
    },
    {
      acRate: 36.79129202484183,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "408",
      paidOnly: true,
      title: "Valid Word Abbreviation",
      titleSlug: "valid-word-abbreviation",
    },
    {
      acRate: 55.51157114324674,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "409",
      paidOnly: false,
      title: "Longest Palindrome",
      titleSlug: "longest-palindrome",
    },
    {
      acRate: 57.75131953457093,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "410",
      paidOnly: false,
      title: "Split Array Largest Sum",
      titleSlug: "split-array-largest-sum",
    },
    {
      acRate: 40.14301112016614,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "411",
      paidOnly: true,
      title: "Minimum Unique Word Abbreviation",
      titleSlug: "minimum-unique-word-abbreviation",
    },
    {
      acRate: 74.20939763842786,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "412",
      paidOnly: false,
      title: "Fizz Buzz",
      titleSlug: "fizz-buzz",
    },
    {
      acRate: 64.82859280853684,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "413",
      paidOnly: false,
      title: "Arithmetic Slices",
      titleSlug: "arithmetic-slices",
    },
    {
      acRate: 36.99201823647228,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "414",
      paidOnly: false,
      title: "Third Maximum Number",
      titleSlug: "third-maximum-number",
    },
    {
      acRate: 51.854011043801584,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "415",
      paidOnly: false,
      title: "Add Strings",
      titleSlug: "add-strings",
    },
    {
      acRate: 48.26410744728975,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "416",
      paidOnly: false,
      title: "Partition Equal Subset Sum",
      titleSlug: "partition-equal-subset-sum",
    },
    {
      acRate: 57.26246421958604,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "417",
      paidOnly: false,
      title: "Pacific Atlantic Water Flow",
      titleSlug: "pacific-atlantic-water-flow",
    },
    {
      acRate: 36.3303438225816,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "418",
      paidOnly: true,
      title: "Sentence Screen Fitting",
      titleSlug: "sentence-screen-fitting",
    },
    {
      acRate: 76.4224324726142,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "419",
      paidOnly: false,
      title: "Battleships in a Board",
      titleSlug: "battleships-in-a-board",
    },
    {
      acRate: 14.519041489435464,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "420",
      paidOnly: false,
      title: "Strong Password Checker",
      titleSlug: "strong-password-checker",
    },
    {
      acRate: 53.16340951190537,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "421",
      paidOnly: false,
      title: "Maximum XOR of Two Numbers in an Array",
      titleSlug: "maximum-xor-of-two-numbers-in-an-array",
    },
    {
      acRate: 41.932085679728445,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "422",
      paidOnly: true,
      title: "Valid Word Square",
      titleSlug: "valid-word-square",
    },
    {
      acRate: 51.559392620668675,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "423",
      paidOnly: false,
      title: "Reconstruct Original Digits from English",
      titleSlug: "reconstruct-original-digits-from-english",
    },
    {
      acRate: 56.86740833893591,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "424",
      paidOnly: false,
      title: "Longest Repeating Character Replacement",
      titleSlug: "longest-repeating-character-replacement",
    },
    {
      acRate: 53.89583175887821,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "425",
      paidOnly: true,
      title: "Word Squares",
      titleSlug: "word-squares",
    },
    {
      acRate: 65.4490335699456,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "426",
      paidOnly: true,
      title: "Convert Binary Search Tree to Sorted Doubly Linked List",
      titleSlug: "convert-binary-search-tree-to-sorted-doubly-linked-list",
    },
    {
      acRate: 76.95139526366607,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "427",
      paidOnly: false,
      title: "Construct Quad Tree",
      titleSlug: "construct-quad-tree",
    },
    {
      acRate: 68.19048848349253,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "428",
      paidOnly: true,
      title: "Serialize and Deserialize N-ary Tree",
      titleSlug: "serialize-and-deserialize-n-ary-tree",
    },
    {
      acRate: 71.21471496509754,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "429",
      paidOnly: false,
      title: "N-ary Tree Level Order Traversal",
      titleSlug: "n-ary-tree-level-order-traversal",
    },
    {
      acRate: 61.16060488944075,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "430",
      paidOnly: false,
      title: "Flatten a Multilevel Doubly Linked List",
      titleSlug: "flatten-a-multilevel-doubly-linked-list",
    },
    {
      acRate: 80.05236848369435,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "431",
      paidOnly: true,
      title: "Encode N-ary Tree to Binary Tree",
      titleSlug: "encode-n-ary-tree-to-binary-tree",
    },
    {
      acRate: 44.183671430997116,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "432",
      paidOnly: false,
      title: "All O`one Data Structure",
      titleSlug: "all-oone-data-structure",
    },
    {
      acRate: 55.29441496082891,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "433",
      paidOnly: false,
      title: "Minimum Genetic Mutation",
      titleSlug: "minimum-genetic-mutation",
    },
    {
      acRate: 36.342162379943595,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "434",
      paidOnly: false,
      title: "Number of Segments in a String",
      titleSlug: "number-of-segments-in-a-string",
    },
    {
      acRate: 55.27122093190129,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "435",
      paidOnly: false,
      title: "Non-overlapping Intervals",
      titleSlug: "non-overlapping-intervals",
    },
    {
      acRate: 53.67355847454264,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "436",
      paidOnly: false,
      title: "Find Right Interval",
      titleSlug: "find-right-interval",
    },
    {
      acRate: 46.06528616893759,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "437",
      paidOnly: false,
      title: "Path Sum III",
      titleSlug: "path-sum-iii",
    },
    {
      acRate: 52.05639592137562,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "438",
      paidOnly: false,
      title: "Find All Anagrams in a String",
      titleSlug: "find-all-anagrams-in-a-string",
    },
    {
      acRate: 61.90841124678553,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "439",
      paidOnly: true,
      title: "Ternary Expression Parser",
      titleSlug: "ternary-expression-parser",
    },
    {
      acRate: 41.988093259523474,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "440",
      paidOnly: false,
      title: "K-th Smallest in Lexicographical Order",
      titleSlug: "k-th-smallest-in-lexicographical-order",
    },
    {
      acRate: 47.268772692042795,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "441",
      paidOnly: false,
      title: "Arranging Coins",
      titleSlug: "arranging-coins",
    },
    {
      acRate: 76.331563522066,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "442",
      paidOnly: false,
      title: "Find All Duplicates in an Array",
      titleSlug: "find-all-duplicates-in-an-array",
    },
    {
      acRate: 57.8040304054378,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "443",
      paidOnly: false,
      title: "String Compression",
      titleSlug: "string-compression",
    },
    {
      acRate: 29.356714252098204,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "444",
      paidOnly: true,
      title: "Sequence Reconstruction",
      titleSlug: "sequence-reconstruction",
    },
    {
      acRate: 61.66913730498762,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "445",
      paidOnly: false,
      title: "Add Two Numbers II",
      titleSlug: "add-two-numbers-ii",
    },
    {
      acRate: 54.52783583507505,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "446",
      paidOnly: false,
      title: "Arithmetic Slices II - Subsequence",
      titleSlug: "arithmetic-slices-ii-subsequence",
    },
    {
      acRate: 56.30448318804483,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "447",
      paidOnly: false,
      title: "Number of Boomerangs",
      titleSlug: "number-of-boomerangs",
    },
    {
      acRate: 62.262970655799045,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "448",
      paidOnly: false,
      title: "Find All Numbers Disappeared in an Array",
      titleSlug: "find-all-numbers-disappeared-in-an-array",
    },
    {
      acRate: 58.485366955976346,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "449",
      paidOnly: false,
      title: "Serialize and Deserialize BST",
      titleSlug: "serialize-and-deserialize-bst",
    },
    {
      acRate: 52.82328216119918,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "450",
      paidOnly: false,
      title: "Delete Node in a BST",
      titleSlug: "delete-node-in-a-bst",
    },
    {
      acRate: 73.88961832752298,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "451",
      paidOnly: false,
      title: "Sort Characters By Frequency",
      titleSlug: "sort-characters-by-frequency",
    },
    {
      acRate: 60.26229292122151,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "452",
      paidOnly: false,
      title: "Minimum Number of Arrows to Burst Balloons",
      titleSlug: "minimum-number-of-arrows-to-burst-balloons",
    },
    {
      acRate: 57.63815635904845,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "453",
      paidOnly: false,
      title: "Minimum Moves to Equal Array Elements",
      titleSlug: "minimum-moves-to-equal-array-elements",
    },
    {
      acRate: 57.54458239551595,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "454",
      paidOnly: false,
      title: "4Sum II",
      titleSlug: "4sum-ii",
    },
    {
      acRate: 53.660711684561825,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "455",
      paidOnly: false,
      title: "Assign Cookies",
      titleSlug: "assign-cookies",
    },
    {
      acRate: 34.00113397876217,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "456",
      paidOnly: false,
      title: "132 Pattern",
      titleSlug: "132-pattern",
    },
    {
      acRate: 35.43609623928942,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "457",
      paidOnly: false,
      title: "Circular Array Loop",
      titleSlug: "circular-array-loop",
    },
    {
      acRate: 59.23444567722114,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "458",
      paidOnly: false,
      title: "Poor Pigs",
      titleSlug: "poor-pigs",
    },
    {
      acRate: 46.78450049831862,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "459",
      paidOnly: false,
      title: "Repeated Substring Pattern",
      titleSlug: "repeated-substring-pattern",
    },
    {
      acRate: 46.25439031619491,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "460",
      paidOnly: false,
      title: "LFU Cache",
      titleSlug: "lfu-cache",
    },
    {
      acRate: 76.0224679443789,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "461",
      paidOnly: false,
      title: "Hamming Distance",
      titleSlug: "hamming-distance",
    },
    {
      acRate: 60.87624236618369,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "462",
      paidOnly: false,
      title: "Minimum Moves to Equal Array Elements II",
      titleSlug: "minimum-moves-to-equal-array-elements-ii",
    },
    {
      acRate: 73.44338507443217,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "463",
      paidOnly: false,
      title: "Island Perimeter",
      titleSlug: "island-perimeter",
    },
    {
      acRate: 30.30599475469416,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "464",
      paidOnly: false,
      title: "Can I Win",
      titleSlug: "can-i-win",
    },
    {
      acRate: 49.83819081462389,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "465",
      paidOnly: true,
      title: "Optimal Account Balancing",
      titleSlug: "optimal-account-balancing",
    },
    {
      acRate: 31.609155077812552,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "466",
      paidOnly: false,
      title: "Count The Repetitions",
      titleSlug: "count-the-repetitions",
    },
    {
      acRate: 41.038816064876755,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "467",
      paidOnly: false,
      title: "Unique Substrings in Wraparound String",
      titleSlug: "unique-substrings-in-wraparound-string",
    },
    {
      acRate: 27.761931180876342,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "468",
      paidOnly: false,
      title: "Validate IP Address",
      titleSlug: "validate-ip-address",
    },
    {
      acRate: 39.83459927592816,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "469",
      paidOnly: true,
      title: "Convex Polygon",
      titleSlug: "convex-polygon",
    },
    {
      acRate: 45.84765833906334,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "470",
      paidOnly: false,
      title: "Implement Rand10() Using Rand7()",
      titleSlug: "implement-rand10-using-rand7",
    },
    {
      acRate: 50.46892004353114,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "471",
      paidOnly: true,
      title: "Encode String with Shortest Length",
      titleSlug: "encode-string-with-shortest-length",
    },
    {
      acRate: 49.39515078127193,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "472",
      paidOnly: false,
      title: "Concatenated Words",
      titleSlug: "concatenated-words",
    },
    {
      acRate: 40.81566543759566,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "473",
      paidOnly: false,
      title: "Matchsticks to Square",
      titleSlug: "matchsticks-to-square",
    },
    {
      acRate: 48.692360562147705,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "474",
      paidOnly: false,
      title: "Ones and Zeroes",
      titleSlug: "ones-and-zeroes",
    },
    {
      acRate: 39.763540824575585,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "475",
      paidOnly: false,
      title: "Heaters",
      titleSlug: "heaters",
    },
    {
      acRate: 70.3110357946479,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "476",
      paidOnly: false,
      title: "Number Complement",
      titleSlug: "number-complement",
    },
    {
      acRate: 53.6488175966708,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "477",
      paidOnly: false,
      title: "Total Hamming Distance",
      titleSlug: "total-hamming-distance",
    },
    {
      acRate: 40.832834032354704,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "478",
      paidOnly: false,
      title: "Generate Random Point in a Circle",
      titleSlug: "generate-random-point-in-a-circle",
    },
    {
      acRate: 34.85370701149714,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "479",
      paidOnly: false,
      title: "Largest Palindrome Product",
      titleSlug: "largest-palindrome-product",
    },
    {
      acRate: 38.63942939826407,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "480",
      paidOnly: false,
      title: "Sliding Window Median",
      titleSlug: "sliding-window-median",
    },
    {
      acRate: 52.28851182874171,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "481",
      paidOnly: false,
      title: "Magical String",
      titleSlug: "magical-string",
    },
    {
      acRate: 44.60457562491173,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "482",
      paidOnly: false,
      title: "License Key Formatting",
      titleSlug: "license-key-formatting",
    },
    {
      acRate: 43.13735145427089,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "483",
      paidOnly: false,
      title: "Smallest Good Base",
      titleSlug: "smallest-good-base",
    },
    {
      acRate: 66.903221653632,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "484",
      paidOnly: true,
      title: "Find Permutation",
      titleSlug: "find-permutation",
    },
    {
      acRate: 62.17415211298888,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "485",
      paidOnly: false,
      title: "Max Consecutive Ones",
      titleSlug: "max-consecutive-ones",
    },
    {
      acRate: 55.656958797476854,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "486",
      paidOnly: false,
      title: "Predict the Winner",
      titleSlug: "predict-the-winner",
    },
    {
      acRate: 51.4713795959828,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "487",
      paidOnly: true,
      title: "Max Consecutive Ones II",
      titleSlug: "max-consecutive-ones-ii",
    },
    {
      acRate: 31.64840486712271,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "488",
      paidOnly: false,
      title: "Zuma Game",
      titleSlug: "zuma-game",
    },
    {
      acRate: 77.39817052475762,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "489",
      paidOnly: true,
      title: "Robot Room Cleaner",
      titleSlug: "robot-room-cleaner",
    },
    {
      acRate: 59.33153929289207,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "490",
      paidOnly: true,
      title: "The Maze",
      titleSlug: "the-maze",
    },
    {
      acRate: 61.54450724704126,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "491",
      paidOnly: false,
      title: "Non-decreasing Subsequences",
      titleSlug: "non-decreasing-subsequences",
    },
    {
      acRate: 60.38077697348696,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "492",
      paidOnly: false,
      title: "Construct the Rectangle",
      titleSlug: "construct-the-rectangle",
    },
    {
      acRate: 31.9249627104463,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "493",
      paidOnly: false,
      title: "Reverse Pairs",
      titleSlug: "reverse-pairs",
    },
    {
      acRate: 50.567318854810765,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "494",
      paidOnly: false,
      title: "Target Sum",
      titleSlug: "target-sum",
    },
    {
      acRate: 56.908265156935336,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "495",
      paidOnly: false,
      title: "Teemo Attacking",
      titleSlug: "teemo-attacking",
    },
    {
      acRate: 74.2575957139215,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "496",
      paidOnly: false,
      title: "Next Greater Element I",
      titleSlug: "next-greater-element-i",
    },
    {
      acRate: 37.95202906734097,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "497",
      paidOnly: false,
      title: "Random Point in Non-overlapping Rectangles",
      titleSlug: "random-point-in-non-overlapping-rectangles",
    },
    {
      acRate: 62.927963909931975,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "498",
      paidOnly: false,
      title: "Diagonal Traverse",
      titleSlug: "diagonal-traverse",
    },
    {
      acRate: 50.520936273540954,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "499",
      paidOnly: true,
      title: "The Maze III",
      titleSlug: "the-maze-iii",
    },
    {
      acRate: 72.31492607491772,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "500",
      paidOnly: false,
      title: "Keyboard Row",
      titleSlug: "keyboard-row",
    },
    {
      acRate: 57.38106631903764,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "501",
      paidOnly: false,
      title: "Find Mode in Binary Search Tree",
      titleSlug: "find-mode-in-binary-search-tree",
    },
    {
      acRate: 53.00765412076501,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "502",
      paidOnly: false,
      title: "IPO",
      titleSlug: "ipo",
    },
    {
      acRate: 65.97437004358395,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "503",
      paidOnly: false,
      title: "Next Greater Element II",
      titleSlug: "next-greater-element-ii",
    },
    {
      acRate: 51.770565011767765,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "504",
      paidOnly: false,
      title: "Base 7",
      titleSlug: "base-7",
    },
    {
      acRate: 54.090170237651215,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "505",
      paidOnly: true,
      title: "The Maze II",
      titleSlug: "the-maze-ii",
    },
    {
      acRate: 73.14269546434461,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "506",
      paidOnly: false,
      title: "Relative Ranks",
      titleSlug: "relative-ranks",
    },
    {
      acRate: 44.51618196400436,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "507",
      paidOnly: false,
      title: "Perfect Number",
      titleSlug: "perfect-number",
    },
    {
      acRate: 67.7111331769701,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "508",
      paidOnly: false,
      title: "Most Frequent Subtree Sum",
      titleSlug: "most-frequent-subtree-sum",
    },
    {
      acRate: 72.76821159495103,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "509",
      paidOnly: false,
      title: "Fibonacci Number",
      titleSlug: "fibonacci-number",
    },
    {
      acRate: 60.97480442954384,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "510",
      paidOnly: true,
      title: "Inorder Successor in BST II",
      titleSlug: "inorder-successor-in-bst-ii",
    },
    {
      acRate: 75.62441001034672,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "511",
      paidOnly: false,
      title: "Game Play Analysis I",
      titleSlug: "game-play-analysis-i",
    },
    {
      acRate: 53.900367614491984,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "512",
      paidOnly: true,
      title: "Game Play Analysis II",
      titleSlug: "game-play-analysis-ii",
    },
    {
      acRate: 71.70206744358505,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "513",
      paidOnly: false,
      title: "Find Bottom Left Tree Value",
      titleSlug: "find-bottom-left-tree-value",
    },
    {
      acRate: 58.82857897517169,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "514",
      paidOnly: false,
      title: "Freedom Trail",
      titleSlug: "freedom-trail",
    },
    {
      acRate: 66.27612333823652,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "515",
      paidOnly: false,
      title: "Find Largest Value in Each Tree Row",
      titleSlug: "find-largest-value-in-each-tree-row",
    },
    {
      acRate: 63.904384051612475,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "516",
      paidOnly: false,
      title: "Longest Palindromic Subsequence",
      titleSlug: "longest-palindromic-subsequence",
    },
    {
      acRate: 42.31750893312915,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "517",
      paidOnly: false,
      title: "Super Washing Machines",
      titleSlug: "super-washing-machines",
    },
    {
      acRate: 62.73710964658801,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "518",
      paidOnly: false,
      title: "Coin Change II",
      titleSlug: "coin-change-ii",
    },
    {
      acRate: 43.373473425666916,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "519",
      paidOnly: false,
      title: "Random Flip Matrix",
      titleSlug: "random-flip-matrix",
    },
    {
      acRate: 56.132843458436085,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "520",
      paidOnly: false,
      title: "Detect Capital",
      titleSlug: "detect-capital",
    },
    {
      acRate: 61.274434210464825,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "521",
      paidOnly: false,
      title: "Longest Uncommon Subsequence I",
      titleSlug: "longest-uncommon-subsequence-i",
    },
    {
      acRate: 42.894940396585,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "522",
      paidOnly: false,
      title: "Longest Uncommon Subsequence II",
      titleSlug: "longest-uncommon-subsequence-ii",
    },
    {
      acRate: 30.84784384087395,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "523",
      paidOnly: false,
      title: "Continuous Subarray Sum",
      titleSlug: "continuous-subarray-sum",
    },
    {
      acRate: 51.70092592592592,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "524",
      paidOnly: false,
      title: "Longest Word in Dictionary through Deleting",
      titleSlug: "longest-word-in-dictionary-through-deleting",
    },
    {
      acRate: 49.15340722532324,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "525",
      paidOnly: false,
      title: "Contiguous Array",
      titleSlug: "contiguous-array",
    },
    {
      acRate: 64.48716298078986,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "526",
      paidOnly: false,
      title: "Beautiful Arrangement",
      titleSlug: "beautiful-arrangement",
    },
    {
      acRate: 61.79440489985102,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "527",
      paidOnly: true,
      title: "Word Abbreviation",
      titleSlug: "word-abbreviation",
    },
    {
      acRate: 48.13715651476759,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "528",
      paidOnly: false,
      title: "Random Pick with Weight",
      titleSlug: "random-pick-with-weight",
    },
    {
      acRate: 67.9674868610531,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "529",
      paidOnly: false,
      title: "Minesweeper",
      titleSlug: "minesweeper",
    },
    {
      acRate: 58.756752587940476,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "530",
      paidOnly: false,
      title: "Minimum Absolute Difference in BST",
      titleSlug: "minimum-absolute-difference-in-bst",
    },
    {
      acRate: 62.46534761102354,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "531",
      paidOnly: true,
      title: "Lonely Pixel I",
      titleSlug: "lonely-pixel-i",
    },
    {
      acRate: 44.502702210941735,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "532",
      paidOnly: false,
      title: "K-diff Pairs in an Array",
      titleSlug: "k-diff-pairs-in-an-array",
    },
    {
      acRate: 48.670147527770965,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "533",
      paidOnly: true,
      title: "Lonely Pixel II",
      titleSlug: "lonely-pixel-ii",
    },
    {
      acRate: 81.23580444576834,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "534",
      paidOnly: true,
      title: "Game Play Analysis III",
      titleSlug: "game-play-analysis-iii",
    },
    {
      acRate: 86.30865080423268,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "535",
      paidOnly: false,
      title: "Encode and Decode TinyURL",
      titleSlug: "encode-and-decode-tinyurl",
    },
    {
      acRate: 58.269966652566964,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "536",
      paidOnly: true,
      title: "Construct Binary Tree from String",
      titleSlug: "construct-binary-tree-from-string",
    },
    {
      acRate: 72.3272121139658,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "537",
      paidOnly: false,
      title: "Complex Number Multiplication",
      titleSlug: "complex-number-multiplication",
    },
    {
      acRate: 70.37711952026469,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "538",
      paidOnly: false,
      title: "Convert BST to Greater Tree",
      titleSlug: "convert-bst-to-greater-tree",
    },
    {
      acRate: 62.32389164476652,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "539",
      paidOnly: false,
      title: "Minimum Time Difference",
      titleSlug: "minimum-time-difference",
    },
    {
      acRate: 59.191750536215146,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "540",
      paidOnly: false,
      title: "Single Element in a Sorted Array",
      titleSlug: "single-element-in-a-sorted-array",
    },
    {
      acRate: 51.95800037358897,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "541",
      paidOnly: false,
      title: "Reverse String II",
      titleSlug: "reverse-string-ii",
    },
    {
      acRate: 51.107351061706794,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "542",
      paidOnly: false,
      title: "01 Matrix",
      titleSlug: "01-matrix",
    },
    {
      acRate: 63.2777926716312,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "543",
      paidOnly: false,
      title: "Diameter of Binary Tree",
      titleSlug: "diameter-of-binary-tree",
    },
    {
      acRate: 77.37890473284136,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "544",
      paidOnly: true,
      title: "Output Contest Matches",
      titleSlug: "output-contest-matches",
    },
    {
      acRate: 47.016538526023325,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "545",
      paidOnly: true,
      title: "Boundary of Binary Tree",
      titleSlug: "boundary-of-binary-tree",
    },
    {
      acRate: 48.225884767253305,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "546",
      paidOnly: false,
      title: "Remove Boxes",
      titleSlug: "remove-boxes",
    },
    {
      acRate: 68.35999799993448,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "547",
      paidOnly: false,
      title: "Number of Provinces",
      titleSlug: "number-of-provinces",
    },
    {
      acRate: 50.12972685856708,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "548",
      paidOnly: true,
      title: "Split Array with Equal Sum",
      titleSlug: "split-array-with-equal-sum",
    },
    {
      acRate: 49.55999197606775,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "549",
      paidOnly: true,
      title: "Binary Tree Longest Consecutive Sequence II",
      titleSlug: "binary-tree-longest-consecutive-sequence-ii",
    },
    {
      acRate: 39.26735234745876,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "550",
      paidOnly: false,
      title: "Game Play Analysis IV",
      titleSlug: "game-play-analysis-iv",
    },
    {
      acRate: 49.56290592200816,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "551",
      paidOnly: false,
      title: "Student Attendance Record I",
      titleSlug: "student-attendance-record-i",
    },
    {
      acRate: 55.71575539920788,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "552",
      paidOnly: false,
      title: "Student Attendance Record II",
      titleSlug: "student-attendance-record-ii",
    },
    {
      acRate: 61.60721551607216,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "553",
      paidOnly: false,
      title: "Optimal Division",
      titleSlug: "optimal-division",
    },
    {
      acRate: 55.81395348837209,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "554",
      paidOnly: false,
      title: "Brick Wall",
      titleSlug: "brick-wall",
    },
    {
      acRate: 43.30432680686488,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "555",
      paidOnly: true,
      title: "Split Concatenated Strings",
      titleSlug: "split-concatenated-strings",
    },
    {
      acRate: 34.50489849703035,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "556",
      paidOnly: false,
      title: "Next Greater Element III",
      titleSlug: "next-greater-element-iii",
    },
    {
      acRate: 83.61132137349833,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "557",
      paidOnly: false,
      title: "Reverse Words in a String III",
      titleSlug: "reverse-words-in-a-string-iii",
    },
    {
      acRate: 50.39921348984091,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "558",
      paidOnly: false,
      title: "Logical OR of Two Binary Grids Represented as Quad-Trees",
      titleSlug: "logical-or-of-two-binary-grids-represented-as-quad-trees",
    },
    {
      acRate: 72.84251817833908,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "559",
      paidOnly: false,
      title: "Maximum Depth of N-ary Tree",
      titleSlug: "maximum-depth-of-n-ary-tree",
    },
    {
      acRate: 45.26665884102203,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "560",
      paidOnly: false,
      title: "Subarray Sum Equals K",
      titleSlug: "subarray-sum-equals-k",
    },
    {
      acRate: 80.29249036517339,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "561",
      paidOnly: false,
      title: "Array Partition",
      titleSlug: "array-partition",
    },
    {
      acRate: 50.50597213005972,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "562",
      paidOnly: true,
      title: "Longest Line of Consecutive One in Matrix",
      titleSlug: "longest-line-of-consecutive-one-in-matrix",
    },
    {
      acRate: 63.83903716391709,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "563",
      paidOnly: false,
      title: "Binary Tree Tilt",
      titleSlug: "binary-tree-tilt",
    },
    {
      acRate: 31.602940551990464,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "564",
      paidOnly: false,
      title: "Find the Closest Palindrome",
      titleSlug: "find-the-closest-palindrome",
    },
    {
      acRate: 55.933421387536185,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "565",
      paidOnly: false,
      title: "Array Nesting",
      titleSlug: "array-nesting",
    },
    {
      acRate: 63.79676433923752,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "566",
      paidOnly: false,
      title: "Reshape the Matrix",
      titleSlug: "reshape-the-matrix",
    },
    {
      acRate: 47.06306321909889,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "567",
      paidOnly: false,
      title: "Permutation in String",
      titleSlug: "permutation-in-string",
    },
    {
      acRate: 46.29906650431959,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "568",
      paidOnly: true,
      title: "Maximum Vacation Days",
      titleSlug: "maximum-vacation-days",
    },
    {
      acRate: 66.27748842592592,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "569",
      paidOnly: true,
      title: "Median Employee Salary",
      titleSlug: "median-employee-salary",
    },
    {
      acRate: 48.96406976964586,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "570",
      paidOnly: false,
      title: "Managers with at Least 5 Direct Reports",
      titleSlug: "managers-with-at-least-5-direct-reports",
    },
    {
      acRate: 42.54598320331261,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "571",
      paidOnly: true,
      title: "Find Median Given Frequency of Numbers",
      titleSlug: "find-median-given-frequency-of-numbers",
    },
    {
      acRate: 49.766385075978235,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "572",
      paidOnly: false,
      title: "Subtree of Another Tree",
      titleSlug: "subtree-of-another-tree",
    },
    {
      acRate: 57.2448233861145,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "573",
      paidOnly: true,
      title: "Squirrel Simulation",
      titleSlug: "squirrel-simulation",
    },
    {
      acRate: 61.89460911769804,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "574",
      paidOnly: true,
      title: "Winning Candidate",
      titleSlug: "winning-candidate",
    },
    {
      acRate: 69.35137804755591,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "575",
      paidOnly: false,
      title: "Distribute Candies",
      titleSlug: "distribute-candies",
    },
    {
      acRate: 48.12718700382953,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "576",
      paidOnly: false,
      title: "Out of Boundary Paths",
      titleSlug: "out-of-boundary-paths",
    },
    {
      acRate: 77.10503920571628,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "577",
      paidOnly: false,
      title: "Employee Bonus",
      titleSlug: "employee-bonus",
    },
    {
      acRate: 40.242280041957684,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "578",
      paidOnly: true,
      title: "Get Highest Answer Rate Question",
      titleSlug: "get-highest-answer-rate-question",
    },
    {
      acRate: 48.718734298214436,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "579",
      paidOnly: true,
      title: "Find Cumulative Salary of an Employee",
      titleSlug: "find-cumulative-salary-of-an-employee",
    },
    {
      acRate: 59.71553183179273,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "580",
      paidOnly: true,
      title: "Count Student Number in Departments",
      titleSlug: "count-student-number-in-departments",
    },
    {
      acRate: 37.358711615802676,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "581",
      paidOnly: false,
      title: "Shortest Unsorted Continuous Subarray",
      titleSlug: "shortest-unsorted-continuous-subarray",
    },
    {
      acRate: 70.04274284323569,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "582",
      paidOnly: true,
      title: "Kill Process",
      titleSlug: "kill-process",
    },
    {
      acRate: 63.416830720721464,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "583",
      paidOnly: false,
      title: "Delete Operation for Two Strings",
      titleSlug: "delete-operation-for-two-strings",
    },
    {
      acRate: 71.72623031482433,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "584",
      paidOnly: false,
      title: "Find Customer Referee",
      titleSlug: "find-customer-referee",
    },
    {
      acRate: 49.959587943981546,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "585",
      paidOnly: false,
      title: "Investments in 2016",
      titleSlug: "investments-in-2016",
    },
    {
      acRate: 64.41490611663218,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "586",
      paidOnly: false,
      title: "Customer Placing the Largest Number of Orders",
      titleSlug: "customer-placing-the-largest-number-of-orders",
    },
    {
      acRate: 52.13472925282371,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "587",
      paidOnly: false,
      title: "Erect the Fence",
      titleSlug: "erect-the-fence",
    },
    {
      acRate: 48.1167892487808,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "588",
      paidOnly: true,
      title: "Design In-Memory File System",
      titleSlug: "design-in-memory-file-system",
    },
    {
      acRate: 76.14056598501708,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "589",
      paidOnly: false,
      title: "N-ary Tree Preorder Traversal",
      titleSlug: "n-ary-tree-preorder-traversal",
    },
    {
      acRate: 80.62199259059489,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "590",
      paidOnly: false,
      title: "N-ary Tree Postorder Traversal",
      titleSlug: "n-ary-tree-postorder-traversal",
    },
    {
      acRate: 38.842394288852276,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "591",
      paidOnly: false,
      title: "Tag Validator",
      titleSlug: "tag-validator",
    },
    {
      acRate: 66.13967528104536,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "592",
      paidOnly: false,
      title: "Fraction Addition and Subtraction",
      titleSlug: "fraction-addition-and-subtraction",
    },
    {
      acRate: 44.21830776106063,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "593",
      paidOnly: false,
      title: "Valid Square",
      titleSlug: "valid-square",
    },
    {
      acRate: 56.92576055179974,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "594",
      paidOnly: false,
      title: "Longest Harmonious Subsequence",
      titleSlug: "longest-harmonious-subsequence",
    },
    {
      acRate: 68.19036697934861,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "595",
      paidOnly: false,
      title: "Big Countries",
      titleSlug: "big-countries",
    },
    {
      acRate: 60.31235159123334,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "596",
      paidOnly: false,
      title: "Classes More Than 5 Students",
      titleSlug: "classes-more-than-5-students",
    },
    {
      acRate: 41.435588493754665,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "597",
      paidOnly: true,
      title: "Friend Requests I: Overall Acceptance Rate",
      titleSlug: "friend-requests-i-overall-acceptance-rate",
    },
    {
      acRate: 57.18542118382819,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "598",
      paidOnly: false,
      title: "Range Addition II",
      titleSlug: "range-addition-ii",
    },
    {
      acRate: 57.74635677010649,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "599",
      paidOnly: false,
      title: "Minimum Index Sum of Two Lists",
      titleSlug: "minimum-index-sum-of-two-lists",
    },
    {
      acRate: 40.17299244181287,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "600",
      paidOnly: false,
      title: "Non-negative Integers without Consecutive Ones",
      titleSlug: "non-negative-integers-without-consecutive-ones",
    },
    {
      acRate: 49.68928227108525,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "601",
      paidOnly: false,
      title: "Human Traffic of Stadium",
      titleSlug: "human-traffic-of-stadium",
    },
    {
      acRate: 60.5940352823469,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "602",
      paidOnly: false,
      title: "Friend Requests II: Who Has the Most Friends",
      titleSlug: "friend-requests-ii-who-has-the-most-friends",
    },
    {
      acRate: 65.40795592466827,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "603",
      paidOnly: true,
      title: "Consecutive Available Seats",
      titleSlug: "consecutive-available-seats",
    },
    {
      acRate: 40.135246972732816,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "604",
      paidOnly: true,
      title: "Design Compressed String Iterator",
      titleSlug: "design-compressed-string-iterator",
    },
    {
      acRate: 28.864406239419697,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "605",
      paidOnly: false,
      title: "Can Place Flowers",
      titleSlug: "can-place-flowers",
    },
    {
      acRate: 70.01489096869997,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "606",
      paidOnly: false,
      title: "Construct String from Binary Tree",
      titleSlug: "construct-string-from-binary-tree",
    },
    {
      acRate: 65.8494382396353,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "607",
      paidOnly: false,
      title: "Sales Person",
      titleSlug: "sales-person",
    },
    {
      acRate: 73.72437770291626,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "608",
      paidOnly: false,
      title: "Tree Node",
      titleSlug: "tree-node",
    },
    {
      acRate: 67.56909334972589,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "609",
      paidOnly: false,
      title: "Find Duplicate File in System",
      titleSlug: "find-duplicate-file-in-system",
    },
    {
      acRate: 73.52854111067593,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "610",
      paidOnly: false,
      title: "Triangle Judgement",
      titleSlug: "triangle-judgement",
    },
    {
      acRate: 52.17253203560258,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "611",
      paidOnly: false,
      title: "Valid Triangle Number",
      titleSlug: "valid-triangle-number",
    },
    {
      acRate: 61.282451026909776,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "612",
      paidOnly: true,
      title: "Shortest Distance in a Plane",
      titleSlug: "shortest-distance-in-a-plane",
    },
    {
      acRate: 79.97885622231172,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "613",
      paidOnly: true,
      title: "Shortest Distance in a Line",
      titleSlug: "shortest-distance-in-a-line",
    },
    {
      acRate: 39.8576052660211,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "614",
      paidOnly: true,
      title: "Second Degree Follower",
      titleSlug: "second-degree-follower",
    },
    {
      acRate: 56.66848808372914,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "615",
      paidOnly: true,
      title: "Average Salary: Departments VS Company",
      titleSlug: "average-salary-departments-vs-company",
    },
    {
      acRate: 50.906788453323024,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "616",
      paidOnly: true,
      title: "Add Bold Tag in String",
      titleSlug: "add-bold-tag-in-string",
    },
    {
      acRate: 78.66023047654515,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "617",
      paidOnly: false,
      title: "Merge Two Binary Trees",
      titleSlug: "merge-two-binary-trees",
    },
    {
      acRate: 63.74575748225856,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "618",
      paidOnly: true,
      title: "Students Report By Geography",
      titleSlug: "students-report-by-geography",
    },
    {
      acRate: 69.27067338111395,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "619",
      paidOnly: false,
      title: "Biggest Single Number",
      titleSlug: "biggest-single-number",
    },
    {
      acRate: 74.88314757762474,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "620",
      paidOnly: false,
      title: "Not Boring Movies",
      titleSlug: "not-boring-movies",
    },
    {
      acRate: 61.31485108341982,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "621",
      paidOnly: false,
      title: "Task Scheduler",
      titleSlug: "task-scheduler",
    },
    {
      acRate: 52.467806576317045,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "622",
      paidOnly: false,
      title: "Design Circular Queue",
      titleSlug: "design-circular-queue",
    },
    {
      acRate: 64.04207276227825,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "623",
      paidOnly: false,
      title: "Add One Row to Tree",
      titleSlug: "add-one-row-to-tree",
    },
    {
      acRate: 45.61333517093304,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "624",
      paidOnly: false,
      title: "Maximum Distance in Arrays",
      titleSlug: "maximum-distance-in-arrays",
    },
    {
      acRate: 33.788493401131234,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "625",
      paidOnly: true,
      title: "Minimum Factorization",
      titleSlug: "minimum-factorization",
    },
    {
      acRate: 72.48328370374044,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "626",
      paidOnly: false,
      title: "Exchange Seats",
      titleSlug: "exchange-seats",
    },
    {
      acRate: 83.9446495397085,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "627",
      paidOnly: false,
      title: "Swap Salary",
      titleSlug: "swap-salary",
    },
    {
      acRate: 45.26086917518513,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "628",
      paidOnly: false,
      title: "Maximum Product of Three Numbers",
      titleSlug: "maximum-product-of-three-numbers",
    },
    {
      acRate: 49.09427538393266,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "629",
      paidOnly: false,
      title: "K Inverse Pairs Array",
      titleSlug: "k-inverse-pairs-array",
    },
    {
      acRate: 40.575939507908956,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "630",
      paidOnly: false,
      title: "Course Schedule III",
      titleSlug: "course-schedule-iii",
    },
    {
      acRate: 43.262199933367235,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "631",
      paidOnly: true,
      title: "Design Excel Sum Formula",
      titleSlug: "design-excel-sum-formula",
    },
    {
      acRate: 69.7306620412777,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "632",
      paidOnly: false,
      title: "Smallest Range Covering Elements from K Lists",
      titleSlug: "smallest-range-covering-elements-from-k-lists",
    },
    {
      acRate: 36.44424364198293,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "633",
      paidOnly: false,
      title: "Sum of Square Numbers",
      titleSlug: "sum-of-square-numbers",
    },
    {
      acRate: 41.707942529946955,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "634",
      paidOnly: true,
      title: "Find the Derangement of An Array",
      titleSlug: "find-the-derangement-of-an-array",
    },
    {
      acRate: 59.21616366022165,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "635",
      paidOnly: true,
      title: "Design Log Storage System",
      titleSlug: "design-log-storage-system",
    },
    {
      acRate: 64.5731989467676,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "636",
      paidOnly: false,
      title: "Exclusive Time of Functions",
      titleSlug: "exclusive-time-of-functions",
    },
    {
      acRate: 73.9924203985821,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "637",
      paidOnly: false,
      title: "Average of Levels in Binary Tree",
      titleSlug: "average-of-levels-in-binary-tree",
    },
    {
      acRate: 51.8248664096572,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "638",
      paidOnly: false,
      title: "Shopping Offers",
      titleSlug: "shopping-offers",
    },
    {
      acRate: 31.134823524920304,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "639",
      paidOnly: false,
      title: "Decode Ways II",
      titleSlug: "decode-ways-ii",
    },
    {
      acRate: 44.49305172327296,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "640",
      paidOnly: false,
      title: "Solve the Equation",
      titleSlug: "solve-the-equation",
    },
    {
      acRate: 64.3594323526951,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "641",
      paidOnly: false,
      title: "Design Circular Deque",
      titleSlug: "design-circular-deque",
    },
    {
      acRate: 49.33948831893552,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "642",
      paidOnly: true,
      title: "Design Search Autocomplete System",
      titleSlug: "design-search-autocomplete-system",
    },
    {
      acRate: 45.11105492105546,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "643",
      paidOnly: false,
      title: "Maximum Average Subarray I",
      titleSlug: "maximum-average-subarray-i",
    },
    {
      acRate: 37.389941926803935,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "644",
      paidOnly: true,
      title: "Maximum Average Subarray II",
      titleSlug: "maximum-average-subarray-ii",
    },
    {
      acRate: 44.90676306724231,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "645",
      paidOnly: false,
      title: "Set Mismatch",
      titleSlug: "set-mismatch",
    },
    {
      acRate: 60.74162705930579,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "646",
      paidOnly: false,
      title: "Maximum Length of Pair Chain",
      titleSlug: "maximum-length-of-pair-chain",
    },
    {
      acRate: 71.51135586248623,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "647",
      paidOnly: false,
      title: "Palindromic Substrings",
      titleSlug: "palindromic-substrings",
    },
    {
      acRate: 68.33541985120016,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "648",
      paidOnly: false,
      title: "Replace Words",
      titleSlug: "replace-words",
    },
    {
      acRate: 48.74900731993647,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "649",
      paidOnly: false,
      title: "Dota2 Senate",
      titleSlug: "dota2-senate",
    },
    {
      acRate: 59.05077971207997,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "650",
      paidOnly: false,
      title: "2 Keys Keyboard",
      titleSlug: "2-keys-keyboard",
    },
    {
      acRate: 55.86426188490409,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "651",
      paidOnly: true,
      title: "4 Keys Keyboard",
      titleSlug: "4-keys-keyboard",
    },
    {
      acRate: 60.01261229595476,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "652",
      paidOnly: false,
      title: "Find Duplicate Subtrees",
      titleSlug: "find-duplicate-subtrees",
    },
    {
      acRate: 62.06993978023886,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "653",
      paidOnly: false,
      title: "Two Sum IV - Input is a BST",
      titleSlug: "two-sum-iv-input-is-a-bst",
    },
    {
      acRate: 85.87296641258553,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "654",
      paidOnly: false,
      title: "Maximum Binary Tree",
      titleSlug: "maximum-binary-tree",
    },
    {
      acRate: 65.44208487762529,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "655",
      paidOnly: false,
      title: "Print Binary Tree",
      titleSlug: "print-binary-tree",
    },
    {
      acRate: 32.41951325984939,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "656",
      paidOnly: true,
      title: "Coin Path",
      titleSlug: "coin-path",
    },
    {
      acRate: 76.12205329635509,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "657",
      paidOnly: false,
      title: "Robot Return to Origin",
      titleSlug: "robot-return-to-origin",
    },
    {
      acRate: 48.526590096389185,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "658",
      paidOnly: false,
      title: "Find K Closest Elements",
      titleSlug: "find-k-closest-elements",
    },
    {
      acRate: 51.45511341898723,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "659",
      paidOnly: false,
      title: "Split Array into Consecutive Subsequences",
      titleSlug: "split-array-into-consecutive-subsequences",
    },
    {
      acRate: 57.347986107511275,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "660",
      paidOnly: true,
      title: "Remove 9",
      titleSlug: "remove-9",
    },
    {
      acRate: 68.23781606889429,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "661",
      paidOnly: false,
      title: "Image Smoother",
      titleSlug: "image-smoother",
    },
    {
      acRate: 43.96832182610534,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "662",
      paidOnly: false,
      title: "Maximum Width of Binary Tree",
      titleSlug: "maximum-width-of-binary-tree",
    },
    {
      acRate: 41.5486476813743,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "663",
      paidOnly: true,
      title: "Equal Tree Partition",
      titleSlug: "equal-tree-partition",
    },
    {
      acRate: 60.77132544359798,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "664",
      paidOnly: false,
      title: "Strange Printer",
      titleSlug: "strange-printer",
    },
    {
      acRate: 25.038380756778217,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "665",
      paidOnly: false,
      title: "Non-decreasing Array",
      titleSlug: "non-decreasing-array",
    },
    {
      acRate: 62.63840803468388,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "666",
      paidOnly: true,
      title: "Path Sum IV",
      titleSlug: "path-sum-iv",
    },
    {
      acRate: 60.37106260757542,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "667",
      paidOnly: false,
      title: "Beautiful Arrangement II",
      titleSlug: "beautiful-arrangement-ii",
    },
    {
      acRate: 52.68784165207761,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "668",
      paidOnly: false,
      title: "Kth Smallest Number in Multiplication Table",
      titleSlug: "kth-smallest-number-in-multiplication-table",
    },
    {
      acRate: 66.36369487183214,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "669",
      paidOnly: false,
      title: "Trim a Binary Search Tree",
      titleSlug: "trim-a-binary-search-tree",
    },
    {
      acRate: 51.79252487564975,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "670",
      paidOnly: false,
      title: "Maximum Swap",
      titleSlug: "maximum-swap",
    },
    {
      acRate: 45.26466985443625,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "671",
      paidOnly: false,
      title: "Second Minimum Node In a Binary Tree",
      titleSlug: "second-minimum-node-in-a-binary-tree",
    },
    {
      acRate: 49.45932799521066,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "672",
      paidOnly: false,
      title: "Bulb Switcher II",
      titleSlug: "bulb-switcher-ii",
    },
    {
      acRate: 49.65753424657534,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "673",
      paidOnly: false,
      title: "Number of Longest Increasing Subsequence",
      titleSlug: "number-of-longest-increasing-subsequence",
    },
    {
      acRate: 51.043162584411505,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "674",
      paidOnly: false,
      title: "Longest Continuous Increasing Subsequence",
      titleSlug: "longest-continuous-increasing-subsequence",
    },
    {
      acRate: 35.22085465230795,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "675",
      paidOnly: false,
      title: "Cut Off Trees for Golf Event",
      titleSlug: "cut-off-trees-for-golf-event",
    },
    {
      acRate: 56.53358304247893,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "676",
      paidOnly: false,
      title: "Implement Magic Dictionary",
      titleSlug: "implement-magic-dictionary",
    },
    {
      acRate: 56.69405319097605,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "677",
      paidOnly: false,
      title: "Map Sum Pairs",
      titleSlug: "map-sum-pairs",
    },
    {
      acRate: 38.77489674926725,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "678",
      paidOnly: false,
      title: "Valid Parenthesis String",
      titleSlug: "valid-parenthesis-string",
    },
    {
      acRate: 49.904765183068854,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "679",
      paidOnly: false,
      title: "24 Game",
      titleSlug: "24-game",
    },
    {
      acRate: 42.84239205925441,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "680",
      paidOnly: false,
      title: "Valid Palindrome II",
      titleSlug: "valid-palindrome-ii",
    },
    {
      acRate: 46.90546537883103,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "681",
      paidOnly: true,
      title: "Next Closest Time",
      titleSlug: "next-closest-time",
    },
    {
      acRate: 78.592039775616,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "682",
      paidOnly: false,
      title: "Baseball Game",
      titleSlug: "baseball-game",
    },
    {
      acRate: 37.25125840899469,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "683",
      paidOnly: true,
      title: "K Empty Slots",
      titleSlug: "k-empty-slots",
    },
    {
      acRate: 66.28852532238135,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "684",
      paidOnly: false,
      title: "Redundant Connection",
      titleSlug: "redundant-connection",
    },
    {
      acRate: 34.986418689283234,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "685",
      paidOnly: false,
      title: "Redundant Connection II",
      titleSlug: "redundant-connection-ii",
    },
    {
      acRate: 36.542508870979326,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "686",
      paidOnly: false,
      title: "Repeated String Match",
      titleSlug: "repeated-string-match",
    },
    {
      acRate: 42.482874224259746,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "687",
      paidOnly: false,
      title: "Longest Univalue Path",
      titleSlug: "longest-univalue-path",
    },
    {
      acRate: 56.541222493240184,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "688",
      paidOnly: false,
      title: "Knight Probability in Chessboard",
      titleSlug: "knight-probability-in-chessboard",
    },
    {
      acRate: 59.43503097206489,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "689",
      paidOnly: false,
      title: "Maximum Sum of 3 Non-Overlapping Subarrays",
      titleSlug: "maximum-sum-of-3-non-overlapping-subarrays",
    },
    {
      acRate: 68.26948193934484,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "690",
      paidOnly: false,
      title: "Employee Importance",
      titleSlug: "employee-importance",
    },
    {
      acRate: 49.961353365642296,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "691",
      paidOnly: false,
      title: "Stickers to Spell Word",
      titleSlug: "stickers-to-spell-word",
    },
    {
      acRate: 59.13618410484239,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "692",
      paidOnly: false,
      title: "Top K Frequent Words",
      titleSlug: "top-k-frequent-words",
    },
    {
      acRate: 63.39041123895035,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "693",
      paidOnly: false,
      title: "Binary Number with Alternating Bits",
      titleSlug: "binary-number-with-alternating-bits",
    },
    {
      acRate: 62.13179640757803,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "694",
      paidOnly: true,
      title: "Number of Distinct Islands",
      titleSlug: "number-of-distinct-islands",
    },
    {
      acRate: 73.05628466969678,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "695",
      paidOnly: false,
      title: "Max Area of Island",
      titleSlug: "max-area-of-island",
    },
    {
      acRate: 65.85334406812197,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "696",
      paidOnly: false,
      title: "Count Binary Substrings",
      titleSlug: "count-binary-substrings",
    },
    {
      acRate: 57.29465015165886,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "697",
      paidOnly: false,
      title: "Degree of an Array",
      titleSlug: "degree-of-an-array",
    },
    {
      acRate: 38.08713167457714,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "698",
      paidOnly: false,
      title: "Partition to K Equal Sum Subsets",
      titleSlug: "partition-to-k-equal-sum-subsets",
    },
    {
      acRate: 46.13839450557566,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "699",
      paidOnly: false,
      title: "Falling Squares",
      titleSlug: "falling-squares",
    },
    {
      acRate: 81.53710171172337,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "700",
      paidOnly: false,
      title: "Search in a Binary Search Tree",
      titleSlug: "search-in-a-binary-search-tree",
    },
    {
      acRate: 73.46788706774774,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "701",
      paidOnly: false,
      title: "Insert into a Binary Search Tree",
      titleSlug: "insert-into-a-binary-search-tree",
    },
    {
      acRate: 72.72082492225435,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "702",
      paidOnly: true,
      title: "Search in a Sorted Array of Unknown Size",
      titleSlug: "search-in-a-sorted-array-of-unknown-size",
    },
    {
      acRate: 59.71012841166324,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "703",
      paidOnly: false,
      title: "Kth Largest Element in a Stream",
      titleSlug: "kth-largest-element-in-a-stream",
    },
    {
      acRate: 59.387844805961706,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "704",
      paidOnly: false,
      title: "Binary Search",
      titleSlug: "binary-search",
    },
    {
      acRate: 66.94442314643416,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "705",
      paidOnly: false,
      title: "Design HashSet",
      titleSlug: "design-hashset",
    },
    {
      acRate: 65.8276638840361,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "706",
      paidOnly: false,
      title: "Design HashMap",
      titleSlug: "design-hashmap",
    },
    {
      acRate: 28.949409154083938,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "707",
      paidOnly: false,
      title: "Design Linked List",
      titleSlug: "design-linked-list",
    },
    {
      acRate: 37.99193677124409,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "708",
      paidOnly: true,
      title: "Insert into a Sorted Circular Linked List",
      titleSlug: "insert-into-a-sorted-circular-linked-list",
    },
    {
      acRate: 84.11594091704356,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "709",
      paidOnly: false,
      title: "To Lower Case",
      titleSlug: "to-lower-case",
    },
    {
      acRate: 33.795790000357385,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "710",
      paidOnly: false,
      title: "Random Pick with Blacklist",
      titleSlug: "random-pick-with-blacklist",
    },
    {
      acRate: 54.59636604994608,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "711",
      paidOnly: true,
      title: "Number of Distinct Islands II",
      titleSlug: "number-of-distinct-islands-ii",
    },
    {
      acRate: 65.64941998738047,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "712",
      paidOnly: false,
      title: "Minimum ASCII Delete Sum for Two Strings",
      titleSlug: "minimum-ascii-delete-sum-for-two-strings",
    },
    {
      acRate: 52.71161524754626,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "713",
      paidOnly: false,
      title: "Subarray Product Less Than K",
      titleSlug: "subarray-product-less-than-k",
    },
    {
      acRate: 70.22235518492202,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "714",
      paidOnly: false,
      title: "Best Time to Buy and Sell Stock with Transaction Fee",
      titleSlug: "best-time-to-buy-and-sell-stock-with-transaction-fee",
    },
    {
      acRate: 44.14965592405583,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "715",
      paidOnly: false,
      title: "Range Module",
      titleSlug: "range-module",
    },
    {
      acRate: 45.46895371904809,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "716",
      paidOnly: true,
      title: "Max Stack",
      titleSlug: "max-stack",
    },
    {
      acRate: 45.11080187338211,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "717",
      paidOnly: false,
      title: "1-bit and 2-bit Characters",
      titleSlug: "1-bit-and-2-bit-characters",
    },
    {
      acRate: 50.99149014934689,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "718",
      paidOnly: false,
      title: "Maximum Length of Repeated Subarray",
      titleSlug: "maximum-length-of-repeated-subarray",
    },
    {
      acRate: 45.71277243593483,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "719",
      paidOnly: false,
      title: "Find K-th Smallest Pair Distance",
      titleSlug: "find-k-th-smallest-pair-distance",
    },
    {
      acRate: 53.34160349471605,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "720",
      paidOnly: false,
      title: "Longest Word in Dictionary",
      titleSlug: "longest-word-in-dictionary",
    },
    {
      acRate: 59.26166949168328,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "721",
      paidOnly: false,
      title: "Accounts Merge",
      titleSlug: "accounts-merge",
    },
    {
      acRate: 39.339452451281645,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "722",
      paidOnly: false,
      title: "Remove Comments",
      titleSlug: "remove-comments",
    },
    {
      acRate: 77.30703795686098,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "723",
      paidOnly: true,
      title: "Candy Crush",
      titleSlug: "candy-crush",
    },
    {
      acRate: 60.3378781128472,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "724",
      paidOnly: false,
      title: "Find Pivot Index",
      titleSlug: "find-pivot-index",
    },
    {
      acRate: 70.14694082033822,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "725",
      paidOnly: false,
      title: "Split Linked List in Parts",
      titleSlug: "split-linked-list-in-parts",
    },
    {
      acRate: 64.99886219015752,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "726",
      paidOnly: false,
      title: "Number of Atoms",
      titleSlug: "number-of-atoms",
    },
    {
      acRate: 43.59413901473409,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "727",
      paidOnly: true,
      title: "Minimum Window Subsequence",
      titleSlug: "minimum-window-subsequence",
    },
    {
      acRate: 79.53027703148332,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "728",
      paidOnly: false,
      title: "Self Dividing Numbers",
      titleSlug: "self-dividing-numbers",
    },
    {
      acRate: 58.12898139474834,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "729",
      paidOnly: false,
      title: "My Calendar I",
      titleSlug: "my-calendar-i",
    },
    {
      acRate: 46.265087295795205,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "730",
      paidOnly: false,
      title: "Count Different Palindromic Subsequences",
      titleSlug: "count-different-palindromic-subsequences",
    },
    {
      acRate: 62.25158128375864,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "731",
      paidOnly: false,
      title: "My Calendar II",
      titleSlug: "my-calendar-ii",
    },
    {
      acRate: 70.57387142817161,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "732",
      paidOnly: false,
      title: "My Calendar III",
      titleSlug: "my-calendar-iii",
    },
    {
      acRate: 66.17923167065658,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "733",
      paidOnly: false,
      title: "Flood Fill",
      titleSlug: "flood-fill",
    },
    {
      acRate: 44.57631112268562,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "734",
      paidOnly: true,
      title: "Sentence Similarity",
      titleSlug: "sentence-similarity",
    },
    {
      acRate: 45.31831737160112,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "735",
      paidOnly: false,
      title: "Asteroid Collision",
      titleSlug: "asteroid-collision",
    },
    {
      acRate: 52.54607537485949,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "736",
      paidOnly: false,
      title: "Parse Lisp Expression",
      titleSlug: "parse-lisp-expression",
    },
    {
      acRate: 50.611644419962246,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "737",
      paidOnly: true,
      title: "Sentence Similarity II",
      titleSlug: "sentence-similarity-ii",
    },
    {
      acRate: 48.63071789221709,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "738",
      paidOnly: false,
      title: "Monotone Increasing Digits",
      titleSlug: "monotone-increasing-digits",
    },
    {
      acRate: 67.20152217126619,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "739",
      paidOnly: false,
      title: "Daily Temperatures",
      titleSlug: "daily-temperatures",
    },
    {
      acRate: 56.67793641564557,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "740",
      paidOnly: false,
      title: "Delete and Earn",
      titleSlug: "delete-and-earn",
    },
    {
      acRate: 37.71307450225311,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "741",
      paidOnly: false,
      title: "Cherry Pickup",
      titleSlug: "cherry-pickup",
    },
    {
      acRate: 47.02645483332269,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "742",
      paidOnly: true,
      title: "Closest Leaf in a Binary Tree",
      titleSlug: "closest-leaf-in-a-binary-tree",
    },
    {
      acRate: 56.965385737234605,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "743",
      paidOnly: false,
      title: "Network Delay Time",
      titleSlug: "network-delay-time",
    },
    {
      acRate: 53.88676146044736,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "744",
      paidOnly: false,
      title: "Find Smallest Letter Greater Than Target",
      titleSlug: "find-smallest-letter-greater-than-target",
    },
    {
      acRate: 40.38067589872055,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "745",
      paidOnly: false,
      title: "Prefix and Suffix Search",
      titleSlug: "prefix-and-suffix-search",
    },
    {
      acRate: 67.0449481881912,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "746",
      paidOnly: false,
      title: "Min Cost Climbing Stairs",
      titleSlug: "min-cost-climbing-stairs",
    },
    {
      acRate: 50.61122702916282,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "747",
      paidOnly: false,
      title: "Largest Number At Least Twice of Others",
      titleSlug: "largest-number-at-least-twice-of-others",
    },
    {
      acRate: 61.19025659060296,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "748",
      paidOnly: false,
      title: "Shortest Completing Word",
      titleSlug: "shortest-completing-word",
    },
    {
      acRate: 52.35482869268192,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "749",
      paidOnly: false,
      title: "Contain Virus",
      titleSlug: "contain-virus",
    },
    {
      acRate: 67.80080156902874,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "750",
      paidOnly: true,
      title: "Number Of Corner Rectangles",
      titleSlug: "number-of-corner-rectangles",
    },
    {
      acRate: 55.21518547811494,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "751",
      paidOnly: true,
      title: "IP to CIDR",
      titleSlug: "ip-to-cidr",
    },
    {
      acRate: 60.66782765166361,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "752",
      paidOnly: false,
      title: "Open the Lock",
      titleSlug: "open-the-lock",
    },
    {
      acRate: 57.68694555690729,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "753",
      paidOnly: false,
      title: "Cracking the Safe",
      titleSlug: "cracking-the-safe",
    },
    {
      acRate: 43.807234351537886,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "754",
      paidOnly: false,
      title: "Reach a Number",
      titleSlug: "reach-a-number",
    },
    {
      acRate: 47.78827764652942,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "755",
      paidOnly: true,
      title: "Pour Water",
      titleSlug: "pour-water",
    },
    {
      acRate: 52.85412864963504,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "756",
      paidOnly: false,
      title: "Pyramid Transition Matrix",
      titleSlug: "pyramid-transition-matrix",
    },
    {
      acRate: 45.09593976784106,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "757",
      paidOnly: false,
      title: "Set Intersection Size At Least Two",
      titleSlug: "set-intersection-size-at-least-two",
    },
    {
      acRate: 52.07122187752549,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "758",
      paidOnly: true,
      title: "Bold Words in String",
      titleSlug: "bold-words-in-string",
    },
    {
      acRate: 72.55704419767677,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "759",
      paidOnly: true,
      title: "Employee Free Time",
      titleSlug: "employee-free-time",
    },
    {
      acRate: 83.85415855311327,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "760",
      paidOnly: true,
      title: "Find Anagram Mappings",
      titleSlug: "find-anagram-mappings",
    },
    {
      acRate: 63.25354365451437,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "761",
      paidOnly: false,
      title: "Special Binary String",
      titleSlug: "special-binary-string",
    },
    {
      acRate: 70.7812109653479,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "762",
      paidOnly: false,
      title: "Prime Number of Set Bits in Binary Representation",
      titleSlug: "prime-number-of-set-bits-in-binary-representation",
    },
    {
      acRate: 81.48349139404732,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "763",
      paidOnly: false,
      title: "Partition Labels",
      titleSlug: "partition-labels",
    },
    {
      acRate: 48.509571558796715,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "764",
      paidOnly: false,
      title: "Largest Plus Sign",
      titleSlug: "largest-plus-sign",
    },
    {
      acRate: 58.27855216190461,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "765",
      paidOnly: false,
      title: "Couples Holding Hands",
      titleSlug: "couples-holding-hands",
    },
    {
      acRate: 69.37034720750614,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "766",
      paidOnly: false,
      title: "Toeplitz Matrix",
      titleSlug: "toeplitz-matrix",
    },
    {
      acRate: 56.04450059053391,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "767",
      paidOnly: false,
      title: "Reorganize String",
      titleSlug: "reorganize-string",
    },
    {
      acRate: 54.081718500238374,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "768",
      paidOnly: false,
      title: "Max Chunks To Make Sorted II",
      titleSlug: "max-chunks-to-make-sorted-ii",
    },
    {
      acRate: 64.00933120536807,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "769",
      paidOnly: false,
      title: "Max Chunks To Make Sorted",
      titleSlug: "max-chunks-to-make-sorted",
    },
    {
      acRate: 48.54941230780157,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "770",
      paidOnly: false,
      title: "Basic Calculator IV",
      titleSlug: "basic-calculator-iv",
    },
    {
      acRate: 89.1753714711892,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "771",
      paidOnly: false,
      title: "Jewels and Stones",
      titleSlug: "jewels-and-stones",
    },
    {
      acRate: 52.28926561849795,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "772",
      paidOnly: true,
      title: "Basic Calculator III",
      titleSlug: "basic-calculator-iii",
    },
    {
      acRate: 73.08647457404118,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "773",
      paidOnly: false,
      title: "Sliding Puzzle",
      titleSlug: "sliding-puzzle",
    },
    {
      acRate: 52.89938556067588,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "774",
      paidOnly: true,
      title: "Minimize Max Distance to Gas Station",
      titleSlug: "minimize-max-distance-to-gas-station",
    },
    {
      acRate: 42.31987042165212,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "775",
      paidOnly: false,
      title: "Global and Local Inversions",
      titleSlug: "global-and-local-inversions",
    },
    {
      acRate: 82.44387876622604,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "776",
      paidOnly: true,
      title: "Split BST",
      titleSlug: "split-bst",
    },
    {
      acRate: 37.47196640740564,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "777",
      paidOnly: false,
      title: "Swap Adjacent in LR String",
      titleSlug: "swap-adjacent-in-lr-string",
    },
    {
      acRate: 62.54832072792604,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "778",
      paidOnly: false,
      title: "Swim in Rising Water",
      titleSlug: "swim-in-rising-water",
    },
    {
      acRate: 47.28808822139196,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "779",
      paidOnly: false,
      title: "K-th Symbol in Grammar",
      titleSlug: "k-th-symbol-in-grammar",
    },
    {
      acRate: 33.57621474501958,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "780",
      paidOnly: false,
      title: "Reaching Points",
      titleSlug: "reaching-points",
    },
    {
      acRate: 58.32462978205385,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "781",
      paidOnly: false,
      title: "Rabbits in Forest",
      titleSlug: "rabbits-in-forest",
    },
    {
      acRate: 50.45911900882027,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "782",
      paidOnly: false,
      title: "Transform to Chessboard",
      titleSlug: "transform-to-chessboard",
    },
    {
      acRate: 60.205743605323335,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "783",
      paidOnly: false,
      title: "Minimum Distance Between BST Nodes",
      titleSlug: "minimum-distance-between-bst-nodes",
    },
    {
      acRate: 75.03708602169755,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "784",
      paidOnly: false,
      title: "Letter Case Permutation",
      titleSlug: "letter-case-permutation",
    },
    {
      acRate: 57.48253047843625,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "785",
      paidOnly: false,
      title: "Is Graph Bipartite?",
      titleSlug: "is-graph-bipartite",
    },
    {
      acRate: 68.46342677630336,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "786",
      paidOnly: false,
      title: "K-th Smallest Prime Fraction",
      titleSlug: "k-th-smallest-prime-fraction",
    },
    {
      acRate: 40.24224297806795,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "787",
      paidOnly: false,
      title: "Cheapest Flights Within K Stops",
      titleSlug: "cheapest-flights-within-k-stops",
    },
    {
      acRate: 56.41862780767095,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "788",
      paidOnly: false,
      title: "Rotated Digits",
      titleSlug: "rotated-digits",
    },
    {
      acRate: 62.520065686292604,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "789",
      paidOnly: false,
      title: "Escape The Ghosts",
      titleSlug: "escape-the-ghosts",
    },
    {
      acRate: 52.08427534601221,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "790",
      paidOnly: false,
      title: "Domino and Tromino Tiling",
      titleSlug: "domino-and-tromino-tiling",
    },
    {
      acRate: 71.93145849968568,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "791",
      paidOnly: false,
      title: "Custom Sort String",
      titleSlug: "custom-sort-string",
    },
    {
      acRate: 50.68159232348245,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "792",
      paidOnly: false,
      title: "Number of Matching Subsequences",
      titleSlug: "number-of-matching-subsequences",
    },
    {
      acRate: 45.56815996923669,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "793",
      paidOnly: false,
      title: "Preimage Size of Factorial Zeroes Function",
      titleSlug: "preimage-size-of-factorial-zeroes-function",
    },
    {
      acRate: 34.60552658790399,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "794",
      paidOnly: false,
      title: "Valid Tic-Tac-Toe State",
      titleSlug: "valid-tic-tac-toe-state",
    },
    {
      acRate: 53.74465826505893,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "795",
      paidOnly: false,
      title: "Number of Subarrays with Bounded Maximum",
      titleSlug: "number-of-subarrays-with-bounded-maximum",
    },
    {
      acRate: 63.78343440689947,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "796",
      paidOnly: false,
      title: "Rotate String",
      titleSlug: "rotate-string",
    },
    {
      acRate: 83.04960422236347,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "797",
      paidOnly: false,
      title: "All Paths From Source to Target",
      titleSlug: "all-paths-from-source-to-target",
    },
    {
      acRate: 51.946643887373924,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "798",
      paidOnly: false,
      title: "Smallest Rotation with Highest Score",
      titleSlug: "smallest-rotation-with-highest-score",
    },
    {
      acRate: 58.24644873838889,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "799",
      paidOnly: false,
      title: "Champagne Tower",
      titleSlug: "champagne-tower",
    },
    {
      acRate: 67.75748446620223,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "800",
      paidOnly: true,
      title: "Similar RGB Color",
      titleSlug: "similar-rgb-color",
    },
    {
      acRate: 40.66397265671532,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "801",
      paidOnly: false,
      title: "Minimum Swaps To Make Sequences Increasing",
      titleSlug: "minimum-swaps-to-make-sequences-increasing",
    },
    {
      acRate: 68.30202846870621,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "802",
      paidOnly: false,
      title: "Find Eventual Safe States",
      titleSlug: "find-eventual-safe-states",
    },
    {
      acRate: 35.57719881469523,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "803",
      paidOnly: false,
      title: "Bricks Falling When Hit",
      titleSlug: "bricks-falling-when-hit",
    },
    {
      acRate: 83.20157281600108,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "804",
      paidOnly: false,
      title: "Unique Morse Code Words",
      titleSlug: "unique-morse-code-words",
    },
    {
      acRate: 25.925902473927824,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "805",
      paidOnly: false,
      title: "Split Array With Same Average",
      titleSlug: "split-array-with-same-average",
    },
    {
      acRate: 70.4711095562941,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "806",
      paidOnly: false,
      title: "Number of Lines To Write String",
      titleSlug: "number-of-lines-to-write-string",
    },
    {
      acRate: 86.17788755471865,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "807",
      paidOnly: false,
      title: "Max Increase to Keep City Skyline",
      titleSlug: "max-increase-to-keep-city-skyline",
    },
    {
      acRate: 53.285155028951635,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "808",
      paidOnly: false,
      title: "Soup Servings",
      titleSlug: "soup-servings",
    },
    {
      acRate: 46.342996881979445,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "809",
      paidOnly: false,
      title: "Expressive Words",
      titleSlug: "expressive-words",
    },
    {
      acRate: 62.58882600740394,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "810",
      paidOnly: false,
      title: "Chalkboard XOR Game",
      titleSlug: "chalkboard-xor-game",
    },
    {
      acRate: 76.78673065379459,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "811",
      paidOnly: false,
      title: "Subdomain Visit Count",
      titleSlug: "subdomain-visit-count",
    },
    {
      acRate: 61.83498714070337,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "812",
      paidOnly: false,
      title: "Largest Triangle Area",
      titleSlug: "largest-triangle-area",
    },
    {
      acRate: 53.959196223480255,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "813",
      paidOnly: false,
      title: "Largest Sum of Averages",
      titleSlug: "largest-sum-of-averages",
    },
    {
      acRate: 72.34023596749373,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "814",
      paidOnly: false,
      title: "Binary Tree Pruning",
      titleSlug: "binary-tree-pruning",
    },
    {
      acRate: 46.98019840619415,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "815",
      paidOnly: false,
      title: "Bus Routes",
      titleSlug: "bus-routes",
    },
    {
      acRate: 55.82886776145203,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "816",
      paidOnly: false,
      title: "Ambiguous Coordinates",
      titleSlug: "ambiguous-coordinates",
    },
    {
      acRate: 57.17532247026064,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "817",
      paidOnly: false,
      title: "Linked List Components",
      titleSlug: "linked-list-components",
    },
    {
      acRate: 44.05172374528014,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "818",
      paidOnly: false,
      title: "Race Car",
      titleSlug: "race-car",
    },
    {
      acRate: 44.53335085903313,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "819",
      paidOnly: false,
      title: "Most Common Word",
      titleSlug: "most-common-word",
    },
    {
      acRate: 60.52726594374707,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "820",
      paidOnly: false,
      title: "Short Encoding of Words",
      titleSlug: "short-encoding-of-words",
    },
    {
      acRate: 72.11421835179961,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "821",
      paidOnly: false,
      title: "Shortest Distance to a Character",
      titleSlug: "shortest-distance-to-a-character",
    },
    {
      acRate: 48.16231282815842,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "822",
      paidOnly: false,
      title: "Card Flipping Game",
      titleSlug: "card-flipping-game",
    },
    {
      acRate: 52.91458735181664,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "823",
      paidOnly: false,
      title: "Binary Trees With Factors",
      titleSlug: "binary-trees-with-factors",
    },
    {
      acRate: 69.26805857077517,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "824",
      paidOnly: false,
      title: "Goat Latin",
      titleSlug: "goat-latin",
    },
    {
      acRate: 49.01348548168958,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "825",
      paidOnly: false,
      title: "Friends Of Appropriate Ages",
      titleSlug: "friends-of-appropriate-ages",
    },
    {
      acRate: 55.88844917140737,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "826",
      paidOnly: false,
      title: "Most Profit Assigning Work",
      titleSlug: "most-profit-assigning-work",
    },
    {
      acRate: 54.53404348602698,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "827",
      paidOnly: false,
      title: "Making A Large Island",
      titleSlug: "making-a-large-island",
    },
    {
      acRate: 52.78868176935186,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "828",
      paidOnly: false,
      title: "Count Unique Characters of All Substrings of a Given String",
      titleSlug: "count-unique-characters-of-all-substrings-of-a-given-string",
    },
    {
      acRate: 41.93728802942308,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "829",
      paidOnly: false,
      title: "Consecutive Numbers Sum",
      titleSlug: "consecutive-numbers-sum",
    },
    {
      acRate: 52.851795301187025,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "830",
      paidOnly: false,
      title: "Positions of Large Groups",
      titleSlug: "positions-of-large-groups",
    },
    {
      acRate: 50.37808625160714,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "831",
      paidOnly: false,
      title: "Masking Personal Information",
      titleSlug: "masking-personal-information",
    },
    {
      acRate: 82.87968960420153,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "832",
      paidOnly: false,
      title: "Flipping an Image",
      titleSlug: "flipping-an-image",
    },
    {
      acRate: 51.3619805937913,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "833",
      paidOnly: false,
      title: "Find And Replace in String",
      titleSlug: "find-and-replace-in-string",
    },
    {
      acRate: 65.28375794693237,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "834",
      paidOnly: false,
      title: "Sum of Distances in Tree",
      titleSlug: "sum-of-distances-in-tree",
    },
    {
      acRate: 63.72751136436392,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "835",
      paidOnly: false,
      title: "Image Overlap",
      titleSlug: "image-overlap",
    },
    {
      acRate: 45.638459078839446,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "836",
      paidOnly: false,
      title: "Rectangle Overlap",
      titleSlug: "rectangle-overlap",
    },
    {
      acRate: 44.780221302437425,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "837",
      paidOnly: false,
      title: "New 21 Game",
      titleSlug: "new-21-game",
    },
    {
      acRate: 63.048420830004225,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "838",
      paidOnly: false,
      title: "Push Dominoes",
      titleSlug: "push-dominoes",
    },
    {
      acRate: 55.297183861359336,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "839",
      paidOnly: false,
      title: "Similar String Groups",
      titleSlug: "similar-string-groups",
    },
    {
      acRate: 51.53017866947371,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "840",
      paidOnly: false,
      title: "Magic Squares In Grid",
      titleSlug: "magic-squares-in-grid",
    },
    {
      acRate: 74.51438544393649,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "841",
      paidOnly: false,
      title: "Keys and Rooms",
      titleSlug: "keys-and-rooms",
    },
    {
      acRate: 39.62916548513095,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "842",
      paidOnly: false,
      title: "Split Array into Fibonacci Sequence",
      titleSlug: "split-array-into-fibonacci-sequence",
    },
    {
      acRate: 37.77683886891718,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "843",
      paidOnly: false,
      title: "Guess the Word",
      titleSlug: "guess-the-word",
    },
    {
      acRate: 49.45231361860557,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "844",
      paidOnly: false,
      title: "Backspace String Compare",
      titleSlug: "backspace-string-compare",
    },
    {
      acRate: 41.008522985564696,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "845",
      paidOnly: false,
      title: "Longest Mountain in Array",
      titleSlug: "longest-mountain-in-array",
    },
    {
      acRate: 56.964714028614296,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "846",
      paidOnly: false,
      title: "Hand of Straights",
      titleSlug: "hand-of-straights",
    },
    {
      acRate: 65.37939291293746,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "847",
      paidOnly: false,
      title: "Shortest Path Visiting All Nodes",
      titleSlug: "shortest-path-visiting-all-nodes",
    },
    {
      acRate: 45.42199706747143,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "848",
      paidOnly: false,
      title: "Shifting Letters",
      titleSlug: "shifting-letters",
    },
    {
      acRate: 48.847449345672864,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "849",
      paidOnly: false,
      title: "Maximize Distance to Closest Person",
      titleSlug: "maximize-distance-to-closest-person",
    },
    {
      acRate: 54.48254257561087,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "850",
      paidOnly: false,
      title: "Rectangle Area II",
      titleSlug: "rectangle-area-ii",
    },
    {
      acRate: 61.38733761684582,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "851",
      paidOnly: false,
      title: "Loud and Rich",
      titleSlug: "loud-and-rich",
    },
    {
      acRate: 67.6741137299859,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "852",
      paidOnly: false,
      title: "Peak Index in a Mountain Array",
      titleSlug: "peak-index-in-a-mountain-array",
    },
    {
      acRate: 53.2679662564025,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "853",
      paidOnly: false,
      title: "Car Fleet",
      titleSlug: "car-fleet",
    },
    {
      acRate: 40.01376914271076,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "854",
      paidOnly: false,
      title: "K-Similar Strings",
      titleSlug: "k-similar-strings",
    },
    {
      acRate: 42.75059285513935,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "855",
      paidOnly: false,
      title: "Exam Room",
      titleSlug: "exam-room",
    },
    {
      acRate: 63.74823688772625,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "856",
      paidOnly: false,
      title: "Score of Parentheses",
      titleSlug: "score-of-parentheses",
    },
    {
      acRate: 63.43446529766103,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "857",
      paidOnly: false,
      title: "Minimum Cost to Hire K Workers",
      titleSlug: "minimum-cost-to-hire-k-workers",
    },
    {
      acRate: 62.000178973586486,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "858",
      paidOnly: false,
      title: "Mirror Reflection",
      titleSlug: "mirror-reflection",
    },
    {
      acRate: 33.605006297423806,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "859",
      paidOnly: false,
      title: "Buddy Strings",
      titleSlug: "buddy-strings",
    },
    {
      acRate: 58.362340987120206,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "860",
      paidOnly: false,
      title: "Lemonade Change",
      titleSlug: "lemonade-change",
    },
    {
      acRate: 80.22407410259966,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "861",
      paidOnly: false,
      title: "Score After Flipping Matrix",
      titleSlug: "score-after-flipping-matrix",
    },
    {
      acRate: 32.23873943384257,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "862",
      paidOnly: false,
      title: "Shortest Subarray with Sum at Least K",
      titleSlug: "shortest-subarray-with-sum-at-least-k",
    },
    {
      acRate: 66.1897259803425,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "863",
      paidOnly: false,
      title: "All Nodes Distance K in Binary Tree",
      titleSlug: "all-nodes-distance-k-in-binary-tree",
    },
    {
      acRate: 53.651262967399894,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "864",
      paidOnly: false,
      title: "Shortest Path to Get All Keys",
      titleSlug: "shortest-path-to-get-all-keys",
    },
    {
      acRate: 72.38895771445826,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "865",
      paidOnly: false,
      title: "Smallest Subtree with all the Deepest Nodes",
      titleSlug: "smallest-subtree-with-all-the-deepest-nodes",
    },
    {
      acRate: 26.7264293878419,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "866",
      paidOnly: false,
      title: "Prime Palindrome",
      titleSlug: "prime-palindrome",
    },
    {
      acRate: 74.07558127082524,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "867",
      paidOnly: false,
      title: "Transpose Matrix",
      titleSlug: "transpose-matrix",
    },
    {
      acRate: 64.51292515168305,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "868",
      paidOnly: false,
      title: "Binary Gap",
      titleSlug: "binary-gap",
    },
    {
      acRate: 62.1588232820254,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "869",
      paidOnly: false,
      title: "Reordered Power of 2",
      titleSlug: "reordered-power-of-2",
    },
    {
      acRate: 53.263669887638834,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "870",
      paidOnly: false,
      title: "Advantage Shuffle",
      titleSlug: "advantage-shuffle",
    },
    {
      acRate: 40.4903521414589,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "871",
      paidOnly: false,
      title: "Minimum Number of Refueling Stops",
      titleSlug: "minimum-number-of-refueling-stops",
    },
    {
      acRate: 70.08812454810933,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "872",
      paidOnly: false,
      title: "Leaf-Similar Trees",
      titleSlug: "leaf-similar-trees",
    },
    {
      acRate: 57.63123440704777,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "873",
      paidOnly: false,
      title: "Length of Longest Fibonacci Subsequence",
      titleSlug: "length-of-longest-fibonacci-subsequence",
    },
    {
      acRate: 58.18111168277932,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "874",
      paidOnly: false,
      title: "Walking Robot Simulation",
      titleSlug: "walking-robot-simulation",
    },
    {
      acRate: 49.034735426509805,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "875",
      paidOnly: false,
      title: "Koko Eating Bananas",
      titleSlug: "koko-eating-bananas",
    },
    {
      acRate: 80.38804902681747,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "876",
      paidOnly: false,
      title: "Middle of the Linked List",
      titleSlug: "middle-of-the-linked-list",
    },
    {
      acRate: 71.51649972034372,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "877",
      paidOnly: false,
      title: "Stone Game",
      titleSlug: "stone-game",
    },
    {
      acRate: 35.72722515196651,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "878",
      paidOnly: false,
      title: "Nth Magical Number",
      titleSlug: "nth-magical-number",
    },
    {
      acRate: 48.02671398701442,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "879",
      paidOnly: false,
      title: "Profitable Schemes",
      titleSlug: "profitable-schemes",
    },
    {
      acRate: 36.62265412177363,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "880",
      paidOnly: false,
      title: "Decoded String at Index",
      titleSlug: "decoded-string-at-index",
    },
    {
      acRate: 60.126456339781576,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "881",
      paidOnly: false,
      title: "Boats to Save People",
      titleSlug: "boats-to-save-people",
    },
    {
      acRate: 50.74187247983871,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "882",
      paidOnly: false,
      title: "Reachable Nodes In Subdivided Graph",
      titleSlug: "reachable-nodes-in-subdivided-graph",
    },
    {
      acRate: 73.96890100075572,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "883",
      paidOnly: false,
      title: "Projection Area of 3D Shapes",
      titleSlug: "projection-area-of-3d-shapes",
    },
    {
      acRate: 75.30860337882523,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "884",
      paidOnly: false,
      title: "Uncommon Words from Two Sentences",
      titleSlug: "uncommon-words-from-two-sentences",
    },
    {
      acRate: 84.45510128238415,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "885",
      paidOnly: false,
      title: "Spiral Matrix III",
      titleSlug: "spiral-matrix-iii",
    },
    {
      acRate: 51.39114098406389,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "886",
      paidOnly: false,
      title: "Possible Bipartition",
      titleSlug: "possible-bipartition",
    },
    {
      acRate: 28.584705032408614,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "887",
      paidOnly: false,
      title: "Super Egg Drop",
      titleSlug: "super-egg-drop",
    },
    {
      acRate: 63.125380666492646,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "888",
      paidOnly: false,
      title: "Fair Candy Swap",
      titleSlug: "fair-candy-swap",
    },
    {
      acRate: 77.9651866260281,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "889",
      paidOnly: false,
      title: "Construct Binary Tree from Preorder and Postorder Traversal",
      titleSlug: "construct-binary-tree-from-preorder-and-postorder-traversal",
    },
    {
      acRate: 76.81168826210782,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "890",
      paidOnly: false,
      title: "Find and Replace Pattern",
      titleSlug: "find-and-replace-pattern",
    },
    {
      acRate: 38.83440058361028,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "891",
      paidOnly: false,
      title: "Sum of Subsequence Widths",
      titleSlug: "sum-of-subsequence-widths",
    },
    {
      acRate: 67.8420617300074,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "892",
      paidOnly: false,
      title: "Surface Area of 3D Shapes",
      titleSlug: "surface-area-of-3d-shapes",
    },
    {
      acRate: 72.68650142153525,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "893",
      paidOnly: false,
      title: "Groups of Special-Equivalent Strings",
      titleSlug: "groups-of-special-equivalent-strings",
    },
    {
      acRate: 82.69759571317775,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "894",
      paidOnly: false,
      title: "All Possible Full Binary Trees",
      titleSlug: "all-possible-full-binary-trees",
    },
    {
      acRate: 66.09721709355803,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "895",
      paidOnly: false,
      title: "Maximum Frequency Stack",
      titleSlug: "maximum-frequency-stack",
    },
    {
      acRate: 61.620332723971174,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "896",
      paidOnly: false,
      title: "Monotonic Array",
      titleSlug: "monotonic-array",
    },
    {
      acRate: 78.60684090616651,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "897",
      paidOnly: false,
      title: "Increasing Order Search Tree",
      titleSlug: "increasing-order-search-tree",
    },
    {
      acRate: 40.570849970387634,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "898",
      paidOnly: false,
      title: "Bitwise ORs of Subarrays",
      titleSlug: "bitwise-ors-of-subarrays",
    },
    {
      acRate: 66.16259880135499,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "899",
      paidOnly: false,
      title: "Orderly Queue",
      titleSlug: "orderly-queue",
    },
    {
      acRate: 58.857524220222516,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "900",
      paidOnly: false,
      title: "RLE Iterator",
      titleSlug: "rle-iterator",
    },
    {
      acRate: 67.1159559994387,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "901",
      paidOnly: false,
      title: "Online Stock Span",
      titleSlug: "online-stock-span",
    },
    {
      acRate: 43.26190835025133,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "902",
      paidOnly: false,
      title: "Numbers At Most N Given Digit Set",
      titleSlug: "numbers-at-most-n-given-digit-set",
    },
    {
      acRate: 56.72614429790536,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "903",
      paidOnly: false,
      title: "Valid Permutations for DI Sequence",
      titleSlug: "valid-permutations-for-di-sequence",
    },
    {
      acRate: 46.03469606925427,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "904",
      paidOnly: false,
      title: "Fruit Into Baskets",
      titleSlug: "fruit-into-baskets",
    },
    {
      acRate: 76.29603700759239,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "905",
      paidOnly: false,
      title: "Sort Array By Parity",
      titleSlug: "sort-array-by-parity",
    },
    {
      acRate: 39.220388465204955,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "906",
      paidOnly: false,
      title: "Super Palindromes",
      titleSlug: "super-palindromes",
    },
    {
      acRate: 37.491416544205634,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "907",
      paidOnly: false,
      title: "Sum of Subarray Minimums",
      titleSlug: "sum-of-subarray-minimums",
    },
    {
      acRate: 71.71535194955604,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "908",
      paidOnly: false,
      title: "Smallest Range I",
      titleSlug: "smallest-range-i",
    },
    {
      acRate: 44.121748123317225,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "909",
      paidOnly: false,
      title: "Snakes and Ladders",
      titleSlug: "snakes-and-ladders",
    },
    {
      acRate: 37.067370233972774,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "910",
      paidOnly: false,
      title: "Smallest Range II",
      titleSlug: "smallest-range-ii",
    },
    {
      acRate: 51.771393153283896,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "911",
      paidOnly: false,
      title: "Online Election",
      titleSlug: "online-election",
    },
    {
      acRate: 56.82135560297108,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "912",
      paidOnly: false,
      title: "Sort an Array",
      titleSlug: "sort-an-array",
    },
    {
      acRate: 33.951327367524684,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "913",
      paidOnly: false,
      title: "Cat and Mouse",
      titleSlug: "cat-and-mouse",
    },
    {
      acRate: 29.856725916313888,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "914",
      paidOnly: false,
      title: "X of a Kind in a Deck of Cards",
      titleSlug: "x-of-a-kind-in-a-deck-of-cards",
    },
    {
      acRate: 48.98235363613907,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "915",
      paidOnly: false,
      title: "Partition Array into Disjoint Intervals",
      titleSlug: "partition-array-into-disjoint-intervals",
    },
    {
      acRate: 55.690824147938,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "916",
      paidOnly: false,
      title: "Word Subsets",
      titleSlug: "word-subsets",
    },
    {
      acRate: 66.68600298473423,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "917",
      paidOnly: false,
      title: "Reverse Only Letters",
      titleSlug: "reverse-only-letters",
    },
    {
      acRate: 47.38713470174097,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "918",
      paidOnly: false,
      title: "Maximum Sum Circular Subarray",
      titleSlug: "maximum-sum-circular-subarray",
    },
    {
      acRate: 64.50522369197068,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "919",
      paidOnly: false,
      title: "Complete Binary Tree Inserter",
      titleSlug: "complete-binary-tree-inserter",
    },
    {
      acRate: 59.965427551333626,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "920",
      paidOnly: false,
      title: "Number of Music Playlists",
      titleSlug: "number-of-music-playlists",
    },
    {
      acRate: 74.7081822899315,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "921",
      paidOnly: false,
      title: "Minimum Add to Make Parentheses Valid",
      titleSlug: "minimum-add-to-make-parentheses-valid",
    },
    {
      acRate: 70.98278517254593,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "922",
      paidOnly: false,
      title: "Sort Array By Parity II",
      titleSlug: "sort-array-by-parity-ii",
    },
    {
      acRate: 45.76063316599349,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "923",
      paidOnly: false,
      title: "3Sum With Multiplicity",
      titleSlug: "3sum-with-multiplicity",
    },
    {
      acRate: 42.33293476816793,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "924",
      paidOnly: false,
      title: "Minimize Malware Spread",
      titleSlug: "minimize-malware-spread",
    },
    {
      acRate: 32.48700597453249,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "925",
      paidOnly: false,
      title: "Long Pressed Name",
      titleSlug: "long-pressed-name",
    },
    {
      acRate: 61.58046193482289,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "926",
      paidOnly: false,
      title: "Flip String to Monotone Increasing",
      titleSlug: "flip-string-to-monotone-increasing",
    },
    {
      acRate: 40.614882732372784,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "927",
      paidOnly: false,
      title: "Three Equal Parts",
      titleSlug: "three-equal-parts",
    },
    {
      acRate: 44.53802745725596,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "928",
      paidOnly: false,
      title: "Minimize Malware Spread II",
      titleSlug: "minimize-malware-spread-ii",
    },
    {
      acRate: 67.53886029901626,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "929",
      paidOnly: false,
      title: "Unique Email Addresses",
      titleSlug: "unique-email-addresses",
    },
    {
      acRate: 65.61513672468783,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "930",
      paidOnly: false,
      title: "Binary Subarrays With Sum",
      titleSlug: "binary-subarrays-with-sum",
    },
    {
      acRate: 61.691832704752436,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "931",
      paidOnly: false,
      title: "Minimum Falling Path Sum",
      titleSlug: "minimum-falling-path-sum",
    },
    {
      acRate: 66.92869324237903,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "932",
      paidOnly: false,
      title: "Beautiful Array",
      titleSlug: "beautiful-array",
    },
    {
      acRate: 77.15087287860246,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "933",
      paidOnly: false,
      title: "Number of Recent Calls",
      titleSlug: "number-of-recent-calls",
    },
    {
      acRate: 58.50413972321267,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "934",
      paidOnly: false,
      title: "Shortest Bridge",
      titleSlug: "shortest-bridge",
    },
    {
      acRate: 61.05899358744264,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "935",
      paidOnly: false,
      title: "Knight Dialer",
      titleSlug: "knight-dialer",
    },
    {
      acRate: 61.83563190579886,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "936",
      paidOnly: false,
      title: "Stamping The Sequence",
      titleSlug: "stamping-the-sequence",
    },
    {
      acRate: 56.72750559432876,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "937",
      paidOnly: false,
      title: "Reorder Data in Log Files",
      titleSlug: "reorder-data-in-log-files",
    },
    {
      acRate: 87.41790516631282,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "938",
      paidOnly: false,
      title: "Range Sum of BST",
      titleSlug: "range-sum-of-bst",
    },
    {
      acRate: 54.93128843671703,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "939",
      paidOnly: false,
      title: "Minimum Area Rectangle",
      titleSlug: "minimum-area-rectangle",
    },
    {
      acRate: 43.46699060700553,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "940",
      paidOnly: false,
      title: "Distinct Subsequences II",
      titleSlug: "distinct-subsequences-ii",
    },
    {
      acRate: 34.23130774134106,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "941",
      paidOnly: false,
      title: "Valid Mountain Array",
      titleSlug: "valid-mountain-array",
    },
    {
      acRate: 79.88351842614229,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "942",
      paidOnly: false,
      title: "DI String Match",
      titleSlug: "di-string-match",
    },
    {
      acRate: 44.16866937377421,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "943",
      paidOnly: false,
      title: "Find the Shortest Superstring",
      titleSlug: "find-the-shortest-superstring",
    },
    {
      acRate: 74.74380334012636,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "944",
      paidOnly: false,
      title: "Delete Columns to Make Sorted",
      titleSlug: "delete-columns-to-make-sorted",
    },
    {
      acRate: 60.293402343251934,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "945",
      paidOnly: false,
      title: "Minimum Increment to Make Array Unique",
      titleSlug: "minimum-increment-to-make-array-unique",
    },
    {
      acRate: 69.64183985110081,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "946",
      paidOnly: false,
      title: "Validate Stack Sequences",
      titleSlug: "validate-stack-sequences",
    },
    {
      acRate: 62.136006380537154,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "947",
      paidOnly: false,
      title: "Most Stones Removed with Same Row or Column",
      titleSlug: "most-stones-removed-with-same-row-or-column",
    },
    {
      acRate: 59.13749516842684,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "948",
      paidOnly: false,
      title: "Bag of Tokens",
      titleSlug: "bag-of-tokens",
    },
    {
      acRate: 35.49869324293852,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "949",
      paidOnly: false,
      title: "Largest Time for Given Digits",
      titleSlug: "largest-time-for-given-digits",
    },
    {
      acRate: 83.21031710706089,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "950",
      paidOnly: false,
      title: "Reveal Cards In Increasing Order",
      titleSlug: "reveal-cards-in-increasing-order",
    },
    {
      acRate: 69.71042877083146,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "951",
      paidOnly: false,
      title: "Flip Equivalent Binary Trees",
      titleSlug: "flip-equivalent-binary-trees",
    },
    {
      acRate: 41.06647667344216,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "952",
      paidOnly: false,
      title: "Largest Component Size by Common Factor",
      titleSlug: "largest-component-size-by-common-factor",
    },
    {
      acRate: 55.52125836688164,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "953",
      paidOnly: false,
      title: "Verifying an Alien Dictionary",
      titleSlug: "verifying-an-alien-dictionary",
    },
    {
      acRate: 39.382931219565954,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "954",
      paidOnly: false,
      title: "Array of Doubled Pairs",
      titleSlug: "array-of-doubled-pairs",
    },
    {
      acRate: 35.54207324800406,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "955",
      paidOnly: false,
      title: "Delete Columns to Make Sorted II",
      titleSlug: "delete-columns-to-make-sorted-ii",
    },
    {
      acRate: 51.87498987148946,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "956",
      paidOnly: false,
      title: "Tallest Billboard",
      titleSlug: "tallest-billboard",
    },
    {
      acRate: 38.94286188548401,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "957",
      paidOnly: false,
      title: "Prison Cells After N Days",
      titleSlug: "prison-cells-after-n-days",
    },
    {
      acRate: 58.232570867275356,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "958",
      paidOnly: false,
      title: "Check Completeness of a Binary Tree",
      titleSlug: "check-completeness-of-a-binary-tree",
    },
    {
      acRate: 77.64024614851249,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "959",
      paidOnly: false,
      title: "Regions Cut By Slashes",
      titleSlug: "regions-cut-by-slashes",
    },
    {
      acRate: 58.45986604481538,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "960",
      paidOnly: false,
      title: "Delete Columns to Make Sorted III",
      titleSlug: "delete-columns-to-make-sorted-iii",
    },
    {
      acRate: 77.39163428219106,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "961",
      paidOnly: false,
      title: "N-Repeated Element in Size 2N Array",
      titleSlug: "n-repeated-element-in-size-2n-array",
    },
    {
      acRate: 55.682258623855084,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "962",
      paidOnly: false,
      title: "Maximum Width Ramp",
      titleSlug: "maximum-width-ramp",
    },
    {
      acRate: 55.5409393709419,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "963",
      paidOnly: false,
      title: "Minimum Area Rectangle II",
      titleSlug: "minimum-area-rectangle-ii",
    },
    {
      acRate: 48.40861768580291,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "964",
      paidOnly: false,
      title: "Least Operators to Express Number",
      titleSlug: "least-operators-to-express-number",
    },
    {
      acRate: 71.99610232842247,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "965",
      paidOnly: false,
      title: "Univalued Binary Tree",
      titleSlug: "univalued-binary-tree",
    },
    {
      acRate: 51.52078538957726,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "966",
      paidOnly: false,
      title: "Vowel Spellchecker",
      titleSlug: "vowel-spellchecker",
    },
    {
      acRate: 58.67187910590766,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "967",
      paidOnly: false,
      title: "Numbers With Same Consecutive Differences",
      titleSlug: "numbers-with-same-consecutive-differences",
    },
    {
      acRate: 47.09036254006575,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "968",
      paidOnly: false,
      title: "Binary Tree Cameras",
      titleSlug: "binary-tree-cameras",
    },
    {
      acRate: 71.10800296028734,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "969",
      paidOnly: false,
      title: "Pancake Sorting",
      titleSlug: "pancake-sorting",
    },
    {
      acRate: 44.00603296056504,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "970",
      paidOnly: false,
      title: "Powerful Integers",
      titleSlug: "powerful-integers",
    },
    {
      acRate: 50.988902810094864,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "971",
      paidOnly: false,
      title: "Flip Binary Tree To Match Preorder Traversal",
      titleSlug: "flip-binary-tree-to-match-preorder-traversal",
    },
    {
      acRate: 44.50380110951305,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "972",
      paidOnly: false,
      title: "Equal Rational Numbers",
      titleSlug: "equal-rational-numbers",
    },
    {
      acRate: 67.78946263835533,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "973",
      paidOnly: false,
      title: "K Closest Points to Origin",
      titleSlug: "k-closest-points-to-origin",
    },
    {
      acRate: 55.57612395561647,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "974",
      paidOnly: false,
      title: "Subarray Sums Divisible by K",
      titleSlug: "subarray-sums-divisible-by-k",
    },
    {
      acRate: 40.69229340134101,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "975",
      paidOnly: false,
      title: "Odd Even Jump",
      titleSlug: "odd-even-jump",
    },
    {
      acRate: 57.219123103718104,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "976",
      paidOnly: false,
      title: "Largest Perimeter Triangle",
      titleSlug: "largest-perimeter-triangle",
    },
    {
      acRate: 73.17087480328269,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "977",
      paidOnly: false,
      title: "Squares of a Sorted Array",
      titleSlug: "squares-of-a-sorted-array",
    },
    {
      acRate: 47.919560359925114,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "978",
      paidOnly: false,
      title: "Longest Turbulent Subarray",
      titleSlug: "longest-turbulent-subarray",
    },
    {
      acRate: 77.13401020430571,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "979",
      paidOnly: false,
      title: "Distribute Coins in Binary Tree",
      titleSlug: "distribute-coins-in-binary-tree",
    },
    {
      acRate: 82.27029333179068,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "980",
      paidOnly: false,
      title: "Unique Paths III",
      titleSlug: "unique-paths-iii",
    },
    {
      acRate: 49.287356596008586,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "981",
      paidOnly: false,
      title: "Time Based Key-Value Store",
      titleSlug: "time-based-key-value-store",
    },
    {
      acRate: 59.15257488968674,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "982",
      paidOnly: false,
      title: "Triples with Bitwise AND Equal To Zero",
      titleSlug: "triples-with-bitwise-and-equal-to-zero",
    },
    {
      acRate: 67.40752750288448,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "983",
      paidOnly: false,
      title: "Minimum Cost For Tickets",
      titleSlug: "minimum-cost-for-tickets",
    },
    {
      acRate: 44.45175545482608,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "984",
      paidOnly: false,
      title: "String Without AAA or BBB",
      titleSlug: "string-without-aaa-or-bbb",
    },
    {
      acRate: 68.46764828835525,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "985",
      paidOnly: false,
      title: "Sum of Even Numbers After Queries",
      titleSlug: "sum-of-even-numbers-after-queries",
    },
    {
      acRate: 72.59149582711024,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "986",
      paidOnly: false,
      title: "Interval List Intersections",
      titleSlug: "interval-list-intersections",
    },
    {
      acRate: 50.89508525505774,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "987",
      paidOnly: false,
      title: "Vertical Order Traversal of a Binary Tree",
      titleSlug: "vertical-order-traversal-of-a-binary-tree",
    },
    {
      acRate: 60.74361280240598,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "988",
      paidOnly: false,
      title: "Smallest String Starting From Leaf",
      titleSlug: "smallest-string-starting-from-leaf",
    },
    {
      acRate: 45.024780958076235,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "989",
      paidOnly: false,
      title: "Add to Array-Form of Integer",
      titleSlug: "add-to-array-form-of-integer",
    },
    {
      acRate: 50.963511634956085,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "990",
      paidOnly: false,
      title: "Satisfiability of Equality Equations",
      titleSlug: "satisfiability-of-equality-equations",
    },
    {
      acRate: 55.0379895965415,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "991",
      paidOnly: false,
      title: "Broken Calculator",
      titleSlug: "broken-calculator",
    },
    {
      acRate: 65.47689762944822,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "992",
      paidOnly: false,
      title: "Subarrays with K Different Integers",
      titleSlug: "subarrays-with-k-different-integers",
    },
    {
      acRate: 57.98698932176829,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "993",
      paidOnly: false,
      title: "Cousins in Binary Tree",
      titleSlug: "cousins-in-binary-tree",
    },
    {
      acRate: 56.34006239105614,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "994",
      paidOnly: false,
      title: "Rotting Oranges",
      titleSlug: "rotting-oranges",
    },
    {
      acRate: 62.12966076365538,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "995",
      paidOnly: false,
      title: "Minimum Number of K Consecutive Bit Flips",
      titleSlug: "minimum-number-of-k-consecutive-bit-flips",
    },
    {
      acRate: 50.46702422617154,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "996",
      paidOnly: false,
      title: "Number of Squareful Arrays",
      titleSlug: "number-of-squareful-arrays",
    },
    {
      acRate: 49.937114208275034,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "997",
      paidOnly: false,
      title: "Find the Town Judge",
      titleSlug: "find-the-town-judge",
    },
    {
      acRate: 69.01185770750988,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "998",
      paidOnly: false,
      title: "Maximum Binary Tree II",
      titleSlug: "maximum-binary-tree-ii",
    },
    {
      acRate: 70.2312481200266,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "999",
      paidOnly: false,
      title: "Available Captures for Rook",
      titleSlug: "available-captures-for-rook",
    },
    {
      acRate: 44.169493519480774,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1000",
      paidOnly: false,
      title: "Minimum Cost to Merge Stones",
      titleSlug: "minimum-cost-to-merge-stones",
    },
    {
      acRate: 37.84477734196556,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1001",
      paidOnly: false,
      title: "Grid Illumination",
      titleSlug: "grid-illumination",
    },
    {
      acRate: 74.52141489621582,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1002",
      paidOnly: false,
      title: "Find Common Characters",
      titleSlug: "find-common-characters",
    },
    {
      acRate: 60.05465578909296,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1003",
      paidOnly: false,
      title: "Check If Word Is Valid After Substitutions",
      titleSlug: "check-if-word-is-valid-after-substitutions",
    },
    {
      acRate: 65.67252505386683,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1004",
      paidOnly: false,
      title: "Max Consecutive Ones III",
      titleSlug: "max-consecutive-ones-iii",
    },
    {
      acRate: 52.20927737927561,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1005",
      paidOnly: false,
      title: "Maximize Sum Of Array After K Negations",
      titleSlug: "maximize-sum-of-array-after-k-negations",
    },
    {
      acRate: 59.03878247822026,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1006",
      paidOnly: false,
      title: "Clumsy Factorial",
      titleSlug: "clumsy-factorial",
    },
    {
      acRate: 56.42672504990479,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1007",
      paidOnly: false,
      title: "Minimum Domino Rotations For Equal Row",
      titleSlug: "minimum-domino-rotations-for-equal-row",
    },
    {
      acRate: 83.1304091064544,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1008",
      paidOnly: false,
      title: "Construct Binary Search Tree from Preorder Traversal",
      titleSlug: "construct-binary-search-tree-from-preorder-traversal",
    },
    {
      acRate: 60.75448667263701,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1009",
      paidOnly: false,
      title: "Complement of Base 10 Integer",
      titleSlug: "complement-of-base-10-integer",
    },
    {
      acRate: 53.221485652015986,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1010",
      paidOnly: false,
      title: "Pairs of Songs With Total Durations Divisible by 60",
      titleSlug: "pairs-of-songs-with-total-durations-divisible-by-60",
    },
    {
      acRate: 71.76735691385925,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1011",
      paidOnly: false,
      title: "Capacity To Ship Packages Within D Days",
      titleSlug: "capacity-to-ship-packages-within-d-days",
    },
    {
      acRate: 43.287362192993655,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1012",
      paidOnly: false,
      title: "Numbers With Repeated Digits",
      titleSlug: "numbers-with-repeated-digits",
    },
    {
      acRate: 42.02241215867315,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1013",
      paidOnly: false,
      title: "Partition Array Into Three Parts With Equal Sum",
      titleSlug: "partition-array-into-three-parts-with-equal-sum",
    },
    {
      acRate: 62.618223899858826,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1014",
      paidOnly: false,
      title: "Best Sightseeing Pair",
      titleSlug: "best-sightseeing-pair",
    },
    {
      acRate: 46.5465277342744,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1015",
      paidOnly: false,
      title: "Smallest Integer Divisible by K",
      titleSlug: "smallest-integer-divisible-by-k",
    },
    {
      acRate: 57.91845464695516,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1016",
      paidOnly: false,
      title: "Binary String With Substrings Representing 1 To N",
      titleSlug: "binary-string-with-substrings-representing-1-to-n",
    },
    {
      acRate: 61.16822253297555,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1017",
      paidOnly: false,
      title: "Convert to Base -2",
      titleSlug: "convert-to-base-2",
    },
    {
      acRate: 46.91865422031786,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1018",
      paidOnly: false,
      title: "Binary Prefix Divisible By 5",
      titleSlug: "binary-prefix-divisible-by-5",
    },
    {
      acRate: 62.09500494956791,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1019",
      paidOnly: false,
      title: "Next Greater Node In Linked List",
      titleSlug: "next-greater-node-in-linked-list",
    },
    {
      acRate: 70.2477987768936,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1020",
      paidOnly: false,
      title: "Number of Enclaves",
      titleSlug: "number-of-enclaves",
    },
    {
      acRate: 85.29517776200099,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1021",
      paidOnly: false,
      title: "Remove Outermost Parentheses",
      titleSlug: "remove-outermost-parentheses",
    },
    {
      acRate: 73.35985538017914,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1022",
      paidOnly: false,
      title: "Sum of Root To Leaf Binary Numbers",
      titleSlug: "sum-of-root-to-leaf-binary-numbers",
    },
    {
      acRate: 63.55489928649526,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1023",
      paidOnly: false,
      title: "Camelcase Matching",
      titleSlug: "camelcase-matching",
    },
    {
      acRate: 51.901351893990096,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1024",
      paidOnly: false,
      title: "Video Stitching",
      titleSlug: "video-stitching",
    },
    {
      acRate: 70.22405489712355,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1025",
      paidOnly: false,
      title: "Divisor Game",
      titleSlug: "divisor-game",
    },
    {
      acRate: 78.04809413047589,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1026",
      paidOnly: false,
      title: "Maximum Difference Between Node and Ancestor",
      titleSlug: "maximum-difference-between-node-and-ancestor",
    },
    {
      acRate: 49.42003684890929,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1027",
      paidOnly: false,
      title: "Longest Arithmetic Subsequence",
      titleSlug: "longest-arithmetic-subsequence",
    },
    {
      acRate: 83.2936594968466,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1028",
      paidOnly: false,
      title: "Recover a Tree From Preorder Traversal",
      titleSlug: "recover-a-tree-from-preorder-traversal",
    },
    {
      acRate: 67.57249471571974,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1029",
      paidOnly: false,
      title: "Two City Scheduling",
      titleSlug: "two-city-scheduling",
    },
    {
      acRate: 72.60259476391035,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1030",
      paidOnly: false,
      title: "Matrix Cells in Distance Order",
      titleSlug: "matrix-cells-in-distance-order",
    },
    {
      acRate: 60.18092574184948,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1031",
      paidOnly: false,
      title: "Maximum Sum of Two Non-Overlapping Subarrays",
      titleSlug: "maximum-sum-of-two-non-overlapping-subarrays",
    },
    {
      acRate: 51.14431964803181,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1032",
      paidOnly: false,
      title: "Stream of Characters",
      titleSlug: "stream-of-characters",
    },
    {
      acRate: 49.34340399965668,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1033",
      paidOnly: false,
      title: "Moving Stones Until Consecutive",
      titleSlug: "moving-stones-until-consecutive",
    },
    {
      acRate: 49.655229414126154,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1034",
      paidOnly: false,
      title: "Coloring A Border",
      titleSlug: "coloring-a-border",
    },
    {
      acRate: 64.15641313469273,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1035",
      paidOnly: false,
      title: "Uncrossed Lines",
      titleSlug: "uncrossed-lines",
    },
    {
      acRate: 35.205195836524005,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1036",
      paidOnly: false,
      title: "Escape a Large Maze",
      titleSlug: "escape-a-large-maze",
    },
    {
      acRate: 37.82214112792625,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1037",
      paidOnly: false,
      title: "Valid Boomerang",
      titleSlug: "valid-boomerang",
    },
    {
      acRate: 88.24045473137843,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1038",
      paidOnly: false,
      title: "Binary Search Tree to Greater Sum Tree",
      titleSlug: "binary-search-tree-to-greater-sum-tree",
    },
    {
      acRate: 60.02958434002268,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1039",
      paidOnly: false,
      title: "Minimum Score Triangulation of Polygon",
      titleSlug: "minimum-score-triangulation-of-polygon",
    },
    {
      acRate: 57.05343372947473,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1040",
      paidOnly: false,
      title: "Moving Stones Until Consecutive II",
      titleSlug: "moving-stones-until-consecutive-ii",
    },
    {
      acRate: 56.2070451409594,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1041",
      paidOnly: false,
      title: "Robot Bounded In Circle",
      titleSlug: "robot-bounded-in-circle",
    },
    {
      acRate: 52.207323451482566,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1042",
      paidOnly: false,
      title: "Flower Planting With No Adjacent",
      titleSlug: "flower-planting-with-no-adjacent",
    },
    {
      acRate: 76.89915730144472,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1043",
      paidOnly: false,
      title: "Partition Array for Maximum Sum",
      titleSlug: "partition-array-for-maximum-sum",
    },
    {
      acRate: 30.705860857914292,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1044",
      paidOnly: false,
      title: "Longest Duplicate Substring",
      titleSlug: "longest-duplicate-substring",
    },
    {
      acRate: 63.03226205096122,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1045",
      paidOnly: false,
      title: "Customers Who Bought All Products",
      titleSlug: "customers-who-bought-all-products",
    },
    {
      acRate: 65.87321462458917,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1046",
      paidOnly: false,
      title: "Last Stone Weight",
      titleSlug: "last-stone-weight",
    },
    {
      acRate: 71.37799365499616,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1047",
      paidOnly: false,
      title: "Remove All Adjacent Duplicates In String",
      titleSlug: "remove-all-adjacent-duplicates-in-string",
    },
    {
      acRate: 61.8505773988444,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1048",
      paidOnly: false,
      title: "Longest String Chain",
      titleSlug: "longest-string-chain",
    },
    {
      acRate: 57.36678107650697,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1049",
      paidOnly: false,
      title: "Last Stone Weight II",
      titleSlug: "last-stone-weight-ii",
    },
    {
      acRate: 70.61218928820128,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1050",
      paidOnly: false,
      title: "Actors and Directors Who Cooperated At Least Three Times",
      titleSlug: "actors-and-directors-who-cooperated-at-least-three-times",
    },
    {
      acRate: 81.08649396511967,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1051",
      paidOnly: false,
      title: "Height Checker",
      titleSlug: "height-checker",
    },
    {
      acRate: 64.09043128440173,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1052",
      paidOnly: false,
      title: "Grumpy Bookstore Owner",
      titleSlug: "grumpy-bookstore-owner",
    },
    {
      acRate: 49.38932909549582,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1053",
      paidOnly: false,
      title: "Previous Permutation With One Swap",
      titleSlug: "previous-permutation-with-one-swap",
    },
    {
      acRate: 47.343202255753695,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1054",
      paidOnly: false,
      title: "Distant Barcodes",
      titleSlug: "distant-barcodes",
    },
    {
      acRate: 61.27563725402797,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1055",
      paidOnly: true,
      title: "Shortest Way to Form String",
      titleSlug: "shortest-way-to-form-string",
    },
    {
      acRate: 49.19370229007634,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1056",
      paidOnly: true,
      title: "Confusing Number",
      titleSlug: "confusing-number",
    },
    {
      acRate: 58.92527891496609,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1057",
      paidOnly: true,
      title: "Campus Bikes",
      titleSlug: "campus-bikes",
    },
    {
      acRate: 45.43689320388349,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1058",
      paidOnly: true,
      title: "Minimize Rounding Error to Meet Target",
      titleSlug: "minimize-rounding-error-to-meet-target",
    },
    {
      acRate: 37.0667452009317,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1059",
      paidOnly: true,
      title: "All Paths from Source Lead to Destination",
      titleSlug: "all-paths-from-source-lead-to-destination",
    },
    {
      acRate: 58.51917694228005,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1060",
      paidOnly: true,
      title: "Missing Element in Sorted Array",
      titleSlug: "missing-element-in-sorted-array",
    },
    {
      acRate: 76.59264146684492,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1061",
      paidOnly: false,
      title: "Lexicographically Smallest Equivalent String",
      titleSlug: "lexicographically-smallest-equivalent-string",
    },
    {
      acRate: 62.951271979049764,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1062",
      paidOnly: true,
      title: "Longest Repeating Substring",
      titleSlug: "longest-repeating-substring",
    },
    {
      acRate: 79.1716947434474,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1063",
      paidOnly: true,
      title: "Number of Valid Subarrays",
      titleSlug: "number-of-valid-subarrays",
    },
    {
      acRate: 63.89064539131136,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1064",
      paidOnly: true,
      title: "Fixed Point",
      titleSlug: "fixed-point",
    },
    {
      acRate: 68.14341173783968,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1065",
      paidOnly: true,
      title: "Index Pairs of a String",
      titleSlug: "index-pairs-of-a-string",
    },
    {
      acRate: 55.287386215864764,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1066",
      paidOnly: true,
      title: "Campus Bikes II",
      titleSlug: "campus-bikes-ii",
    },
    {
      acRate: 45.99958437240233,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1067",
      paidOnly: true,
      title: "Digit Count in Range",
      titleSlug: "digit-count-in-range",
    },
    {
      acRate: 84.3911926912994,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1068",
      paidOnly: false,
      title: "Product Sales Analysis I",
      titleSlug: "product-sales-analysis-i",
    },
    {
      acRate: 82.20433053717208,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1069",
      paidOnly: true,
      title: "Product Sales Analysis II",
      titleSlug: "product-sales-analysis-ii",
    },
    {
      acRate: 44.34391409522686,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1070",
      paidOnly: false,
      title: "Product Sales Analysis III",
      titleSlug: "product-sales-analysis-iii",
    },
    {
      acRate: 52.60974323443946,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1071",
      paidOnly: false,
      title: "Greatest Common Divisor of Strings",
      titleSlug: "greatest-common-divisor-of-strings",
    },
    {
      acRate: 78.4994416240177,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1072",
      paidOnly: false,
      title: "Flip Columns For Maximum Number of Equal Rows",
      titleSlug: "flip-columns-for-maximum-number-of-equal-rows",
    },
    {
      acRate: 36.832142525749276,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1073",
      paidOnly: false,
      title: "Adding Two Negabinary Numbers",
      titleSlug: "adding-two-negabinary-numbers",
    },
    {
      acRate: 74.4266851980542,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1074",
      paidOnly: false,
      title: "Number of Submatrices That Sum to Target",
      titleSlug: "number-of-submatrices-that-sum-to-target",
    },
    {
      acRate: 65.4405507199973,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1075",
      paidOnly: false,
      title: "Project Employees I",
      titleSlug: "project-employees-i",
    },
    {
      acRate: 50.25555573358115,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1076",
      paidOnly: true,
      title: "Project Employees II",
      titleSlug: "project-employees-ii",
    },
    {
      acRate: 77.13142790886428,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1077",
      paidOnly: true,
      title: "Project Employees III",
      titleSlug: "project-employees-iii",
    },
    {
      acRate: 63.63895457661586,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1078",
      paidOnly: false,
      title: "Occurrences After Bigram",
      titleSlug: "occurrences-after-bigram",
    },
    {
      acRate: 83.55910698950002,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1079",
      paidOnly: false,
      title: "Letter Tile Possibilities",
      titleSlug: "letter-tile-possibilities",
    },
    {
      acRate: 53.416347381864625,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1080",
      paidOnly: false,
      title: "Insufficient Nodes in Root to Leaf Paths",
      titleSlug: "insufficient-nodes-in-root-to-leaf-paths",
    },
    {
      acRate: 61.78846285858116,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1081",
      paidOnly: false,
      title: "Smallest Subsequence of Distinct Characters",
      titleSlug: "smallest-subsequence-of-distinct-characters",
    },
    {
      acRate: 74.71490870082322,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1082",
      paidOnly: true,
      title: "Sales Analysis I",
      titleSlug: "sales-analysis-i",
    },
    {
      acRate: 49.92174036774122,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1083",
      paidOnly: true,
      title: "Sales Analysis II",
      titleSlug: "sales-analysis-ii",
    },
    {
      acRate: 46.699140006879944,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1084",
      paidOnly: false,
      title: "Sales Analysis III",
      titleSlug: "sales-analysis-iii",
    },
    {
      acRate: 76.60360224004843,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1085",
      paidOnly: true,
      title: "Sum of Digits in the Minimum Number",
      titleSlug: "sum-of-digits-in-the-minimum-number",
    },
    {
      acRate: 74.36072061884815,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1086",
      paidOnly: true,
      title: "High Five",
      titleSlug: "high-five",
    },
    {
      acRate: 66.67348701859682,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1087",
      paidOnly: true,
      title: "Brace Expansion",
      titleSlug: "brace-expansion",
    },
    {
      acRate: 47.079298933692854,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1088",
      paidOnly: true,
      title: "Confusing Number II",
      titleSlug: "confusing-number-ii",
    },
    {
      acRate: 52.71005442430686,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1089",
      paidOnly: false,
      title: "Duplicate Zeros",
      titleSlug: "duplicate-zeros",
    },
    {
      acRate: 63.01779359430605,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1090",
      paidOnly: false,
      title: "Largest Values From Labels",
      titleSlug: "largest-values-from-labels",
    },
    {
      acRate: 49.49654934101296,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1091",
      paidOnly: false,
      title: "Shortest Path in Binary Matrix",
      titleSlug: "shortest-path-in-binary-matrix",
    },
    {
      acRate: 61.23009803675752,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1092",
      paidOnly: false,
      title: "Shortest Common Supersequence ",
      titleSlug: "shortest-common-supersequence",
    },
    {
      acRate: 42.2131605407217,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1093",
      paidOnly: false,
      title: "Statistics from a Large Sample",
      titleSlug: "statistics-from-a-large-sample",
    },
    {
      acRate: 55.998384532540136,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1094",
      paidOnly: false,
      title: "Car Pooling",
      titleSlug: "car-pooling",
    },
    {
      acRate: 40.3991751326466,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1095",
      paidOnly: false,
      title: "Find in Mountain Array",
      titleSlug: "find-in-mountain-array",
    },
    {
      acRate: 63.10356933879462,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1096",
      paidOnly: false,
      title: "Brace Expansion II",
      titleSlug: "brace-expansion-ii",
    },
    {
      acRate: 50.823321690400334,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1097",
      paidOnly: true,
      title: "Game Play Analysis V",
      titleSlug: "game-play-analysis-v",
    },
    {
      acRate: 43.35091832747167,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1098",
      paidOnly: true,
      title: "Unpopular Books",
      titleSlug: "unpopular-books",
    },
    {
      acRate: 62.00324921477309,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1099",
      paidOnly: true,
      title: "Two Sum Less Than K",
      titleSlug: "two-sum-less-than-k",
    },
    {
      acRate: 76.19360011662658,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1100",
      paidOnly: true,
      title: "Find K-Length Substrings With No Repeated Characters",
      titleSlug: "find-k-length-substrings-with-no-repeated-characters",
    },
    {
      acRate: 65.66959083613658,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1101",
      paidOnly: true,
      title: "The Earliest Moment When Everyone Become Friends",
      titleSlug: "the-earliest-moment-when-everyone-become-friends",
    },
    {
      acRate: 53.9622641509434,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1102",
      paidOnly: true,
      title: "Path With Maximum Minimum Value",
      titleSlug: "path-with-maximum-minimum-value",
    },
    {
      acRate: 66.3829929471538,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1103",
      paidOnly: false,
      title: "Distribute Candies to People",
      titleSlug: "distribute-candies-to-people",
    },
    {
      acRate: 75.47636010853583,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1104",
      paidOnly: false,
      title: "Path In Zigzag Labelled Binary Tree",
      titleSlug: "path-in-zigzag-labelled-binary-tree",
    },
    {
      acRate: 68.6848635235732,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1105",
      paidOnly: false,
      title: "Filling Bookcase Shelves",
      titleSlug: "filling-bookcase-shelves",
    },
    {
      acRate: 69.93775251588,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1106",
      paidOnly: false,
      title: "Parsing A Boolean Expression",
      titleSlug: "parsing-a-boolean-expression",
    },
    {
      acRate: 44.99630662712369,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1107",
      paidOnly: true,
      title: "New Users Daily Count",
      titleSlug: "new-users-daily-count",
    },
    {
      acRate: 89.63743298162599,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1108",
      paidOnly: false,
      title: "Defanging an IP Address",
      titleSlug: "defanging-an-ip-address",
    },
    {
      acRate: 63.96020183805502,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1109",
      paidOnly: false,
      title: "Corporate Flight Bookings",
      titleSlug: "corporate-flight-bookings",
    },
    {
      acRate: 72.41852480381773,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1110",
      paidOnly: false,
      title: "Delete Nodes And Return Forest",
      titleSlug: "delete-nodes-and-return-forest",
    },
    {
      acRate: 71.32995748339943,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1111",
      paidOnly: false,
      title: "Maximum Nesting Depth of Two Valid Parentheses Strings",
      titleSlug: "maximum-nesting-depth-of-two-valid-parentheses-strings",
    },
    {
      acRate: 71.0947060520739,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1112",
      paidOnly: true,
      title: "Highest Grade For Each Student",
      titleSlug: "highest-grade-for-each-student",
    },
    {
      acRate: 65.1302246487067,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1113",
      paidOnly: true,
      title: "Reported Posts",
      titleSlug: "reported-posts",
    },
    {
      acRate: 71.37194173174672,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1114",
      paidOnly: false,
      title: "Print in Order",
      titleSlug: "print-in-order",
    },
    {
      acRate: 69.32679847577013,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1115",
      paidOnly: false,
      title: "Print FooBar Alternately",
      titleSlug: "print-foobar-alternately",
    },
    {
      acRate: 63.26137239784118,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1116",
      paidOnly: false,
      title: "Print Zero Even Odd",
      titleSlug: "print-zero-even-odd",
    },
    {
      acRate: 57.44638959037795,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1117",
      paidOnly: false,
      title: "Building H2O",
      titleSlug: "building-h2o",
    },
    {
      acRate: 58.96404164271571,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1118",
      paidOnly: true,
      title: "Number of Days in a Month",
      titleSlug: "number-of-days-in-a-month",
    },
    {
      acRate: 91.22260788067004,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1119",
      paidOnly: true,
      title: "Remove Vowels from a String",
      titleSlug: "remove-vowels-from-a-string",
    },
    {
      acRate: 66.80543423718103,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1120",
      paidOnly: true,
      title: "Maximum Average Subtree",
      titleSlug: "maximum-average-subtree",
    },
    {
      acRate: 60.50615277455306,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1121",
      paidOnly: true,
      title: "Divide Array Into Increasing Sequences",
      titleSlug: "divide-array-into-increasing-sequences",
    },
    {
      acRate: 74.90309029188245,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1122",
      paidOnly: false,
      title: "Relative Sort Array",
      titleSlug: "relative-sort-array",
    },
    {
      acRate: 78.87986661922999,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1123",
      paidOnly: false,
      title: "Lowest Common Ancestor of Deepest Leaves",
      titleSlug: "lowest-common-ancestor-of-deepest-leaves",
    },
    {
      acRate: 35.788045246261234,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1124",
      paidOnly: false,
      title: "Longest Well-Performing Interval",
      titleSlug: "longest-well-performing-interval",
    },
    {
      acRate: 55.33065412010717,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1125",
      paidOnly: false,
      title: "Smallest Sufficient Team",
      titleSlug: "smallest-sufficient-team",
    },
    {
      acRate: 65.91609417728273,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1126",
      paidOnly: true,
      title: "Active Businesses",
      titleSlug: "active-businesses",
    },
    {
      acRate: 47.17596521001273,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1127",
      paidOnly: true,
      title: "User Purchase Platform",
      titleSlug: "user-purchase-platform",
    },
    {
      acRate: 60.4661236651943,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1128",
      paidOnly: false,
      title: "Number of Equivalent Domino Pairs",
      titleSlug: "number-of-equivalent-domino-pairs",
    },
    {
      acRate: 47.259346025204984,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1129",
      paidOnly: false,
      title: "Shortest Path with Alternating Colors",
      titleSlug: "shortest-path-with-alternating-colors",
    },
    {
      acRate: 67.63978861234231,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1130",
      paidOnly: false,
      title: "Minimum Cost Tree From Leaf Values",
      titleSlug: "minimum-cost-tree-from-leaf-values",
    },
    {
      acRate: 48.24102977798043,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1131",
      paidOnly: false,
      title: "Maximum of Absolute Value Expression",
      titleSlug: "maximum-of-absolute-value-expression",
    },
    {
      acRate: 32.25103710398851,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1132",
      paidOnly: true,
      title: "Reported Posts II",
      titleSlug: "reported-posts-ii",
    },
    {
      acRate: 70.74797596876876,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1133",
      paidOnly: true,
      title: "Largest Unique Number",
      titleSlug: "largest-unique-number",
    },
    {
      acRate: 77.83031561142506,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1134",
      paidOnly: true,
      title: "Armstrong Number",
      titleSlug: "armstrong-number",
    },
    {
      acRate: 62.576406217806365,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1135",
      paidOnly: true,
      title: "Connecting Cities With Minimum Cost",
      titleSlug: "connecting-cities-with-minimum-cost",
    },
    {
      acRate: 61.788576965182266,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1136",
      paidOnly: true,
      title: "Parallel Courses",
      titleSlug: "parallel-courses",
    },
    {
      acRate: 63.60571231624533,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1137",
      paidOnly: false,
      title: "N-th Tribonacci Number",
      titleSlug: "n-th-tribonacci-number",
    },
    {
      acRate: 51.574708387335676,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1138",
      paidOnly: false,
      title: "Alphabet Board Path",
      titleSlug: "alphabet-board-path",
    },
    {
      acRate: 50.59408626458088,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1139",
      paidOnly: false,
      title: "Largest 1-Bordered Square",
      titleSlug: "largest-1-bordered-square",
    },
    {
      acRate: 73.00031952284588,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1140",
      paidOnly: false,
      title: "Stone Game II",
      titleSlug: "stone-game-ii",
    },
    {
      acRate: 49.393309324581786,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1141",
      paidOnly: false,
      title: "User Activity for the Past 30 Days I",
      titleSlug: "user-activity-for-the-past-30-days-i",
    },
    {
      acRate: 35.7124110354623,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1142",
      paidOnly: true,
      title: "User Activity for the Past 30 Days II",
      titleSlug: "user-activity-for-the-past-30-days-ii",
    },
    {
      acRate: 58.14629288034967,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1143",
      paidOnly: false,
      title: "Longest Common Subsequence",
      titleSlug: "longest-common-subsequence",
    },
    {
      acRate: 48.327930565722056,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1144",
      paidOnly: false,
      title: "Decrease Elements To Make Array Zigzag",
      titleSlug: "decrease-elements-to-make-array-zigzag",
    },
    {
      acRate: 52.46321111476489,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1145",
      paidOnly: false,
      title: "Binary Tree Coloring Game",
      titleSlug: "binary-tree-coloring-game",
    },
    {
      acRate: 36.67463225532367,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1146",
      paidOnly: false,
      title: "Snapshot Array",
      titleSlug: "snapshot-array",
    },
    {
      acRate: 58.77518334316784,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1147",
      paidOnly: false,
      title: "Longest Chunked Palindrome Decomposition",
      titleSlug: "longest-chunked-palindrome-decomposition",
    },
    {
      acRate: 77.18953454301172,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1148",
      paidOnly: false,
      title: "Article Views I",
      titleSlug: "article-views-i",
    },
    {
      acRate: 47.22358442150881,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1149",
      paidOnly: true,
      title: "Article Views II",
      titleSlug: "article-views-ii",
    },
    {
      acRate: 59.04717252549362,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1150",
      paidOnly: true,
      title: "Check If a Number Is Majority Element in a Sorted Array",
      titleSlug: "check-if-a-number-is-majority-element-in-a-sorted-array",
    },
    {
      acRate: 61.0738924682137,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1151",
      paidOnly: true,
      title: "Minimum Swaps to Group All 1's Together",
      titleSlug: "minimum-swaps-to-group-all-1s-together",
    },
    {
      acRate: 43.56055184259493,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1152",
      paidOnly: true,
      title: "Analyze User Website Visit Pattern",
      titleSlug: "analyze-user-website-visit-pattern",
    },
    {
      acRate: 34.7855866198745,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1153",
      paidOnly: true,
      title: "String Transforms Into Another String",
      titleSlug: "string-transforms-into-another-string",
    },
    {
      acRate: 48.00865746391675,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1154",
      paidOnly: false,
      title: "Day of the Year",
      titleSlug: "day-of-the-year",
    },
    {
      acRate: 61.52661134025742,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1155",
      paidOnly: false,
      title: "Number of Dice Rolls With Target Sum",
      titleSlug: "number-of-dice-rolls-with-target-sum",
    },
    {
      acRate: 43.59423769507803,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1156",
      paidOnly: false,
      title: "Swap For Longest Repeated Character Substring",
      titleSlug: "swap-for-longest-repeated-character-substring",
    },
    {
      acRate: 39.03022799958733,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1157",
      paidOnly: false,
      title: "Online Majority Element In Subarray",
      titleSlug: "online-majority-element-in-subarray",
    },
    {
      acRate: 57.20923658592605,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1158",
      paidOnly: false,
      title: "Market Analysis I",
      titleSlug: "market-analysis-i",
    },
    {
      acRate: 57.86510801055864,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1159",
      paidOnly: true,
      title: "Market Analysis II",
      titleSlug: "market-analysis-ii",
    },
    {
      acRate: 70.99494340056313,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1160",
      paidOnly: false,
      title: "Find Words That Can Be Formed by Characters",
      titleSlug: "find-words-that-can-be-formed-by-characters",
    },
    {
      acRate: 67.33643577653744,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1161",
      paidOnly: false,
      title: "Maximum Level Sum of a Binary Tree",
      titleSlug: "maximum-level-sum-of-a-binary-tree",
    },
    {
      acRate: 51.78993411114921,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1162",
      paidOnly: false,
      title: "As Far from Land as Possible",
      titleSlug: "as-far-from-land-as-possible",
    },
    {
      acRate: 34.383304816338416,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1163",
      paidOnly: false,
      title: "Last Substring in Lexicographical Order",
      titleSlug: "last-substring-in-lexicographical-order",
    },
    {
      acRate: 57.30572291353631,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1164",
      paidOnly: false,
      title: "Product Price at a Given Date",
      titleSlug: "product-price-at-a-given-date",
    },
    {
      acRate: 87.69227792504304,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1165",
      paidOnly: true,
      title: "Single-Row Keyboard",
      titleSlug: "single-row-keyboard",
    },
    {
      acRate: 63.99684236094243,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1166",
      paidOnly: true,
      title: "Design File System",
      titleSlug: "design-file-system",
    },
    {
      acRate: 71.04113436950968,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1167",
      paidOnly: true,
      title: "Minimum Cost to Connect Sticks",
      titleSlug: "minimum-cost-to-connect-sticks",
    },
    {
      acRate: 65.14764812517889,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1168",
      paidOnly: true,
      title: "Optimize Water Distribution in a Village",
      titleSlug: "optimize-water-distribution-in-a-village",
    },
    {
      acRate: 31.232911619065984,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1169",
      paidOnly: false,
      title: "Invalid Transactions",
      titleSlug: "invalid-transactions",
    },
    {
      acRate: 62.6157590770959,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1170",
      paidOnly: false,
      title: "Compare Strings by Frequency of the Smallest Character",
      titleSlug: "compare-strings-by-frequency-of-the-smallest-character",
    },
    {
      acRate: 52.83862624804523,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1171",
      paidOnly: false,
      title: "Remove Zero Sum Consecutive Nodes from Linked List",
      titleSlug: "remove-zero-sum-consecutive-nodes-from-linked-list",
    },
    {
      acRate: 32.770429482547364,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1172",
      paidOnly: false,
      title: "Dinner Plate Stacks",
      titleSlug: "dinner-plate-stacks",
    },
    {
      acRate: 80.85189601717147,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1173",
      paidOnly: true,
      title: "Immediate Food Delivery I",
      titleSlug: "immediate-food-delivery-i",
    },
    {
      acRate: 54.110346297134015,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1174",
      paidOnly: false,
      title: "Immediate Food Delivery II",
      titleSlug: "immediate-food-delivery-ii",
    },
    {
      acRate: 59.326208028844604,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1175",
      paidOnly: false,
      title: "Prime Arrangements",
      titleSlug: "prime-arrangements",
    },
    {
      acRate: 54.11792613678483,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1176",
      paidOnly: true,
      title: "Diet Plan Performance",
      titleSlug: "diet-plan-performance",
    },
    {
      acRate: 40.09301387646043,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1177",
      paidOnly: false,
      title: "Can Make Palindrome from Substring",
      titleSlug: "can-make-palindrome-from-substring",
    },
    {
      acRate: 47.02789208962048,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1178",
      paidOnly: false,
      title: "Number of Valid Words for Each Puzzle",
      titleSlug: "number-of-valid-words-for-each-puzzle",
    },
    {
      acRate: 76.74147368192644,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1179",
      paidOnly: false,
      title: "Reformat Department Table",
      titleSlug: "reformat-department-table",
    },
    {
      acRate: 80.59223037218148,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1180",
      paidOnly: true,
      title: "Count Substrings with Only One Distinct Letter",
      titleSlug: "count-substrings-with-only-one-distinct-letter",
    },
    {
      acRate: 46.50655021834061,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1181",
      paidOnly: true,
      title: "Before and After Puzzle",
      titleSlug: "before-and-after-puzzle",
    },
    {
      acRate: 55.43014984332536,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1182",
      paidOnly: true,
      title: "Shortest Distance to Target Color",
      titleSlug: "shortest-distance-to-target-color",
    },
    {
      acRate: 68.60407962644385,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1183",
      paidOnly: true,
      title: "Maximum Number of Ones",
      titleSlug: "maximum-number-of-ones",
    },
    {
      acRate: 54.60688151953915,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1184",
      paidOnly: false,
      title: "Distance Between Bus Stops",
      titleSlug: "distance-between-bus-stops",
    },
    {
      acRate: 58.40026422062422,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1185",
      paidOnly: false,
      title: "Day of the Week",
      titleSlug: "day-of-the-week",
    },
    {
      acRate: 45.00488773031578,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1186",
      paidOnly: false,
      title: "Maximum Subarray Sum with One Deletion",
      titleSlug: "maximum-subarray-sum-with-one-deletion",
    },
    {
      acRate: 57.815335647609565,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1187",
      paidOnly: false,
      title: "Make Array Strictly Increasing",
      titleSlug: "make-array-strictly-increasing",
    },
    {
      acRate: 72.98173283494977,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1188",
      paidOnly: true,
      title: "Design Bounded Blocking Queue",
      titleSlug: "design-bounded-blocking-queue",
    },
    {
      acRate: 59.71676865778227,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1189",
      paidOnly: false,
      title: "Maximum Number of Balloons",
      titleSlug: "maximum-number-of-balloons",
    },
    {
      acRate: 71.68267619792248,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1190",
      paidOnly: false,
      title: "Reverse Substrings Between Each Pair of Parentheses",
      titleSlug: "reverse-substrings-between-each-pair-of-parentheses",
    },
    {
      acRate: 24.179989701402718,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1191",
      paidOnly: false,
      title: "K-Concatenation Maximum Sum",
      titleSlug: "k-concatenation-maximum-sum",
    },
    {
      acRate: 57.533460762585754,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1192",
      paidOnly: false,
      title: "Critical Connections in a Network",
      titleSlug: "critical-connections-in-a-network",
    },
    {
      acRate: 58.27570331399047,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1193",
      paidOnly: false,
      title: "Monthly Transactions I",
      titleSlug: "monthly-transactions-i",
    },
    {
      acRate: 49.819689477207454,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1194",
      paidOnly: true,
      title: "Tournament Winners",
      titleSlug: "tournament-winners",
    },
    {
      acRate: 73.80964038287351,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1195",
      paidOnly: false,
      title: "Fizz Buzz Multithreaded",
      titleSlug: "fizz-buzz-multithreaded",
    },
    {
      acRate: 67.05846482201387,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1196",
      paidOnly: true,
      title: "How Many Apples Can You Put into the Basket",
      titleSlug: "how-many-apples-can-you-put-into-the-basket",
    },
    {
      acRate: 41.25611078688269,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1197",
      paidOnly: true,
      title: "Minimum Knight Moves",
      titleSlug: "minimum-knight-moves",
    },
    {
      acRate: 76.43733366927546,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1198",
      paidOnly: true,
      title: "Find Smallest Common Element in All Rows",
      titleSlug: "find-smallest-common-element-in-all-rows",
    },
    {
      acRate: 46.177472123923344,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1199",
      paidOnly: true,
      title: "Minimum Time to Build Blocks",
      titleSlug: "minimum-time-to-build-blocks",
    },
    {
      acRate: 70.50896916174146,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1200",
      paidOnly: false,
      title: "Minimum Absolute Difference",
      titleSlug: "minimum-absolute-difference",
    },
    {
      acRate: 30.334576674491142,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1201",
      paidOnly: false,
      title: "Ugly Number III",
      titleSlug: "ugly-number-iii",
    },
    {
      acRate: 59.27059539433351,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1202",
      paidOnly: false,
      title: "Smallest String With Swaps",
      titleSlug: "smallest-string-with-swaps",
    },
    {
      acRate: 65.62042751685975,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1203",
      paidOnly: false,
      title: "Sort Items by Groups Respecting Dependencies",
      titleSlug: "sort-items-by-groups-respecting-dependencies",
    },
    {
      acRate: 68.2515054553545,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1204",
      paidOnly: false,
      title: "Last Person to Fit in the Bus",
      titleSlug: "last-person-to-fit-in-the-bus",
    },
    {
      acRate: 42.110106554730386,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1205",
      paidOnly: true,
      title: "Monthly Transactions II",
      titleSlug: "monthly-transactions-ii",
    },
    {
      acRate: 57.955669083717865,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1206",
      paidOnly: false,
      title: "Design Skiplist",
      titleSlug: "design-skiplist",
    },
    {
      acRate: 78.20260282821539,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1207",
      paidOnly: false,
      title: "Unique Number of Occurrences",
      titleSlug: "unique-number-of-occurrences",
    },
    {
      acRate: 58.84435976611261,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1208",
      paidOnly: false,
      title: "Get Equal Substrings Within Budget",
      titleSlug: "get-equal-substrings-within-budget",
    },
    {
      acRate: 59.404051205576856,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1209",
      paidOnly: false,
      title: "Remove All Adjacent Duplicates in String II",
      titleSlug: "remove-all-adjacent-duplicates-in-string-ii",
    },
    {
      acRate: 50.384702936489866,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1210",
      paidOnly: false,
      title: "Minimum Moves to Reach Target with Rotations",
      titleSlug: "minimum-moves-to-reach-target-with-rotations",
    },
    {
      acRate: 47.52019951325829,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1211",
      paidOnly: false,
      title: "Queries Quality and Percentage",
      titleSlug: "queries-quality-and-percentage",
    },
    {
      acRate: 55.79157263793865,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1212",
      paidOnly: true,
      title: "Team Scores in Football Tournament",
      titleSlug: "team-scores-in-football-tournament",
    },
    {
      acRate: 80.09908966406188,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1213",
      paidOnly: true,
      title: "Intersection of Three Sorted Arrays",
      titleSlug: "intersection-of-three-sorted-arrays",
    },
    {
      acRate: 67.36696768415553,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1214",
      paidOnly: true,
      title: "Two Sum BSTs",
      titleSlug: "two-sum-bsts",
    },
    {
      acRate: 47.61514655015474,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1215",
      paidOnly: true,
      title: "Stepping Numbers",
      titleSlug: "stepping-numbers",
    },
    {
      acRate: 49.04610372962131,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1216",
      paidOnly: true,
      title: "Valid Palindrome III",
      titleSlug: "valid-palindrome-iii",
    },
    {
      acRate: 72.2375143665672,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1217",
      paidOnly: false,
      title: "Minimum Cost to Move Chips to The Same Position",
      titleSlug: "minimum-cost-to-move-chips-to-the-same-position",
    },
    {
      acRate: 54.48079804945629,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1218",
      paidOnly: false,
      title: "Longest Arithmetic Subsequence of Given Difference",
      titleSlug: "longest-arithmetic-subsequence-of-given-difference",
    },
    {
      acRate: 68.10386696886998,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1219",
      paidOnly: false,
      title: "Path with Maximum Gold",
      titleSlug: "path-with-maximum-gold",
    },
    {
      acRate: 61.50195090285969,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1220",
      paidOnly: false,
      title: "Count Vowels Permutation",
      titleSlug: "count-vowels-permutation",
    },
    {
      acRate: 86.73505661205051,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1221",
      paidOnly: false,
      title: "Split a String in Balanced Strings",
      titleSlug: "split-a-string-in-balanced-strings",
    },
    {
      acRate: 72.12777077504842,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1222",
      paidOnly: false,
      title: "Queens That Can Attack the King",
      titleSlug: "queens-that-can-attack-the-king",
    },
    {
      acRate: 49.85919646148175,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1223",
      paidOnly: false,
      title: "Dice Roll Simulation",
      titleSlug: "dice-roll-simulation",
    },
    {
      acRate: 37.40202303279766,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1224",
      paidOnly: false,
      title: "Maximum Equal Frequency",
      titleSlug: "maximum-equal-frequency",
    },
    {
      acRate: 57.36296944273246,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1225",
      paidOnly: true,
      title: "Report Contiguous Dates",
      titleSlug: "report-contiguous-dates",
    },
    {
      acRate: 54.547990363889944,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1226",
      paidOnly: false,
      title: "The Dining Philosophers",
      titleSlug: "the-dining-philosophers",
    },
    {
      acRate: 66.6045517449269,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1227",
      paidOnly: false,
      title: "Airplane Seat Assignment Probability",
      titleSlug: "airplane-seat-assignment-probability",
    },
    {
      acRate: 52.064044552732334,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1228",
      paidOnly: true,
      title: "Missing Number In Arithmetic Progression",
      titleSlug: "missing-number-in-arithmetic-progression",
    },
    {
      acRate: 55.241224138030766,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1229",
      paidOnly: true,
      title: "Meeting Scheduler",
      titleSlug: "meeting-scheduler",
    },
    {
      acRate: 58.1448971570811,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1230",
      paidOnly: true,
      title: "Toss Strange Coins",
      titleSlug: "toss-strange-coins",
    },
    {
      acRate: 59.8281316398319,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1231",
      paidOnly: true,
      title: "Divide Chocolate",
      titleSlug: "divide-chocolate",
    },
    {
      acRate: 39.66509445873866,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1232",
      paidOnly: false,
      title: "Check If It Is a Straight Line",
      titleSlug: "check-if-it-is-a-straight-line",
    },
    {
      acRate: 75.71355009563042,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1233",
      paidOnly: false,
      title: "Remove Sub-Folders from the Filesystem",
      titleSlug: "remove-sub-folders-from-the-filesystem",
    },
    {
      acRate: 39.395681490431464,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1234",
      paidOnly: false,
      title: "Replace the Substring for Balanced String",
      titleSlug: "replace-the-substring-for-balanced-string",
    },
    {
      acRate: 54.38300751925128,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1235",
      paidOnly: false,
      title: "Maximum Profit in Job Scheduling",
      titleSlug: "maximum-profit-in-job-scheduling",
    },
    {
      acRate: 68.67127184071515,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1236",
      paidOnly: true,
      title: "Web Crawler",
      titleSlug: "web-crawler",
    },
    {
      acRate: 69.40677730777419,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1237",
      paidOnly: false,
      title: "Find Positive Integer Solution for a Given Equation",
      titleSlug: "find-positive-integer-solution-for-a-given-equation",
    },
    {
      acRate: 71.50744520662539,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1238",
      paidOnly: false,
      title: "Circular Permutation in Binary Representation",
      titleSlug: "circular-permutation-in-binary-representation",
    },
    {
      acRate: 54.2244912890556,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1239",
      paidOnly: false,
      title: "Maximum Length of a Concatenated String with Unique Characters",
      titleSlug:
        "maximum-length-of-a-concatenated-string-with-unique-characters",
    },
    {
      acRate: 54.34327632496881,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1240",
      paidOnly: false,
      title: "Tiling a Rectangle with the Fewest Squares",
      titleSlug: "tiling-a-rectangle-with-the-fewest-squares",
    },
    {
      acRate: 66.09236659487917,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1241",
      paidOnly: true,
      title: "Number of Comments per Post",
      titleSlug: "number-of-comments-per-post",
    },
    {
      acRate: 49.952000000000005,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1242",
      paidOnly: true,
      title: "Web Crawler Multithreaded",
      titleSlug: "web-crawler-multithreaded",
    },
    {
      acRate: 53.03245508131524,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1243",
      paidOnly: true,
      title: "Array Transformation",
      titleSlug: "array-transformation",
    },
    {
      acRate: 67.91476833500552,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1244",
      paidOnly: true,
      title: "Design A Leaderboard",
      titleSlug: "design-a-leaderboard",
    },
    {
      acRate: 61.08226513061821,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1245",
      paidOnly: true,
      title: "Tree Diameter",
      titleSlug: "tree-diameter",
    },
    {
      acRate: 46.34910303868527,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1246",
      paidOnly: true,
      title: "Palindrome Removal",
      titleSlug: "palindrome-removal",
    },
    {
      acRate: 64.60761189655413,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1247",
      paidOnly: false,
      title: "Minimum Swaps to Make Strings Equal",
      titleSlug: "minimum-swaps-to-make-strings-equal",
    },
    {
      acRate: 72.81276433767552,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1248",
      paidOnly: false,
      title: "Count Number of Nice Subarrays",
      titleSlug: "count-number-of-nice-subarrays",
    },
    {
      acRate: 70.57619022264142,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1249",
      paidOnly: false,
      title: "Minimum Remove to Make Valid Parentheses",
      titleSlug: "minimum-remove-to-make-valid-parentheses",
    },
    {
      acRate: 61.00161483996522,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1250",
      paidOnly: false,
      title: "Check If It Is a Good Array",
      titleSlug: "check-if-it-is-a-good-array",
    },
    {
      acRate: 36.81617039999805,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1251",
      paidOnly: false,
      title: "Average Selling Price",
      titleSlug: "average-selling-price",
    },
    {
      acRate: 79.17330555215099,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1252",
      paidOnly: false,
      title: "Cells with Odd Values in a Matrix",
      titleSlug: "cells-with-odd-values-in-a-matrix",
    },
    {
      acRate: 47.58580301138903,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1253",
      paidOnly: false,
      title: "Reconstruct a 2-Row Binary Matrix",
      titleSlug: "reconstruct-a-2-row-binary-matrix",
    },
    {
      acRate: 66.69115800880103,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1254",
      paidOnly: false,
      title: "Number of Closed Islands",
      titleSlug: "number-of-closed-islands",
    },
    {
      acRate: 81.56681428302022,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1255",
      paidOnly: false,
      title: "Maximum Score Words Formed by Letters",
      titleSlug: "maximum-score-words-formed-by-letters",
    },
    {
      acRate: 70.11032241512015,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1256",
      paidOnly: true,
      title: "Encode Number",
      titleSlug: "encode-number",
    },
    {
      acRate: 67.91194394267225,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1257",
      paidOnly: true,
      title: "Smallest Common Region",
      titleSlug: "smallest-common-region",
    },
    {
      acRate: 56.51989299817417,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1258",
      paidOnly: true,
      title: "Synonymous Sentences",
      titleSlug: "synonymous-sentences",
    },
    {
      acRate: 59.989803957918156,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1259",
      paidOnly: true,
      title: "Handshakes That Don't Cross",
      titleSlug: "handshakes-that-dont-cross",
    },
    {
      acRate: 67.60035818170113,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1260",
      paidOnly: false,
      title: "Shift 2D Grid",
      titleSlug: "shift-2d-grid",
    },
    {
      acRate: 83.98035759908889,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1261",
      paidOnly: false,
      title: "Find Elements in a Contaminated Binary Tree",
      titleSlug: "find-elements-in-a-contaminated-binary-tree",
    },
    {
      acRate: 50.804643714971974,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1262",
      paidOnly: false,
      title: "Greatest Sum Divisible by Three",
      titleSlug: "greatest-sum-divisible-by-three",
    },
    {
      acRate: 48.90996347435834,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1263",
      paidOnly: false,
      title: "Minimum Moves to Move a Box to Their Target Location",
      titleSlug: "minimum-moves-to-move-a-box-to-their-target-location",
    },
    {
      acRate: 65.43877941584067,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1264",
      paidOnly: true,
      title: "Page Recommendations",
      titleSlug: "page-recommendations",
    },
    {
      acRate: 94.03953837242118,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1265",
      paidOnly: true,
      title: "Print Immutable Linked List in Reverse",
      titleSlug: "print-immutable-linked-list-in-reverse",
    },
    {
      acRate: 82.52731101793587,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1266",
      paidOnly: false,
      title: "Minimum Time Visiting All Points",
      titleSlug: "minimum-time-visiting-all-points",
    },
    {
      acRate: 73.4626771358695,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1267",
      paidOnly: false,
      title: "Count Servers that Communicate",
      titleSlug: "count-servers-that-communicate",
    },
    {
      acRate: 65.04405506586652,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1268",
      paidOnly: false,
      title: "Search Suggestions System",
      titleSlug: "search-suggestions-system",
    },
    {
      acRate: 50.078697226565716,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1269",
      paidOnly: false,
      title: "Number of Ways to Stay in the Same Place After Some Steps",
      titleSlug: "number-of-ways-to-stay-in-the-same-place-after-some-steps",
    },
    {
      acRate: 84.4489740453866,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1270",
      paidOnly: true,
      title: "All People Report to the Given Manager",
      titleSlug: "all-people-report-to-the-given-manager",
    },
    {
      acRate: 58.34171094834601,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1271",
      paidOnly: true,
      title: "Hexspeak",
      titleSlug: "hexspeak",
    },
    {
      acRate: 66.70081623055995,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1272",
      paidOnly: true,
      title: "Remove Interval",
      titleSlug: "remove-interval",
    },
    {
      acRate: 61.2624176805447,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1273",
      paidOnly: true,
      title: "Delete Tree Nodes",
      titleSlug: "delete-tree-nodes",
    },
    {
      acRate: 68.8066098175231,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1274",
      paidOnly: true,
      title: "Number of Ships in a Rectangle",
      titleSlug: "number-of-ships-in-a-rectangle",
    },
    {
      acRate: 54.1313981949731,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1275",
      paidOnly: false,
      title: "Find Winner on a Tic Tac Toe Game",
      titleSlug: "find-winner-on-a-tic-tac-toe-game",
    },
    {
      acRate: 50.339881084212145,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1276",
      paidOnly: false,
      title: "Number of Burgers with No Waste of Ingredients",
      titleSlug: "number-of-burgers-with-no-waste-of-ingredients",
    },
    {
      acRate: 78.60844536390621,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1277",
      paidOnly: false,
      title: "Count Square Submatrices with All Ones",
      titleSlug: "count-square-submatrices-with-all-ones",
    },
    {
      acRate: 61.48653702318624,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1278",
      paidOnly: false,
      title: "Palindrome Partitioning III",
      titleSlug: "palindrome-partitioning-iii",
    },
    {
      acRate: 72.90950264195253,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1279",
      paidOnly: true,
      title: "Traffic Light Controlled Intersection",
      titleSlug: "traffic-light-controlled-intersection",
    },
    {
      acRate: 60.43842891142397,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1280",
      paidOnly: false,
      title: "Students and Examinations",
      titleSlug: "students-and-examinations",
    },
    {
      acRate: 86.66709681978581,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1281",
      paidOnly: false,
      title: "Subtract the Product and Sum of Digits of an Integer",
      titleSlug: "subtract-the-product-and-sum-of-digits-of-an-integer",
    },
    {
      acRate: 87.38013536314861,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1282",
      paidOnly: false,
      title: "Group the People Given the Group Size They Belong To",
      titleSlug: "group-the-people-given-the-group-size-they-belong-to",
    },
    {
      acRate: 63.136035658614695,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1283",
      paidOnly: false,
      title: "Find the Smallest Divisor Given a Threshold",
      titleSlug: "find-the-smallest-divisor-given-a-threshold",
    },
    {
      acRate: 71.88911016030129,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1284",
      paidOnly: false,
      title: "Minimum Number of Flips to Convert Binary Matrix to Zero Matrix",
      titleSlug:
        "minimum-number-of-flips-to-convert-binary-matrix-to-zero-matrix",
    },
    {
      acRate: 81.88530064804954,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1285",
      paidOnly: true,
      title: "Find the Start and End Number of Continuous Ranges",
      titleSlug: "find-the-start-and-end-number-of-continuous-ranges",
    },
    {
      acRate: 72.39316714889829,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1286",
      paidOnly: false,
      title: "Iterator for Combination",
      titleSlug: "iterator-for-combination",
    },
    {
      acRate: 61.04635646023876,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1287",
      paidOnly: false,
      title: "Element Appearing More Than 25% In Sorted Array",
      titleSlug: "element-appearing-more-than-25-in-sorted-array",
    },
    {
      acRate: 56.17677971750109,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1288",
      paidOnly: false,
      title: "Remove Covered Intervals",
      titleSlug: "remove-covered-intervals",
    },
    {
      acRate: 63.93072794364307,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1289",
      paidOnly: false,
      title: "Minimum Falling Path Sum II",
      titleSlug: "minimum-falling-path-sum-ii",
    },
    {
      acRate: 81.177328847358,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1290",
      paidOnly: false,
      title: "Convert Binary Number in a Linked List to Integer",
      titleSlug: "convert-binary-number-in-a-linked-list-to-integer",
    },
    {
      acRate: 65.26325145072136,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1291",
      paidOnly: false,
      title: "Sequential Digits",
      titleSlug: "sequential-digits",
    },
    {
      acRate: 53.44409184244914,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1292",
      paidOnly: false,
      title:
        "Maximum Side Length of a Square with Sum Less than or Equal to Threshold",
      titleSlug:
        "maximum-side-length-of-a-square-with-sum-less-than-or-equal-to-threshold",
    },
    {
      acRate: 45.5224349993996,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1293",
      paidOnly: false,
      title: "Shortest Path in a Grid with Obstacles Elimination",
      titleSlug: "shortest-path-in-a-grid-with-obstacles-elimination",
    },
    {
      acRate: 67.04187583798448,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1294",
      paidOnly: true,
      title: "Weather Type in Each Country",
      titleSlug: "weather-type-in-each-country",
    },
    {
      acRate: 79.33871662899396,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1295",
      paidOnly: false,
      title: "Find Numbers with Even Number of Digits",
      titleSlug: "find-numbers-with-even-number-of-digits",
    },
    {
      acRate: 58.61696151277784,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1296",
      paidOnly: false,
      title: "Divide Array in Sets of K Consecutive Numbers",
      titleSlug: "divide-array-in-sets-of-k-consecutive-numbers",
    },
    {
      acRate: 53.212567007797276,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1297",
      paidOnly: false,
      title: "Maximum Number of Occurrences of a Substring",
      titleSlug: "maximum-number-of-occurrences-of-a-substring",
    },
    {
      acRate: 57.47235730392024,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1298",
      paidOnly: false,
      title: "Maximum Candies You Can Get from Boxes",
      titleSlug: "maximum-candies-you-can-get-from-boxes",
    },
    {
      acRate: 71.40137225768328,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1299",
      paidOnly: false,
      title: "Replace Elements with Greatest Element on Right Side",
      titleSlug: "replace-elements-with-greatest-element-on-right-side",
    },
    {
      acRate: 45.15219666898132,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1300",
      paidOnly: false,
      title: "Sum of Mutated Array Closest to Target",
      titleSlug: "sum-of-mutated-array-closest-to-target",
    },
    {
      acRate: 40.80965296965702,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1301",
      paidOnly: false,
      title: "Number of Paths with Max Score",
      titleSlug: "number-of-paths-with-max-score",
    },
    {
      acRate: 86.3128119411359,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1302",
      paidOnly: false,
      title: "Deepest Leaves Sum",
      titleSlug: "deepest-leaves-sum",
    },
    {
      acRate: 89.68439951966236,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1303",
      paidOnly: true,
      title: "Find the Team Size",
      titleSlug: "find-the-team-size",
    },
    {
      acRate: 76.14554366781354,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1304",
      paidOnly: false,
      title: "Find N Unique Integers Sum up to Zero",
      titleSlug: "find-n-unique-integers-sum-up-to-zero",
    },
    {
      acRate: 79.98762065677435,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1305",
      paidOnly: false,
      title: "All Elements in Two Binary Search Trees",
      titleSlug: "all-elements-in-two-binary-search-trees",
    },
    {
      acRate: 65.93193644900418,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1306",
      paidOnly: false,
      title: "Jump Game III",
      titleSlug: "jump-game-iii",
    },
    {
      acRate: 34.69221988057605,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1307",
      paidOnly: false,
      title: "Verbal Arithmetic Puzzle",
      titleSlug: "verbal-arithmetic-puzzle",
    },
    {
      acRate: 86.3725547331818,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1308",
      paidOnly: true,
      title: "Running Total for Different Genders",
      titleSlug: "running-total-for-different-genders",
    },
    {
      acRate: 80.14091964322078,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1309",
      paidOnly: false,
      title: "Decrypt String from Alphabet to Integer Mapping",
      titleSlug: "decrypt-string-from-alphabet-to-integer-mapping",
    },
    {
      acRate: 78.42207951822037,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1310",
      paidOnly: false,
      title: "XOR Queries of a Subarray",
      titleSlug: "xor-queries-of-a-subarray",
    },
    {
      acRate: 49.448881157586776,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1311",
      paidOnly: false,
      title: "Get Watched Videos by Your Friends",
      titleSlug: "get-watched-videos-by-your-friends",
    },
    {
      acRate: 72.11466212493112,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1312",
      paidOnly: false,
      title: "Minimum Insertion Steps to Make a String Palindrome",
      titleSlug: "minimum-insertion-steps-to-make-a-string-palindrome",
    },
    {
      acRate: 86.00011957789005,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1313",
      paidOnly: false,
      title: "Decompress Run-Length Encoded List",
      titleSlug: "decompress-run-length-encoded-list",
    },
    {
      acRate: 75.8512184562098,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1314",
      paidOnly: false,
      title: "Matrix Block Sum",
      titleSlug: "matrix-block-sum",
    },
    {
      acRate: 85.66797869877286,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1315",
      paidOnly: false,
      title: "Sum of Nodes with Even-Valued Grandparent",
      titleSlug: "sum-of-nodes-with-even-valued-grandparent",
    },
    {
      acRate: 51.844316440310735,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1316",
      paidOnly: false,
      title: "Distinct Echo Substrings",
      titleSlug: "distinct-echo-substrings",
    },
    {
      acRate: 54.15933747254523,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1317",
      paidOnly: false,
      title: "Convert Integer to the Sum of Two No-Zero Integers",
      titleSlug: "convert-integer-to-the-sum-of-two-no-zero-integers",
    },
    {
      acRate: 71.57431913258773,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1318",
      paidOnly: false,
      title: "Minimum Flips to Make a OR b Equal to c",
      titleSlug: "minimum-flips-to-make-a-or-b-equal-to-c",
    },
    {
      acRate: 64.34627709795495,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1319",
      paidOnly: false,
      title: "Number of Operations to Make Network Connected",
      titleSlug: "number-of-operations-to-make-network-connected",
    },
    {
      acRate: 59.064841912946385,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1320",
      paidOnly: false,
      title: "Minimum Distance to Type a Word Using Two Fingers",
      titleSlug: "minimum-distance-to-type-a-word-using-two-fingers",
    },
    {
      acRate: 56.27165604890811,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1321",
      paidOnly: false,
      title: "Restaurant Growth",
      titleSlug: "restaurant-growth",
    },
    {
      acRate: 59.27312775330397,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1322",
      paidOnly: true,
      title: "Ads Performance",
      titleSlug: "ads-performance",
    },
    {
      acRate: 81.70217167620302,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1323",
      paidOnly: false,
      title: "Maximum 69 Number",
      titleSlug: "maximum-69-number",
    },
    {
      acRate: 66.04306637056195,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1324",
      paidOnly: false,
      title: "Print Words Vertically",
      titleSlug: "print-words-vertically",
    },
    {
      acRate: 77.28009158526869,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1325",
      paidOnly: false,
      title: "Delete Leaves With a Given Value",
      titleSlug: "delete-leaves-with-a-given-value",
    },
    {
      acRate: 50.70700034127411,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1326",
      paidOnly: false,
      title: "Minimum Number of Taps to Open to Water a Garden",
      titleSlug: "minimum-number-of-taps-to-open-to-water-a-garden",
    },
    {
      acRate: 71.84735163760631,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1327",
      paidOnly: false,
      title: "List the Products Ordered in a Period",
      titleSlug: "list-the-products-ordered-in-a-period",
    },
    {
      acRate: 51.52160707474537,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1328",
      paidOnly: false,
      title: "Break a Palindrome",
      titleSlug: "break-a-palindrome",
    },
    {
      acRate: 82.95727004070405,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1329",
      paidOnly: false,
      title: "Sort the Matrix Diagonally",
      titleSlug: "sort-the-matrix-diagonally",
    },
    {
      acRate: 42.210409486535426,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1330",
      paidOnly: false,
      title: "Reverse Subarray To Maximize Array Value",
      titleSlug: "reverse-subarray-to-maximize-array-value",
    },
    {
      acRate: 70.63885567215362,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1331",
      paidOnly: false,
      title: "Rank Transform of an Array",
      titleSlug: "rank-transform-of-an-array",
    },
    {
      acRate: 76.60790014135972,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1332",
      paidOnly: false,
      title: "Remove Palindromic Subsequences",
      titleSlug: "remove-palindromic-subsequences",
    },
    {
      acRate: 63.105642300800824,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1333",
      paidOnly: false,
      title: "Filter Restaurants by Vegan-Friendly, Price and Distance",
      titleSlug: "filter-restaurants-by-vegan-friendly-price-and-distance",
    },
    {
      acRate: 69.7726320493841,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1334",
      paidOnly: false,
      title:
        "Find the City With the Smallest Number of Neighbors at a Threshold Distance",
      titleSlug:
        "find-the-city-with-the-smallest-number-of-neighbors-at-a-threshold-distance",
    },
    {
      acRate: 59.64513142444223,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1335",
      paidOnly: false,
      title: "Minimum Difficulty of a Job Schedule",
      titleSlug: "minimum-difficulty-of-a-job-schedule",
    },
    {
      acRate: 48.240262787423745,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1336",
      paidOnly: true,
      title: "Number of Transactions per Visit",
      titleSlug: "number-of-transactions-per-visit",
    },
    {
      acRate: 73.9236664732318,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1337",
      paidOnly: false,
      title: "The K Weakest Rows in a Matrix",
      titleSlug: "the-k-weakest-rows-in-a-matrix",
    },
    {
      acRate: 69.08905537165018,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1338",
      paidOnly: false,
      title: "Reduce Array Size to The Half",
      titleSlug: "reduce-array-size-to-the-half",
    },
    {
      acRate: 47.86721787239902,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1339",
      paidOnly: false,
      title: "Maximum Product of Splitted Binary Tree",
      titleSlug: "maximum-product-of-splitted-binary-tree",
    },
    {
      acRate: 63.97888168946484,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1340",
      paidOnly: false,
      title: "Jump Game V",
      titleSlug: "jump-game-v",
    },
    {
      acRate: 41.37676861450651,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1341",
      paidOnly: false,
      title: "Movie Rating",
      titleSlug: "movie-rating",
    },
    {
      acRate: 85.59253901080649,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1342",
      paidOnly: false,
      title: "Number of Steps to Reduce a Number to Zero",
      titleSlug: "number-of-steps-to-reduce-a-number-to-zero",
    },
    {
      acRate: 70.06155370029715,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1343",
      paidOnly: false,
      title:
        "Number of Sub-arrays of Size K and Average Greater than or Equal to Threshold",
      titleSlug:
        "number-of-sub-arrays-of-size-k-and-average-greater-than-or-equal-to-threshold",
    },
    {
      acRate: 64.14360938247967,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1344",
      paidOnly: false,
      title: "Angle Between Hands of a Clock",
      titleSlug: "angle-between-hands-of-a-clock",
    },
    {
      acRate: 46.0628201445737,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1345",
      paidOnly: false,
      title: "Jump Game IV",
      titleSlug: "jump-game-iv",
    },
    {
      acRate: 41.1978046973021,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1346",
      paidOnly: false,
      title: "Check If N and Its Double Exist",
      titleSlug: "check-if-n-and-its-double-exist",
    },
    {
      acRate: 82.12433089049964,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1347",
      paidOnly: false,
      title: "Minimum Number of Steps to Make Two Strings Anagram",
      titleSlug: "minimum-number-of-steps-to-make-two-strings-anagram",
    },
    {
      acRate: 45.19169067780616,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1348",
      paidOnly: false,
      title: "Tweet Counts Per Frequency",
      titleSlug: "tweet-counts-per-frequency",
    },
    {
      acRate: 52.03396106644097,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1349",
      paidOnly: false,
      title: "Maximum Students Taking Exam",
      titleSlug: "maximum-students-taking-exam",
    },
    {
      acRate: 89.90988393050249,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1350",
      paidOnly: true,
      title: "Students With Invalid Departments",
      titleSlug: "students-with-invalid-departments",
    },
    {
      acRate: 77.63998334294317,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1351",
      paidOnly: false,
      title: "Count Negative Numbers in a Sorted Matrix",
      titleSlug: "count-negative-numbers-in-a-sorted-matrix",
    },
    {
      acRate: 62.730620723051246,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1352",
      paidOnly: false,
      title: "Product of the Last K Numbers",
      titleSlug: "product-of-the-last-k-numbers",
    },
    {
      acRate: 32.870436694550506,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1353",
      paidOnly: false,
      title: "Maximum Number of Events That Can Be Attended",
      titleSlug: "maximum-number-of-events-that-can-be-attended",
    },
    {
      acRate: 36.24893944631242,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1354",
      paidOnly: false,
      title: "Construct Target Array With Multiple Sums",
      titleSlug: "construct-target-array-with-multiple-sums",
    },
    {
      acRate: 72.33967427285167,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1355",
      paidOnly: true,
      title: "Activity Participants",
      titleSlug: "activity-participants",
    },
    {
      acRate: 78.62142952081369,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1356",
      paidOnly: false,
      title: "Sort Integers by The Number of 1 Bits",
      titleSlug: "sort-integers-by-the-number-of-1-bits",
    },
    {
      acRate: 64.09703373400542,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1357",
      paidOnly: false,
      title: "Apply Discount Every n Orders",
      titleSlug: "apply-discount-every-n-orders",
    },
    {
      acRate: 73.06986186603919,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1358",
      paidOnly: false,
      title: "Number of Substrings Containing All Three Characters",
      titleSlug: "number-of-substrings-containing-all-three-characters",
    },
    {
      acRate: 64.87200396219902,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1359",
      paidOnly: false,
      title: "Count All Valid Pickup and Delivery Options",
      titleSlug: "count-all-valid-pickup-and-delivery-options",
    },
    {
      acRate: 51.183942925396266,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1360",
      paidOnly: false,
      title: "Number of Days Between Two Dates",
      titleSlug: "number-of-days-between-two-dates",
    },
    {
      acRate: 43.869045743671606,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1361",
      paidOnly: false,
      title: "Validate Binary Tree Nodes",
      titleSlug: "validate-binary-tree-nodes",
    },
    {
      acRate: 61.199571581578006,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1362",
      paidOnly: false,
      title: "Closest Divisors",
      titleSlug: "closest-divisors",
    },
    {
      acRate: 32.72085783465929,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1363",
      paidOnly: false,
      title: "Largest Multiple of Three",
      titleSlug: "largest-multiple-of-three",
    },
    {
      acRate: 75.31885213232363,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1364",
      paidOnly: true,
      title: "Number of Trusted Contacts of a Customer",
      titleSlug: "number-of-trusted-contacts-of-a-customer",
    },
    {
      acRate: 87.09673197310609,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1365",
      paidOnly: false,
      title: "How Many Numbers Are Smaller Than the Current Number",
      titleSlug: "how-many-numbers-are-smaller-than-the-current-number",
    },
    {
      acRate: 59.27504640918999,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1366",
      paidOnly: false,
      title: "Rank Teams by Votes",
      titleSlug: "rank-teams-by-votes",
    },
    {
      acRate: 51.911224920830236,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1367",
      paidOnly: false,
      title: "Linked List in Binary Tree",
      titleSlug: "linked-list-in-binary-tree",
    },
    {
      acRate: 70.6873045151977,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1368",
      paidOnly: false,
      title: "Minimum Cost to Make at Least One Valid Path in a Grid",
      titleSlug: "minimum-cost-to-make-at-least-one-valid-path-in-a-grid",
    },
    {
      acRate: 67.52256545383192,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1369",
      paidOnly: true,
      title: "Get the Second Most Recent Activity",
      titleSlug: "get-the-second-most-recent-activity",
    },
    {
      acRate: 76.65535024749268,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1370",
      paidOnly: false,
      title: "Increasing Decreasing String",
      titleSlug: "increasing-decreasing-string",
    },
    {
      acRate: 75.77939137003754,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1371",
      paidOnly: false,
      title: "Find the Longest Substring Containing Vowels in Even Counts",
      titleSlug: "find-the-longest-substring-containing-vowels-in-even-counts",
    },
    {
      acRate: 66.54265551224411,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1372",
      paidOnly: false,
      title: "Longest ZigZag Path in a Binary Tree",
      titleSlug: "longest-zigzag-path-in-a-binary-tree",
    },
    {
      acRate: 43.88476469386365,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1373",
      paidOnly: false,
      title: "Maximum Sum BST in Binary Tree",
      titleSlug: "maximum-sum-bst-in-binary-tree",
    },
    {
      acRate: 78.0236724295898,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1374",
      paidOnly: false,
      title: "Generate a String With Characters That Have Odd Counts",
      titleSlug: "generate-a-string-with-characters-that-have-odd-counts",
    },
    {
      acRate: 65.73270374742495,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1375",
      paidOnly: false,
      title: "Number of Times Binary String Is Prefix-Aligned",
      titleSlug: "number-of-times-binary-string-is-prefix-aligned",
    },
    {
      acRate: 60.200184314208016,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1376",
      paidOnly: false,
      title: "Time Needed to Inform All Employees",
      titleSlug: "time-needed-to-inform-all-employees",
    },
    {
      acRate: 35.81615513818904,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1377",
      paidOnly: false,
      title: "Frog Position After T Seconds",
      titleSlug: "frog-position-after-t-seconds",
    },
    {
      acRate: 83.6221468416959,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1378",
      paidOnly: false,
      title: "Replace Employee ID With The Unique Identifier",
      titleSlug: "replace-employee-id-with-the-unique-identifier",
    },
    {
      acRate: 85.69609071673618,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1379",
      paidOnly: false,
      title:
        "Find a Corresponding Node of a Binary Tree in a Clone of That Tree",
      titleSlug:
        "find-a-corresponding-node-of-a-binary-tree-in-a-clone-of-that-tree",
    },
    {
      acRate: 79.87757616124345,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1380",
      paidOnly: false,
      title: "Lucky Numbers in a Matrix",
      titleSlug: "lucky-numbers-in-a-matrix",
    },
    {
      acRate: 80.12297272022872,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1381",
      paidOnly: false,
      title: "Design a Stack With Increment Operation",
      titleSlug: "design-a-stack-with-increment-operation",
    },
    {
      acRate: 84.62442375485854,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1382",
      paidOnly: false,
      title: "Balance a Binary Search Tree",
      titleSlug: "balance-a-binary-search-tree",
    },
    {
      acRate: 47.519325237804225,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1383",
      paidOnly: false,
      title: "Maximum Performance of a Team",
      titleSlug: "maximum-performance-of-a-team",
    },
    {
      acRate: 61.41307941545989,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1384",
      paidOnly: true,
      title: "Total Sales Amount by Year",
      titleSlug: "total-sales-amount-by-year",
    },
    {
      acRate: 70.03531649008423,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1385",
      paidOnly: false,
      title: "Find the Distance Value Between Two Arrays",
      titleSlug: "find-the-distance-value-between-two-arrays",
    },
    {
      acRate: 42.67370190511767,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1386",
      paidOnly: false,
      title: "Cinema Seat Allocation",
      titleSlug: "cinema-seat-allocation",
    },
    {
      acRate: 70.67983041685932,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1387",
      paidOnly: false,
      title: "Sort Integers by The Power Value",
      titleSlug: "sort-integers-by-the-power-value",
    },
    {
      acRate: 52.80449385761672,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1388",
      paidOnly: false,
      title: "Pizza With 3n Slices",
      titleSlug: "pizza-with-3n-slices",
    },
    {
      acRate: 86.19941710913012,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1389",
      paidOnly: false,
      title: "Create Target Array in the Given Order",
      titleSlug: "create-target-array-in-the-given-order",
    },
    {
      acRate: 44.58638869158972,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1390",
      paidOnly: false,
      title: "Four Divisors",
      titleSlug: "four-divisors",
    },
    {
      acRate: 48.76861690466099,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1391",
      paidOnly: false,
      title: "Check if There is a Valid Path in a Grid",
      titleSlug: "check-if-there-is-a-valid-path-in-a-grid",
    },
    {
      acRate: 48.74821066443994,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1392",
      paidOnly: false,
      title: "Longest Happy Prefix",
      titleSlug: "longest-happy-prefix",
    },
    {
      acRate: 84.94660005759431,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1393",
      paidOnly: false,
      title: "Capital Gain/Loss",
      titleSlug: "capital-gainloss",
    },
    {
      acRate: 69.11991696232434,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1394",
      paidOnly: false,
      title: "Find Lucky Integer in an Array",
      titleSlug: "find-lucky-integer-in-an-array",
    },
    {
      acRate: 70.0878585794432,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1395",
      paidOnly: false,
      title: "Count Number of Teams",
      titleSlug: "count-number-of-teams",
    },
    {
      acRate: 73.9889500123872,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1396",
      paidOnly: false,
      title: "Design Underground System",
      titleSlug: "design-underground-system",
    },
    {
      acRate: 43.49568941848334,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1397",
      paidOnly: false,
      title: "Find All Good Strings",
      titleSlug: "find-all-good-strings",
    },
    {
      acRate: 72.01929067540439,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1398",
      paidOnly: true,
      title: "Customers Who Bought Products A and B but Not C",
      titleSlug: "customers-who-bought-products-a-and-b-but-not-c",
    },
    {
      acRate: 75.10802835380461,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1399",
      paidOnly: false,
      title: "Count Largest Group",
      titleSlug: "count-largest-group",
    },
    {
      acRate: 68.70872510708008,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1400",
      paidOnly: false,
      title: "Construct K Palindrome Strings",
      titleSlug: "construct-k-palindrome-strings",
    },
    {
      acRate: 48.68973930330276,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1401",
      paidOnly: false,
      title: "Circle and Rectangle Overlapping",
      titleSlug: "circle-and-rectangle-overlapping",
    },
    {
      acRate: 76.30785494323666,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1402",
      paidOnly: false,
      title: "Reducing Dishes",
      titleSlug: "reducing-dishes",
    },
    {
      acRate: 72.8607531857336,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1403",
      paidOnly: false,
      title: "Minimum Subsequence in Non-Increasing Order",
      titleSlug: "minimum-subsequence-in-non-increasing-order",
    },
    {
      acRate: 61.38380276019776,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1404",
      paidOnly: false,
      title:
        "Number of Steps to Reduce a Number in Binary Representation to One",
      titleSlug:
        "number-of-steps-to-reduce-a-number-in-binary-representation-to-one",
    },
    {
      acRate: 65.4549446516231,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1405",
      paidOnly: false,
      title: "Longest Happy String",
      titleSlug: "longest-happy-string",
    },
    {
      acRate: 63.20688410614896,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1406",
      paidOnly: false,
      title: "Stone Game III",
      titleSlug: "stone-game-iii",
    },
    {
      acRate: 57.10645805218174,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1407",
      paidOnly: false,
      title: "Top Travellers",
      titleSlug: "top-travellers",
    },
    {
      acRate: 69.84325294753751,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1408",
      paidOnly: false,
      title: "String Matching in an Array",
      titleSlug: "string-matching-in-an-array",
    },
    {
      acRate: 84.49897624582417,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1409",
      paidOnly: false,
      title: "Queries on a Permutation With Key",
      titleSlug: "queries-on-a-permutation-with-key",
    },
    {
      acRate: 50.22585312488972,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1410",
      paidOnly: false,
      title: "HTML Entity Parser",
      titleSlug: "html-entity-parser",
    },
    {
      acRate: 64.24157017216204,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1411",
      paidOnly: false,
      title: "Number of Ways to Paint N × 3 Grid",
      titleSlug: "number-of-ways-to-paint-n-3-grid",
    },
    {
      acRate: 58.427275226835306,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1412",
      paidOnly: true,
      title: "Find the Quiet Students in All Exams",
      titleSlug: "find-the-quiet-students-in-all-exams",
    },
    {
      acRate: 64.78781276405562,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1413",
      paidOnly: false,
      title: "Minimum Value to Get Positive Step by Step Sum",
      titleSlug: "minimum-value-to-get-positive-step-by-step-sum",
    },
    {
      acRate: 64.30041013917838,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1414",
      paidOnly: false,
      title: "Find the Minimum Number of Fibonacci Numbers Whose Sum Is K",
      titleSlug: "find-the-minimum-number-of-fibonacci-numbers-whose-sum-is-k",
    },
    {
      acRate: 85.09921935522317,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1415",
      paidOnly: false,
      title: "The k-th Lexicographical String of All Happy Strings of Length n",
      titleSlug:
        "the-k-th-lexicographical-string-of-all-happy-strings-of-length-n",
    },
    {
      acRate: 46.98233016334585,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1416",
      paidOnly: false,
      title: "Restore The Array",
      titleSlug: "restore-the-array",
    },
    {
      acRate: 52.06188852417222,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1417",
      paidOnly: false,
      title: "Reformat The String",
      titleSlug: "reformat-the-string",
    },
    {
      acRate: 75.59090601834119,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1418",
      paidOnly: false,
      title: "Display Table of Food Orders in a Restaurant",
      titleSlug: "display-table-of-food-orders-in-a-restaurant",
    },
    {
      acRate: 50.73188808597369,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1419",
      paidOnly: false,
      title: "Minimum Number of Frogs Croaking",
      titleSlug: "minimum-number-of-frogs-croaking",
    },
    {
      acRate: 66.89945094341476,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1420",
      paidOnly: false,
      title: "Build Array Where You Can Find The Maximum Exactly K Comparisons",
      titleSlug:
        "build-array-where-you-can-find-the-maximum-exactly-k-comparisons",
    },
    {
      acRate: 83.0088744893647,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1421",
      paidOnly: true,
      title: "NPV Queries",
      titleSlug: "npv-queries",
    },
    {
      acRate: 65.16942181061533,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1422",
      paidOnly: false,
      title: "Maximum Score After Splitting a String",
      titleSlug: "maximum-score-after-splitting-a-string",
    },
    {
      acRate: 55.27813767606817,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1423",
      paidOnly: false,
      title: "Maximum Points You Can Obtain from Cards",
      titleSlug: "maximum-points-you-can-obtain-from-cards",
    },
    {
      acRate: 57.92559852147725,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1424",
      paidOnly: false,
      title: "Diagonal Traverse II",
      titleSlug: "diagonal-traverse-ii",
    },
    {
      acRate: 56.399081650359726,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1425",
      paidOnly: false,
      title: "Constrained Subsequence Sum",
      titleSlug: "constrained-subsequence-sum",
    },
    {
      acRate: 60.41256370170345,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1426",
      paidOnly: true,
      title: "Counting Elements",
      titleSlug: "counting-elements",
    },
    {
      acRate: 55.81878890913761,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1427",
      paidOnly: true,
      title: "Perform String Shifts",
      titleSlug: "perform-string-shifts",
    },
    {
      acRate: 54.91456896157888,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1428",
      paidOnly: true,
      title: "Leftmost Column with at Least a One",
      titleSlug: "leftmost-column-with-at-least-a-one",
    },
    {
      acRate: 55.20257536788924,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1429",
      paidOnly: true,
      title: "First Unique Number",
      titleSlug: "first-unique-number",
    },
    {
      acRate: 47.25669767730974,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1430",
      paidOnly: true,
      title:
        "Check If a String Is a Valid Sequence from Root to Leaves Path in a Binary Tree",
      titleSlug:
        "check-if-a-string-is-a-valid-sequence-from-root-to-leaves-path-in-a-binary-tree",
    },
    {
      acRate: 88.08866093810668,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1431",
      paidOnly: false,
      title: "Kids With the Greatest Number of Candies",
      titleSlug: "kids-with-the-greatest-number-of-candies",
    },
    {
      acRate: 40.22411128284389,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1432",
      paidOnly: false,
      title: "Max Difference You Can Get From Changing an Integer",
      titleSlug: "max-difference-you-can-get-from-changing-an-integer",
    },
    {
      acRate: 70.18508603099721,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1433",
      paidOnly: false,
      title: "Check If a String Can Break Another String",
      titleSlug: "check-if-a-string-can-break-another-string",
    },
    {
      acRate: 44.21775578224422,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1434",
      paidOnly: false,
      title: "Number of Ways to Wear Different Hats to Each Other",
      titleSlug: "number-of-ways-to-wear-different-hats-to-each-other",
    },
    {
      acRate: 74.98963945296312,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1435",
      paidOnly: true,
      title: "Create a Session Bar Chart",
      titleSlug: "create-a-session-bar-chart",
    },
    {
      acRate: 79.43073553086485,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1436",
      paidOnly: false,
      title: "Destination City",
      titleSlug: "destination-city",
    },
    {
      acRate: 58.03543487958665,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1437",
      paidOnly: false,
      title: "Check If All 1's Are at Least Length K Places Away",
      titleSlug: "check-if-all-1s-are-at-least-length-k-places-away",
    },
    {
      acRate: 56.67915663958023,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1438",
      paidOnly: false,
      title:
        "Longest Continuous Subarray With Absolute Diff Less Than or Equal to Limit",
      titleSlug:
        "longest-continuous-subarray-with-absolute-diff-less-than-or-equal-to-limit",
    },
    {
      acRate: 61.87321566586223,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1439",
      paidOnly: false,
      title: "Find the Kth Smallest Sum of a Matrix With Sorted Rows",
      titleSlug: "find-the-kth-smallest-sum-of-a-matrix-with-sorted-rows",
    },
    {
      acRate: 72.16543708527388,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1440",
      paidOnly: true,
      title: "Evaluate Boolean Expression",
      titleSlug: "evaluate-boolean-expression",
    },
    {
      acRate: 80.1595540261771,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1441",
      paidOnly: false,
      title: "Build an Array With Stack Operations",
      titleSlug: "build-an-array-with-stack-operations",
    },
    {
      acRate: 84.79861164085743,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1442",
      paidOnly: false,
      title: "Count Triplets That Can Form Two Arrays of Equal XOR",
      titleSlug: "count-triplets-that-can-form-two-arrays-of-equal-xor",
    },
    {
      acRate: 62.90549127148686,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1443",
      paidOnly: false,
      title: "Minimum Time to Collect All Apples in a Tree",
      titleSlug: "minimum-time-to-collect-all-apples-in-a-tree",
    },
    {
      acRate: 61.614560699404386,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1444",
      paidOnly: false,
      title: "Number of Ways of Cutting a Pizza",
      titleSlug: "number-of-ways-of-cutting-a-pizza",
    },
    {
      acRate: 86.07739640961951,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1445",
      paidOnly: true,
      title: "Apples & Oranges",
      titleSlug: "apples-oranges",
    },
    {
      acRate: 60.10535428139907,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1446",
      paidOnly: false,
      title: "Consecutive Characters",
      titleSlug: "consecutive-characters",
    },
    {
      acRate: 68.14439078622799,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1447",
      paidOnly: false,
      title: "Simplified Fractions",
      titleSlug: "simplified-fractions",
    },
    {
      acRate: 73.41509619180296,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1448",
      paidOnly: false,
      title: "Count Good Nodes in Binary Tree",
      titleSlug: "count-good-nodes-in-binary-tree",
    },
    {
      acRate: 48.594787940725595,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1449",
      paidOnly: false,
      title: "Form Largest Integer With Digits That Add up to Target",
      titleSlug: "form-largest-integer-with-digits-that-add-up-to-target",
    },
    {
      acRate: 75.64421773953663,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1450",
      paidOnly: false,
      title: "Number of Students Doing Homework at a Given Time",
      titleSlug: "number-of-students-doing-homework-at-a-given-time",
    },
    {
      acRate: 65.7021247770226,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1451",
      paidOnly: false,
      title: "Rearrange Words in a Sentence",
      titleSlug: "rearrange-words-in-a-sentence",
    },
    {
      acRate: 59.13993068329235,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1452",
      paidOnly: false,
      title:
        "People Whose List of Favorite Companies Is Not a Subset of Another List",
      titleSlug:
        "people-whose-list-of-favorite-companies-is-not-a-subset-of-another-list",
    },
    {
      acRate: 37.97976637463496,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1453",
      paidOnly: false,
      title: "Maximum Number of Darts Inside of a Circular Dartboard",
      titleSlug: "maximum-number-of-darts-inside-of-a-circular-dartboard",
    },
    {
      acRate: 36.599602479054674,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1454",
      paidOnly: true,
      title: "Active Users",
      titleSlug: "active-users",
    },
    {
      acRate: 68.67660677903315,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1455",
      paidOnly: false,
      title: "Check If a Word Occurs As a Prefix of Any Word in a Sentence",
      titleSlug: "check-if-a-word-occurs-as-a-prefix-of-any-word-in-a-sentence",
    },
    {
      acRate: 60.17326188354302,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1456",
      paidOnly: false,
      title: "Maximum Number of Vowels in a Substring of Given Length",
      titleSlug: "maximum-number-of-vowels-in-a-substring-of-given-length",
    },
    {
      acRate: 68.31649326897131,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1457",
      paidOnly: false,
      title: "Pseudo-Palindromic Paths in a Binary Tree",
      titleSlug: "pseudo-palindromic-paths-in-a-binary-tree",
    },
    {
      acRate: 62.32801822323463,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1458",
      paidOnly: false,
      title: "Max Dot Product of Two Subsequences",
      titleSlug: "max-dot-product-of-two-subsequences",
    },
    {
      acRate: 68.7192566952086,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1459",
      paidOnly: true,
      title: "Rectangles Area",
      titleSlug: "rectangles-area",
    },
    {
      acRate: 75.81480185418654,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1460",
      paidOnly: false,
      title: "Make Two Arrays Equal by Reversing Subarrays",
      titleSlug: "make-two-arrays-equal-by-reversing-subarrays",
    },
    {
      acRate: 56.608061236694176,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1461",
      paidOnly: false,
      title: "Check If a String Contains All Binary Codes of Size K",
      titleSlug: "check-if-a-string-contains-all-binary-codes-of-size-k",
    },
    {
      acRate: 59.55203815545917,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1462",
      paidOnly: false,
      title: "Course Schedule IV",
      titleSlug: "course-schedule-iv",
    },
    {
      acRate: 71.88402238295086,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1463",
      paidOnly: false,
      title: "Cherry Pickup II",
      titleSlug: "cherry-pickup-ii",
    },
    {
      acRate: 83.17486485081109,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1464",
      paidOnly: false,
      title: "Maximum Product of Two Elements in an Array",
      titleSlug: "maximum-product-of-two-elements-in-an-array",
    },
    {
      acRate: 41.19933476795959,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1465",
      paidOnly: false,
      title:
        "Maximum Area of a Piece of Cake After Horizontal and Vertical Cuts",
      titleSlug:
        "maximum-area-of-a-piece-of-cake-after-horizontal-and-vertical-cuts",
    },
    {
      acRate: 64.91599765805638,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1466",
      paidOnly: false,
      title: "Reorder Routes to Make All Paths Lead to the City Zero",
      titleSlug: "reorder-routes-to-make-all-paths-lead-to-the-city-zero",
    },
    {
      acRate: 59.80211003159087,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1467",
      paidOnly: false,
      title:
        "Probability of a Two Boxes Having The Same Number of Distinct Balls",
      titleSlug:
        "probability-of-a-two-boxes-having-the-same-number-of-distinct-balls",
    },
    {
      acRate: 78.08572904114305,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1468",
      paidOnly: true,
      title: "Calculate Salaries",
      titleSlug: "calculate-salaries",
    },
    {
      acRate: 83.96423842945204,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1469",
      paidOnly: true,
      title: "Find All The Lonely Nodes",
      titleSlug: "find-all-the-lonely-nodes",
    },
    {
      acRate: 88.81960885517768,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1470",
      paidOnly: false,
      title: "Shuffle the Array",
      titleSlug: "shuffle-the-array",
    },
    {
      acRate: 61.82795698924731,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1471",
      paidOnly: false,
      title: "The k Strongest Values in an Array",
      titleSlug: "the-k-strongest-values-in-an-array",
    },
    {
      acRate: 77.67697758582335,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1472",
      paidOnly: false,
      title: "Design Browser History",
      titleSlug: "design-browser-history",
    },
    {
      acRate: 60.955662344727536,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1473",
      paidOnly: false,
      title: "Paint House III",
      titleSlug: "paint-house-iii",
    },
    {
      acRate: 73.52500809323405,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1474",
      paidOnly: true,
      title: "Delete N Nodes After M Nodes of a Linked List",
      titleSlug: "delete-n-nodes-after-m-nodes-of-a-linked-list",
    },
    {
      acRate: 83.24434025168549,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1475",
      paidOnly: false,
      title: "Final Prices With a Special Discount in a Shop",
      titleSlug: "final-prices-with-a-special-discount-in-a-shop",
    },
    {
      acRate: 85.92225745537463,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1476",
      paidOnly: false,
      title: "Subrectangle Queries",
      titleSlug: "subrectangle-queries",
    },
    {
      acRate: 36.46219827038924,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1477",
      paidOnly: false,
      title: "Find Two Non-overlapping Sub-arrays Each With Target Sum",
      titleSlug: "find-two-non-overlapping-sub-arrays-each-with-target-sum",
    },
    {
      acRate: 55.70121893957891,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1478",
      paidOnly: false,
      title: "Allocate Mailboxes",
      titleSlug: "allocate-mailboxes",
    },
    {
      acRate: 77.30205278592376,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1479",
      paidOnly: true,
      title: "Sales by Day of the Week",
      titleSlug: "sales-by-day-of-the-week",
    },
    {
      acRate: 86.96443885812106,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1480",
      paidOnly: false,
      title: "Running Sum of 1d Array",
      titleSlug: "running-sum-of-1d-array",
    },
    {
      acRate: 63.361142107304836,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1481",
      paidOnly: false,
      title: "Least Number of Unique Integers after K Removals",
      titleSlug: "least-number-of-unique-integers-after-k-removals",
    },
    {
      acRate: 55.3672013642195,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1482",
      paidOnly: false,
      title: "Minimum Number of Days to Make m Bouquets",
      titleSlug: "minimum-number-of-days-to-make-m-bouquets",
    },
    {
      acRate: 35.493891246750444,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1483",
      paidOnly: false,
      title: "Kth Ancestor of a Tree Node",
      titleSlug: "kth-ancestor-of-a-tree-node",
    },
    {
      acRate: 77.64255815291772,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1484",
      paidOnly: false,
      title: "Group Sold Products By The Date",
      titleSlug: "group-sold-products-by-the-date",
    },
    {
      acRate: 80.84033189579077,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1485",
      paidOnly: true,
      title: "Clone Binary Tree With Random Pointer",
      titleSlug: "clone-binary-tree-with-random-pointer",
    },
    {
      acRate: 86.75562591011608,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1486",
      paidOnly: false,
      title: "XOR Operation in an Array",
      titleSlug: "xor-operation-in-an-array",
    },
    {
      acRate: 37.77011020702441,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1487",
      paidOnly: false,
      title: "Making File Names Unique",
      titleSlug: "making-file-names-unique",
    },
    {
      acRate: 27.303251889134593,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1488",
      paidOnly: false,
      title: "Avoid Flood in The City",
      titleSlug: "avoid-flood-in-the-city",
    },
    {
      acRate: 66.35700066357,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1489",
      paidOnly: false,
      title: "Find Critical and Pseudo-Critical Edges in Minimum Spanning Tree",
      titleSlug:
        "find-critical-and-pseudo-critical-edges-in-minimum-spanning-tree",
    },
    {
      acRate: 83.15145886541289,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1490",
      paidOnly: true,
      title: "Clone N-ary Tree",
      titleSlug: "clone-n-ary-tree",
    },
    {
      acRate: 63.44021436212381,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1491",
      paidOnly: false,
      title: "Average Salary Excluding the Minimum and Maximum Salary",
      titleSlug: "average-salary-excluding-the-minimum-and-maximum-salary",
    },
    {
      acRate: 69.4970128622133,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1492",
      paidOnly: false,
      title: "The kth Factor of n",
      titleSlug: "the-kth-factor-of-n",
    },
    {
      acRate: 69.0890525178115,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1493",
      paidOnly: false,
      title: "Longest Subarray of 1's After Deleting One Element",
      titleSlug: "longest-subarray-of-1s-after-deleting-one-element",
    },
    {
      acRate: 29.445611593582317,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1494",
      paidOnly: false,
      title: "Parallel Courses II",
      titleSlug: "parallel-courses-ii",
    },
    {
      acRate: 48.96292472435108,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1495",
      paidOnly: true,
      title: "Friendly Movies Streamed Last Month",
      titleSlug: "friendly-movies-streamed-last-month",
    },
    {
      acRate: 62.5233237964921,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1496",
      paidOnly: false,
      title: "Path Crossing",
      titleSlug: "path-crossing",
    },
    {
      acRate: 46.217661084409734,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1497",
      paidOnly: false,
      title: "Check If Array Pairs Are Divisible by k",
      titleSlug: "check-if-array-pairs-are-divisible-by-k",
    },
    {
      acRate: 43.70278782510273,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1498",
      paidOnly: false,
      title: "Number of Subsequences That Satisfy the Given Sum Condition",
      titleSlug: "number-of-subsequences-that-satisfy-the-given-sum-condition",
    },
    {
      acRate: 44.485809429431036,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1499",
      paidOnly: false,
      title: "Max Value of Equation",
      titleSlug: "max-value-of-equation",
    },
    {
      acRate: 41.650248246512724,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1500",
      paidOnly: true,
      title: "Design a File Sharing System",
      titleSlug: "design-a-file-sharing-system",
    },
    {
      acRate: 50.4557175884759,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1501",
      paidOnly: true,
      title: "Countries You Can Safely Invest In",
      titleSlug: "countries-you-can-safely-invest-in",
    },
    {
      acRate: 69.42634746040166,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1502",
      paidOnly: false,
      title: "Can Make Arithmetic Progression From Sequence",
      titleSlug: "can-make-arithmetic-progression-from-sequence",
    },
    {
      acRate: 68.1921463528315,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1503",
      paidOnly: false,
      title: "Last Moment Before All Ants Fall Out of a Plank",
      titleSlug: "last-moment-before-all-ants-fall-out-of-a-plank",
    },
    {
      acRate: 57.184170921002156,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1504",
      paidOnly: false,
      title: "Count Submatrices With All Ones",
      titleSlug: "count-submatrices-with-all-ones",
    },
    {
      acRate: 39.851485148514854,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1505",
      paidOnly: false,
      title:
        "Minimum Possible Integer After at Most K Adjacent Swaps On Digits",
      titleSlug:
        "minimum-possible-integer-after-at-most-k-adjacent-swaps-on-digits",
    },
    {
      acRate: 78.42504470801043,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1506",
      paidOnly: true,
      title: "Find Root of N-Ary Tree",
      titleSlug: "find-root-of-n-ary-tree",
    },
    {
      acRate: 67.2708789490147,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1507",
      paidOnly: false,
      title: "Reformat Date",
      titleSlug: "reformat-date",
    },
    {
      acRate: 63.11666149550108,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1508",
      paidOnly: false,
      title: "Range Sum of Sorted Subarray Sums",
      titleSlug: "range-sum-of-sorted-subarray-sums",
    },
    {
      acRate: 59.1811273126334,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1509",
      paidOnly: false,
      title:
        "Minimum Difference Between Largest and Smallest Value in Three Moves",
      titleSlug:
        "minimum-difference-between-largest-and-smallest-value-in-three-moves",
    },
    {
      acRate: 59.48389341967892,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1510",
      paidOnly: false,
      title: "Stone Game IV",
      titleSlug: "stone-game-iv",
    },
    {
      acRate: 66.98130057843179,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1511",
      paidOnly: true,
      title: "Customer Order Frequency",
      titleSlug: "customer-order-frequency",
    },
    {
      acRate: 89.55043176182514,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1512",
      paidOnly: false,
      title: "Number of Good Pairs",
      titleSlug: "number-of-good-pairs",
    },
    {
      acRate: 47.768281101614434,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1513",
      paidOnly: false,
      title: "Number of Substrings With Only 1s",
      titleSlug: "number-of-substrings-with-only-1s",
    },
    {
      acRate: 65.28952761031933,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1514",
      paidOnly: false,
      title: "Path with Maximum Probability",
      titleSlug: "path-with-maximum-probability",
    },
    {
      acRate: 34.758657410251686,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1515",
      paidOnly: false,
      title: "Best Position for a Service Centre",
      titleSlug: "best-position-for-a-service-centre",
    },
    {
      acRate: 60.11167759164846,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1516",
      paidOnly: true,
      title: "Move Sub-Tree of N-Ary Tree",
      titleSlug: "move-sub-tree-of-n-ary-tree",
    },
    {
      acRate: 44.42278831764628,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1517",
      paidOnly: false,
      title: "Find Users With Valid E-Mails",
      titleSlug: "find-users-with-valid-e-mails",
    },
    {
      acRate: 70.6837516612667,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1518",
      paidOnly: false,
      title: "Water Bottles",
      titleSlug: "water-bottles",
    },
    {
      acRate: 55.00285416459844,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1519",
      paidOnly: false,
      title: "Number of Nodes in the Sub-Tree With the Same Label",
      titleSlug: "number-of-nodes-in-the-sub-tree-with-the-same-label",
    },
    {
      acRate: 39.71880151265393,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1520",
      paidOnly: false,
      title: "Maximum Number of Non-Overlapping Substrings",
      titleSlug: "maximum-number-of-non-overlapping-substrings",
    },
    {
      acRate: 45.65751283768698,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1521",
      paidOnly: false,
      title: "Find a Value of a Mysterious Function Closest to Target",
      titleSlug: "find-a-value-of-a-mysterious-function-closest-to-target",
    },
    {
      acRate: 75.00600817111271,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1522",
      paidOnly: true,
      title: "Diameter of N-Ary Tree",
      titleSlug: "diameter-of-n-ary-tree",
    },
    {
      acRate: 50.45690584013156,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1523",
      paidOnly: false,
      title: "Count Odd Numbers in an Interval Range",
      titleSlug: "count-odd-numbers-in-an-interval-range",
    },
    {
      acRate: 56.06796367815616,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1524",
      paidOnly: false,
      title: "Number of Sub-arrays With Odd Sum",
      titleSlug: "number-of-sub-arrays-with-odd-sum",
    },
    {
      acRate: 68.30959899898707,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1525",
      paidOnly: false,
      title: "Number of Good Ways to Split a String",
      titleSlug: "number-of-good-ways-to-split-a-string",
    },
    {
      acRate: 72.24054361730843,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1526",
      paidOnly: false,
      title: "Minimum Number of Increments on Subarrays to Form a Target Array",
      titleSlug:
        "minimum-number-of-increments-on-subarrays-to-form-a-target-array",
    },
    {
      acRate: 39.26316866643691,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1527",
      paidOnly: false,
      title: "Patients With a Condition",
      titleSlug: "patients-with-a-condition",
    },
    {
      acRate: 85.06815056126251,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1528",
      paidOnly: false,
      title: "Shuffle String",
      titleSlug: "shuffle-string",
    },
    {
      acRate: 73.43805046345227,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1529",
      paidOnly: false,
      title: "Minimum Suffix Flips",
      titleSlug: "minimum-suffix-flips",
    },
    {
      acRate: 71.7922879937875,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1530",
      paidOnly: false,
      title: "Number of Good Leaf Nodes Pairs",
      titleSlug: "number-of-good-leaf-nodes-pairs",
    },
    {
      acRate: 51.986551480708385,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1531",
      paidOnly: false,
      title: "String Compression II",
      titleSlug: "string-compression-ii",
    },
    {
      acRate: 68.98176202670211,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1532",
      paidOnly: true,
      title: "The Most Recent Three Orders",
      titleSlug: "the-most-recent-three-orders",
    },
    {
      acRate: 56.26755435347967,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1533",
      paidOnly: true,
      title: "Find the Index of the Large Integer",
      titleSlug: "find-the-index-of-the-large-integer",
    },
    {
      acRate: 85.4617018208513,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1534",
      paidOnly: false,
      title: "Count Good Triplets",
      titleSlug: "count-good-triplets",
    },
    {
      acRate: 56.74564156865711,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1535",
      paidOnly: false,
      title: "Find the Winner of an Array Game",
      titleSlug: "find-the-winner-of-an-array-game",
    },
    {
      acRate: 47.85671844495374,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1536",
      paidOnly: false,
      title: "Minimum Swaps to Arrange a Binary Grid",
      titleSlug: "minimum-swaps-to-arrange-a-binary-grid",
    },
    {
      acRate: 39.8930864260685,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1537",
      paidOnly: false,
      title: "Get the Maximum Score",
      titleSlug: "get-the-maximum-score",
    },
    {
      acRate: 69.27772126144455,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1538",
      paidOnly: true,
      title: "Guess the Majority in a Hidden Array",
      titleSlug: "guess-the-majority-in-a-hidden-array",
    },
    {
      acRate: 62.12606927153951,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1539",
      paidOnly: false,
      title: "Kth Missing Positive Number",
      titleSlug: "kth-missing-positive-number",
    },
    {
      acRate: 35.82954273401963,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1540",
      paidOnly: false,
      title: "Can Convert String in K Moves",
      titleSlug: "can-convert-string-in-k-moves",
    },
    {
      acRate: 53.07994850749984,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1541",
      paidOnly: false,
      title: "Minimum Insertions to Balance a Parentheses String",
      titleSlug: "minimum-insertions-to-balance-a-parentheses-string",
    },
    {
      acRate: 45.04516129032258,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1542",
      paidOnly: false,
      title: "Find Longest Awesome Substring",
      titleSlug: "find-longest-awesome-substring",
    },
    {
      acRate: 58.931201346517994,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1543",
      paidOnly: true,
      title: "Fix Product Name Format",
      titleSlug: "fix-product-name-format",
    },
    {
      acRate: 68.25477161276625,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1544",
      paidOnly: false,
      title: "Make The String Great",
      titleSlug: "make-the-string-great",
    },
    {
      acRate: 70.18396800252059,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1545",
      paidOnly: false,
      title: "Find Kth Bit in Nth Binary String",
      titleSlug: "find-kth-bit-in-nth-binary-string",
    },
    {
      acRate: 47.912653503491455,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1546",
      paidOnly: false,
      title:
        "Maximum Number of Non-Overlapping Subarrays With Sum Equals Target",
      titleSlug:
        "maximum-number-of-non-overlapping-subarrays-with-sum-equals-target",
    },
    {
      acRate: 61.85769651566005,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1547",
      paidOnly: false,
      title: "Minimum Cost to Cut a Stick",
      titleSlug: "minimum-cost-to-cut-a-stick",
    },
    {
      acRate: 59.285450950162556,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1548",
      paidOnly: true,
      title: "The Most Similar Path in a Graph",
      titleSlug: "the-most-similar-path-in-a-graph",
    },
    {
      acRate: 64.82179984912327,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1549",
      paidOnly: true,
      title: "The Most Recent Orders for Each Product",
      titleSlug: "the-most-recent-orders-for-each-product",
    },
    {
      acRate: 68.02191253323554,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1550",
      paidOnly: false,
      title: "Three Consecutive Odds",
      titleSlug: "three-consecutive-odds",
    },
    {
      acRate: 82.21692782308561,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1551",
      paidOnly: false,
      title: "Minimum Operations to Make Array Equal",
      titleSlug: "minimum-operations-to-make-array-equal",
    },
    {
      acRate: 71.2252859631846,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1552",
      paidOnly: false,
      title: "Magnetic Force Between Two Balls",
      titleSlug: "magnetic-force-between-two-balls",
    },
    {
      acRate: 35.614081292248265,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1553",
      paidOnly: false,
      title: "Minimum Number of Days to Eat N Oranges",
      titleSlug: "minimum-number-of-days-to-eat-n-oranges",
    },
    {
      acRate: 41.136335248563576,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1554",
      paidOnly: true,
      title: "Strings Differ by One Character",
      titleSlug: "strings-differ-by-one-character",
    },
    {
      acRate: 51.878579899573566,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1555",
      paidOnly: true,
      title: "Bank Account Summary",
      titleSlug: "bank-account-summary",
    },
    {
      acRate: 53.53603403953551,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1556",
      paidOnly: false,
      title: "Thousand Separator",
      titleSlug: "thousand-separator",
    },
    {
      acRate: 81.10867374162567,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1557",
      paidOnly: false,
      title: "Minimum Number of Vertices to Reach All Nodes",
      titleSlug: "minimum-number-of-vertices-to-reach-all-nodes",
    },
    {
      acRate: 62.53142019271052,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1558",
      paidOnly: false,
      title: "Minimum Numbers of Function Calls to Make Target Array",
      titleSlug: "minimum-numbers-of-function-calls-to-make-target-array",
    },
    {
      acRate: 49.98186434530287,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1559",
      paidOnly: false,
      title: "Detect Cycles in 2D Grid",
      titleSlug: "detect-cycles-in-2d-grid",
    },
    {
      acRate: 59.01111474338019,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1560",
      paidOnly: false,
      title: "Most Visited Sector in  a Circular Track",
      titleSlug: "most-visited-sector-in-a-circular-track",
    },
    {
      acRate: 84.41646043058373,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1561",
      paidOnly: false,
      title: "Maximum Number of Coins You Can Get",
      titleSlug: "maximum-number-of-coins-you-can-get",
    },
    {
      acRate: 42.981165077536744,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1562",
      paidOnly: false,
      title: "Find Latest Group of Size M",
      titleSlug: "find-latest-group-of-size-m",
    },
    {
      acRate: 41.03324681745149,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1563",
      paidOnly: false,
      title: "Stone Game V",
      titleSlug: "stone-game-v",
    },
    {
      acRate: 67.15991387747113,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1564",
      paidOnly: true,
      title: "Put Boxes Into the Warehouse I",
      titleSlug: "put-boxes-into-the-warehouse-i",
    },
    {
      acRate: 82.23930344874498,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1565",
      paidOnly: true,
      title: "Unique Orders and Customers Per Month",
      titleSlug: "unique-orders-and-customers-per-month",
    },
    {
      acRate: 43.43100543973906,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1566",
      paidOnly: false,
      title: "Detect Pattern of Length M Repeated K or More Times",
      titleSlug: "detect-pattern-of-length-m-repeated-k-or-more-times",
    },
    {
      acRate: 44.36878484980857,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1567",
      paidOnly: false,
      title: "Maximum Length of Subarray With Positive Product",
      titleSlug: "maximum-length-of-subarray-with-positive-product",
    },
    {
      acRate: 59.10965581023321,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1568",
      paidOnly: false,
      title: "Minimum Number of Days to Disconnect Island",
      titleSlug: "minimum-number-of-days-to-disconnect-island",
    },
    {
      acRate: 53.55656843720384,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1569",
      paidOnly: false,
      title: "Number of Ways to Reorder Array to Get Same BST",
      titleSlug: "number-of-ways-to-reorder-array-to-get-same-bst",
    },
    {
      acRate: 89.94679137775626,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1570",
      paidOnly: true,
      title: "Dot Product of Two Sparse Vectors",
      titleSlug: "dot-product-of-two-sparse-vectors",
    },
    {
      acRate: 87.47063002021747,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1571",
      paidOnly: true,
      title: "Warehouse Manager",
      titleSlug: "warehouse-manager",
    },
    {
      acRate: 83.65003452101128,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1572",
      paidOnly: false,
      title: "Matrix Diagonal Sum",
      titleSlug: "matrix-diagonal-sum",
    },
    {
      acRate: 33.76818404707421,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1573",
      paidOnly: false,
      title: "Number of Ways to Split a String",
      titleSlug: "number-of-ways-to-split-a-string",
    },
    {
      acRate: 51.478359742099975,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1574",
      paidOnly: false,
      title: "Shortest Subarray to be Removed to Make Array Sorted",
      titleSlug: "shortest-subarray-to-be-removed-to-make-array-sorted",
    },
    {
      acRate: 64.95035594837438,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1575",
      paidOnly: false,
      title: "Count All Possible Routes",
      titleSlug: "count-all-possible-routes",
    },
    {
      acRate: 45.212559155930336,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1576",
      paidOnly: false,
      title: "Replace All ?'s to Avoid Consecutive Repeating Characters",
      titleSlug: "replace-all-s-to-avoid-consecutive-repeating-characters",
    },
    {
      acRate: 41.88674588343147,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1577",
      paidOnly: false,
      title:
        "Number of Ways Where Square of Number Is Equal to Product of Two Numbers",
      titleSlug:
        "number-of-ways-where-square-of-number-is-equal-to-product-of-two-numbers",
    },
    {
      acRate: 63.457473624813254,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1578",
      paidOnly: false,
      title: "Minimum Time to Make Rope Colorful",
      titleSlug: "minimum-time-to-make-rope-colorful",
    },
    {
      acRate: 70.44758575891615,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1579",
      paidOnly: false,
      title: "Remove Max Number of Edges to Keep Graph Fully Traversable",
      titleSlug: "remove-max-number-of-edges-to-keep-graph-fully-traversable",
    },
    {
      acRate: 65.47917711991971,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1580",
      paidOnly: true,
      title: "Put Boxes Into the Warehouse II",
      titleSlug: "put-boxes-into-the-warehouse-ii",
    },
    {
      acRate: 67.43073201471755,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1581",
      paidOnly: false,
      title: "Customer Who Visited but Did Not Make Any Transactions",
      titleSlug: "customer-who-visited-but-did-not-make-any-transactions",
    },
    {
      acRate: 68.68104740224842,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1582",
      paidOnly: false,
      title: "Special Positions in a Binary Matrix",
      titleSlug: "special-positions-in-a-binary-matrix",
    },
    {
      acRate: 61.95868251802767,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1583",
      paidOnly: false,
      title: "Count Unhappy Friends",
      titleSlug: "count-unhappy-friends",
    },
    {
      acRate: 68.7256728587504,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1584",
      paidOnly: false,
      title: "Min Cost to Connect All Points",
      titleSlug: "min-cost-to-connect-all-points",
    },
    {
      acRate: 48.32359421400517,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1585",
      paidOnly: false,
      title: "Check If String Is Transformable With Substring Sort Operations",
      titleSlug:
        "check-if-string-is-transformable-with-substring-sort-operations",
    },
    {
      acRate: 63.17366434491615,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1586",
      paidOnly: true,
      title: "Binary Search Tree Iterator II",
      titleSlug: "binary-search-tree-iterator-ii",
    },
    {
      acRate: 83.35700848466234,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1587",
      paidOnly: false,
      title: "Bank Account Summary II",
      titleSlug: "bank-account-summary-ii",
    },
    {
      acRate: 83.46402205487816,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1588",
      paidOnly: false,
      title: "Sum of All Odd Length Subarrays",
      titleSlug: "sum-of-all-odd-length-subarrays",
    },
    {
      acRate: 39.19428553165649,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1589",
      paidOnly: false,
      title: "Maximum Sum Obtained of Any Permutation",
      titleSlug: "maximum-sum-obtained-of-any-permutation",
    },
    {
      acRate: 39.49094821879762,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1590",
      paidOnly: false,
      title: "Make Sum Divisible by P",
      titleSlug: "make-sum-divisible-by-p",
    },
    {
      acRate: 59.613711501653036,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1591",
      paidOnly: false,
      title: "Strange Printer II",
      titleSlug: "strange-printer-ii",
    },
    {
      acRate: 43.89519720739879,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1592",
      paidOnly: false,
      title: "Rearrange Spaces Between Words",
      titleSlug: "rearrange-spaces-between-words",
    },
    {
      acRate: 68.34193371203908,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1593",
      paidOnly: false,
      title: "Split a String Into the Max Number of Unique Substrings",
      titleSlug: "split-a-string-into-the-max-number-of-unique-substrings",
    },
    {
      acRate: 34.5521612120612,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1594",
      paidOnly: false,
      title: "Maximum Non Negative Product in a Matrix",
      titleSlug: "maximum-non-negative-product-in-a-matrix",
    },
    {
      acRate: 48.18695335276968,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1595",
      paidOnly: false,
      title: "Minimum Cost to Connect Two Groups of Points",
      titleSlug: "minimum-cost-to-connect-two-groups-of-points",
    },
    {
      acRate: 77.8565423417915,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1596",
      paidOnly: true,
      title: "The Most Frequently Ordered Products for Each Customer",
      titleSlug: "the-most-frequently-ordered-products-for-each-customer",
    },
    {
      acRate: 62.436345923925074,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1597",
      paidOnly: true,
      title: "Build Binary Expression Tree From Infix Expression",
      titleSlug: "build-binary-expression-tree-from-infix-expression",
    },
    {
      acRate: 71.5906425891182,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1598",
      paidOnly: false,
      title: "Crawler Log Folder",
      titleSlug: "crawler-log-folder",
    },
    {
      acRate: 43.88287078949833,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1599",
      paidOnly: false,
      title: "Maximum Profit of Operating a Centennial Wheel",
      titleSlug: "maximum-profit-of-operating-a-centennial-wheel",
    },
    {
      acRate: 64.6085409252669,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1600",
      paidOnly: false,
      title: "Throne Inheritance",
      titleSlug: "throne-inheritance",
    },
    {
      acRate: 64.43431146397725,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1601",
      paidOnly: false,
      title: "Maximum Number of Achievable Transfer Requests",
      titleSlug: "maximum-number-of-achievable-transfer-requests",
    },
    {
      acRate: 75.03017921812611,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1602",
      paidOnly: true,
      title: "Find Nearest Right Node in Binary Tree",
      titleSlug: "find-nearest-right-node-in-binary-tree",
    },
    {
      acRate: 87.0432875902338,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1603",
      paidOnly: false,
      title: "Design Parking System",
      titleSlug: "design-parking-system",
    },
    {
      acRate: 45.758078057391344,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1604",
      paidOnly: false,
      title:
        "Alert Using Same Key-Card Three or More Times in a One Hour Period",
      titleSlug:
        "alert-using-same-key-card-three-or-more-times-in-a-one-hour-period",
    },
    {
      acRate: 82.85178497013474,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1605",
      paidOnly: false,
      title: "Find Valid Matrix Given Row and Column Sums",
      titleSlug: "find-valid-matrix-given-row-and-column-sums",
    },
    {
      acRate: 43.894417271040645,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1606",
      paidOnly: false,
      title: "Find Servers That Handled Most Number of Requests",
      titleSlug: "find-servers-that-handled-most-number-of-requests",
    },
    {
      acRate: 54.43963508024239,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1607",
      paidOnly: true,
      title: "Sellers With No Sales",
      titleSlug: "sellers-with-no-sales",
    },
    {
      acRate: 66.60367054665497,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1608",
      paidOnly: false,
      title: "Special Array With X Elements Greater Than or Equal X",
      titleSlug: "special-array-with-x-elements-greater-than-or-equal-x",
    },
    {
      acRate: 66.50275308171118,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1609",
      paidOnly: false,
      title: "Even Odd Tree",
      titleSlug: "even-odd-tree",
    },
    {
      acRate: 37.57698050768796,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1610",
      paidOnly: false,
      title: "Maximum Number of Visible Points",
      titleSlug: "maximum-number-of-visible-points",
    },
    {
      acRate: 73.28168570395175,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1611",
      paidOnly: false,
      title: "Minimum One Bit Operations to Make Integers Zero",
      titleSlug: "minimum-one-bit-operations-to-make-integers-zero",
    },
    {
      acRate: 71.08093810615411,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1612",
      paidOnly: true,
      title: "Check If Two Expression Trees are Equivalent",
      titleSlug: "check-if-two-expression-trees-are-equivalent",
    },
    {
      acRate: 73.12761721699732,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1613",
      paidOnly: true,
      title: "Find the Missing IDs",
      titleSlug: "find-the-missing-ids",
    },
    {
      acRate: 84.27557022785757,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1614",
      paidOnly: false,
      title: "Maximum Nesting Depth of the Parentheses",
      titleSlug: "maximum-nesting-depth-of-the-parentheses",
    },
    {
      acRate: 65.40042659648917,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1615",
      paidOnly: false,
      title: "Maximal Network Rank",
      titleSlug: "maximal-network-rank",
    },
    {
      acRate: 31.359194551376962,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1616",
      paidOnly: false,
      title: "Split Two Strings to Make Palindrome",
      titleSlug: "split-two-strings-to-make-palindrome",
    },
    {
      acRate: 66.43701799485862,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1617",
      paidOnly: false,
      title: "Count Subtrees With Max Distance Between Cities",
      titleSlug: "count-subtrees-with-max-distance-between-cities",
    },
    {
      acRate: 61.281242002900285,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1618",
      paidOnly: true,
      title: "Maximum Font to Fit a Sentence in a Screen",
      titleSlug: "maximum-font-to-fit-a-sentence-in-a-screen",
    },
    {
      acRate: 70.28189753905085,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1619",
      paidOnly: false,
      title: "Mean of Array After Removing Some Elements",
      titleSlug: "mean-of-array-after-removing-some-elements",
    },
    {
      acRate: 38.29571487587787,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1620",
      paidOnly: false,
      title: "Coordinate With Maximum Network Quality",
      titleSlug: "coordinate-with-maximum-network-quality",
    },
    {
      acRate: 44.53172900061312,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1621",
      paidOnly: false,
      title: "Number of Sets of K Non-Overlapping Line Segments",
      titleSlug: "number-of-sets-of-k-non-overlapping-line-segments",
    },
    {
      acRate: 17.316680714121524,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1622",
      paidOnly: false,
      title: "Fancy Sequence",
      titleSlug: "fancy-sequence",
    },
    {
      acRate: 80.97081596188207,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1623",
      paidOnly: true,
      title: "All Valid Triplets That Can Represent a Country",
      titleSlug: "all-valid-triplets-that-can-represent-a-country",
    },
    {
      acRate: 68.23345147461308,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1624",
      paidOnly: false,
      title: "Largest Substring Between Two Equal Characters",
      titleSlug: "largest-substring-between-two-equal-characters",
    },
    {
      acRate: 65.14407684098185,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1625",
      paidOnly: false,
      title: "Lexicographically Smallest String After Applying Operations",
      titleSlug: "lexicographically-smallest-string-after-applying-operations",
    },
    {
      acRate: 50.3945166616798,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1626",
      paidOnly: false,
      title: "Best Team With No Conflicts",
      titleSlug: "best-team-with-no-conflicts",
    },
    {
      acRate: 47.995151063036175,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1627",
      paidOnly: false,
      title: "Graph Connectivity With Threshold",
      titleSlug: "graph-connectivity-with-threshold",
    },
    {
      acRate: 82.42373029517177,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1628",
      paidOnly: true,
      title: "Design an Expression Tree With Evaluate Function",
      titleSlug: "design-an-expression-tree-with-evaluate-function",
    },
    {
      acRate: 59.23876483735868,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1629",
      paidOnly: false,
      title: "Slowest Key",
      titleSlug: "slowest-key",
    },
    {
      acRate: 83.6981114913647,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1630",
      paidOnly: false,
      title: "Arithmetic Subarrays",
      titleSlug: "arithmetic-subarrays",
    },
    {
      acRate: 61.130264922719626,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1631",
      paidOnly: false,
      title: "Path With Minimum Effort",
      titleSlug: "path-with-minimum-effort",
    },
    {
      acRate: 41.332598383109506,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1632",
      paidOnly: false,
      title: "Rank Transform of a Matrix",
      titleSlug: "rank-transform-of-a-matrix",
    },
    {
      acRate: 58.71383075018349,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1633",
      paidOnly: false,
      title: "Percentage of Users Attended a Contest",
      titleSlug: "percentage-of-users-attended-a-contest",
    },
    {
      acRate: 60.69860586921359,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1634",
      paidOnly: true,
      title: "Add Two Polynomials Represented as Linked Lists",
      titleSlug: "add-two-polynomials-represented-as-linked-lists",
    },
    {
      acRate: 48.20325796255774,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1635",
      paidOnly: true,
      title: "Hopper Company Queries I",
      titleSlug: "hopper-company-queries-i",
    },
    {
      acRate: 80.17095408234253,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1636",
      paidOnly: false,
      title: "Sort Array by Increasing Frequency",
      titleSlug: "sort-array-by-increasing-frequency",
    },
    {
      acRate: 87.075758140228,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1637",
      paidOnly: false,
      title: "Widest Vertical Area Between Two Points Containing No Points",
      titleSlug: "widest-vertical-area-between-two-points-containing-no-points",
    },
    {
      acRate: 71.62551097021773,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1638",
      paidOnly: false,
      title: "Count Substrings That Differ by One Character",
      titleSlug: "count-substrings-that-differ-by-one-character",
    },
    {
      acRate: 57.156014163596694,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1639",
      paidOnly: false,
      title: "Number of Ways to Form a Target String Given a Dictionary",
      titleSlug: "number-of-ways-to-form-a-target-string-given-a-dictionary",
    },
    {
      acRate: 56.930072428464705,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1640",
      paidOnly: false,
      title: "Check Array Formation Through Concatenation",
      titleSlug: "check-array-formation-through-concatenation",
    },
    {
      acRate: 78.8275695866972,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1641",
      paidOnly: false,
      title: "Count Sorted Vowel Strings",
      titleSlug: "count-sorted-vowel-strings",
    },
    {
      acRate: 50.31432154502132,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1642",
      paidOnly: false,
      title: "Furthest Building You Can Reach",
      titleSlug: "furthest-building-you-can-reach",
    },
    {
      acRate: 43.628475012052064,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1643",
      paidOnly: false,
      title: "Kth Smallest Instructions",
      titleSlug: "kth-smallest-instructions",
    },
    {
      acRate: 68.53655952180605,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1644",
      paidOnly: true,
      title: "Lowest Common Ancestor of a Binary Tree II",
      titleSlug: "lowest-common-ancestor-of-a-binary-tree-ii",
    },
    {
      acRate: 39.527079353606275,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1645",
      paidOnly: true,
      title: "Hopper Company Queries II",
      titleSlug: "hopper-company-queries-ii",
    },
    {
      acRate: 50.93836005416976,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1646",
      paidOnly: false,
      title: "Get Maximum in Generated Array",
      titleSlug: "get-maximum-in-generated-array",
    },
    {
      acRate: 61.27502656930302,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1647",
      paidOnly: false,
      title: "Minimum Deletions to Make Character Frequencies Unique",
      titleSlug: "minimum-deletions-to-make-character-frequencies-unique",
    },
    {
      acRate: 29.93865765880476,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1648",
      paidOnly: false,
      title: "Sell Diminishing-Valued Colored Balls",
      titleSlug: "sell-diminishing-valued-colored-balls",
    },
    {
      acRate: 39.9262524605617,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1649",
      paidOnly: false,
      title: "Create Sorted Array through Instructions",
      titleSlug: "create-sorted-array-through-instructions",
    },
    {
      acRate: 82.31795141677976,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1650",
      paidOnly: true,
      title: "Lowest Common Ancestor of a Binary Tree III",
      titleSlug: "lowest-common-ancestor-of-a-binary-tree-iii",
    },
    {
      acRate: 65.90642294147241,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1651",
      paidOnly: true,
      title: "Hopper Company Queries III",
      titleSlug: "hopper-company-queries-iii",
    },
    {
      acRate: 79.18753525580759,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1652",
      paidOnly: false,
      title: "Defuse the Bomb",
      titleSlug: "defuse-the-bomb",
    },
    {
      acRate: 65.58843007476199,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1653",
      paidOnly: false,
      title: "Minimum Deletions to Make String Balanced",
      titleSlug: "minimum-deletions-to-make-string-balanced",
    },
    {
      acRate: 30.05231915301036,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1654",
      paidOnly: false,
      title: "Minimum Jumps to Reach Home",
      titleSlug: "minimum-jumps-to-reach-home",
    },
    {
      acRate: 39.62729692877086,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1655",
      paidOnly: false,
      title: "Distribute Repeating Integers",
      titleSlug: "distribute-repeating-integers",
    },
    {
      acRate: 82.11845482118456,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1656",
      paidOnly: false,
      title: "Design an Ordered Stream",
      titleSlug: "design-an-ordered-stream",
    },
    {
      acRate: 54.08941455840716,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1657",
      paidOnly: false,
      title: "Determine if Two Strings Are Close",
      titleSlug: "determine-if-two-strings-are-close",
    },
    {
      acRate: 40.00829676540325,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1658",
      paidOnly: false,
      title: "Minimum Operations to Reduce X to Zero",
      titleSlug: "minimum-operations-to-reduce-x-to-zero",
    },
    {
      acRate: 39.59525386978257,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1659",
      paidOnly: false,
      title: "Maximize Grid Happiness",
      titleSlug: "maximize-grid-happiness",
    },
    {
      acRate: 74.29943678518364,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1660",
      paidOnly: true,
      title: "Correct a Binary Tree",
      titleSlug: "correct-a-binary-tree",
    },
    {
      acRate: 68.88404193799815,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1661",
      paidOnly: false,
      title: "Average Time of Process per Machine",
      titleSlug: "average-time-of-process-per-machine",
    },
    {
      acRate: 85.7240582717971,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1662",
      paidOnly: false,
      title: "Check If Two String Arrays are Equivalent",
      titleSlug: "check-if-two-string-arrays-are-equivalent",
    },
    {
      acRate: 67.03048702672568,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1663",
      paidOnly: false,
      title: "Smallest String With A Given Numeric Value",
      titleSlug: "smallest-string-with-a-given-numeric-value",
    },
    {
      acRate: 64.35745263638438,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1664",
      paidOnly: false,
      title: "Ways to Make a Fair Array",
      titleSlug: "ways-to-make-a-fair-array",
    },
    {
      acRate: 59.13441775794234,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1665",
      paidOnly: false,
      title: "Minimum Initial Energy to Finish Tasks",
      titleSlug: "minimum-initial-energy-to-finish-tasks",
    },
    {
      acRate: 74.58017334777898,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1666",
      paidOnly: true,
      title: "Change the Root of a Binary Tree",
      titleSlug: "change-the-root-of-a-binary-tree",
    },
    {
      acRate: 60.969402183134434,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1667",
      paidOnly: false,
      title: "Fix Names in a Table",
      titleSlug: "fix-names-in-a-table",
    },
    {
      acRate: 39.469345983797055,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1668",
      paidOnly: false,
      title: "Maximum Repeating Substring",
      titleSlug: "maximum-repeating-substring",
    },
    {
      acRate: 82.24509999358041,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1669",
      paidOnly: false,
      title: "Merge In Between Linked Lists",
      titleSlug: "merge-in-between-linked-lists",
    },
    {
      acRate: 56.20755534862813,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1670",
      paidOnly: false,
      title: "Design Front Middle Back Queue",
      titleSlug: "design-front-middle-back-queue",
    },
    {
      acRate: 54.95255183795661,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1671",
      paidOnly: false,
      title: "Minimum Number of Removals to Make Mountain Array",
      titleSlug: "minimum-number-of-removals-to-make-mountain-array",
    },
    {
      acRate: 88.54079471013742,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1672",
      paidOnly: false,
      title: "Richest Customer Wealth",
      titleSlug: "richest-customer-wealth",
    },
    {
      acRate: 51.672581952323725,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1673",
      paidOnly: false,
      title: "Find the Most Competitive Subsequence",
      titleSlug: "find-the-most-competitive-subsequence",
    },
    {
      acRate: 41.79693315468215,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1674",
      paidOnly: false,
      title: "Minimum Moves to Make Array Complementary",
      titleSlug: "minimum-moves-to-make-array-complementary",
    },
    {
      acRate: 53.9082518253203,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1675",
      paidOnly: false,
      title: "Minimize Deviation in Array",
      titleSlug: "minimize-deviation-in-array",
    },
    {
      acRate: 79.01199757510821,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1676",
      paidOnly: true,
      title: "Lowest Common Ancestor of a Binary Tree IV",
      titleSlug: "lowest-common-ancestor-of-a-binary-tree-iv",
    },
    {
      acRate: 38.42328536342785,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1677",
      paidOnly: true,
      title: "Product's Worth Over Invoices",
      titleSlug: "products-worth-over-invoices",
    },
    {
      acRate: 87.6555963174907,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1678",
      paidOnly: false,
      title: "Goal Parser Interpretation",
      titleSlug: "goal-parser-interpretation",
    },
    {
      acRate: 56.11612818325591,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1679",
      paidOnly: false,
      title: "Max Number of K-Sum Pairs",
      titleSlug: "max-number-of-k-sum-pairs",
    },
    {
      acRate: 56.6546402692296,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1680",
      paidOnly: false,
      title: "Concatenation of Consecutive Binary Numbers",
      titleSlug: "concatenation-of-consecutive-binary-numbers",
    },
    {
      acRate: 39.661471018022404,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1681",
      paidOnly: false,
      title: "Minimum Incompatibility",
      titleSlug: "minimum-incompatibility",
    },
    {
      acRate: 50.18456375838927,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1682",
      paidOnly: true,
      title: "Longest Palindromic Subsequence II",
      titleSlug: "longest-palindromic-subsequence-ii",
    },
    {
      acRate: 85.57292326862071,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1683",
      paidOnly: false,
      title: "Invalid Tweets",
      titleSlug: "invalid-tweets",
    },
    {
      acRate: 88.26884915073715,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1684",
      paidOnly: false,
      title: "Count the Number of Consistent Strings",
      titleSlug: "count-the-number-of-consistent-strings",
    },
    {
      acRate: 68.13575606861276,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1685",
      paidOnly: false,
      title: "Sum of Absolute Differences in a Sorted Array",
      titleSlug: "sum-of-absolute-differences-in-a-sorted-array",
    },
    {
      acRate: 58.671345595353344,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1686",
      paidOnly: false,
      title: "Stone Game VI",
      titleSlug: "stone-game-vi",
    },
    {
      acRate: 39.24611973392461,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1687",
      paidOnly: false,
      title: "Delivering Boxes from Storage to Ports",
      titleSlug: "delivering-boxes-from-storage-to-ports",
    },
    {
      acRate: 85.9511066553559,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1688",
      paidOnly: false,
      title: "Count of Matches in Tournament",
      titleSlug: "count-of-matches-in-tournament",
    },
    {
      acRate: 88.61774863275431,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1689",
      paidOnly: false,
      title: "Partitioning Into Minimum Number Of Deci-Binary Numbers",
      titleSlug: "partitioning-into-minimum-number-of-deci-binary-numbers",
    },
    {
      acRate: 58.23241167208676,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1690",
      paidOnly: false,
      title: "Stone Game VII",
      titleSlug: "stone-game-vii",
    },
    {
      acRate: 59.80100307393626,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1691",
      paidOnly: false,
      title: "Maximum Height by Stacking Cuboids ",
      titleSlug: "maximum-height-by-stacking-cuboids",
    },
    {
      acRate: 63.16836058329651,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1692",
      paidOnly: true,
      title: "Count Ways to Distribute Candies",
      titleSlug: "count-ways-to-distribute-candies",
    },
    {
      acRate: 86.58033537076624,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1693",
      paidOnly: false,
      title: "Daily Leads and Partners",
      titleSlug: "daily-leads-and-partners",
    },
    {
      acRate: 66.83366733466933,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1694",
      paidOnly: false,
      title: "Reformat Phone Number",
      titleSlug: "reformat-phone-number",
    },
    {
      acRate: 59.251816479930774,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1695",
      paidOnly: false,
      title: "Maximum Erasure Value",
      titleSlug: "maximum-erasure-value",
    },
    {
      acRate: 45.932150735944695,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1696",
      paidOnly: false,
      title: "Jump Game VI",
      titleSlug: "jump-game-vi",
    },
    {
      acRate: 62.69927783076713,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1697",
      paidOnly: false,
      title: "Checking Existence of Edge Length Limited Paths",
      titleSlug: "checking-existence-of-edge-length-limited-paths",
    },
    {
      acRate: 64.44090093681483,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1698",
      paidOnly: true,
      title: "Number of Distinct Substrings in a String",
      titleSlug: "number-of-distinct-substrings-in-a-string",
    },
    {
      acRate: 80.9600052820098,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1699",
      paidOnly: true,
      title: "Number of Calls Between Two Persons",
      titleSlug: "number-of-calls-between-two-persons",
    },
    {
      acRate: 78.63796708983756,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1700",
      paidOnly: false,
      title: "Number of Students Unable to Eat Lunch",
      titleSlug: "number-of-students-unable-to-eat-lunch",
    },
    {
      acRate: 73.05759118075648,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1701",
      paidOnly: false,
      title: "Average Waiting Time",
      titleSlug: "average-waiting-time",
    },
    {
      acRate: 46.94016459377514,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1702",
      paidOnly: false,
      title: "Maximum Binary String After Change",
      titleSlug: "maximum-binary-string-after-change",
    },
    {
      acRate: 42.06436920191567,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1703",
      paidOnly: false,
      title: "Minimum Adjacent Swaps for K Consecutive Ones",
      titleSlug: "minimum-adjacent-swaps-for-k-consecutive-ones",
    },
    {
      acRate: 78.63637118125006,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1704",
      paidOnly: false,
      title: "Determine if String Halves Are Alike",
      titleSlug: "determine-if-string-halves-are-alike",
    },
    {
      acRate: 40.35765335604148,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1705",
      paidOnly: false,
      title: "Maximum Number of Eaten Apples",
      titleSlug: "maximum-number-of-eaten-apples",
    },
    {
      acRate: 71.98848406631589,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1706",
      paidOnly: false,
      title: "Where Will the Ball Fall",
      titleSlug: "where-will-the-ball-fall",
    },
    {
      acRate: 54.370142487046635,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1707",
      paidOnly: false,
      title: "Maximum XOR With an Element From Array",
      titleSlug: "maximum-xor-with-an-element-from-array",
    },
    {
      acRate: 65.13210568454764,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1708",
      paidOnly: true,
      title: "Largest Subarray Length K",
      titleSlug: "largest-subarray-length-k",
    },
    {
      acRate: 70.32551831040496,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1709",
      paidOnly: true,
      title: "Biggest Window Between Visits",
      titleSlug: "biggest-window-between-visits",
    },
    {
      acRate: 74.18072720030666,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1710",
      paidOnly: false,
      title: "Maximum Units on a Truck",
      titleSlug: "maximum-units-on-a-truck",
    },
    {
      acRate: 31.44666454224326,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1711",
      paidOnly: false,
      title: "Count Good Meals",
      titleSlug: "count-good-meals",
    },
    {
      acRate: 33.39033504338463,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1712",
      paidOnly: false,
      title: "Ways to Split Array Into Three Subarrays",
      titleSlug: "ways-to-split-array-into-three-subarrays",
    },
    {
      acRate: 48.63806662841327,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1713",
      paidOnly: false,
      title: "Minimum Operations to Make a Subsequence",
      titleSlug: "minimum-operations-to-make-a-subsequence",
    },
    {
      acRate: 49.020217729393465,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1714",
      paidOnly: true,
      title: "Sum Of Special Evenly-Spaced Elements In Array",
      titleSlug: "sum-of-special-evenly-spaced-elements-in-array",
    },
    {
      acRate: 75.8999653859467,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1715",
      paidOnly: true,
      title: "Count Apples and Oranges",
      titleSlug: "count-apples-and-oranges",
    },
    {
      acRate: 78.4607135229457,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1716",
      paidOnly: false,
      title: "Calculate Money in Leetcode Bank",
      titleSlug: "calculate-money-in-leetcode-bank",
    },
    {
      acRate: 62.840938086135964,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1717",
      paidOnly: false,
      title: "Maximum Score From Removing Substrings",
      titleSlug: "maximum-score-from-removing-substrings",
    },
    {
      acRate: 73.14977094174408,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1718",
      paidOnly: false,
      title: "Construct the Lexicographically Largest Valid Sequence",
      titleSlug: "construct-the-lexicographically-largest-valid-sequence",
    },
    {
      acRate: 44.11078013042428,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1719",
      paidOnly: false,
      title: "Number Of Ways To Reconstruct A Tree",
      titleSlug: "number-of-ways-to-reconstruct-a-tree",
    },
    {
      acRate: 86.89867814820032,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1720",
      paidOnly: false,
      title: "Decode XORed Array",
      titleSlug: "decode-xored-array",
    },
    {
      acRate: 68.3700318754697,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1721",
      paidOnly: false,
      title: "Swapping Nodes in a Linked List",
      titleSlug: "swapping-nodes-in-a-linked-list",
    },
    {
      acRate: 47.988485406196176,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1722",
      paidOnly: false,
      title: "Minimize Hamming Distance After Swap Operations",
      titleSlug: "minimize-hamming-distance-after-swap-operations",
    },
    {
      acRate: 43.14790396490724,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1723",
      paidOnly: false,
      title: "Find Minimum Time to Finish All Jobs",
      titleSlug: "find-minimum-time-to-finish-all-jobs",
    },
    {
      acRate: 51.462822891394325,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1724",
      paidOnly: true,
      title: "Checking Existence of Edge Length Limited Paths II",
      titleSlug: "checking-existence-of-edge-length-limited-paths-ii",
    },
    {
      acRate: 78.93029355789805,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1725",
      paidOnly: false,
      title: "Number Of Rectangles That Can Form The Largest Square",
      titleSlug: "number-of-rectangles-that-can-form-the-largest-square",
    },
    {
      acRate: 70.21559823638216,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1726",
      paidOnly: false,
      title: "Tuple with Same Product",
      titleSlug: "tuple-with-same-product",
    },
    {
      acRate: 75.16826211388532,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1727",
      paidOnly: false,
      title: "Largest Submatrix With Rearrangements",
      titleSlug: "largest-submatrix-with-rearrangements",
    },
    {
      acRate: 39.53757225433526,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1728",
      paidOnly: false,
      title: "Cat and Mouse II",
      titleSlug: "cat-and-mouse-ii",
    },
    {
      acRate: 69.54445057412804,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1729",
      paidOnly: false,
      title: "Find Followers Count",
      titleSlug: "find-followers-count",
    },
    {
      acRate: 56.59524861158377,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1730",
      paidOnly: true,
      title: "Shortest Path to Get Food",
      titleSlug: "shortest-path-to-get-food",
    },
    {
      acRate: 51.958755537249324,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1731",
      paidOnly: false,
      title: "The Number of Employees Which Report to Each Employee",
      titleSlug: "the-number-of-employees-which-report-to-each-employee",
    },
    {
      acRate: 83.8172117717217,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1732",
      paidOnly: false,
      title: "Find the Highest Altitude",
      titleSlug: "find-the-highest-altitude",
    },
    {
      acRate: 43.47266128088046,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1733",
      paidOnly: false,
      title: "Minimum Number of People to Teach",
      titleSlug: "minimum-number-of-people-to-teach",
    },
    {
      acRate: 65.69975857780379,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1734",
      paidOnly: false,
      title: "Decode XORed Permutation",
      titleSlug: "decode-xored-permutation",
    },
    {
      acRate: 52.91419320021586,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1735",
      paidOnly: false,
      title: "Count Ways to Make Array With Product",
      titleSlug: "count-ways-to-make-array-with-product",
    },
    {
      acRate: 42.99594895068685,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1736",
      paidOnly: false,
      title: "Latest Time by Replacing Hidden Digits",
      titleSlug: "latest-time-by-replacing-hidden-digits",
    },
    {
      acRate: 37.056603773584904,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1737",
      paidOnly: false,
      title: "Change Minimum Characters to Satisfy One of Three Conditions",
      titleSlug: "change-minimum-characters-to-satisfy-one-of-three-conditions",
    },
    {
      acRate: 62.797725271849046,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1738",
      paidOnly: false,
      title: "Find Kth Largest XOR Coordinate Value",
      titleSlug: "find-kth-largest-xor-coordinate-value",
    },
    {
      acRate: 51.758583562627116,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1739",
      paidOnly: false,
      title: "Building Boxes",
      titleSlug: "building-boxes",
    },
    {
      acRate: 73.95039429049739,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1740",
      paidOnly: true,
      title: "Find Distance in a Binary Tree",
      titleSlug: "find-distance-in-a-binary-tree",
    },
    {
      acRate: 86.84147365894636,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1741",
      paidOnly: false,
      title: "Find Total Time Spent by Each Employee",
      titleSlug: "find-total-time-spent-by-each-employee",
    },
    {
      acRate: 74.18432047186042,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1742",
      paidOnly: false,
      title: "Maximum Number of Balls in a Box",
      titleSlug: "maximum-number-of-balls-in-a-box",
    },
    {
      acRate: 74.69760375121973,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1743",
      paidOnly: false,
      title: "Restore the Array From Adjacent Pairs",
      titleSlug: "restore-the-array-from-adjacent-pairs",
    },
    {
      acRate: 34.54778521578123,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1744",
      paidOnly: false,
      title: "Can You Eat Your Favorite Candy on Your Favorite Day?",
      titleSlug: "can-you-eat-your-favorite-candy-on-your-favorite-day",
    },
    {
      acRate: 44.68358347516633,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1745",
      paidOnly: false,
      title: "Palindrome Partitioning IV",
      titleSlug: "palindrome-partitioning-iv",
    },
    {
      acRate: 65.21996449003748,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1746",
      paidOnly: true,
      title: "Maximum Subarray Sum After One Operation",
      titleSlug: "maximum-subarray-sum-after-one-operation",
    },
    {
      acRate: 62.36625655829725,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1747",
      paidOnly: true,
      title: "Leetflex Banned Accounts",
      titleSlug: "leetflex-banned-accounts",
    },
    {
      acRate: 78.92628500963619,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1748",
      paidOnly: false,
      title: "Sum of Unique Elements",
      titleSlug: "sum-of-unique-elements",
    },
    {
      acRate: 71.51050732328592,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1749",
      paidOnly: false,
      title: "Maximum Absolute Sum of Any Subarray",
      titleSlug: "maximum-absolute-sum-of-any-subarray",
    },
    {
      acRate: 55.889857942643864,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1750",
      paidOnly: false,
      title: "Minimum Length of String After Deleting Similar Ends",
      titleSlug: "minimum-length-of-string-after-deleting-similar-ends",
    },
    {
      acRate: 60.847751782885815,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1751",
      paidOnly: false,
      title: "Maximum Number of Events That Can Be Attended II",
      titleSlug: "maximum-number-of-events-that-can-be-attended-ii",
    },
    {
      acRate: 55.03377952197626,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1752",
      paidOnly: false,
      title: "Check if Array Is Sorted and Rotated",
      titleSlug: "check-if-array-is-sorted-and-rotated",
    },
    {
      acRate: 67.706203135651,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1753",
      paidOnly: false,
      title: "Maximum Score From Removing Stones",
      titleSlug: "maximum-score-from-removing-stones",
    },
    {
      acRate: 50.95989152155296,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1754",
      paidOnly: false,
      title: "Largest Merge Of Two Strings",
      titleSlug: "largest-merge-of-two-strings",
    },
    {
      acRate: 41.37943651664837,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1755",
      paidOnly: false,
      title: "Closest Subsequence Sum",
      titleSlug: "closest-subsequence-sum",
    },
    {
      acRate: 77.71898693337636,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1756",
      paidOnly: true,
      title: "Design Most Recently Used Queue",
      titleSlug: "design-most-recently-used-queue",
    },
    {
      acRate: 89.3379693518131,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1757",
      paidOnly: false,
      title: "Recyclable and Low Fat Products",
      titleSlug: "recyclable-and-low-fat-products",
    },
    {
      acRate: 63.6956662145579,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1758",
      paidOnly: false,
      title: "Minimum Changes To Make Alternating Binary String",
      titleSlug: "minimum-changes-to-make-alternating-binary-string",
    },
    {
      acRate: 57.405349970088025,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1759",
      paidOnly: false,
      title: "Count Number of Homogenous Substrings",
      titleSlug: "count-number-of-homogenous-substrings",
    },
    {
      acRate: 67.50733728491684,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1760",
      paidOnly: false,
      title: "Minimum Limit of Balls in a Bag",
      titleSlug: "minimum-limit-of-balls-in-a-bag",
    },
    {
      acRate: 43.215096064380276,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1761",
      paidOnly: false,
      title: "Minimum Degree of a Connected Trio in a Graph",
      titleSlug: "minimum-degree-of-a-connected-trio-in-a-graph",
    },
    {
      acRate: 80.70748788897602,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1762",
      paidOnly: true,
      title: "Buildings With an Ocean View",
      titleSlug: "buildings-with-an-ocean-view",
    },
    {
      acRate: 62.268637586326115,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1763",
      paidOnly: false,
      title: "Longest Nice Substring",
      titleSlug: "longest-nice-substring",
    },
    {
      acRate: 53.70817624882187,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1764",
      paidOnly: false,
      title: "Form Array by Concatenating Subarrays of Another Array",
      titleSlug: "form-array-by-concatenating-subarrays-of-another-array",
    },
    {
      acRate: 75.02711683254232,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1765",
      paidOnly: false,
      title: "Map of Highest Peak",
      titleSlug: "map-of-highest-peak",
    },
    {
      acRate: 41.94186632131808,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1766",
      paidOnly: false,
      title: "Tree of Coprimes",
      titleSlug: "tree-of-coprimes",
    },
    {
      acRate: 77.99759080800594,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1767",
      paidOnly: true,
      title: "Find the Subtasks That Did Not Execute",
      titleSlug: "find-the-subtasks-that-did-not-execute",
    },
    {
      acRate: 82.17934678534336,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1768",
      paidOnly: false,
      title: "Merge Strings Alternately",
      titleSlug: "merge-strings-alternately",
    },
    {
      acRate: 90.12482838355372,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1769",
      paidOnly: false,
      title: "Minimum Number of Operations to Move All Balls to Each Box",
      titleSlug: "minimum-number-of-operations-to-move-all-balls-to-each-box",
    },
    {
      acRate: 42.0725458241629,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1770",
      paidOnly: false,
      title: "Maximum Score from Performing Multiplication Operations",
      titleSlug: "maximum-score-from-performing-multiplication-operations",
    },
    {
      acRate: 37.122082998045755,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1771",
      paidOnly: false,
      title: "Maximize Palindrome Length From Subsequences",
      titleSlug: "maximize-palindrome-length-from-subsequences",
    },
    {
      acRate: 65.79249617151608,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1772",
      paidOnly: true,
      title: "Sort Features by Popularity",
      titleSlug: "sort-features-by-popularity",
    },
    {
      acRate: 84.91153914631813,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1773",
      paidOnly: false,
      title: "Count Items Matching a Rule",
      titleSlug: "count-items-matching-a-rule",
    },
    {
      acRate: 47.59277764849215,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1774",
      paidOnly: false,
      title: "Closest Dessert Cost",
      titleSlug: "closest-dessert-cost",
    },
    {
      acRate: 53.87927465430157,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1775",
      paidOnly: false,
      title: "Equal Sum Arrays With Minimum Number of Operations",
      titleSlug: "equal-sum-arrays-with-minimum-number-of-operations",
    },
    {
      acRate: 56.20183942331594,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1776",
      paidOnly: false,
      title: "Car Fleet II",
      titleSlug: "car-fleet-ii",
    },
    {
      acRate: 82.48222365869424,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1777",
      paidOnly: true,
      title: "Product's Price for Each Store",
      titleSlug: "products-price-for-each-store",
    },
    {
      acRate: 44.15965787598004,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1778",
      paidOnly: true,
      title: "Shortest Path in a Hidden Grid",
      titleSlug: "shortest-path-in-a-hidden-grid",
    },
    {
      acRate: 69.31383465443682,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1779",
      paidOnly: false,
      title: "Find Nearest Point That Has the Same X or Y Coordinate",
      titleSlug: "find-nearest-point-that-has-the-same-x-or-y-coordinate",
    },
    {
      acRate: 79.32076393375459,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1780",
      paidOnly: false,
      title: "Check if Number is a Sum of Powers of Three",
      titleSlug: "check-if-number-is-a-sum-of-powers-of-three",
    },
    {
      acRate: 70.15987720561269,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1781",
      paidOnly: false,
      title: "Sum of Beauty of All Substrings",
      titleSlug: "sum-of-beauty-of-all-substrings",
    },
    {
      acRate: 40.62562065541211,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1782",
      paidOnly: false,
      title: "Count Pairs Of Nodes",
      titleSlug: "count-pairs-of-nodes",
    },
    {
      acRate: 83.19045944995808,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1783",
      paidOnly: true,
      title: "Grand Slam Titles",
      titleSlug: "grand-slam-titles",
    },
    {
      acRate: 39.01564123067266,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1784",
      paidOnly: false,
      title: "Check if Binary String Has at Most One Segment of Ones",
      titleSlug: "check-if-binary-string-has-at-most-one-segment-of-ones",
    },
    {
      acRate: 44.237824616934034,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1785",
      paidOnly: false,
      title: "Minimum Elements to Add to Form a Given Sum",
      titleSlug: "minimum-elements-to-add-to-form-a-given-sum",
    },
    {
      acRate: 39.878367827742544,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1786",
      paidOnly: false,
      title: "Number of Restricted Paths From First to Last Node",
      titleSlug: "number-of-restricted-paths-from-first-to-last-node",
    },
    {
      acRate: 39.80499934563539,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1787",
      paidOnly: false,
      title: "Make the XOR of All Segments Equal to Zero",
      titleSlug: "make-the-xor-of-all-segments-equal-to-zero",
    },
    {
      acRate: 63.68407898025493,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1788",
      paidOnly: true,
      title: "Maximize the Beauty of the Garden",
      titleSlug: "maximize-the-beauty-of-the-garden",
    },
    {
      acRate: 71.19182551949167,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1789",
      paidOnly: false,
      title: "Primary Department for Each Employee",
      titleSlug: "primary-department-for-each-employee",
    },
    {
      acRate: 49.446360286096514,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1790",
      paidOnly: false,
      title: "Check if One String Swap Can Make Strings Equal",
      titleSlug: "check-if-one-string-swap-can-make-strings-equal",
    },
    {
      acRate: 86.59781734272856,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1791",
      paidOnly: false,
      title: "Find Center of Star Graph",
      titleSlug: "find-center-of-star-graph",
    },
    {
      acRate: 71.55645940449567,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1792",
      paidOnly: false,
      title: "Maximum Average Pass Ratio",
      titleSlug: "maximum-average-pass-ratio",
    },
    {
      acRate: 64.2247773025154,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1793",
      paidOnly: false,
      title: "Maximum Score of a Good Subarray",
      titleSlug: "maximum-score-of-a-good-subarray",
    },
    {
      acRate: 63.754594288945434,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1794",
      paidOnly: true,
      title: "Count Pairs of Equal Substrings With Minimum Difference",
      titleSlug: "count-pairs-of-equal-substrings-with-minimum-difference",
    },
    {
      acRate: 85.57818312478864,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1795",
      paidOnly: false,
      title: "Rearrange Products Table",
      titleSlug: "rearrange-products-table",
    },
    {
      acRate: 51.73593723919212,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1796",
      paidOnly: false,
      title: "Second Largest Digit in a String",
      titleSlug: "second-largest-digit-in-a-string",
    },
    {
      acRate: 57.62870156180405,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1797",
      paidOnly: false,
      title: "Design Authentication Manager",
      titleSlug: "design-authentication-manager",
    },
    {
      acRate: 61.756857134996835,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1798",
      paidOnly: false,
      title: "Maximum Number of Consecutive Values You Can Make",
      titleSlug: "maximum-number-of-consecutive-values-you-can-make",
    },
    {
      acRate: 57.80261232835663,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1799",
      paidOnly: false,
      title: "Maximize Score After N Operations",
      titleSlug: "maximize-score-after-n-operations",
    },
    {
      acRate: 66.55039978372596,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1800",
      paidOnly: false,
      title: "Maximum Ascending Subarray Sum",
      titleSlug: "maximum-ascending-subarray-sum",
    },
    {
      acRate: 51.587757603616026,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1801",
      paidOnly: false,
      title: "Number of Orders in the Backlog",
      titleSlug: "number-of-orders-in-the-backlog",
    },
    {
      acRate: 38.846761826117735,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1802",
      paidOnly: false,
      title: "Maximum Value at a Given Index in a Bounded Array",
      titleSlug: "maximum-value-at-a-given-index-in-a-bounded-array",
    },
    {
      acRate: 45.705869976856725,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1803",
      paidOnly: false,
      title: "Count Pairs With XOR in a Range",
      titleSlug: "count-pairs-with-xor-in-a-range",
    },
    {
      acRate: 63.09879063923355,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1804",
      paidOnly: true,
      title: "Implement Trie II (Prefix Tree)",
      titleSlug: "implement-trie-ii-prefix-tree",
    },
    {
      acRate: 39.00443445131472,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1805",
      paidOnly: false,
      title: "Number of Different Integers in a String",
      titleSlug: "number-of-different-integers-in-a-string",
    },
    {
      acRate: 72.0281862745098,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1806",
      paidOnly: false,
      title: "Minimum Number of Operations to Reinitialize a Permutation",
      titleSlug: "minimum-number-of-operations-to-reinitialize-a-permutation",
    },
    {
      acRate: 68.03304974439267,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1807",
      paidOnly: false,
      title: "Evaluate the Bracket Pairs of a String",
      titleSlug: "evaluate-the-bracket-pairs-of-a-string",
    },
    {
      acRate: 32.83500951345474,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1808",
      paidOnly: false,
      title: "Maximize Number of Nice Divisors",
      titleSlug: "maximize-number-of-nice-divisors",
    },
    {
      acRate: 58.6719621873564,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1809",
      paidOnly: true,
      title: "Ad-Free Sessions",
      titleSlug: "ad-free-sessions",
    },
    {
      acRate: 57.94914448669202,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1810",
      paidOnly: true,
      title: "Minimum Path Cost in a Hidden Grid",
      titleSlug: "minimum-path-cost-in-a-hidden-grid",
    },
    {
      acRate: 60.681253451131965,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1811",
      paidOnly: true,
      title: "Find Interview Candidates",
      titleSlug: "find-interview-candidates",
    },
    {
      acRate: 79.26798173431307,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1812",
      paidOnly: false,
      title: "Determine Color of a Chessboard Square",
      titleSlug: "determine-color-of-a-chessboard-square",
    },
    {
      acRate: 48.63826200237557,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1813",
      paidOnly: false,
      title: "Sentence Similarity III",
      titleSlug: "sentence-similarity-iii",
    },
    {
      acRate: 48.545451656723415,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1814",
      paidOnly: false,
      title: "Count Nice Pairs in an Array",
      titleSlug: "count-nice-pairs-in-an-array",
    },
    {
      acRate: 40.248806906536544,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1815",
      paidOnly: false,
      title: "Maximum Number of Groups Getting Fresh Donuts",
      titleSlug: "maximum-number-of-groups-getting-fresh-donuts",
    },
    {
      acRate: 85.9799300399104,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1816",
      paidOnly: false,
      title: "Truncate Sentence",
      titleSlug: "truncate-sentence",
    },
    {
      acRate: 80.43782661965844,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1817",
      paidOnly: false,
      title: "Finding the Users Active Minutes",
      titleSlug: "finding-the-users-active-minutes",
    },
    {
      acRate: 31.25946257992136,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1818",
      paidOnly: false,
      title: "Minimum Absolute Sum Difference",
      titleSlug: "minimum-absolute-sum-difference",
    },
    {
      acRate: 41.689996451244035,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1819",
      paidOnly: false,
      title: "Number of Different Subsequences GCDs",
      titleSlug: "number-of-different-subsequences-gcds",
    },
    {
      acRate: 51.687667628156476,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1820",
      paidOnly: true,
      title: "Maximum Number of Accepted Invitations",
      titleSlug: "maximum-number-of-accepted-invitations",
    },
    {
      acRate: 87.64449291166848,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1821",
      paidOnly: true,
      title: "Find Customers With Positive Revenue this Year",
      titleSlug: "find-customers-with-positive-revenue-this-year",
    },
    {
      acRate: 65.05932378682093,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1822",
      paidOnly: false,
      title: "Sign of the Product of an Array",
      titleSlug: "sign-of-the-product-of-an-array",
    },
    {
      acRate: 82.03060395977765,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1823",
      paidOnly: false,
      title: "Find the Winner of the Circular Game",
      titleSlug: "find-the-winner-of-the-circular-game",
    },
    {
      acRate: 50.667657992565054,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1824",
      paidOnly: false,
      title: "Minimum Sideway Jumps",
      titleSlug: "minimum-sideway-jumps",
    },
    {
      acRate: 37.966885441527445,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1825",
      paidOnly: false,
      title: "Finding MK Average",
      titleSlug: "finding-mk-average",
    },
    {
      acRate: 50.24420497713001,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1826",
      paidOnly: true,
      title: "Faulty Sensor",
      titleSlug: "faulty-sensor",
    },
    {
      acRate: 80.98635623982977,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1827",
      paidOnly: false,
      title: "Minimum Operations to Make the Array Increasing",
      titleSlug: "minimum-operations-to-make-the-array-increasing",
    },
    {
      acRate: 86.37393795988459,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1828",
      paidOnly: false,
      title: "Queries on Number of Points Inside a Circle",
      titleSlug: "queries-on-number-of-points-inside-a-circle",
    },
    {
      acRate: 84.80191798538328,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1829",
      paidOnly: false,
      title: "Maximum XOR for Each Query",
      titleSlug: "maximum-xor-for-each-query",
    },
    {
      acRate: 49.88510549404638,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1830",
      paidOnly: false,
      title: "Minimum Number of Operations to Make String Sorted",
      titleSlug: "minimum-number-of-operations-to-make-string-sorted",
    },
    {
      acRate: 82.40883238541318,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1831",
      paidOnly: true,
      title: "Maximum Transaction Each Day",
      titleSlug: "maximum-transaction-each-day",
    },
    {
      acRate: 83.79050536461597,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1832",
      paidOnly: false,
      title: "Check if the Sentence Is Pangram",
      titleSlug: "check-if-the-sentence-is-pangram",
    },
    {
      acRate: 73.84911955198857,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1833",
      paidOnly: false,
      title: "Maximum Ice Cream Bars",
      titleSlug: "maximum-ice-cream-bars",
    },
    {
      acRate: 46.27299234468223,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1834",
      paidOnly: false,
      title: "Single-Threaded CPU",
      titleSlug: "single-threaded-cpu",
    },
    {
      acRate: 61.494314238428274,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1835",
      paidOnly: false,
      title: "Find XOR Sum of All Pairs Bitwise AND",
      titleSlug: "find-xor-sum-of-all-pairs-bitwise-and",
    },
    {
      acRate: 75.27839643652561,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1836",
      paidOnly: true,
      title: "Remove Duplicates From an Unsorted Linked List",
      titleSlug: "remove-duplicates-from-an-unsorted-linked-list",
    },
    {
      acRate: 77.93459592714187,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1837",
      paidOnly: false,
      title: "Sum of Digits in Base K",
      titleSlug: "sum-of-digits-in-base-k",
    },
    {
      acRate: 44.06776324423641,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1838",
      paidOnly: false,
      title: "Frequency of the Most Frequent Element",
      titleSlug: "frequency-of-the-most-frequent-element",
    },
    {
      acRate: 50.249586178357134,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1839",
      paidOnly: false,
      title: "Longest Substring Of All Vowels in Order",
      titleSlug: "longest-substring-of-all-vowels-in-order",
    },
    {
      acRate: 37.28349240014139,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1840",
      paidOnly: false,
      title: "Maximum Building Height",
      titleSlug: "maximum-building-height",
    },
    {
      acRate: 53.452975115925106,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1841",
      paidOnly: true,
      title: "League Statistics",
      titleSlug: "league-statistics",
    },
    {
      acRate: 53.68056728009455,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1842",
      paidOnly: true,
      title: "Next Palindrome Using Same Digits",
      titleSlug: "next-palindrome-using-same-digits",
    },
    {
      acRate: 44.95842170824496,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1843",
      paidOnly: true,
      title: "Suspicious Bank Accounts",
      titleSlug: "suspicious-bank-accounts",
    },
    {
      acRate: 82.01194073377997,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1844",
      paidOnly: false,
      title: "Replace All Digits with Characters",
      titleSlug: "replace-all-digits-with-characters",
    },
    {
      acRate: 66.27991890307766,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1845",
      paidOnly: false,
      title: "Seat Reservation Manager",
      titleSlug: "seat-reservation-manager",
    },
    {
      acRate: 65.71625468164794,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1846",
      paidOnly: false,
      title: "Maximum Element After Decreasing and Rearranging",
      titleSlug: "maximum-element-after-decreasing-and-rearranging",
    },
    {
      acRate: 39.46336726252563,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1847",
      paidOnly: false,
      title: "Closest Room",
      titleSlug: "closest-room",
    },
    {
      acRate: 54.257516406369234,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1848",
      paidOnly: false,
      title: "Minimum Distance to the Target Element",
      titleSlug: "minimum-distance-to-the-target-element",
    },
    {
      acRate: 36.700564168207464,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1849",
      paidOnly: false,
      title: "Splitting a String Into Descending Consecutive Values",
      titleSlug: "splitting-a-string-into-descending-consecutive-values",
    },
    {
      acRate: 71.16658029596361,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1850",
      paidOnly: false,
      title: "Minimum Adjacent Swaps to Reach the Kth Smallest Number",
      titleSlug: "minimum-adjacent-swaps-to-reach-the-kth-smallest-number",
    },
    {
      acRate: 52.0240639274031,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1851",
      paidOnly: false,
      title: "Minimum Interval to Include Each Query",
      titleSlug: "minimum-interval-to-include-each-query",
    },
    {
      acRate: 76.95129107981221,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1852",
      paidOnly: true,
      title: "Distinct Numbers in Each Subarray",
      titleSlug: "distinct-numbers-in-each-subarray",
    },
    {
      acRate: 85.48245870060126,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1853",
      paidOnly: true,
      title: "Convert Date Format",
      titleSlug: "convert-date-format",
    },
    {
      acRate: 62.54761153021947,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1854",
      paidOnly: false,
      title: "Maximum Population Year",
      titleSlug: "maximum-population-year",
    },
    {
      acRate: 53.75128666390896,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1855",
      paidOnly: false,
      title: "Maximum Distance Between a Pair of Values",
      titleSlug: "maximum-distance-between-a-pair-of-values",
    },
    {
      acRate: 38.828983755896914,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1856",
      paidOnly: false,
      title: "Maximum Subarray Min-Product",
      titleSlug: "maximum-subarray-min-product",
    },
    {
      acRate: 49.46135894023793,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1857",
      paidOnly: false,
      title: "Largest Color Value in a Directed Graph",
      titleSlug: "largest-color-value-in-a-directed-graph",
    },
    {
      acRate: 71.43388605442176,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1858",
      paidOnly: true,
      title: "Longest Word With All Prefixes",
      titleSlug: "longest-word-with-all-prefixes",
    },
    {
      acRate: 83.68673419443684,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1859",
      paidOnly: false,
      title: "Sorting the Sentence",
      titleSlug: "sorting-the-sentence",
    },
    {
      acRate: 72.45967741935485,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1860",
      paidOnly: false,
      title: "Incremental Memory Leak",
      titleSlug: "incremental-memory-leak",
    },
    {
      acRate: 79.04306120646204,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1861",
      paidOnly: false,
      title: "Rotating the Box",
      titleSlug: "rotating-the-box",
    },
    {
      acRate: 29.599206130437178,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1862",
      paidOnly: false,
      title: "Sum of Floored Pairs",
      titleSlug: "sum-of-floored-pairs",
    },
    {
      acRate: 90.07948485763156,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1863",
      paidOnly: false,
      title: "Sum of All Subset XOR Totals",
      titleSlug: "sum-of-all-subset-xor-totals",
    },
    {
      acRate: 43.380788292307905,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1864",
      paidOnly: false,
      title: "Minimum Number of Swaps to Make the Binary String Alternating",
      titleSlug:
        "minimum-number-of-swaps-to-make-the-binary-string-alternating",
    },
    {
      acRate: 48.94650306001279,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1865",
      paidOnly: false,
      title: "Finding Pairs With a Certain Sum",
      titleSlug: "finding-pairs-with-a-certain-sum",
    },
    {
      acRate: 57.66492643569055,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1866",
      paidOnly: false,
      title: "Number of Ways to Rearrange Sticks With K Sticks Visible",
      titleSlug: "number-of-ways-to-rearrange-sticks-with-k-sticks-visible",
    },
    {
      acRate: 70.84606345475912,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1867",
      paidOnly: true,
      title: "Orders With Maximum Quantity Above Average",
      titleSlug: "orders-with-maximum-quantity-above-average",
    },
    {
      acRate: 59.285271428135836,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1868",
      paidOnly: true,
      title: "Product of Two Run-Length Encoded Arrays",
      titleSlug: "product-of-two-run-length-encoded-arrays",
    },
    {
      acRate: 61.54879985782675,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1869",
      paidOnly: false,
      title: "Longer Contiguous Segments of Ones than Zeros",
      titleSlug: "longer-contiguous-segments-of-ones-than-zeros",
    },
    {
      acRate: 47.17061873835775,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1870",
      paidOnly: false,
      title: "Minimum Speed to Arrive on Time",
      titleSlug: "minimum-speed-to-arrive-on-time",
    },
    {
      acRate: 25.46808491328063,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1871",
      paidOnly: false,
      title: "Jump Game VII",
      titleSlug: "jump-game-vii",
    },
    {
      acRate: 52.90349927000424,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1872",
      paidOnly: false,
      title: "Stone Game VIII",
      titleSlug: "stone-game-viii",
    },
    {
      acRate: 57.32904099898687,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1873",
      paidOnly: false,
      title: "Calculate Special Bonus",
      titleSlug: "calculate-special-bonus",
    },
    {
      acRate: 89.03446549278145,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1874",
      paidOnly: true,
      title: "Minimize Product Sum of Two Arrays",
      titleSlug: "minimize-product-sum-of-two-arrays",
    },
    {
      acRate: 66.53855392745615,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1875",
      paidOnly: true,
      title: "Group Employees of the Same Salary",
      titleSlug: "group-employees-of-the-same-salary",
    },
    {
      acRate: 75.28570430245288,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1876",
      paidOnly: false,
      title: "Substrings of Size Three with Distinct Characters",
      titleSlug: "substrings-of-size-three-with-distinct-characters",
    },
    {
      acRate: 81.43726308678374,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1877",
      paidOnly: false,
      title: "Minimize Maximum Pair Sum in Array",
      titleSlug: "minimize-maximum-pair-sum-in-array",
    },
    {
      acRate: 49.06720848615985,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1878",
      paidOnly: false,
      title: "Get Biggest Three Rhombus Sums in a Grid",
      titleSlug: "get-biggest-three-rhombus-sums-in-a-grid",
    },
    {
      acRate: 48.82390154129285,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1879",
      paidOnly: false,
      title: "Minimum XOR Sum of Two Arrays",
      titleSlug: "minimum-xor-sum-of-two-arrays",
    },
    {
      acRate: 74.61488263560679,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1880",
      paidOnly: false,
      title: "Check if Word Equals Summation of Two Words",
      titleSlug: "check-if-word-equals-summation-of-two-words",
    },
    {
      acRate: 38.45771267997911,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1881",
      paidOnly: false,
      title: "Maximum Value after Insertion",
      titleSlug: "maximum-value-after-insertion",
    },
    {
      acRate: 40.93896133325094,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1882",
      paidOnly: false,
      title: "Process Tasks Using Servers",
      titleSlug: "process-tasks-using-servers",
    },
    {
      acRate: 38.194748891811585,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1883",
      paidOnly: false,
      title: "Minimum Skips to Arrive at Meeting On Time",
      titleSlug: "minimum-skips-to-arrive-at-meeting-on-time",
    },
    {
      acRate: 73.60364141983892,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1884",
      paidOnly: false,
      title: "Egg Drop With 2 Eggs and N Floors",
      titleSlug: "egg-drop-with-2-eggs-and-n-floors",
    },
    {
      acRate: 60.13595404963904,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1885",
      paidOnly: true,
      title: "Count Pairs in Two Arrays",
      titleSlug: "count-pairs-in-two-arrays",
    },
    {
      acRate: 57.93071919871995,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1886",
      paidOnly: false,
      title: "Determine Whether Matrix Can Be Obtained By Rotation",
      titleSlug: "determine-whether-matrix-can-be-obtained-by-rotation",
    },
    {
      acRate: 72.29398371135827,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1887",
      paidOnly: false,
      title: "Reduction Operations to Make the Array Elements Equal",
      titleSlug: "reduction-operations-to-make-the-array-elements-equal",
    },
    {
      acRate: 40.4230259606419,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1888",
      paidOnly: false,
      title: "Minimum Number of Flips to Make the Binary String Alternating",
      titleSlug:
        "minimum-number-of-flips-to-make-the-binary-string-alternating",
    },
    {
      acRate: 32.476835964310226,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1889",
      paidOnly: false,
      title: "Minimum Space Wasted From Packaging",
      titleSlug: "minimum-space-wasted-from-packaging",
    },
    {
      acRate: 77.41445130839175,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1890",
      paidOnly: false,
      title: "The Latest Login in 2020",
      titleSlug: "the-latest-login-in-2020",
    },
    {
      acRate: 52.32572311995227,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1891",
      paidOnly: true,
      title: "Cutting Ribbons",
      titleSlug: "cutting-ribbons",
    },
    {
      acRate: 44.59203036053131,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1892",
      paidOnly: true,
      title: "Page Recommendations II",
      titleSlug: "page-recommendations-ii",
    },
    {
      acRate: 50.354058258677114,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1893",
      paidOnly: false,
      title: "Check if All the Integers in a Range Are Covered",
      titleSlug: "check-if-all-the-integers-in-a-range-are-covered",
    },
    {
      acRate: 53.17952465649635,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1894",
      paidOnly: false,
      title: "Find the Student that Will Replace the Chalk",
      titleSlug: "find-the-student-that-will-replace-the-chalk",
    },
    {
      acRate: 52.348887576294544,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1895",
      paidOnly: false,
      title: "Largest Magic Square",
      titleSlug: "largest-magic-square",
    },
    {
      acRate: 50.71760008632783,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1896",
      paidOnly: false,
      title: "Minimum Cost to Change the Final Value of Expression",
      titleSlug: "minimum-cost-to-change-the-final-value-of-expression",
    },
    {
      acRate: 66.77680584523296,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1897",
      paidOnly: false,
      title: "Redistribute Characters to Make All Strings Equal",
      titleSlug: "redistribute-characters-to-make-all-strings-equal",
    },
    {
      acRate: 45.55248145337023,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1898",
      paidOnly: false,
      title: "Maximum Number of Removable Characters",
      titleSlug: "maximum-number-of-removable-characters",
    },
    {
      acRate: 67.44617839770443,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1899",
      paidOnly: false,
      title: "Merge Triplets to Form Target Triplet",
      titleSlug: "merge-triplets-to-form-target-triplet",
    },
    {
      acRate: 48.046875,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1900",
      paidOnly: false,
      title: "The Earliest and Latest Rounds Where Players Compete",
      titleSlug: "the-earliest-and-latest-rounds-where-players-compete",
    },
    {
      acRate: 52.99935260816264,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1901",
      paidOnly: false,
      title: "Find a Peak Element II",
      titleSlug: "find-a-peak-element-ii",
    },
    {
      acRate: 42.26658283558629,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1902",
      paidOnly: true,
      title: "Depth of BST Given Insertion Order",
      titleSlug: "depth-of-bst-given-insertion-order",
    },
    {
      acRate: 64.8988563909185,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1903",
      paidOnly: false,
      title: "Largest Odd Number in String",
      titleSlug: "largest-odd-number-in-string",
    },
    {
      acRate: 43.39329576650773,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1904",
      paidOnly: false,
      title: "The Number of Full Rounds You Have Played",
      titleSlug: "the-number-of-full-rounds-you-have-played",
    },
    {
      acRate: 72.79903651782193,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1905",
      paidOnly: false,
      title: "Count Sub Islands",
      titleSlug: "count-sub-islands",
    },
    {
      acRate: 44.68322133180005,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1906",
      paidOnly: false,
      title: "Minimum Absolute Difference Queries",
      titleSlug: "minimum-absolute-difference-queries",
    },
    {
      acRate: 62.11887035369814,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1907",
      paidOnly: false,
      title: "Count Salary Categories",
      titleSlug: "count-salary-categories",
    },
    {
      acRate: 62.800565770862804,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1908",
      paidOnly: true,
      title: "Game of Nim",
      titleSlug: "game-of-nim",
    },
    {
      acRate: 28.593860522992486,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1909",
      paidOnly: false,
      title: "Remove One Element to Make the Array Strictly Increasing",
      titleSlug: "remove-one-element-to-make-the-array-strictly-increasing",
    },
    {
      acRate: 78.0271676558107,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1910",
      paidOnly: false,
      title: "Remove All Occurrences of a Substring",
      titleSlug: "remove-all-occurrences-of-a-substring",
    },
    {
      acRate: 58.71048616942017,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1911",
      paidOnly: false,
      title: "Maximum Alternating Subsequence Sum",
      titleSlug: "maximum-alternating-subsequence-sum",
    },
    {
      acRate: 35.29868114817688,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1912",
      paidOnly: false,
      title: "Design Movie Rental System",
      titleSlug: "design-movie-rental-system",
    },
    {
      acRate: 82.88488680288802,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1913",
      paidOnly: false,
      title: "Maximum Product Difference Between Two Pairs",
      titleSlug: "maximum-product-difference-between-two-pairs",
    },
    {
      acRate: 50.24295087781522,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1914",
      paidOnly: false,
      title: "Cyclically Rotating a Grid",
      titleSlug: "cyclically-rotating-a-grid",
    },
    {
      acRate: 66.64484224796648,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1915",
      paidOnly: false,
      title: "Number of Wonderful Substrings",
      titleSlug: "number-of-wonderful-substrings",
    },
    {
      acRate: 48.300010691756654,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1916",
      paidOnly: false,
      title: "Count Ways to Build Rooms in an Ant Colony",
      titleSlug: "count-ways-to-build-rooms-in-an-ant-colony",
    },
    {
      acRate: 27.828506206306177,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1917",
      paidOnly: true,
      title: "Leetcodify Friends Recommendations",
      titleSlug: "leetcodify-friends-recommendations",
    },
    {
      acRate: 52.75338361400971,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1918",
      paidOnly: true,
      title: "Kth Smallest Subarray Sum",
      titleSlug: "kth-smallest-subarray-sum",
    },
    {
      acRate: 42.50735800613689,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1919",
      paidOnly: true,
      title: "Leetcodify Similar Friends",
      titleSlug: "leetcodify-similar-friends",
    },
    {
      acRate: 91.10341487933603,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1920",
      paidOnly: false,
      title: "Build Array from Permutation",
      titleSlug: "build-array-from-permutation",
    },
    {
      acRate: 50.79691651746825,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1921",
      paidOnly: false,
      title: "Eliminate Maximum Number of Monsters",
      titleSlug: "eliminate-maximum-number-of-monsters",
    },
    {
      acRate: 56.49090365826845,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1922",
      paidOnly: false,
      title: "Count Good Numbers",
      titleSlug: "count-good-numbers",
    },
    {
      acRate: 27.95578698527298,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1923",
      paidOnly: false,
      title: "Longest Common Subpath",
      titleSlug: "longest-common-subpath",
    },
    {
      acRate: 49.4335122242099,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1924",
      paidOnly: true,
      title: "Erect the Fence II",
      titleSlug: "erect-the-fence-ii",
    },
    {
      acRate: 68.84434669599119,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1925",
      paidOnly: false,
      title: "Count Square Sum Triples",
      titleSlug: "count-square-sum-triples",
    },
    {
      acRate: 47.437275870283216,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1926",
      paidOnly: false,
      title: "Nearest Exit from Entrance in Maze",
      titleSlug: "nearest-exit-from-entrance-in-maze",
    },
    {
      acRate: 48.26660240300203,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1927",
      paidOnly: false,
      title: "Sum Game",
      titleSlug: "sum-game",
    },
    {
      acRate: 39.79607624706028,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1928",
      paidOnly: false,
      title: "Minimum Cost to Reach Destination in Time",
      titleSlug: "minimum-cost-to-reach-destination-in-time",
    },
    {
      acRate: 90.45034057853181,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1929",
      paidOnly: false,
      title: "Concatenation of Array",
      titleSlug: "concatenation-of-array",
    },
    {
      acRate: 70.90116530236266,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1930",
      paidOnly: false,
      title: "Unique Length-3 Palindromic Subsequences",
      titleSlug: "unique-length-3-palindromic-subsequences",
    },
    {
      acRate: 56.92132150822052,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1931",
      paidOnly: false,
      title: "Painting a Grid With Three Different Colors",
      titleSlug: "painting-a-grid-with-three-different-colors",
    },
    {
      acRate: 35.60742423795332,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1932",
      paidOnly: false,
      title: "Merge BSTs to Create Single BST",
      titleSlug: "merge-bsts-to-create-single-bst",
    },
    {
      acRate: 50.63115228720324,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1933",
      paidOnly: true,
      title: "Check if String Is Decomposable Into Value-Equal Substrings",
      titleSlug: "check-if-string-is-decomposable-into-value-equal-substrings",
    },
    {
      acRate: 60.83743194165842,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1934",
      paidOnly: false,
      title: "Confirmation Rate",
      titleSlug: "confirmation-rate",
    },
    {
      acRate: 74.5433252820561,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1935",
      paidOnly: false,
      title: "Maximum Number of Words You Can Type",
      titleSlug: "maximum-number-of-words-you-can-type",
    },
    {
      acRate: 43.28996232867562,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1936",
      paidOnly: false,
      title: "Add Minimum Number of Rungs",
      titleSlug: "add-minimum-number-of-rungs",
    },
    {
      acRate: 42.20561998215879,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1937",
      paidOnly: false,
      title: "Maximum Number of Points with Cost",
      titleSlug: "maximum-number-of-points-with-cost",
    },
    {
      acRate: 44.050131926121374,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1938",
      paidOnly: false,
      title: "Maximum Genetic Difference Query",
      titleSlug: "maximum-genetic-difference-query",
    },
    {
      acRate: 56.59192042579182,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1939",
      paidOnly: true,
      title: "Users That Actively Request Confirmation Messages",
      titleSlug: "users-that-actively-request-confirmation-messages",
    },
    {
      acRate: 81.27156513377454,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1940",
      paidOnly: true,
      title: "Longest Common Subsequence Between Sorted Arrays",
      titleSlug: "longest-common-subsequence-between-sorted-arrays",
    },
    {
      acRate: 78.51003950857823,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1941",
      paidOnly: false,
      title: "Check if All Characters Have Equal Number of Occurrences",
      titleSlug: "check-if-all-characters-have-equal-number-of-occurrences",
    },
    {
      acRate: 60.458571147411924,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1942",
      paidOnly: false,
      title: "The Number of the Smallest Unoccupied Chair",
      titleSlug: "the-number-of-the-smallest-unoccupied-chair",
    },
    {
      acRate: 51.02200519610604,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1943",
      paidOnly: false,
      title: "Describe the Painting",
      titleSlug: "describe-the-painting",
    },
    {
      acRate: 71.03621144980082,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1944",
      paidOnly: false,
      title: "Number of Visible People in a Queue",
      titleSlug: "number-of-visible-people-in-a-queue",
    },
    {
      acRate: 74.70406837081411,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1945",
      paidOnly: false,
      title: "Sum of Digits of String After Convert",
      titleSlug: "sum-of-digits-of-string-after-convert",
    },
    {
      acRate: 36.747006638128916,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1946",
      paidOnly: false,
      title: "Largest Number After Mutating Substring",
      titleSlug: "largest-number-after-mutating-substring",
    },
    {
      acRate: 63.09116989410624,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1947",
      paidOnly: false,
      title: "Maximum Compatibility Score Sum",
      titleSlug: "maximum-compatibility-score-sum",
    },
    {
      acRate: 53.67161937456418,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1948",
      paidOnly: false,
      title: "Delete Duplicate Folders in System",
      titleSlug: "delete-duplicate-folders-in-system",
    },
    {
      acRate: 54.420202325230264,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1949",
      paidOnly: true,
      title: "Strong Friendship",
      titleSlug: "strong-friendship",
    },
    {
      acRate: 47.94226921977708,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1950",
      paidOnly: true,
      title: "Maximum of Minimum Values in All Subarrays",
      titleSlug: "maximum-of-minimum-values-in-all-subarrays",
    },
    {
      acRate: 69.2044076554015,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1951",
      paidOnly: true,
      title: "All the Pairs With the Maximum Number of Common Followers",
      titleSlug: "all-the-pairs-with-the-maximum-number-of-common-followers",
    },
    {
      acRate: 62.584146468451586,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1952",
      paidOnly: false,
      title: "Three Divisors",
      titleSlug: "three-divisors",
    },
    {
      acRate: 41.21964217738866,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1953",
      paidOnly: false,
      title: "Maximum Number of Weeks for Which You Can Work",
      titleSlug: "maximum-number-of-weeks-for-which-you-can-work",
    },
    {
      acRate: 54.31024678721711,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1954",
      paidOnly: false,
      title: "Minimum Garden Perimeter to Collect Enough Apples",
      titleSlug: "minimum-garden-perimeter-to-collect-enough-apples",
    },
    {
      acRate: 51.67487684729064,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1955",
      paidOnly: false,
      title: "Count Number of Special Subsequences",
      titleSlug: "count-number-of-special-subsequences",
    },
    {
      acRate: 49.15110356536502,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1956",
      paidOnly: true,
      title: "Minimum Time For K Virus Variants to Spread",
      titleSlug: "minimum-time-for-k-virus-variants-to-spread",
    },
    {
      acRate: 71.58416465555271,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1957",
      paidOnly: false,
      title: "Delete Characters to Make Fancy String",
      titleSlug: "delete-characters-to-make-fancy-string",
    },
    {
      acRate: 49.12641937925814,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1958",
      paidOnly: false,
      title: "Check if Move is Legal",
      titleSlug: "check-if-move-is-legal",
    },
    {
      acRate: 42.74204142400491,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1959",
      paidOnly: false,
      title: "Minimum Total Space Wasted With K Resizing Operations",
      titleSlug: "minimum-total-space-wasted-with-k-resizing-operations",
    },
    {
      acRate: 30.34188034188034,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1960",
      paidOnly: false,
      title: "Maximum Product of the Length of Two Palindromic Substrings",
      titleSlug: "maximum-product-of-the-length-of-two-palindromic-substrings",
    },
    {
      acRate: 52.44219259089148,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1961",
      paidOnly: false,
      title: "Check If String Is a Prefix of Array",
      titleSlug: "check-if-string-is-a-prefix-of-array",
    },
    {
      acRate: 64.44789560464494,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1962",
      paidOnly: false,
      title: "Remove Stones to Minimize the Total",
      titleSlug: "remove-stones-to-minimize-the-total",
    },
    {
      acRate: 77.93995326860886,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1963",
      paidOnly: false,
      title: "Minimum Number of Swaps to Make the String Balanced",
      titleSlug: "minimum-number-of-swaps-to-make-the-string-balanced",
    },
    {
      acRate: 62.50528156904361,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1964",
      paidOnly: false,
      title: "Find the Longest Valid Obstacle Course at Each Position",
      titleSlug: "find-the-longest-valid-obstacle-course-at-each-position",
    },
    {
      acRate: 72.83289137815667,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1965",
      paidOnly: false,
      title: "Employees With Missing Information",
      titleSlug: "employees-with-missing-information",
    },
    {
      acRate: 62.44922826969943,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1966",
      paidOnly: true,
      title: "Binary Searchable Numbers in an Unsorted Array",
      titleSlug: "binary-searchable-numbers-in-an-unsorted-array",
    },
    {
      acRate: 81.79327320421143,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1967",
      paidOnly: false,
      title: "Number of Strings That Appear as Substrings in Word",
      titleSlug: "number-of-strings-that-appear-as-substrings-in-word",
    },
    {
      acRate: 50.035673435181934,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1968",
      paidOnly: false,
      title: "Array With Elements Not Equal to Average of Neighbors",
      titleSlug: "array-with-elements-not-equal-to-average-of-neighbors",
    },
    {
      acRate: 36.25993778085033,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1969",
      paidOnly: false,
      title: "Minimum Non-Zero Product of the Array Elements",
      titleSlug: "minimum-non-zero-product-of-the-array-elements",
    },
    {
      acRate: 62.196395925829194,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1970",
      paidOnly: false,
      title: "Last Day Where You Can Still Cross",
      titleSlug: "last-day-where-you-can-still-cross",
    },
    {
      acRate: 53.911081976950356,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1971",
      paidOnly: false,
      title: "Find if Path Exists in Graph",
      titleSlug: "find-if-path-exists-in-graph",
    },
    {
      acRate: 51.026878015161955,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1972",
      paidOnly: true,
      title: "First and Last Call On the Same Day",
      titleSlug: "first-and-last-call-on-the-same-day",
    },
    {
      acRate: 76.97548387096774,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1973",
      paidOnly: true,
      title: "Count Nodes Equal to Sum of Descendants",
      titleSlug: "count-nodes-equal-to-sum-of-descendants",
    },
    {
      acRate: 77.30374046007388,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1974",
      paidOnly: false,
      title: "Minimum Time to Type Word Using Special Typewriter",
      titleSlug: "minimum-time-to-type-word-using-special-typewriter",
    },
    {
      acRate: 65.93883854163555,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1975",
      paidOnly: false,
      title: "Maximum Matrix Sum",
      titleSlug: "maximum-matrix-sum",
    },
    {
      acRate: 37.75230541045979,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1976",
      paidOnly: false,
      title: "Number of Ways to Arrive at Destination",
      titleSlug: "number-of-ways-to-arrive-at-destination",
    },
    {
      acRate: 20.968967166530682,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1977",
      paidOnly: false,
      title: "Number of Ways to Separate Numbers",
      titleSlug: "number-of-ways-to-separate-numbers",
    },
    {
      acRate: 48.85078304787895,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1978",
      paidOnly: false,
      title: "Employees Whose Manager Left the Company",
      titleSlug: "employees-whose-manager-left-the-company",
    },
    {
      acRate: 78.49177095834048,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1979",
      paidOnly: false,
      title: "Find Greatest Common Divisor of Array",
      titleSlug: "find-greatest-common-divisor-of-array",
    },
    {
      acRate: 79.35093397979091,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1980",
      paidOnly: false,
      title: "Find Unique Binary String",
      titleSlug: "find-unique-binary-string",
    },
    {
      acRate: 35.77899990463172,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1981",
      paidOnly: false,
      title: "Minimize the Difference Between Target and Chosen Elements",
      titleSlug: "minimize-the-difference-between-target-and-chosen-elements",
    },
    {
      acRate: 48.615652932199694,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1982",
      paidOnly: false,
      title: "Find Array Given Subset Sums",
      titleSlug: "find-array-given-subset-sums",
    },
    {
      acRate: 53.0632249632413,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1983",
      paidOnly: true,
      title: "Widest Pair of Indices With Equal Range Sum",
      titleSlug: "widest-pair-of-indices-with-equal-range-sum",
    },
    {
      acRate: 58.342012651705346,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1984",
      paidOnly: false,
      title: "Minimum Difference Between Highest and Lowest of K Scores",
      titleSlug: "minimum-difference-between-highest-and-lowest-of-k-scores",
    },
    {
      acRate: 46.70210518121462,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1985",
      paidOnly: false,
      title: "Find the Kth Largest Integer in the Array",
      titleSlug: "find-the-kth-largest-integer-in-the-array",
    },
    {
      acRate: 33.60492425507285,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1986",
      paidOnly: false,
      title: "Minimum Number of Work Sessions to Finish the Tasks",
      titleSlug: "minimum-number-of-work-sessions-to-finish-the-tasks",
    },
    {
      acRate: 52.07739665787159,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1987",
      paidOnly: false,
      title: "Number of Unique Good Subsequences",
      titleSlug: "number-of-unique-good-subsequences",
    },
    {
      acRate: 66.82970442831598,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1988",
      paidOnly: true,
      title: "Find Cutoff Score for Each School",
      titleSlug: "find-cutoff-score-for-each-school",
    },
    {
      acRate: 49.43955164131305,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1989",
      paidOnly: true,
      title: "Maximum Number of People That Can Be Caught in Tag",
      titleSlug: "maximum-number-of-people-that-can-be-caught-in-tag",
    },
    {
      acRate: 49.02602999482848,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1990",
      paidOnly: true,
      title: "Count the Number of Experiments",
      titleSlug: "count-the-number-of-experiments",
    },
    {
      acRate: 67.99356035046145,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1991",
      paidOnly: false,
      title: "Find the Middle Index in Array",
      titleSlug: "find-the-middle-index-in-array",
    },
    {
      acRate: 75.47389747717244,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1992",
      paidOnly: false,
      title: "Find All Groups of Farmland",
      titleSlug: "find-all-groups-of-farmland",
    },
    {
      acRate: 43.069338489980666,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1993",
      paidOnly: false,
      title: "Operations on Tree",
      titleSlug: "operations-on-tree",
    },
    {
      acRate: 35.78531788893441,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1994",
      paidOnly: false,
      title: "The Number of Good Subsets",
      titleSlug: "the-number-of-good-subsets",
    },
    {
      acRate: 63.07235169870762,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "1995",
      paidOnly: false,
      title: "Count Special Quadruplets",
      titleSlug: "count-special-quadruplets",
    },
    {
      acRate: 44.1800119213193,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1996",
      paidOnly: false,
      title: "The Number of Weak Characters in the Game",
      titleSlug: "the-number-of-weak-characters-in-the-game",
    },
    {
      acRate: 39.58076448828607,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1997",
      paidOnly: false,
      title: "First Day Where You Have Been in All the Rooms",
      titleSlug: "first-day-where-you-have-been-in-all-the-rooms",
    },
    {
      acRate: 46.38328049390956,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "1998",
      paidOnly: false,
      title: "GCD Sort of an Array",
      titleSlug: "gcd-sort-of-an-array",
    },
    {
      acRate: 47.98362333674514,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "1999",
      paidOnly: true,
      title: "Smallest Greater Multiple Made of Two Digits",
      titleSlug: "smallest-greater-multiple-made-of-two-digits",
    },
    {
      acRate: 86.40302664859499,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2000",
      paidOnly: false,
      title: "Reverse Prefix of Word",
      titleSlug: "reverse-prefix-of-word",
    },
    {
      acRate: 51.37628035147923,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2001",
      paidOnly: false,
      title: "Number of Pairs of Interchangeable Rectangles",
      titleSlug: "number-of-pairs-of-interchangeable-rectangles",
    },
    {
      acRate: 61.17254725783599,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2002",
      paidOnly: false,
      title: "Maximum Product of the Length of Two Palindromic Subsequences",
      titleSlug:
        "maximum-product-of-the-length-of-two-palindromic-subsequences",
    },
    {
      acRate: 46.32901641712002,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2003",
      paidOnly: false,
      title: "Smallest Missing Genetic Value in Each Subtree",
      titleSlug: "smallest-missing-genetic-value-in-each-subtree",
    },
    {
      acRate: 45.0655181893155,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2004",
      paidOnly: true,
      title: "The Number of Seniors and Juniors to Join the Company",
      titleSlug: "the-number-of-seniors-and-juniors-to-join-the-company",
    },
    {
      acRate: 56.972408650260995,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2005",
      paidOnly: true,
      title: "Subtree Removal Game with Fibonacci Tree",
      titleSlug: "subtree-removal-game-with-fibonacci-tree",
    },
    {
      acRate: 84.80104734515173,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2006",
      paidOnly: false,
      title: "Count Number of Pairs With Absolute Difference K",
      titleSlug: "count-number-of-pairs-with-absolute-difference-k",
    },
    {
      acRate: 40.4375308475793,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2007",
      paidOnly: false,
      title: "Find Original Array From Doubled Array",
      titleSlug: "find-original-array-from-doubled-array",
    },
    {
      acRate: 44.76409666283084,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2008",
      paidOnly: false,
      title: "Maximum Earnings From Taxi",
      titleSlug: "maximum-earnings-from-taxi",
    },
    {
      acRate: 52.22792191492511,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2009",
      paidOnly: false,
      title: "Minimum Number of Operations to Make Array Continuous",
      titleSlug: "minimum-number-of-operations-to-make-array-continuous",
    },
    {
      acRate: 64.41520467836257,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2010",
      paidOnly: true,
      title: "The Number of Seniors and Juniors to Join the Company II",
      titleSlug: "the-number-of-seniors-and-juniors-to-join-the-company-ii",
    },
    {
      acRate: 89.53656564276034,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2011",
      paidOnly: false,
      title: "Final Value of Variable After Performing Operations",
      titleSlug: "final-value-of-variable-after-performing-operations",
    },
    {
      acRate: 49.98351238306809,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2012",
      paidOnly: false,
      title: "Sum of Beauty in the Array",
      titleSlug: "sum-of-beauty-in-the-array",
    },
    {
      acRate: 51.13359554508756,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2013",
      paidOnly: false,
      title: "Detect Squares",
      titleSlug: "detect-squares",
    },
    {
      acRate: 53.883045397569354,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2014",
      paidOnly: false,
      title: "Longest Subsequence Repeated k Times",
      titleSlug: "longest-subsequence-repeated-k-times",
    },
    {
      acRate: 57.51052877866167,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2015",
      paidOnly: true,
      title: "Average Height of Buildings in Each Segment",
      titleSlug: "average-height-of-buildings-in-each-segment",
    },
    {
      acRate: 59.04155824079561,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2016",
      paidOnly: false,
      title: "Maximum Difference Between Increasing Elements",
      titleSlug: "maximum-difference-between-increasing-elements",
    },
    {
      acRate: 61.00159975206122,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2017",
      paidOnly: false,
      title: "Grid Game",
      titleSlug: "grid-game",
    },
    {
      acRate: 49.989429378639656,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2018",
      paidOnly: false,
      title: "Check if Word Can Be Placed In Crossword",
      titleSlug: "check-if-word-can-be-placed-in-crossword",
    },
    {
      acRate: 33.02682300032123,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2019",
      paidOnly: false,
      title: "The Score of Students Solving Math Expression",
      titleSlug: "the-score-of-students-solving-math-expression",
    },
    {
      acRate: 72.29548372038744,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2020",
      paidOnly: true,
      title: "Number of Accounts That Did Not Stream",
      titleSlug: "number-of-accounts-that-did-not-stream",
    },
    {
      acRate: 60.78578955291284,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2021",
      paidOnly: true,
      title: "Brightest Position on Street",
      titleSlug: "brightest-position-on-street",
    },
    {
      acRate: 71.75541727396427,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2022",
      paidOnly: false,
      title: "Convert 1D Array Into 2D Array",
      titleSlug: "convert-1d-array-into-2d-array",
    },
    {
      acRate: 74.81931116165764,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2023",
      paidOnly: false,
      title: "Number of Pairs of Strings With Concatenation Equal to Target",
      titleSlug:
        "number-of-pairs-of-strings-with-concatenation-equal-to-target",
    },
    {
      acRate: 68.42450898695967,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2024",
      paidOnly: false,
      title: "Maximize the Confusion of an Exam",
      titleSlug: "maximize-the-confusion-of-an-exam",
    },
    {
      acRate: 34.4930695282808,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2025",
      paidOnly: false,
      title: "Maximum Number of Ways to Partition an Array",
      titleSlug: "maximum-number-of-ways-to-partition-an-array",
    },
    {
      acRate: 84.5954575576842,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2026",
      paidOnly: true,
      title: "Low-Quality Problems",
      titleSlug: "low-quality-problems",
    },
    {
      acRate: 56.337964887056735,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2027",
      paidOnly: false,
      title: "Minimum Moves to Convert String",
      titleSlug: "minimum-moves-to-convert-string",
    },
    {
      acRate: 57.39858083659482,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2028",
      paidOnly: false,
      title: "Find Missing Observations",
      titleSlug: "find-missing-observations",
    },
    {
      acRate: 28.745911840467713,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2029",
      paidOnly: false,
      title: "Stone Game IX",
      titleSlug: "stone-game-ix",
    },
    {
      acRate: 38.795675591893676,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2030",
      paidOnly: false,
      title: "Smallest K-Length Subsequence With Occurrences of a Letter",
      titleSlug: "smallest-k-length-subsequence-with-occurrences-of-a-letter",
    },
    {
      acRate: 51.16428801373538,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2031",
      paidOnly: true,
      title: "Count Subarrays With More Ones Than Zeros",
      titleSlug: "count-subarrays-with-more-ones-than-zeros",
    },
    {
      acRate: 76.39246486870735,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2032",
      paidOnly: false,
      title: "Two Out of Three",
      titleSlug: "two-out-of-three",
    },
    {
      acRate: 67.45265585500347,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2033",
      paidOnly: false,
      title: "Minimum Operations to Make a Uni-Value Grid",
      titleSlug: "minimum-operations-to-make-a-uni-value-grid",
    },
    {
      acRate: 47.96483249253217,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2034",
      paidOnly: false,
      title: "Stock Price Fluctuation ",
      titleSlug: "stock-price-fluctuation",
    },
    {
      acRate: 21.535276885991937,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2035",
      paidOnly: false,
      title: "Partition Array Into Two Arrays to Minimize Sum Difference",
      titleSlug: "partition-array-into-two-arrays-to-minimize-sum-difference",
    },
    {
      acRate: 39.663385201651316,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2036",
      paidOnly: true,
      title: "Maximum Alternating Subarray Sum",
      titleSlug: "maximum-alternating-subarray-sum",
    },
    {
      acRate: 87.27281894421942,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2037",
      paidOnly: false,
      title: "Minimum Number of Moves to Seat Everyone",
      titleSlug: "minimum-number-of-moves-to-seat-everyone",
    },
    {
      acRate: 62.7884270759952,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2038",
      paidOnly: false,
      title: "Remove Colored Pieces if Both Neighbors are the Same Color",
      titleSlug: "remove-colored-pieces-if-both-neighbors-are-the-same-color",
    },
    {
      acRate: 53.36541167201305,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2039",
      paidOnly: false,
      title: "The Time When the Network Becomes Idle",
      titleSlug: "the-time-when-the-network-becomes-idle",
    },
    {
      acRate: 30.59880117018883,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2040",
      paidOnly: false,
      title: "Kth Smallest Product of Two Sorted Arrays",
      titleSlug: "kth-smallest-product-of-two-sorted-arrays",
    },
    {
      acRate: 78.62828795569912,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2041",
      paidOnly: true,
      title: "Accepted Candidates From the Interviews",
      titleSlug: "accepted-candidates-from-the-interviews",
    },
    {
      acRate: 71.56796182421292,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2042",
      paidOnly: false,
      title: "Check if Numbers Are Ascending in a Sentence",
      titleSlug: "check-if-numbers-are-ascending-in-a-sentence",
    },
    {
      acRate: 61.36245844236288,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2043",
      paidOnly: false,
      title: "Simple Bank System",
      titleSlug: "simple-bank-system",
    },
    {
      acRate: 87.9344746890011,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2044",
      paidOnly: false,
      title: "Count Number of Maximum Bitwise-OR Subsets",
      titleSlug: "count-number-of-maximum-bitwise-or-subsets",
    },
    {
      acRate: 62.58384410778305,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2045",
      paidOnly: false,
      title: "Second Minimum Time to Reach Destination",
      titleSlug: "second-minimum-time-to-reach-destination",
    },
    {
      acRate: 66.85559876095695,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2046",
      paidOnly: true,
      title: "Sort Linked List Already Sorted Using Absolute Values",
      titleSlug: "sort-linked-list-already-sorted-using-absolute-values",
    },
    {
      acRate: 29.86875065867875,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2047",
      paidOnly: false,
      title: "Number of Valid Words in a Sentence",
      titleSlug: "number-of-valid-words-in-a-sentence",
    },
    {
      acRate: 49.04107025914492,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2048",
      paidOnly: false,
      title: "Next Greater Numerically Balanced Number",
      titleSlug: "next-greater-numerically-balanced-number",
    },
    {
      acRate: 51.04260172172761,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2049",
      paidOnly: false,
      title: "Count Nodes With the Highest Score",
      titleSlug: "count-nodes-with-the-highest-score",
    },
    {
      acRate: 66.7560530926994,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2050",
      paidOnly: false,
      title: "Parallel Courses III",
      titleSlug: "parallel-courses-iii",
    },
    {
      acRate: 70.69515542696045,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2051",
      paidOnly: true,
      title: "The Category of Each Member in the Store",
      titleSlug: "the-category-of-each-member-in-the-store",
    },
    {
      acRate: 50.47361299052774,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2052",
      paidOnly: true,
      title: "Minimum Cost to Separate Sentence Into Rows",
      titleSlug: "minimum-cost-to-separate-sentence-into-rows",
    },
    {
      acRate: 82.01082864211696,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2053",
      paidOnly: false,
      title: "Kth Distinct String in an Array",
      titleSlug: "kth-distinct-string-in-an-array",
    },
    {
      acRate: 60.90391635573036,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2054",
      paidOnly: false,
      title: "Two Best Non-Overlapping Events",
      titleSlug: "two-best-non-overlapping-events",
    },
    {
      acRate: 46.538620042021634,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2055",
      paidOnly: false,
      title: "Plates Between Candles",
      titleSlug: "plates-between-candles",
    },
    {
      acRate: 47.565543071161045,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2056",
      paidOnly: false,
      title: "Number of Valid Move Combinations On Chessboard",
      titleSlug: "number-of-valid-move-combinations-on-chessboard",
    },
    {
      acRate: 72.42760585462854,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2057",
      paidOnly: false,
      title: "Smallest Index With Equal Value",
      titleSlug: "smallest-index-with-equal-value",
    },
    {
      acRate: 69.41291585127202,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2058",
      paidOnly: false,
      title:
        "Find the Minimum and Maximum Number of Nodes Between Critical Points",
      titleSlug:
        "find-the-minimum-and-maximum-number-of-nodes-between-critical-points",
    },
    {
      acRate: 50.41822901644073,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2059",
      paidOnly: false,
      title: "Minimum Operations to Convert Number",
      titleSlug: "minimum-operations-to-convert-number",
    },
    {
      acRate: 43.135710977304306,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2060",
      paidOnly: false,
      title: "Check if an Original String Exists Given Two Encoded Strings",
      titleSlug: "check-if-an-original-string-exists-given-two-encoded-strings",
    },
    {
      acRate: 61.97001351849576,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2061",
      paidOnly: true,
      title: "Number of Spaces Cleaning Robot Cleaned",
      titleSlug: "number-of-spaces-cleaning-robot-cleaned",
    },
    {
      acRate: 71.03297438778071,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2062",
      paidOnly: false,
      title: "Count Vowel Substrings of a String",
      titleSlug: "count-vowel-substrings-of-a-string",
    },
    {
      acRate: 54.60657444593188,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2063",
      paidOnly: false,
      title: "Vowels of All Substrings",
      titleSlug: "vowels-of-all-substrings",
    },
    {
      acRate: 62.52230151650312,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2064",
      paidOnly: false,
      title: "Minimized Maximum of Products Distributed to Any Store",
      titleSlug: "minimized-maximum-of-products-distributed-to-any-store",
    },
    {
      acRate: 59.4691273638642,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2065",
      paidOnly: false,
      title: "Maximum Path Quality of a Graph",
      titleSlug: "maximum-path-quality-of-a-graph",
    },
    {
      acRate: 82.23460452999494,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2066",
      paidOnly: true,
      title: "Account Balance",
      titleSlug: "account-balance",
    },
    {
      acRate: 44.533991940725336,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2067",
      paidOnly: true,
      title: "Number of Equal Count Substrings",
      titleSlug: "number-of-equal-count-substrings",
    },
    {
      acRate: 63.58929721005722,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2068",
      paidOnly: false,
      title: "Check Whether Two Strings are Almost Equivalent",
      titleSlug: "check-whether-two-strings-are-almost-equivalent",
    },
    {
      acRate: 24.988725760384828,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2069",
      paidOnly: false,
      title: "Walking Robot Simulation II",
      titleSlug: "walking-robot-simulation-ii",
    },
    {
      acRate: 62.047013958050776,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2070",
      paidOnly: false,
      title: "Most Beautiful Item for Each Query",
      titleSlug: "most-beautiful-item-for-each-query",
    },
    {
      acRate: 50.99432921618893,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2071",
      paidOnly: false,
      title: "Maximum Number of Tasks You Can Assign",
      titleSlug: "maximum-number-of-tasks-you-can-assign",
    },
    {
      acRate: 75.39284900933728,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2072",
      paidOnly: true,
      title: "The Winner University",
      titleSlug: "the-winner-university",
    },
    {
      acRate: 70.55407461126393,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2073",
      paidOnly: false,
      title: "Time Needed to Buy Tickets",
      titleSlug: "time-needed-to-buy-tickets",
    },
    {
      acRate: 60.576690508275455,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2074",
      paidOnly: false,
      title: "Reverse Nodes in Even Length Groups",
      titleSlug: "reverse-nodes-in-even-length-groups",
    },
    {
      acRate: 49.0154434297157,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2075",
      paidOnly: false,
      title: "Decode the Slanted Ciphertext",
      titleSlug: "decode-the-slanted-ciphertext",
    },
    {
      acRate: 56.770671268139516,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2076",
      paidOnly: false,
      title: "Process Restricted Friend Requests",
      titleSlug: "process-restricted-friend-requests",
    },
    {
      acRate: 55.94565109590399,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2077",
      paidOnly: true,
      title: "Paths in Maze That Lead to Same Room",
      titleSlug: "paths-in-maze-that-lead-to-same-room",
    },
    {
      acRate: 65.51815907598957,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2078",
      paidOnly: false,
      title: "Two Furthest Houses With Different Colors",
      titleSlug: "two-furthest-houses-with-different-colors",
    },
    {
      acRate: 79.92881808920231,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2079",
      paidOnly: false,
      title: "Watering Plants",
      titleSlug: "watering-plants",
    },
    {
      acRate: 39.47762535194393,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2080",
      paidOnly: false,
      title: "Range Frequency Queries",
      titleSlug: "range-frequency-queries",
    },
    {
      acRate: 41.39340022757836,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2081",
      paidOnly: false,
      title: "Sum of k-Mirror Numbers",
      titleSlug: "sum-of-k-mirror-numbers",
    },
    {
      acRate: 77.42009132420091,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2082",
      paidOnly: true,
      title: "The Number of Rich Customers",
      titleSlug: "the-number-of-rich-customers",
    },
    {
      acRate: 74.30422133172311,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2083",
      paidOnly: true,
      title: "Substrings That Begin and End With the Same Letter",
      titleSlug: "substrings-that-begin-and-end-with-the-same-letter",
    },
    {
      acRate: 87.20984996299535,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2084",
      paidOnly: true,
      title: "Drop Type 1 Orders for Customers With Type 0 Orders",
      titleSlug: "drop-type-1-orders-for-customers-with-type-0-orders",
    },
    {
      acRate: 72.20341591014002,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2085",
      paidOnly: false,
      title: "Count Common Words With One Occurrence",
      titleSlug: "count-common-words-with-one-occurrence",
    },
    {
      acRate: 46.88542307190639,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2086",
      paidOnly: false,
      title: "Minimum Number of Food Buckets to Feed the Hamsters",
      titleSlug: "minimum-number-of-food-buckets-to-feed-the-hamsters",
    },
    {
      acRate: 51.01567700323639,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2087",
      paidOnly: false,
      title: "Minimum Cost Homecoming of a Robot in a Grid",
      titleSlug: "minimum-cost-homecoming-of-a-robot-in-a-grid",
    },
    {
      acRate: 65.21813031161473,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2088",
      paidOnly: false,
      title: "Count Fertile Pyramids in a Land",
      titleSlug: "count-fertile-pyramids-in-a-land",
    },
    {
      acRate: 77.1525766251263,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2089",
      paidOnly: false,
      title: "Find Target Indices After Sorting Array",
      titleSlug: "find-target-indices-after-sorting-array",
    },
    {
      acRate: 45.98337950138504,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2090",
      paidOnly: false,
      title: "K Radius Subarray Averages",
      titleSlug: "k-radius-subarray-averages",
    },
    {
      acRate: 55.154462119748395,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2091",
      paidOnly: false,
      title: "Removing Minimum and Maximum From Array",
      titleSlug: "removing-minimum-and-maximum-from-array",
    },
    {
      acRate: 45.33510040724617,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2092",
      paidOnly: false,
      title: "Find All People With Secret",
      titleSlug: "find-all-people-with-secret",
    },
    {
      acRate: 59.796697681923305,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2093",
      paidOnly: true,
      title: "Minimum Cost to Reach City With Discounts",
      titleSlug: "minimum-cost-to-reach-city-with-discounts",
    },
    {
      acRate: 64.52325917364924,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2094",
      paidOnly: false,
      title: "Finding 3-Digit Even Numbers",
      titleSlug: "finding-3-digit-even-numbers",
    },
    {
      acRate: 59.60340222648293,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2095",
      paidOnly: false,
      title: "Delete the Middle Node of a Linked List",
      titleSlug: "delete-the-middle-node-of-a-linked-list",
    },
    {
      acRate: 56.267735804847575,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2096",
      paidOnly: false,
      title: "Step-By-Step Directions From a Binary Tree Node to Another",
      titleSlug: "step-by-step-directions-from-a-binary-tree-node-to-another",
    },
    {
      acRate: 66.27419922562477,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2097",
      paidOnly: false,
      title: "Valid Arrangement of Pairs",
      titleSlug: "valid-arrangement-of-pairs",
    },
    {
      acRate: 35.58577946113454,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2098",
      paidOnly: true,
      title: "Subsequence of Size K With the Largest Even Sum",
      titleSlug: "subsequence-of-size-k-with-the-largest-even-sum",
    },
    {
      acRate: 45.253984236658454,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2099",
      paidOnly: false,
      title: "Find Subsequence of Length K With the Largest Sum",
      titleSlug: "find-subsequence-of-length-k-with-the-largest-sum",
    },
    {
      acRate: 50.178521225752036,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2100",
      paidOnly: false,
      title: "Find Good Days to Rob the Bank",
      titleSlug: "find-good-days-to-rob-the-bank",
    },
    {
      acRate: 49.094567404426556,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2101",
      paidOnly: false,
      title: "Detonate the Maximum Bombs",
      titleSlug: "detonate-the-maximum-bombs",
    },
    {
      acRate: 61.61461770938271,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2102",
      paidOnly: false,
      title: "Sequentially Ordinal Rank Tracker",
      titleSlug: "sequentially-ordinal-rank-tracker",
    },
    {
      acRate: 81.0865059043117,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2103",
      paidOnly: false,
      title: "Rings and Rods",
      titleSlug: "rings-and-rods",
    },
    {
      acRate: 60.17372208548139,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2104",
      paidOnly: false,
      title: "Sum of Subarray Ranges",
      titleSlug: "sum-of-subarray-ranges",
    },
    {
      acRate: 48.05027456733343,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2105",
      paidOnly: false,
      title: "Watering Plants II",
      titleSlug: "watering-plants-ii",
    },
    {
      acRate: 36.24243814329539,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2106",
      paidOnly: false,
      title: "Maximum Fruits Harvested After at Most K Steps",
      titleSlug: "maximum-fruits-harvested-after-at-most-k-steps",
    },
    {
      acRate: 59.72475775874175,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2107",
      paidOnly: true,
      title: "Number of Unique Flavors After Sharing K Candies",
      titleSlug: "number-of-unique-flavors-after-sharing-k-candies",
    },
    {
      acRate: 83.8771684604903,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2108",
      paidOnly: false,
      title: "Find First Palindromic String in the Array",
      titleSlug: "find-first-palindromic-string-in-the-array",
    },
    {
      acRate: 71.63246607312645,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2109",
      paidOnly: false,
      title: "Adding Spaces to a String",
      titleSlug: "adding-spaces-to-a-string",
    },
    {
      acRate: 59.11202242959367,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2110",
      paidOnly: false,
      title: "Number of Smooth Descent Periods of a Stock",
      titleSlug: "number-of-smooth-descent-periods-of-a-stock",
    },
    {
      acRate: 39.006688872640616,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2111",
      paidOnly: false,
      title: "Minimum Operations to Make the Array K-Increasing",
      titleSlug: "minimum-operations-to-make-the-array-k-increasing",
    },
    {
      acRate: 71.39512463847954,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2112",
      paidOnly: true,
      title: "The Airport With the Most Traffic",
      titleSlug: "the-airport-with-the-most-traffic",
    },
    {
      acRate: 69.68652037617555,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2113",
      paidOnly: true,
      title: "Elements in Array After Removing and Replacing Elements",
      titleSlug: "elements-in-array-after-removing-and-replacing-elements",
    },
    {
      acRate: 86.6176911544228,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2114",
      paidOnly: false,
      title: "Maximum Number of Words Found in Sentences",
      titleSlug: "maximum-number-of-words-found-in-sentences",
    },
    {
      acRate: 56.42886597938145,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2115",
      paidOnly: false,
      title: "Find All Possible Recipes from Given Supplies",
      titleSlug: "find-all-possible-recipes-from-given-supplies",
    },
    {
      acRate: 44.78189790835893,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2116",
      paidOnly: false,
      title: "Check if a Parentheses String Can Be Valid",
      titleSlug: "check-if-a-parentheses-string-can-be-valid",
    },
    {
      acRate: 24.39377488237423,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2117",
      paidOnly: false,
      title: "Abbreviating the Product of a Range",
      titleSlug: "abbreviating-the-product-of-a-range",
    },
    {
      acRate: 56.36616293208269,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2118",
      paidOnly: true,
      title: "Build the Equation",
      titleSlug: "build-the-equation",
    },
    {
      acRate: 81.09280846606907,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2119",
      paidOnly: false,
      title: "A Number After a Double Reversal",
      titleSlug: "a-number-after-a-double-reversal",
    },
    {
      acRate: 81.49203531555099,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2120",
      paidOnly: false,
      title: "Execution of All Suffix Instructions Staying in a Grid",
      titleSlug: "execution-of-all-suffix-instructions-staying-in-a-grid",
    },
    {
      acRate: 44.798277209231415,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2121",
      paidOnly: false,
      title: "Intervals Between Identical Elements",
      titleSlug: "intervals-between-identical-elements",
    },
    {
      acRate: 39.86331839721479,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2122",
      paidOnly: false,
      title: "Recover the Original Array",
      titleSlug: "recover-the-original-array",
    },
    {
      acRate: 40.65934065934066,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2123",
      paidOnly: true,
      title: "Minimum Operations to Remove Adjacent Ones in Matrix",
      titleSlug: "minimum-operations-to-remove-adjacent-ones-in-matrix",
    },
    {
      acRate: 72.39630918588675,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2124",
      paidOnly: false,
      title: "Check if All A's Appears Before All B's",
      titleSlug: "check-if-all-as-appears-before-all-bs",
    },
    {
      acRate: 85.402667889768,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2125",
      paidOnly: false,
      title: "Number of Laser Beams in a Bank",
      titleSlug: "number-of-laser-beams-in-a-bank",
    },
    {
      acRate: 52.56290686612822,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2126",
      paidOnly: false,
      title: "Destroying Asteroids",
      titleSlug: "destroying-asteroids",
    },
    {
      acRate: 62.14877375345136,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2127",
      paidOnly: false,
      title: "Maximum Employees to Be Invited to a Meeting",
      titleSlug: "maximum-employees-to-be-invited-to-a-meeting",
    },
    {
      acRate: 76.16132275723383,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2128",
      paidOnly: true,
      title: "Remove All Ones With Row and Column Flips",
      titleSlug: "remove-all-ones-with-row-and-column-flips",
    },
    {
      acRate: 66.3172542516936,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2129",
      paidOnly: false,
      title: "Capitalize the Title",
      titleSlug: "capitalize-the-title",
    },
    {
      acRate: 81.38297659731798,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2130",
      paidOnly: false,
      title: "Maximum Twin Sum of a Linked List",
      titleSlug: "maximum-twin-sum-of-a-linked-list",
    },
    {
      acRate: 47.86443207933376,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2131",
      paidOnly: false,
      title: "Longest Palindrome by Concatenating Two Letter Words",
      titleSlug: "longest-palindrome-by-concatenating-two-letter-words",
    },
    {
      acRate: 32.96966883317858,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2132",
      paidOnly: false,
      title: "Stamping the Grid",
      titleSlug: "stamping-the-grid",
    },
    {
      acRate: 52.6878754613106,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2133",
      paidOnly: false,
      title: "Check if Every Row and Column Contains All Numbers",
      titleSlug: "check-if-every-row-and-column-contains-all-numbers",
    },
    {
      acRate: 65.49203226441078,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2134",
      paidOnly: false,
      title: "Minimum Swaps to Group All 1's Together II",
      titleSlug: "minimum-swaps-to-group-all-1s-together-ii",
    },
    {
      acRate: 43.39993110575267,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2135",
      paidOnly: false,
      title: "Count Words Obtained After Adding a Letter",
      titleSlug: "count-words-obtained-after-adding-a-letter",
    },
    {
      acRate: 71.1047335343481,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2136",
      paidOnly: false,
      title: "Earliest Possible Day of Full Bloom",
      titleSlug: "earliest-possible-day-of-full-bloom",
    },
    {
      acRate: 66.87103594080338,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2137",
      paidOnly: true,
      title: "Pour Water Between Buckets to Make Water Levels Equal",
      titleSlug: "pour-water-between-buckets-to-make-water-levels-equal",
    },
    {
      acRate: 67.38622386223862,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2138",
      paidOnly: false,
      title: "Divide a String Into Groups of Size k",
      titleSlug: "divide-a-string-into-groups-of-size-k",
    },
    {
      acRate: 51.41367840337499,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2139",
      paidOnly: false,
      title: "Minimum Moves to Reach Target Score",
      titleSlug: "minimum-moves-to-reach-target-score",
    },
    {
      acRate: 60.34042639573299,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2140",
      paidOnly: false,
      title: "Solving Questions With Brainpower",
      titleSlug: "solving-questions-with-brainpower",
    },
    {
      acRate: 49.84519406718809,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2141",
      paidOnly: false,
      title: "Maximum Running Time of N Computers",
      titleSlug: "maximum-running-time-of-n-computers",
    },
    {
      acRate: 48.85342139057054,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2142",
      paidOnly: true,
      title: "The Number of Passengers in Each Bus I",
      titleSlug: "the-number-of-passengers-in-each-bus-i",
    },
    {
      acRate: 52.27747597158378,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2143",
      paidOnly: true,
      title: "Choose Numbers From Two Arrays in Range",
      titleSlug: "choose-numbers-from-two-arrays-in-range",
    },
    {
      acRate: 61.99160655230433,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2144",
      paidOnly: false,
      title: "Minimum Cost of Buying Candies With Discount",
      titleSlug: "minimum-cost-of-buying-candies-with-discount",
    },
    {
      acRate: 56.70493797129652,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2145",
      paidOnly: false,
      title: "Count the Hidden Sequences",
      titleSlug: "count-the-hidden-sequences",
    },
    {
      acRate: 44.4813637676972,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2146",
      paidOnly: false,
      title: "K Highest Ranked Items Within a Price Range",
      titleSlug: "k-highest-ranked-items-within-a-price-range",
    },
    {
      acRate: 48.81130495655635,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2147",
      paidOnly: false,
      title: "Number of Ways to Divide a Long Corridor",
      titleSlug: "number-of-ways-to-divide-a-long-corridor",
    },
    {
      acRate: 59.184921653587395,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2148",
      paidOnly: false,
      title: "Count Elements With Strictly Smaller and Greater Elements ",
      titleSlug: "count-elements-with-strictly-smaller-and-greater-elements",
    },
    {
      acRate: 84.30335227973141,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2149",
      paidOnly: false,
      title: "Rearrange Array Elements by Sign",
      titleSlug: "rearrange-array-elements-by-sign",
    },
    {
      acRate: 61.44367689438888,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2150",
      paidOnly: false,
      title: "Find All Lonely Numbers in the Array",
      titleSlug: "find-all-lonely-numbers-in-the-array",
    },
    {
      acRate: 50.77842323651453,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2151",
      paidOnly: false,
      title: "Maximum Good People Based on Statements",
      titleSlug: "maximum-good-people-based-on-statements",
    },
    {
      acRate: 42.53016323633783,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2152",
      paidOnly: true,
      title: "Minimum Number of Lines to Cover Points",
      titleSlug: "minimum-number-of-lines-to-cover-points",
    },
    {
      acRate: 39.863325740318906,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2153",
      paidOnly: true,
      title: "The Number of Passengers in Each Bus II",
      titleSlug: "the-number-of-passengers-in-each-bus-ii",
    },
    {
      acRate: 71.30810849935762,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2154",
      paidOnly: false,
      title: "Keep Multiplying Found Values by Two",
      titleSlug: "keep-multiplying-found-values-by-two",
    },
    {
      acRate: 64.30192632252808,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2155",
      paidOnly: false,
      title: "All Divisions With the Highest Score of a Binary Array",
      titleSlug: "all-divisions-with-the-highest-score-of-a-binary-array",
    },
    {
      acRate: 24.597444939783088,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2156",
      paidOnly: false,
      title: "Find Substring With Given Hash Value",
      titleSlug: "find-substring-with-given-hash-value",
    },
    {
      acRate: 26.533838548593515,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2157",
      paidOnly: false,
      title: "Groups of Strings",
      titleSlug: "groups-of-strings",
    },
    {
      acRate: 55.46344091627996,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2158",
      paidOnly: true,
      title: "Amount of New Area Painted Each Day",
      titleSlug: "amount-of-new-area-painted-each-day",
    },
    {
      acRate: 60.89160384715363,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2159",
      paidOnly: true,
      title: "Order Two Columns Independently",
      titleSlug: "order-two-columns-independently",
    },
    {
      acRate: 86.03565171888154,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2160",
      paidOnly: false,
      title: "Minimum Sum of Four Digit Number After Splitting Digits",
      titleSlug: "minimum-sum-of-four-digit-number-after-splitting-digits",
    },
    {
      acRate: 89.92919095886104,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2161",
      paidOnly: false,
      title: "Partition Array According to Given Pivot",
      titleSlug: "partition-array-according-to-given-pivot",
    },
    {
      acRate: 40.89065155807366,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2162",
      paidOnly: false,
      title: "Minimum Cost to Set Cooking Time",
      titleSlug: "minimum-cost-to-set-cooking-time",
    },
    {
      acRate: 49.07692307692308,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2163",
      paidOnly: false,
      title: "Minimum Difference in Sums After Removal of Elements",
      titleSlug: "minimum-difference-in-sums-after-removal-of-elements",
    },
    {
      acRate: 62.54541031462861,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2164",
      paidOnly: false,
      title: "Sort Even and Odd Indices Independently",
      titleSlug: "sort-even-and-odd-indices-independently",
    },
    {
      acRate: 52.5697776785825,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2165",
      paidOnly: false,
      title: "Smallest Value of the Rearranged Number",
      titleSlug: "smallest-value-of-the-rearranged-number",
    },
    {
      acRate: 31.709297097467154,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2166",
      paidOnly: false,
      title: "Design Bitset",
      titleSlug: "design-bitset",
    },
    {
      acRate: 41.119214256307714,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2167",
      paidOnly: false,
      title: "Minimum Time to Remove All Cars Containing Illegal Goods",
      titleSlug: "minimum-time-to-remove-all-cars-containing-illegal-goods",
    },
    {
      acRate: 64.05416783609319,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2168",
      paidOnly: true,
      title: "Unique Substrings With Equal Digit Frequency",
      titleSlug: "unique-substrings-with-equal-digit-frequency",
    },
    {
      acRate: 74.7314377278896,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2169",
      paidOnly: false,
      title: "Count Operations to Obtain Zero",
      titleSlug: "count-operations-to-obtain-zero",
    },
    {
      acRate: 34.18468361447691,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2170",
      paidOnly: false,
      title: "Minimum Operations to Make the Array Alternating",
      titleSlug: "minimum-operations-to-make-the-array-alternating",
    },
    {
      acRate: 43.48535347143118,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2171",
      paidOnly: false,
      title: "Removing Minimum Number of Magic Beans",
      titleSlug: "removing-minimum-number-of-magic-beans",
    },
    {
      acRate: 49.64232817571613,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2172",
      paidOnly: false,
      title: "Maximum AND Sum of Array",
      titleSlug: "maximum-and-sum-of-array",
    },
    {
      acRate: 53.98009950248757,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2173",
      paidOnly: true,
      title: "Longest Winning Streak",
      titleSlug: "longest-winning-streak",
    },
    {
      acRate: 66.86435331230284,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2174",
      paidOnly: true,
      title: "Remove All Ones With Row and Column Flips II",
      titleSlug: "remove-all-ones-with-row-and-column-flips-ii",
    },
    {
      acRate: 60.586395621579356,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2175",
      paidOnly: true,
      title: "The Change in Global Rankings",
      titleSlug: "the-change-in-global-rankings",
    },
    {
      acRate: 84.08008155720309,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2176",
      paidOnly: false,
      title: "Count Equal and Divisible Pairs in an Array",
      titleSlug: "count-equal-and-divisible-pairs-in-an-array",
    },
    {
      acRate: 64.56588906883522,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2177",
      paidOnly: false,
      title: "Find Three Consecutive Integers That Sum to a Given Number",
      titleSlug: "find-three-consecutive-integers-that-sum-to-a-given-number",
    },
    {
      acRate: 59.332189796249516,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2178",
      paidOnly: false,
      title: "Maximum Split of Positive Even Integers",
      titleSlug: "maximum-split-of-positive-even-integers",
    },
    {
      acRate: 66.03625476916336,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2179",
      paidOnly: false,
      title: "Count Good Triplets in an Array",
      titleSlug: "count-good-triplets-in-an-array",
    },
    {
      acRate: 68.55810710706349,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2180",
      paidOnly: false,
      title: "Count Integers With Even Digit Sum",
      titleSlug: "count-integers-with-even-digit-sum",
    },
    {
      acRate: 89.53565515540787,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2181",
      paidOnly: false,
      title: "Merge Nodes in Between Zeros",
      titleSlug: "merge-nodes-in-between-zeros",
    },
    {
      acRate: 70.88927056679168,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2182",
      paidOnly: false,
      title: "Construct String With Repeat Limit",
      titleSlug: "construct-string-with-repeat-limit",
    },
    {
      acRate: 30.040623384297216,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2183",
      paidOnly: false,
      title: "Count Array Pairs Divisible by K",
      titleSlug: "count-array-pairs-divisible-by-k",
    },
    {
      acRate: 49.4131209390065,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2184",
      paidOnly: true,
      title: "Number of Ways to Build Sturdy Brick Wall",
      titleSlug: "number-of-ways-to-build-sturdy-brick-wall",
    },
    {
      acRate: 84.51987505211197,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2185",
      paidOnly: false,
      title: "Counting Words With a Given Prefix",
      titleSlug: "counting-words-with-a-given-prefix",
    },
    {
      acRate: 72.69423801510119,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2186",
      paidOnly: false,
      title: "Minimum Number of Steps to Make Two Strings Anagram II",
      titleSlug: "minimum-number-of-steps-to-make-two-strings-anagram-ii",
    },
    {
      acRate: 38.984633970269755,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2187",
      paidOnly: false,
      title: "Minimum Time to Complete Trips",
      titleSlug: "minimum-time-to-complete-trips",
    },
    {
      acRate: 41.97729422894986,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2188",
      paidOnly: false,
      title: "Minimum Time to Finish the Race",
      titleSlug: "minimum-time-to-finish-the-race",
    },
    {
      acRate: 62.01106282101936,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2189",
      paidOnly: true,
      title: "Number of Ways to Build House of Cards",
      titleSlug: "number-of-ways-to-build-house-of-cards",
    },
    {
      acRate: 59.125188536953246,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2190",
      paidOnly: false,
      title: "Most Frequent Number Following Key In an Array",
      titleSlug: "most-frequent-number-following-key-in-an-array",
    },
    {
      acRate: 59.98134883628643,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2191",
      paidOnly: false,
      title: "Sort the Jumbled Numbers",
      titleSlug: "sort-the-jumbled-numbers",
    },
    {
      acRate: 61.87342958136366,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2192",
      paidOnly: false,
      title: "All Ancestors of a Node in a Directed Acyclic Graph",
      titleSlug: "all-ancestors-of-a-node-in-a-directed-acyclic-graph",
    },
    {
      acRate: 51.87074829931972,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2193",
      paidOnly: false,
      title: "Minimum Number of Moves to Make Palindrome",
      titleSlug: "minimum-number-of-moves-to-make-palindrome",
    },
    {
      acRate: 83.8663434173079,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2194",
      paidOnly: false,
      title: "Cells in a Range on an Excel Sheet",
      titleSlug: "cells-in-a-range-on-an-excel-sheet",
    },
    {
      acRate: 26.022813794452322,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2195",
      paidOnly: false,
      title: "Append K Integers With Minimal Sum",
      titleSlug: "append-k-integers-with-minimal-sum",
    },
    {
      acRate: 81.62933018920891,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2196",
      paidOnly: false,
      title: "Create Binary Tree From Descriptions",
      titleSlug: "create-binary-tree-from-descriptions",
    },
    {
      acRate: 40.280682979033905,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2197",
      paidOnly: false,
      title: "Replace Non-Coprime Numbers in Array",
      titleSlug: "replace-non-coprime-numbers-in-array",
    },
    {
      acRate: 54.07066052227343,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2198",
      paidOnly: true,
      title: "Number of Single Divisor Triplets",
      titleSlug: "number-of-single-divisor-triplets",
    },
    {
      acRate: 50.162720233419364,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2199",
      paidOnly: true,
      title: "Finding the Topic of Each Post",
      titleSlug: "finding-the-topic-of-each-post",
    },
    {
      acRate: 67.19257540603249,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2200",
      paidOnly: false,
      title: "Find All K-Distant Indices in an Array",
      titleSlug: "find-all-k-distant-indices-in-an-array",
    },
    {
      acRate: 56.25704326860078,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2201",
      paidOnly: false,
      title: "Count Artifacts That Can Be Extracted",
      titleSlug: "count-artifacts-that-can-be-extracted",
    },
    {
      acRate: 23.369195247419135,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2202",
      paidOnly: false,
      title: "Maximize the Topmost Element After K Moves",
      titleSlug: "maximize-the-topmost-element-after-k-moves",
    },
    {
      acRate: 38.218010871162036,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2203",
      paidOnly: false,
      title: "Minimum Weighted Subgraph With the Required Paths",
      titleSlug: "minimum-weighted-subgraph-with-the-required-paths",
    },
    {
      acRate: 72.85510009532888,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2204",
      paidOnly: true,
      title: "Distance to a Cycle in Undirected Graph",
      titleSlug: "distance-to-a-cycle-in-undirected-graph",
    },
    {
      acRate: 50.57267521134442,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2205",
      paidOnly: true,
      title: "The Number of Users That Are Eligible for Discount",
      titleSlug: "the-number-of-users-that-are-eligible-for-discount",
    },
    {
      acRate: 79.25677391063516,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2206",
      paidOnly: false,
      title: "Divide Array Into Equal Pairs",
      titleSlug: "divide-array-into-equal-pairs",
    },
    {
      acRate: 35.125624940292326,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2207",
      paidOnly: false,
      title: "Maximize Number of Subsequences in a String",
      titleSlug: "maximize-number-of-subsequences-in-a-string",
    },
    {
      acRate: 48.72279206659492,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2208",
      paidOnly: false,
      title: "Minimum Operations to Halve Array Sum",
      titleSlug: "minimum-operations-to-halve-array-sum",
    },
    {
      acRate: 36.91794015667138,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2209",
      paidOnly: false,
      title: "Minimum White Tiles After Covering With Carpets",
      titleSlug: "minimum-white-tiles-after-covering-with-carpets",
    },
    {
      acRate: 61.523522241276005,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2210",
      paidOnly: false,
      title: "Count Hills and Valleys in an Array",
      titleSlug: "count-hills-and-valleys-in-an-array",
    },
    {
      acRate: 44.25349654971843,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2211",
      paidOnly: false,
      title: "Count Collisions on a Road",
      titleSlug: "count-collisions-on-a-road",
    },
    {
      acRate: 50.16335186565025,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2212",
      paidOnly: false,
      title: "Maximum Points in an Archery Competition",
      titleSlug: "maximum-points-in-an-archery-competition",
    },
    {
      acRate: 32.84812346545072,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2213",
      paidOnly: false,
      title: "Longest Substring of One Repeating Character",
      titleSlug: "longest-substring-of-one-repeating-character",
    },
    {
      acRate: 58.654123359380925,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2214",
      paidOnly: true,
      title: "Minimum Health to Beat Game",
      titleSlug: "minimum-health-to-beat-game",
    },
    {
      acRate: 80.7027520164708,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2215",
      paidOnly: false,
      title: "Find the Difference of Two Arrays",
      titleSlug: "find-the-difference-of-two-arrays",
    },
    {
      acRate: 48.71407978228947,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2216",
      paidOnly: false,
      title: "Minimum Deletions to Make Array Beautiful",
      titleSlug: "minimum-deletions-to-make-array-beautiful",
    },
    {
      acRate: 37.343057470242066,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2217",
      paidOnly: false,
      title: "Find Palindrome With Fixed Length",
      titleSlug: "find-palindrome-with-fixed-length",
    },
    {
      acRate: 60.361808718810636,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2218",
      paidOnly: false,
      title: "Maximum Value of K Coins From Piles",
      titleSlug: "maximum-value-of-k-coins-from-piles",
    },
    {
      acRate: 61.95274079405062,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2219",
      paidOnly: true,
      title: "Maximum Sum Score of Array",
      titleSlug: "maximum-sum-score-of-array",
    },
    {
      acRate: 87.52194927680527,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2220",
      paidOnly: false,
      title: "Minimum Bit Flips to Convert Number",
      titleSlug: "minimum-bit-flips-to-convert-number",
    },
    {
      acRate: 78.80608910496532,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2221",
      paidOnly: false,
      title: "Find Triangular Sum of an Array",
      titleSlug: "find-triangular-sum-of-an-array",
    },
    {
      acRate: 50.425901877489935,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2222",
      paidOnly: false,
      title: "Number of Ways to Select Buildings",
      titleSlug: "number-of-ways-to-select-buildings",
    },
    {
      acRate: 41.92934892566665,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2223",
      paidOnly: false,
      title: "Sum of Scores of Built Strings",
      titleSlug: "sum-of-scores-of-built-strings",
    },
    {
      acRate: 65.47143161709839,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2224",
      paidOnly: false,
      title: "Minimum Number of Operations to Convert Time",
      titleSlug: "minimum-number-of-operations-to-convert-time",
    },
    {
      acRate: 72.63064864990581,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2225",
      paidOnly: false,
      title: "Find Players With Zero or One Losses",
      titleSlug: "find-players-with-zero-or-one-losses",
    },
    {
      acRate: 50.11102516013779,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2226",
      paidOnly: false,
      title: "Maximum Candies Allocated to K Children",
      titleSlug: "maximum-candies-allocated-to-k-children",
    },
    {
      acRate: 36.6623569877784,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2227",
      paidOnly: false,
      title: "Encrypt and Decrypt Strings",
      titleSlug: "encrypt-and-decrypt-strings",
    },
    {
      acRate: 45.9862130309095,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2228",
      paidOnly: true,
      title: "Users With Two Purchases Within Seven Days",
      titleSlug: "users-with-two-purchases-within-seven-days",
    },
    {
      acRate: 61.81184668989547,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2229",
      paidOnly: true,
      title: "Check if an Array Is Consecutive",
      titleSlug: "check-if-an-array-is-consecutive",
    },
    {
      acRate: 50.67268061280037,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2230",
      paidOnly: true,
      title: "The Users That Are Eligible for Discount",
      titleSlug: "the-users-that-are-eligible-for-discount",
    },
    {
      acRate: 63.496555534258626,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2231",
      paidOnly: false,
      title: "Largest Number After Digit Swaps by Parity",
      titleSlug: "largest-number-after-digit-swaps-by-parity",
    },
    {
      acRate: 67.43401029273421,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2232",
      paidOnly: false,
      title: "Minimize Result by Adding Parentheses to Expression",
      titleSlug: "minimize-result-by-adding-parentheses-to-expression",
    },
    {
      acRate: 42.19325773894788,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2233",
      paidOnly: false,
      title: "Maximum Product After K Increments",
      titleSlug: "maximum-product-after-k-increments",
    },
    {
      acRate: 29.93107858462413,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2234",
      paidOnly: false,
      title: "Maximum Total Beauty of the Gardens",
      titleSlug: "maximum-total-beauty-of-the-gardens",
    },
    {
      acRate: 88.18166616244976,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2235",
      paidOnly: false,
      title: "Add Two Integers",
      titleSlug: "add-two-integers",
    },
    {
      acRate: 84.90893749293218,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2236",
      paidOnly: false,
      title: "Root Equals Sum of Children",
      titleSlug: "root-equals-sum-of-children",
    },
    {
      acRate: 62.09046100318933,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2237",
      paidOnly: true,
      title: "Count Positions on Street With Required Brightness",
      titleSlug: "count-positions-on-street-with-required-brightness",
    },
    {
      acRate: 72.0353982300885,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2238",
      paidOnly: true,
      title: "Number of Times a Driver Was a Passenger",
      titleSlug: "number-of-times-a-driver-was-a-passenger",
    },
    {
      acRate: 47.03146015437378,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2239",
      paidOnly: false,
      title: "Find Closest Number to Zero",
      titleSlug: "find-closest-number-to-zero",
    },
    {
      acRate: 55.82159546888159,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2240",
      paidOnly: false,
      title: "Number of Ways to Buy Pens and Pencils",
      titleSlug: "number-of-ways-to-buy-pens-and-pencils",
    },
    {
      acRate: 41.95914977390876,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2241",
      paidOnly: false,
      title: "Design an ATM Machine",
      titleSlug: "design-an-atm-machine",
    },
    {
      acRate: 38.952913179496775,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2242",
      paidOnly: false,
      title: "Maximum Score of a Node Sequence",
      titleSlug: "maximum-score-of-a-node-sequence",
    },
    {
      acRate: 66.48479681727764,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2243",
      paidOnly: false,
      title: "Calculate Digit Sum of a String",
      titleSlug: "calculate-digit-sum-of-a-string",
    },
    {
      acRate: 62.92794974764442,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2244",
      paidOnly: false,
      title: "Minimum Rounds to Complete All Tasks",
      titleSlug: "minimum-rounds-to-complete-all-tasks",
    },
    {
      acRate: 36.51495126383612,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2245",
      paidOnly: false,
      title: "Maximum Trailing Zeros in a Cornered Path",
      titleSlug: "maximum-trailing-zeros-in-a-cornered-path",
    },
    {
      acRate: 53.913734377951016,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2246",
      paidOnly: false,
      title: "Longest Path With Different Adjacent Characters",
      titleSlug: "longest-path-with-different-adjacent-characters",
    },
    {
      acRate: 50.13281815986477,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2247",
      paidOnly: true,
      title: "Maximum Cost of Trip With K Highways",
      titleSlug: "maximum-cost-of-trip-with-k-highways",
    },
    {
      acRate: 68.392685889649,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2248",
      paidOnly: false,
      title: "Intersection of Multiple Arrays",
      titleSlug: "intersection-of-multiple-arrays",
    },
    {
      acRate: 54.97306454990196,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2249",
      paidOnly: false,
      title: "Count Lattice Points Inside a Circle",
      titleSlug: "count-lattice-points-inside-a-circle",
    },
    {
      acRate: 35.917518314190104,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2250",
      paidOnly: false,
      title: "Count Number of Rectangles Containing Each Point",
      titleSlug: "count-number-of-rectangles-containing-each-point",
    },
    {
      acRate: 57.12257281553398,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2251",
      paidOnly: false,
      title: "Number of Flowers in Full Bloom",
      titleSlug: "number-of-flowers-in-full-bloom",
    },
    {
      acRate: 57.23645026801668,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2252",
      paidOnly: true,
      title: "Dynamic Pivoting of a Table",
      titleSlug: "dynamic-pivoting-of-a-table",
    },
    {
      acRate: 68.16168327796235,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2253",
      paidOnly: true,
      title: "Dynamic Unpivoting of a Table",
      titleSlug: "dynamic-unpivoting-of-a-table",
    },
    {
      acRate: 63.6674883593536,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2254",
      paidOnly: true,
      title: "Design Video Sharing Platform",
      titleSlug: "design-video-sharing-platform",
    },
    {
      acRate: 73.80168584649338,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2255",
      paidOnly: false,
      title: "Count Prefixes of a Given String",
      titleSlug: "count-prefixes-of-a-given-string",
    },
    {
      acRate: 43.5003299085682,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2256",
      paidOnly: false,
      title: "Minimum Average Difference",
      titleSlug: "minimum-average-difference",
    },
    {
      acRate: 65.8083810496371,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2257",
      paidOnly: false,
      title: "Count Unguarded Cells in the Grid",
      titleSlug: "count-unguarded-cells-in-the-grid",
    },
    {
      acRate: 36.07073464669569,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2258",
      paidOnly: false,
      title: "Escape the Spreading Fire",
      titleSlug: "escape-the-spreading-fire",
    },
    {
      acRate: 47.118517469189065,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2259",
      paidOnly: false,
      title: "Remove Digit From Number to Maximize Result",
      titleSlug: "remove-digit-from-number-to-maximize-result",
    },
    {
      acRate: 52.570507313244455,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2260",
      paidOnly: false,
      title: "Minimum Consecutive Cards to Pick Up",
      titleSlug: "minimum-consecutive-cards-to-pick-up",
    },
    {
      acRate: 53.527706389497276,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2261",
      paidOnly: false,
      title: "K Divisible Elements Subarrays",
      titleSlug: "k-divisible-elements-subarrays",
    },
    {
      acRate: 55.74033452152454,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2262",
      paidOnly: false,
      title: "Total Appeal of A String",
      titleSlug: "total-appeal-of-a-string",
    },
    {
      acRate: 65.35100495193709,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2263",
      paidOnly: true,
      title: "Make Array Non-decreasing or Non-increasing",
      titleSlug: "make-array-non-decreasing-or-non-increasing",
    },
    {
      acRate: 69.07038417732426,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2264",
      paidOnly: false,
      title: "Largest 3-Same-Digit Number in String",
      titleSlug: "largest-3-same-digit-number-in-string",
    },
    {
      acRate: 86.34586189446566,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2265",
      paidOnly: false,
      title: "Count Nodes Equal to Average of Subtree",
      titleSlug: "count-nodes-equal-to-average-of-subtree",
    },
    {
      acRate: 48.69713212567002,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2266",
      paidOnly: false,
      title: "Count Number of Texts",
      titleSlug: "count-number-of-texts",
    },
    {
      acRate: 39.27746546389506,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2267",
      paidOnly: false,
      title: " Check if There Is a Valid Parentheses String Path",
      titleSlug: "check-if-there-is-a-valid-parentheses-string-path",
    },
    {
      acRate: 71.26590890898903,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2268",
      paidOnly: true,
      title: "Minimum Number of Keypresses",
      titleSlug: "minimum-number-of-keypresses",
    },
    {
      acRate: 61.500651524898146,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2269",
      paidOnly: false,
      title: "Find the K-Beauty of a Number",
      titleSlug: "find-the-k-beauty-of-a-number",
    },
    {
      acRate: 56.084210636746555,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2270",
      paidOnly: false,
      title: "Number of Ways to Split Array",
      titleSlug: "number-of-ways-to-split-array",
    },
    {
      acRate: 34.81118054685122,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2271",
      paidOnly: false,
      title: "Maximum White Tiles Covered by a Carpet",
      titleSlug: "maximum-white-tiles-covered-by-a-carpet",
    },
    {
      acRate: 45.89968378997595,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2272",
      paidOnly: false,
      title: "Substring With Largest Variance",
      titleSlug: "substring-with-largest-variance",
    },
    {
      acRate: 59.325742248153205,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2273",
      paidOnly: false,
      title: "Find Resultant Array After Removing Anagrams",
      titleSlug: "find-resultant-array-after-removing-anagrams",
    },
    {
      acRate: 51.95473251028807,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2274",
      paidOnly: false,
      title: "Maximum Consecutive Floors Without Special Floors",
      titleSlug: "maximum-consecutive-floors-without-special-floors",
    },
    {
      acRate: 80.90583322106964,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2275",
      paidOnly: false,
      title: "Largest Combination With Bitwise AND Greater Than Zero",
      titleSlug: "largest-combination-with-bitwise-and-greater-than-zero",
    },
    {
      acRate: 33.907099444695454,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2276",
      paidOnly: false,
      title: "Count Integers in Intervals",
      titleSlug: "count-integers-in-intervals",
    },
    {
      acRate: 62.54491650813782,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2277",
      paidOnly: true,
      title: "Closest Node to Path in Tree",
      titleSlug: "closest-node-to-path-in-tree",
    },
    {
      acRate: 74.44071729425711,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2278",
      paidOnly: false,
      title: "Percentage of Letter in String",
      titleSlug: "percentage-of-letter-in-string",
    },
    {
      acRate: 67.54379054071798,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2279",
      paidOnly: false,
      title: "Maximum Bags With Full Capacity of Rocks",
      titleSlug: "maximum-bags-with-full-capacity-of-rocks",
    },
    {
      acRate: 25.97706675213219,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2280",
      paidOnly: false,
      title: "Minimum Lines to Represent a Line Chart",
      titleSlug: "minimum-lines-to-represent-a-line-chart",
    },
    {
      acRate: 28.224651989337545,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2281",
      paidOnly: false,
      title: "Sum of Total Strength of Wizards",
      titleSlug: "sum-of-total-strength-of-wizards",
    },
    {
      acRate: 47.0842777663301,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2282",
      paidOnly: true,
      title: "Number of People That Can Be Seen in a Grid",
      titleSlug: "number-of-people-that-can-be-seen-in-a-grid",
    },
    {
      acRate: 72.3284161646084,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2283",
      paidOnly: false,
      title: "Check if Number Has Equal Digit Count and Digit Value",
      titleSlug: "check-if-number-has-equal-digit-count-and-digit-value",
    },
    {
      acRate: 58.13378943367541,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2284",
      paidOnly: false,
      title: "Sender With Largest Word Count",
      titleSlug: "sender-with-largest-word-count",
    },
    {
      acRate: 69.15355695879111,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2285",
      paidOnly: false,
      title: "Maximum Total Importance of Roads",
      titleSlug: "maximum-total-importance-of-roads",
    },
    {
      acRate: 17.45347401260914,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2286",
      paidOnly: false,
      title: "Booking Concert Tickets in Groups",
      titleSlug: "booking-concert-tickets-in-groups",
    },
    {
      acRate: 60.007853628008,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2287",
      paidOnly: false,
      title: "Rearrange Characters to Make Target String",
      titleSlug: "rearrange-characters-to-make-target-string",
    },
    {
      acRate: 32.578872801409865,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2288",
      paidOnly: false,
      title: "Apply Discount to Prices",
      titleSlug: "apply-discount-to-prices",
    },
    {
      acRate: 23.010477625538776,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2289",
      paidOnly: false,
      title: "Steps to Make Array Non-decreasing",
      titleSlug: "steps-to-make-array-non-decreasing",
    },
    {
      acRate: 69.99485528095882,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2290",
      paidOnly: false,
      title: "Minimum Obstacle Removal to Reach Corner",
      titleSlug: "minimum-obstacle-removal-to-reach-corner",
    },
    {
      acRate: 46.46584610955157,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2291",
      paidOnly: true,
      title: "Maximum Profit From Trading Stocks",
      titleSlug: "maximum-profit-from-trading-stocks",
    },
    {
      acRate: 40.04807906334862,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2292",
      paidOnly: true,
      title: "Products With Three or More Orders in Two Consecutive Years",
      titleSlug: "products-with-three-or-more-orders-in-two-consecutive-years",
    },
    {
      acRate: 63.65664446985494,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2293",
      paidOnly: false,
      title: "Min Max Game",
      titleSlug: "min-max-game",
    },
    {
      acRate: 74.41935389391676,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2294",
      paidOnly: false,
      title: "Partition Array Such That Maximum Difference Is K",
      titleSlug: "partition-array-such-that-maximum-difference-is-k",
    },
    {
      acRate: 58.67546878292015,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2295",
      paidOnly: false,
      title: "Replace Elements in an Array",
      titleSlug: "replace-elements-in-an-array",
    },
    {
      acRate: 46.9104721522901,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2296",
      paidOnly: false,
      title: "Design a Text Editor",
      titleSlug: "design-a-text-editor",
    },
    {
      acRate: 44.81827882744335,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2297",
      paidOnly: true,
      title: "Jump Game VIII",
      titleSlug: "jump-game-viii",
    },
    {
      acRate: 82.25941422594141,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2298",
      paidOnly: true,
      title: "Tasks Count in the Weekend",
      titleSlug: "tasks-count-in-the-weekend",
    },
    {
      acRate: 54.86354093771868,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2299",
      paidOnly: false,
      title: "Strong Password Checker II",
      titleSlug: "strong-password-checker-ii",
    },
    {
      acRate: 45.268131761116024,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2300",
      paidOnly: false,
      title: "Successful Pairs of Spells and Potions",
      titleSlug: "successful-pairs-of-spells-and-potions",
    },
    {
      acRate: 41.97062391904799,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2301",
      paidOnly: false,
      title: "Match Substring After Replacement",
      titleSlug: "match-substring-after-replacement",
    },
    {
      acRate: 62.44880520934618,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2302",
      paidOnly: false,
      title: "Count Subarrays With Score Less Than K",
      titleSlug: "count-subarrays-with-score-less-than-k",
    },
    {
      acRate: 67.21098453675228,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2303",
      paidOnly: false,
      title: "Calculate Amount Paid in Taxes",
      titleSlug: "calculate-amount-paid-in-taxes",
    },
    {
      acRate: 67.12659733101795,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2304",
      paidOnly: false,
      title: "Minimum Path Cost in a Grid",
      titleSlug: "minimum-path-cost-in-a-grid",
    },
    {
      acRate: 69.29169262787367,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2305",
      paidOnly: false,
      title: "Fair Distribution of Cookies",
      titleSlug: "fair-distribution-of-cookies",
    },
    {
      acRate: 46.332412966939856,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2306",
      paidOnly: false,
      title: "Naming a Company",
      titleSlug: "naming-a-company",
    },
    {
      acRate: 43.24761733501169,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2307",
      paidOnly: true,
      title: "Check for Contradictions in Equations",
      titleSlug: "check-for-contradictions-in-equations",
    },
    {
      acRate: 70.38630713329509,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2308",
      paidOnly: true,
      title: "Arrange Table by Gender",
      titleSlug: "arrange-table-by-gender",
    },
    {
      acRate: 70.9395913466883,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2309",
      paidOnly: false,
      title: "Greatest English Letter in Upper and Lower Case",
      titleSlug: "greatest-english-letter-in-upper-and-lower-case",
    },
    {
      acRate: 27.23180236992392,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2310",
      paidOnly: false,
      title: "Sum of Numbers With Units Digit K",
      titleSlug: "sum-of-numbers-with-units-digit-k",
    },
    {
      acRate: 38.16475986924818,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2311",
      paidOnly: false,
      title: "Longest Binary Subsequence Less Than or Equal to K",
      titleSlug: "longest-binary-subsequence-less-than-or-equal-to-k",
    },
    {
      acRate: 51.492450863034335,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2312",
      paidOnly: false,
      title: "Selling Pieces of Wood",
      titleSlug: "selling-pieces-of-wood",
    },
    {
      acRate: 56.7150979153506,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2313",
      paidOnly: true,
      title: "Minimum Flips in Binary Tree to Get Result",
      titleSlug: "minimum-flips-in-binary-tree-to-get-result",
    },
    {
      acRate: 73.12793307488268,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2314",
      paidOnly: true,
      title: "The First Day of the Maximum Recorded Degree in Each City",
      titleSlug: "the-first-day-of-the-maximum-recorded-degree-in-each-city",
    },
    {
      acRate: 82.68749636353057,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2315",
      paidOnly: false,
      title: "Count Asterisks",
      titleSlug: "count-asterisks",
    },
    {
      acRate: 49.2520480199328,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2316",
      paidOnly: false,
      title: "Count Unreachable Pairs of Nodes in an Undirected Graph",
      titleSlug: "count-unreachable-pairs-of-nodes-in-an-undirected-graph",
    },
    {
      acRate: 79.20808528312335,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2317",
      paidOnly: false,
      title: "Maximum XOR After Operations ",
      titleSlug: "maximum-xor-after-operations",
    },
    {
      acRate: 57.1200219218122,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2318",
      paidOnly: false,
      title: "Number of Distinct Roll Sequences",
      titleSlug: "number-of-distinct-roll-sequences",
    },
    {
      acRate: 65.38291883717022,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2319",
      paidOnly: false,
      title: "Check if Matrix Is X-Matrix",
      titleSlug: "check-if-matrix-is-x-matrix",
    },
    {
      acRate: 42.66055669626467,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2320",
      paidOnly: false,
      title: "Count Number of Ways to Place Houses",
      titleSlug: "count-number-of-ways-to-place-houses",
    },
    {
      acRate: 57.382246376811594,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2321",
      paidOnly: false,
      title: "Maximum Score Of Spliced Array",
      titleSlug: "maximum-score-of-spliced-array",
    },
    {
      acRate: 51.967911757332665,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2322",
      paidOnly: false,
      title: "Minimum Score After Removals on a Tree",
      titleSlug: "minimum-score-after-removals-on-a-tree",
    },
    {
      acRate: 65.61262617812727,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2323",
      paidOnly: true,
      title: "Find Minimum Time to Finish All Jobs II",
      titleSlug: "find-minimum-time-to-finish-all-jobs-ii",
    },
    {
      acRate: 75.4640966901019,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2324",
      paidOnly: true,
      title: "Product Sales Analysis IV",
      titleSlug: "product-sales-analysis-iv",
    },
    {
      acRate: 85.37018666562928,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2325",
      paidOnly: false,
      title: "Decode the Message",
      titleSlug: "decode-the-message",
    },
    {
      acRate: 82.17513877989944,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2326",
      paidOnly: false,
      title: "Spiral Matrix IV",
      titleSlug: "spiral-matrix-iv",
    },
    {
      acRate: 46.261906734034625,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2327",
      paidOnly: false,
      title: "Number of People Aware of a Secret",
      titleSlug: "number-of-people-aware-of-a-secret",
    },
    {
      acRate: 57.69499757910188,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2328",
      paidOnly: false,
      title: "Number of Increasing Paths in a Grid",
      titleSlug: "number-of-increasing-paths-in-a-grid",
    },
    {
      acRate: 70.42372232012872,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2329",
      paidOnly: true,
      title: "Product Sales Analysis V",
      titleSlug: "product-sales-analysis-v",
    },
    {
      acRate: 75.73418290242209,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2330",
      paidOnly: true,
      title: "Valid Palindrome IV",
      titleSlug: "valid-palindrome-iv",
    },
    {
      acRate: 82.42681448120561,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2331",
      paidOnly: false,
      title: "Evaluate Boolean Binary Tree",
      titleSlug: "evaluate-boolean-binary-tree",
    },
    {
      acRate: 28.219196706028587,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2332",
      paidOnly: false,
      title: "The Latest Time to Catch a Bus",
      titleSlug: "the-latest-time-to-catch-a-bus",
    },
    {
      acRate: 25.845969735619693,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2333",
      paidOnly: false,
      title: "Minimum Sum of Squared Difference",
      titleSlug: "minimum-sum-of-squared-difference",
    },
    {
      acRate: 44.40137086353166,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2334",
      paidOnly: false,
      title: "Subarray With Elements Greater Than Varying Threshold",
      titleSlug: "subarray-with-elements-greater-than-varying-threshold",
    },
    {
      acRate: 58.72896359455445,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2335",
      paidOnly: false,
      title: "Minimum Amount of Time to Fill Cups",
      titleSlug: "minimum-amount-of-time-to-fill-cups",
    },
    {
      acRate: 70.42664020835917,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2336",
      paidOnly: false,
      title: "Smallest Number in Infinite Set",
      titleSlug: "smallest-number-in-infinite-set",
    },
    {
      acRate: 56.85519052162071,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2337",
      paidOnly: false,
      title: "Move Pieces to Obtain a String",
      titleSlug: "move-pieces-to-obtain-a-string",
    },
    {
      acRate: 57.351822394356454,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2338",
      paidOnly: false,
      title: "Count the Number of Ideal Arrays",
      titleSlug: "count-the-number-of-ideal-arrays",
    },
    {
      acRate: 88.446000538648,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2339",
      paidOnly: true,
      title: "All the Matches of the League",
      titleSlug: "all-the-matches-of-the-league",
    },
    {
      acRate: 72.23578205575232,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2340",
      paidOnly: true,
      title: "Minimum Adjacent Swaps to Make a Valid Array",
      titleSlug: "minimum-adjacent-swaps-to-make-a-valid-array",
    },
    {
      acRate: 75.47282093243821,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2341",
      paidOnly: false,
      title: "Maximum Number of Pairs in Array",
      titleSlug: "maximum-number-of-pairs-in-array",
    },
    {
      acRate: 65.99702695765248,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2342",
      paidOnly: false,
      title: "Max Sum of a Pair With Equal Sum of Digits",
      titleSlug: "max-sum-of-a-pair-with-equal-sum-of-digits",
    },
    {
      acRate: 45.314830426042406,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2343",
      paidOnly: false,
      title: "Query Kth Smallest Trimmed Number",
      titleSlug: "query-kth-smallest-trimmed-number",
    },
    {
      acRate: 57.50920421401591,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2344",
      paidOnly: false,
      title: "Minimum Deletions to Make Array Divisible",
      titleSlug: "minimum-deletions-to-make-array-divisible",
    },
    {
      acRate: 36.737621780328304,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2345",
      paidOnly: true,
      title: "Finding the Number of Visible Mountains",
      titleSlug: "finding-the-number-of-visible-mountains",
    },
    {
      acRate: 33.7926966593383,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2346",
      paidOnly: true,
      title: "Compute the Rank as a Percentage",
      titleSlug: "compute-the-rank-as-a-percentage",
    },
    {
      acRate: 61.10969938759434,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2347",
      paidOnly: false,
      title: "Best Poker Hand",
      titleSlug: "best-poker-hand",
    },
    {
      acRate: 66.66682231426184,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2348",
      paidOnly: false,
      title: "Number of Zero-Filled Subarrays",
      titleSlug: "number-of-zero-filled-subarrays",
    },
    {
      acRate: 57.24787777924115,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2349",
      paidOnly: false,
      title: "Design a Number Container System",
      titleSlug: "design-a-number-container-system",
    },
    {
      acRate: 68.59794628751975,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2350",
      paidOnly: false,
      title: "Shortest Impossible Sequence of Rolls",
      titleSlug: "shortest-impossible-sequence-of-rolls",
    },
    {
      acRate: 74.10682553637231,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2351",
      paidOnly: false,
      title: "First Letter to Appear Twice",
      titleSlug: "first-letter-to-appear-twice",
    },
    {
      acRate: 70.44045536969281,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2352",
      paidOnly: false,
      title: "Equal Row and Column Pairs",
      titleSlug: "equal-row-and-column-pairs",
    },
    {
      acRate: 44.849380983409354,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2353",
      paidOnly: false,
      title: "Design a Food Rating System",
      titleSlug: "design-a-food-rating-system",
    },
    {
      acRate: 47.94669101909192,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2354",
      paidOnly: false,
      title: "Number of Excellent Pairs",
      titleSlug: "number-of-excellent-pairs",
    },
    {
      acRate: 39.272971242109115,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2355",
      paidOnly: true,
      title: "Maximum Number of Books You Can Take",
      titleSlug: "maximum-number-of-books-you-can-take",
    },
    {
      acRate: 89.34357531353899,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2356",
      paidOnly: false,
      title: "Number of Unique Subjects Taught by Each Teacher",
      titleSlug: "number-of-unique-subjects-taught-by-each-teacher",
    },
    {
      acRate: 73.21874969603238,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2357",
      paidOnly: false,
      title: "Make Array Zero by Subtracting Equal Amounts",
      titleSlug: "make-array-zero-by-subtracting-equal-amounts",
    },
    {
      acRate: 68.08350265451924,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2358",
      paidOnly: false,
      title: "Maximum Number of Groups Entering a Competition",
      titleSlug: "maximum-number-of-groups-entering-a-competition",
    },
    {
      acRate: 45.73999186939684,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2359",
      paidOnly: false,
      title: "Find Closest Node to Given Two Nodes",
      titleSlug: "find-closest-node-to-given-two-nodes",
    },
    {
      acRate: 49.77524486776297,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2360",
      paidOnly: false,
      title: "Longest Cycle in a Graph",
      titleSlug: "longest-cycle-in-a-graph",
    },
    {
      acRate: 77.53135160241523,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2361",
      paidOnly: true,
      title: "Minimum Costs Using the Train Line",
      titleSlug: "minimum-costs-using-the-train-line",
    },
    {
      acRate: 76.48974275480299,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2362",
      paidOnly: true,
      title: "Generate the Invoice",
      titleSlug: "generate-the-invoice",
    },
    {
      acRate: 76.65216060181945,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2363",
      paidOnly: false,
      title: "Merge Similar Items",
      titleSlug: "merge-similar-items",
    },
    {
      acRate: 54.39984334008877,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2364",
      paidOnly: false,
      title: "Count Number of Bad Pairs",
      titleSlug: "count-number-of-bad-pairs",
    },
    {
      acRate: 53.913667099241856,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2365",
      paidOnly: false,
      title: "Task Scheduler II",
      titleSlug: "task-scheduler-ii",
    },
    {
      acRate: 53.26377276544873,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2366",
      paidOnly: false,
      title: "Minimum Replacements to Sort the Array",
      titleSlug: "minimum-replacements-to-sort-the-array",
    },
    {
      acRate: 84.91740780940347,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2367",
      paidOnly: false,
      title: "Number of Arithmetic Triplets",
      titleSlug: "number-of-arithmetic-triplets",
    },
    {
      acRate: 59.39755621864008,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2368",
      paidOnly: false,
      title: "Reachable Nodes With Restrictions",
      titleSlug: "reachable-nodes-with-restrictions",
    },
    {
      acRate: 51.90006998818949,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2369",
      paidOnly: false,
      title: "Check if There is a Valid Partition For The Array",
      titleSlug: "check-if-there-is-a-valid-partition-for-the-array",
    },
    {
      acRate: 46.862141330142975,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2370",
      paidOnly: false,
      title: "Longest Ideal Subsequence",
      titleSlug: "longest-ideal-subsequence",
    },
    {
      acRate: 70.57672502574665,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2371",
      paidOnly: true,
      title: "Minimize Maximum Value in a Grid",
      titleSlug: "minimize-maximum-value-in-a-grid",
    },
    {
      acRate: 83.68369591786849,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2372",
      paidOnly: true,
      title: "Calculate the Influence of Each Salesperson",
      titleSlug: "calculate-the-influence-of-each-salesperson",
    },
    {
      acRate: 87.76212756672889,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2373",
      paidOnly: false,
      title: "Largest Local Values in a Matrix",
      titleSlug: "largest-local-values-in-a-matrix",
    },
    {
      acRate: 48.35446452657135,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2374",
      paidOnly: false,
      title: "Node With Highest Edge Score",
      titleSlug: "node-with-highest-edge-score",
    },
    {
      acRate: 85.83171827511784,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2375",
      paidOnly: false,
      title: "Construct Smallest Number From DI String",
      titleSlug: "construct-smallest-number-from-di-string",
    },
    {
      acRate: 39.646471687066104,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2376",
      paidOnly: false,
      title: "Count Special Integers",
      titleSlug: "count-special-integers",
    },
    {
      acRate: 79.495693680606,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2377",
      paidOnly: true,
      title: "Sort the Olympic Table",
      titleSlug: "sort-the-olympic-table",
    },
    {
      acRate: 55.649803089972735,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2378",
      paidOnly: true,
      title: "Choose Edges to Maximize Score in a Tree",
      titleSlug: "choose-edges-to-maximize-score-in-a-tree",
    },
    {
      acRate: 68.4456099947417,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2379",
      paidOnly: false,
      title: "Minimum Recolors to Get K Consecutive Black Blocks",
      titleSlug: "minimum-recolors-to-get-k-consecutive-black-blocks",
    },
    {
      acRate: 51.489569619565955,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2380",
      paidOnly: false,
      title: "Time Needed to Rearrange a Binary String",
      titleSlug: "time-needed-to-rearrange-a-binary-string",
    },
    {
      acRate: 53.28067870201097,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2381",
      paidOnly: false,
      title: "Shifting Letters II",
      titleSlug: "shifting-letters-ii",
    },
    {
      acRate: 48.23434270823974,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2382",
      paidOnly: false,
      title: "Maximum Segment Sum After Removals",
      titleSlug: "maximum-segment-sum-after-removals",
    },
    {
      acRate: 41.792122087028254,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2383",
      paidOnly: false,
      title: "Minimum Hours of Training to Win a Competition",
      titleSlug: "minimum-hours-of-training-to-win-a-competition",
    },
    {
      acRate: 36.355480581221485,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2384",
      paidOnly: false,
      title: "Largest Palindromic Number",
      titleSlug: "largest-palindromic-number",
    },
    {
      acRate: 63.43293695814635,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2385",
      paidOnly: false,
      title: "Amount of Time for Binary Tree to Be Infected",
      titleSlug: "amount-of-time-for-binary-tree-to-be-infected",
    },
    {
      acRate: 39.46474086661003,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2386",
      paidOnly: false,
      title: "Find the K-Sum of an Array",
      titleSlug: "find-the-k-sum-of-an-array",
    },
    {
      acRate: 69.63114156582593,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2387",
      paidOnly: true,
      title: "Median of a Row Wise Sorted Matrix",
      titleSlug: "median-of-a-row-wise-sorted-matrix",
    },
    {
      acRate: 51.38271828814942,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2388",
      paidOnly: true,
      title: "Change Null Values in a Table to the Previous Value",
      titleSlug: "change-null-values-in-a-table-to-the-previous-value",
    },
    {
      acRate: 72.68946297630653,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2389",
      paidOnly: false,
      title: "Longest Subsequence With Limited Sum",
      titleSlug: "longest-subsequence-with-limited-sum",
    },
    {
      acRate: 77.77166129327368,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2390",
      paidOnly: false,
      title: "Removing Stars From a String",
      titleSlug: "removing-stars-from-a-string",
    },
    {
      acRate: 85.10073698456884,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2391",
      paidOnly: false,
      title: "Minimum Amount of Time to Collect Garbage",
      titleSlug: "minimum-amount-of-time-to-collect-garbage",
    },
    {
      acRate: 79.23041901757695,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2392",
      paidOnly: false,
      title: "Build a Matrix With Conditions",
      titleSlug: "build-a-matrix-with-conditions",
    },
    {
      acRate: 71.23013985348682,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2393",
      paidOnly: true,
      title: "Count Strictly Increasing Subarrays",
      titleSlug: "count-strictly-increasing-subarrays",
    },
    {
      acRate: 41.966158579219695,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2394",
      paidOnly: true,
      title: "Employees With Deductions",
      titleSlug: "employees-with-deductions",
    },
    {
      acRate: 66.11316966907643,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2395",
      paidOnly: false,
      title: "Find Subarrays With Equal Sum",
      titleSlug: "find-subarrays-with-equal-sum",
    },
    {
      acRate: 88.06879506953025,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2396",
      paidOnly: false,
      title: "Strictly Palindromic Number",
      titleSlug: "strictly-palindromic-number",
    },
    {
      acRate: 56.33048578350122,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2397",
      paidOnly: false,
      title: "Maximum Rows Covered by Columns",
      titleSlug: "maximum-rows-covered-by-columns",
    },
    {
      acRate: 36.50162059606314,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2398",
      paidOnly: false,
      title: "Maximum Number of Robots Within Budget",
      titleSlug: "maximum-number-of-robots-within-budget",
    },
    {
      acRate: 70.72578536476037,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2399",
      paidOnly: false,
      title: "Check Distances Between Same Letters",
      titleSlug: "check-distances-between-same-letters",
    },
    {
      acRate: 36.030425238654345,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2400",
      paidOnly: false,
      title: "Number of Ways to Reach a Position After Exactly k Steps",
      titleSlug: "number-of-ways-to-reach-a-position-after-exactly-k-steps",
    },
    {
      acRate: 64.7940164595257,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2401",
      paidOnly: false,
      title: "Longest Nice Subarray",
      titleSlug: "longest-nice-subarray",
    },
    {
      acRate: 43.89066510275765,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2402",
      paidOnly: false,
      title: "Meeting Rooms III",
      titleSlug: "meeting-rooms-iii",
    },
    {
      acRate: 55.92932381923208,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2403",
      paidOnly: true,
      title: "Minimum Time to Kill All Monsters",
      titleSlug: "minimum-time-to-kill-all-monsters",
    },
    {
      acRate: 51.68575217555441,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2404",
      paidOnly: false,
      title: "Most Frequent Even Element",
      titleSlug: "most-frequent-even-element",
    },
    {
      acRate: 78.19936751364486,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2405",
      paidOnly: false,
      title: "Optimal Partition of String",
      titleSlug: "optimal-partition-of-string",
    },
    {
      acRate: 63.66918001885015,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2406",
      paidOnly: false,
      title: "Divide Intervals Into Minimum Number of Groups",
      titleSlug: "divide-intervals-into-minimum-number-of-groups",
    },
    {
      acRate: 25.476633856522124,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2407",
      paidOnly: false,
      title: "Longest Increasing Subsequence II",
      titleSlug: "longest-increasing-subsequence-ii",
    },
    {
      acRate: 70.71402106600328,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2408",
      paidOnly: true,
      title: "Design SQL",
      titleSlug: "design-sql",
    },
    {
      acRate: 46.317116380485146,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2409",
      paidOnly: false,
      title: "Count Days Spent Together",
      titleSlug: "count-days-spent-together",
    },
    {
      acRate: 66.84259788882534,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2410",
      paidOnly: false,
      title: "Maximum Matching of Players With Trainers",
      titleSlug: "maximum-matching-of-players-with-trainers",
    },
    {
      acRate: 45.04137115839244,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2411",
      paidOnly: false,
      title: "Smallest Subarrays With Maximum Bitwise OR",
      titleSlug: "smallest-subarrays-with-maximum-bitwise-or",
    },
    {
      acRate: 41.06566017205617,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2412",
      paidOnly: false,
      title: "Minimum Money Required Before Transactions",
      titleSlug: "minimum-money-required-before-transactions",
    },
    {
      acRate: 88.09120685503751,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2413",
      paidOnly: false,
      title: "Smallest Even Multiple",
      titleSlug: "smallest-even-multiple",
    },
    {
      acRate: 59.18256426979727,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2414",
      paidOnly: false,
      title: "Length of the Longest Alphabetical Continuous Substring",
      titleSlug: "length-of-the-longest-alphabetical-continuous-substring",
    },
    {
      acRate: 86.62522110082197,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2415",
      paidOnly: false,
      title: "Reverse Odd Levels of Binary Tree",
      titleSlug: "reverse-odd-levels-of-binary-tree",
    },
    {
      acRate: 60.70211208699289,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2416",
      paidOnly: false,
      title: "Sum of Prefix Scores of Strings",
      titleSlug: "sum-of-prefix-scores-of-strings",
    },
    {
      acRate: 45.0850989927058,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2417",
      paidOnly: true,
      title: "Closest Fair Integer",
      titleSlug: "closest-fair-integer",
    },
    {
      acRate: 84.80967344178832,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2418",
      paidOnly: false,
      title: "Sort the People",
      titleSlug: "sort-the-people",
    },
    {
      acRate: 61.7930391547545,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2419",
      paidOnly: false,
      title: "Longest Subarray With Maximum Bitwise AND",
      titleSlug: "longest-subarray-with-maximum-bitwise-and",
    },
    {
      acRate: 39.66438588554625,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2420",
      paidOnly: false,
      title: "Find All Good Indices",
      titleSlug: "find-all-good-indices",
    },
    {
      acRate: 55.93971137237421,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2421",
      paidOnly: false,
      title: "Number of Good Paths",
      titleSlug: "number-of-good-paths",
    },
    {
      acRate: 68.94512499519988,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2422",
      paidOnly: true,
      title: "Merge Operations to Turn Array Into a Palindrome",
      titleSlug: "merge-operations-to-turn-array-into-a-palindrome",
    },
    {
      acRate: 18.103186113970242,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2423",
      paidOnly: false,
      title: "Remove Letter To Equalize Frequency",
      titleSlug: "remove-letter-to-equalize-frequency",
    },
    {
      acRate: 53.61022501939823,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2424",
      paidOnly: false,
      title: "Longest Uploaded Prefix",
      titleSlug: "longest-uploaded-prefix",
    },
    {
      acRate: 67.02690326273611,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2425",
      paidOnly: false,
      title: "Bitwise XOR of All Pairings",
      titleSlug: "bitwise-xor-of-all-pairings",
    },
    {
      acRate: 45.19257722711218,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2426",
      paidOnly: false,
      title: "Number of Pairs Satisfying Inequality",
      titleSlug: "number-of-pairs-satisfying-inequality",
    },
    {
      acRate: 79.46717133013921,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2427",
      paidOnly: false,
      title: "Number of Common Factors",
      titleSlug: "number-of-common-factors",
    },
    {
      acRate: 75.83000895546691,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2428",
      paidOnly: false,
      title: "Maximum Sum of an Hourglass",
      titleSlug: "maximum-sum-of-an-hourglass",
    },
    {
      acRate: 62.445582883237904,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2429",
      paidOnly: false,
      title: "Minimize XOR",
      titleSlug: "minimize-xor",
    },
    {
      acRate: 34.41876905403614,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2430",
      paidOnly: false,
      title: "Maximum Deletions on a String",
      titleSlug: "maximum-deletions-on-a-string",
    },
    {
      acRate: 64.23141108844798,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2431",
      paidOnly: true,
      title: "Maximize Total Tastiness of Purchased Fruits",
      titleSlug: "maximize-total-tastiness-of-purchased-fruits",
    },
    {
      acRate: 50.47937171706869,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2432",
      paidOnly: false,
      title: "The Employee That Worked on the Longest Task",
      titleSlug: "the-employee-that-worked-on-the-longest-task",
    },
    {
      acRate: 88.06833460757692,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2433",
      paidOnly: false,
      title: "Find The Original Array of Prefix Xor",
      titleSlug: "find-the-original-array-of-prefix-xor",
    },
    {
      acRate: 41.54192999963041,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2434",
      paidOnly: false,
      title: "Using a Robot to Print the Lexicographically Smallest String",
      titleSlug: "using-a-robot-to-print-the-lexicographically-smallest-string",
    },
    {
      acRate: 43.954738785009226,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2435",
      paidOnly: false,
      title: "Paths in Matrix Whose Sum Is Divisible by K",
      titleSlug: "paths-in-matrix-whose-sum-is-divisible-by-k",
    },
    {
      acRate: 69.81634282672346,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2436",
      paidOnly: true,
      title: "Minimum Split Into Subarrays With GCD Greater Than One",
      titleSlug: "minimum-split-into-subarrays-with-gcd-greater-than-one",
    },
    {
      acRate: 47.362434428862,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2437",
      paidOnly: false,
      title: "Number of Valid Clock Times",
      titleSlug: "number-of-valid-clock-times",
    },
    {
      acRate: 41.748884984457355,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2438",
      paidOnly: false,
      title: "Range Product Queries of Powers",
      titleSlug: "range-product-queries-of-powers",
    },
    {
      acRate: 46.411021365963364,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2439",
      paidOnly: false,
      title: "Minimize Maximum of Array",
      titleSlug: "minimize-maximum-of-array",
    },
    {
      acRate: 51.94743975016204,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2440",
      paidOnly: false,
      title: "Create Components With Same Value",
      titleSlug: "create-components-with-same-value",
    },
    {
      acRate: 74.69018345042934,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2441",
      paidOnly: false,
      title: "Largest Positive Integer That Exists With Its Negative",
      titleSlug: "largest-positive-integer-that-exists-with-its-negative",
    },
    {
      acRate: 80.12338026506094,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2442",
      paidOnly: false,
      title: "Count Number of Distinct Integers After Reverse Operations",
      titleSlug: "count-number-of-distinct-integers-after-reverse-operations",
    },
    {
      acRate: 48.116943988750876,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2443",
      paidOnly: false,
      title: "Sum of Number and Its Reverse",
      titleSlug: "sum-of-number-and-its-reverse",
    },
    {
      acRate: 69.40960929843507,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2444",
      paidOnly: false,
      title: "Count Subarrays With Fixed Bounds",
      titleSlug: "count-subarrays-with-fixed-bounds",
    },
    {
      acRate: 65.4419595314164,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2445",
      paidOnly: true,
      title: "Number of Nodes With Value One",
      titleSlug: "number-of-nodes-with-value-one",
    },
    {
      acRate: 52.22904268778408,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2446",
      paidOnly: false,
      title: "Determine if Two Events Have Conflict",
      titleSlug: "determine-if-two-events-have-conflict",
    },
    {
      acRate: 50.900924068645104,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2447",
      paidOnly: false,
      title: "Number of Subarrays With GCD Equal to K",
      titleSlug: "number-of-subarrays-with-gcd-equal-to-k",
    },
    {
      acRate: 46.2161864752374,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2448",
      paidOnly: false,
      title: "Minimum Cost to Make Array Equal",
      titleSlug: "minimum-cost-to-make-array-equal",
    },
    {
      acRate: 60.26985288141103,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2449",
      paidOnly: false,
      title: "Minimum Number of Operations to Make Arrays Similar",
      titleSlug: "minimum-number-of-operations-to-make-arrays-similar",
    },
    {
      acRate: 63.589743589743584,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2450",
      paidOnly: true,
      title: "Number of Distinct Binary Strings After Applying Operations",
      titleSlug: "number-of-distinct-binary-strings-after-applying-operations",
    },
    {
      acRate: 60.91907802673272,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2451",
      paidOnly: false,
      title: "Odd String Difference",
      titleSlug: "odd-string-difference",
    },
    {
      acRate: 61.20665284583491,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2452",
      paidOnly: false,
      title: "Words Within Two Edits of Dictionary",
      titleSlug: "words-within-two-edits-of-dictionary",
    },
    {
      acRate: 40.46249606051055,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2453",
      paidOnly: false,
      title: "Destroy Sequential Targets",
      titleSlug: "destroy-sequential-targets",
    },
    {
      acRate: 39.94957078505255,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2454",
      paidOnly: false,
      title: "Next Greater Element IV",
      titleSlug: "next-greater-element-iv",
    },
    {
      acRate: 61.478918427187146,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2455",
      paidOnly: false,
      title: "Average Value of Even Numbers That Are Divisible by Three",
      titleSlug: "average-value-of-even-numbers-that-are-divisible-by-three",
    },
    {
      acRate: 44.36835809510601,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2456",
      paidOnly: false,
      title: "Most Popular Video Creator",
      titleSlug: "most-popular-video-creator",
    },
    {
      acRate: 37.92590589507842,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2457",
      paidOnly: false,
      title: "Minimum Addition to Make Integer Beautiful",
      titleSlug: "minimum-addition-to-make-integer-beautiful",
    },
    {
      acRate: 54.90565014640495,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2458",
      paidOnly: false,
      title: "Height of Binary Tree After Subtree Removal Queries",
      titleSlug: "height-of-binary-tree-after-subtree-removal-queries",
    },
    {
      acRate: 44.60521614862451,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2459",
      paidOnly: true,
      title: "Sort Array by Moving Items to Empty Space",
      titleSlug: "sort-array-by-moving-items-to-empty-space",
    },
    {
      acRate: 74.86910830523095,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2460",
      paidOnly: false,
      title: "Apply Operations to an Array",
      titleSlug: "apply-operations-to-an-array",
    },
    {
      acRate: 42.64145633338231,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2461",
      paidOnly: false,
      title: "Maximum Sum of Distinct Subarrays With Length K",
      titleSlug: "maximum-sum-of-distinct-subarrays-with-length-k",
    },
    {
      acRate: 43.02482656752031,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2462",
      paidOnly: false,
      title: "Total Cost to Hire K Workers",
      titleSlug: "total-cost-to-hire-k-workers",
    },
    {
      acRate: 59.02271306522192,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2463",
      paidOnly: false,
      title: "Minimum Total Distance Traveled",
      titleSlug: "minimum-total-distance-traveled",
    },
    {
      acRate: 54.48543689320389,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2464",
      paidOnly: true,
      title: "Minimum Subarrays in a Valid Split",
      titleSlug: "minimum-subarrays-in-a-valid-split",
    },
    {
      acRate: 58.3406667234413,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2465",
      paidOnly: false,
      title: "Number of Distinct Averages",
      titleSlug: "number-of-distinct-averages",
    },
    {
      acRate: 59.23562868596134,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2466",
      paidOnly: false,
      title: "Count Ways To Build Good Strings",
      titleSlug: "count-ways-to-build-good-strings",
    },
    {
      acRate: 67.71039661738128,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2467",
      paidOnly: false,
      title: "Most Profitable Path in a Tree",
      titleSlug: "most-profitable-path-in-a-tree",
    },
    {
      acRate: 42.8963833358767,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2468",
      paidOnly: false,
      title: "Split Message Based on Limit",
      titleSlug: "split-message-based-on-limit",
    },
    {
      acRate: 90.05188625473907,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2469",
      paidOnly: false,
      title: "Convert the Temperature",
      titleSlug: "convert-the-temperature",
    },
    {
      acRate: 39.64896703714861,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2470",
      paidOnly: false,
      title: "Number of Subarrays With LCM Equal to K",
      titleSlug: "number-of-subarrays-with-lcm-equal-to-k",
    },
    {
      acRate: 74.26821061103287,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2471",
      paidOnly: false,
      title: "Minimum Number of Operations to Sort a Binary Tree by Level",
      titleSlug: "minimum-number-of-operations-to-sort-a-binary-tree-by-level",
    },
    {
      acRate: 41.40713871777811,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2472",
      paidOnly: false,
      title: "Maximum Number of Non-overlapping Palindrome Substrings",
      titleSlug: "maximum-number-of-non-overlapping-palindrome-substrings",
    },
    {
      acRate: 67.18672854744742,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2473",
      paidOnly: true,
      title: "Minimum Cost to Buy Apples",
      titleSlug: "minimum-cost-to-buy-apples",
    },
    {
      acRate: 48.32038631114843,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2474",
      paidOnly: true,
      title: "Customers With Strictly Increasing Purchases",
      titleSlug: "customers-with-strictly-increasing-purchases",
    },
    {
      acRate: 72.47109326317246,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2475",
      paidOnly: false,
      title: "Number of Unequal Triplets in Array",
      titleSlug: "number-of-unequal-triplets-in-array",
    },
    {
      acRate: 42.383537362211264,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2476",
      paidOnly: false,
      title: "Closest Nodes Queries in a Binary Search Tree",
      titleSlug: "closest-nodes-queries-in-a-binary-search-tree",
    },
    {
      acRate: 64.33087374853726,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2477",
      paidOnly: false,
      title: "Minimum Fuel Cost to Report to the Capital",
      titleSlug: "minimum-fuel-cost-to-report-to-the-capital",
    },
    {
      acRate: 32.04790805091573,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2478",
      paidOnly: false,
      title: "Number of Beautiful Partitions",
      titleSlug: "number-of-beautiful-partitions",
    },
    {
      acRate: 49.605343047966,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2479",
      paidOnly: true,
      title: "Maximum XOR of Two Non-Overlapping Subtrees",
      titleSlug: "maximum-xor-of-two-non-overlapping-subtrees",
    },
    {
      acRate: 78.7906254046355,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2480",
      paidOnly: true,
      title: "Form a Chemical Bond",
      titleSlug: "form-a-chemical-bond",
    },
    {
      acRate: 54.97100374767675,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2481",
      paidOnly: false,
      title: "Minimum Cuts to Divide a Circle",
      titleSlug: "minimum-cuts-to-divide-a-circle",
    },
    {
      acRate: 84.27440205845154,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2482",
      paidOnly: false,
      title: "Difference Between Ones and Zeros in Row and Column",
      titleSlug: "difference-between-ones-and-zeros-in-row-and-column",
    },
    {
      acRate: 67.5518102714721,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2483",
      paidOnly: false,
      title: "Minimum Penalty for a Shop",
      titleSlug: "minimum-penalty-for-a-shop",
    },
    {
      acRate: 39.20332688183292,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2484",
      paidOnly: false,
      title: "Count Palindromic Subsequences",
      titleSlug: "count-palindromic-subsequences",
    },
    {
      acRate: 83.72745359180519,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2485",
      paidOnly: false,
      title: "Find the Pivot Integer",
      titleSlug: "find-the-pivot-integer",
    },
    {
      acRate: 72.97411535196258,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2486",
      paidOnly: false,
      title: "Append Characters to String to Make Subsequence",
      titleSlug: "append-characters-to-string-to-make-subsequence",
    },
    {
      acRate: 74.2887453935138,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2487",
      paidOnly: false,
      title: "Remove Nodes From Linked List",
      titleSlug: "remove-nodes-from-linked-list",
    },
    {
      acRate: 45.15693047004055,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2488",
      paidOnly: false,
      title: "Count Subarrays With Median K",
      titleSlug: "count-subarrays-with-median-k",
    },
    {
      acRate: 55.524306950582556,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2489",
      paidOnly: true,
      title: "Number of Substrings With Fixed Ratio",
      titleSlug: "number-of-substrings-with-fixed-ratio",
    },
    {
      acRate: 70.44349070100144,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2490",
      paidOnly: false,
      title: "Circular Sentence",
      titleSlug: "circular-sentence",
    },
    {
      acRate: 68.94502500860472,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2491",
      paidOnly: false,
      title: "Divide Players Into Teams of Equal Skill",
      titleSlug: "divide-players-into-teams-of-equal-skill",
    },
    {
      acRate: 57.70484157403476,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2492",
      paidOnly: false,
      title: "Minimum Score of a Path Between Two Cities",
      titleSlug: "minimum-score-of-a-path-between-two-cities",
    },
    {
      acRate: 67.44538535042341,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2493",
      paidOnly: false,
      title: "Divide Nodes Into the Maximum Number of Groups",
      titleSlug: "divide-nodes-into-the-maximum-number-of-groups",
    },
    {
      acRate: 34.74705474705475,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2494",
      paidOnly: true,
      title: "Merge Overlapping Events in the Same Hall",
      titleSlug: "merge-overlapping-events-in-the-same-hall",
    },
    {
      acRate: 61.19123931623932,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2495",
      paidOnly: true,
      title: "Number of Subarrays Having Even Product",
      titleSlug: "number-of-subarrays-having-even-product",
    },
    {
      acRate: 73.3270375908292,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2496",
      paidOnly: false,
      title: "Maximum Value of a String in an Array",
      titleSlug: "maximum-value-of-a-string-in-an-array",
    },
    {
      acRate: 40.692872679128705,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2497",
      paidOnly: false,
      title: "Maximum Star Sum of a Graph",
      titleSlug: "maximum-star-sum-of-a-graph",
    },
    {
      acRate: 62.07734314053271,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2498",
      paidOnly: false,
      title: "Frog Jump II",
      titleSlug: "frog-jump-ii",
    },
    {
      acRate: 40.219929200873686,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2499",
      paidOnly: false,
      title: "Minimum Total Cost to Make Arrays Unequal",
      titleSlug: "minimum-total-cost-to-make-arrays-unequal",
    },
    {
      acRate: 78.8635698203883,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2500",
      paidOnly: false,
      title: "Delete Greatest Value in Each Row",
      titleSlug: "delete-greatest-value-in-each-row",
    },
    {
      acRate: 53.070942119173814,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2501",
      paidOnly: false,
      title: "Longest Square Streak in an Array",
      titleSlug: "longest-square-streak-in-an-array",
    },
    {
      acRate: 48.20931349015842,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2502",
      paidOnly: false,
      title: "Design Memory Allocator",
      titleSlug: "design-memory-allocator",
    },
    {
      acRate: 59.55630191544257,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2503",
      paidOnly: false,
      title: "Maximum Number of Points From Grid Queries",
      titleSlug: "maximum-number-of-points-from-grid-queries",
    },
    {
      acRate: 78.84537200162623,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2504",
      paidOnly: true,
      title: "Concatenate the Name and the Profession",
      titleSlug: "concatenate-the-name-and-the-profession",
    },
    {
      acRate: 64.99608457321848,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2505",
      paidOnly: true,
      title: "Bitwise OR of All Subsequence Sums",
      titleSlug: "bitwise-or-of-all-subsequence-sums",
    },
    {
      acRate: 72.31558464532107,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2506",
      paidOnly: false,
      title: "Count Pairs Of Similar Strings",
      titleSlug: "count-pairs-of-similar-strings",
    },
    {
      acRate: 48.88785747438323,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2507",
      paidOnly: false,
      title: "Smallest Value After Replacing With Sum of Prime Factors",
      titleSlug: "smallest-value-after-replacing-with-sum-of-prime-factors",
    },
    {
      acRate: 33.34593046383961,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2508",
      paidOnly: false,
      title: "Add Edges to Make Degrees of All Nodes Even",
      titleSlug: "add-edges-to-make-degrees-of-all-nodes-even",
    },
    {
      acRate: 57.98970013514007,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2509",
      paidOnly: false,
      title: "Cycle Length Queries in a Tree",
      titleSlug: "cycle-length-queries-in-a-tree",
    },
    {
      acRate: 51.21766752382393,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2510",
      paidOnly: true,
      title: "Check if There is a Path With Equal Number of 0's And 1's",
      titleSlug: "check-if-there-is-a-path-with-equal-number-of-0s-and-1s",
    },
    {
      acRate: 39.896126497260404,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2511",
      paidOnly: false,
      title: "Maximum Enemy Forts That Can Be Captured",
      titleSlug: "maximum-enemy-forts-that-can-be-captured",
    },
    {
      acRate: 45.830224729323994,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2512",
      paidOnly: false,
      title: "Reward Top K Students",
      titleSlug: "reward-top-k-students",
    },
    {
      acRate: 31.16459691822071,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2513",
      paidOnly: false,
      title: "Minimize the Maximum of Two Arrays",
      titleSlug: "minimize-the-maximum-of-two-arrays",
    },
    {
      acRate: 35.011005468696816,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2514",
      paidOnly: false,
      title: "Count Anagrams",
      titleSlug: "count-anagrams",
    },
    {
      acRate: 50.13274088978314,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2515",
      paidOnly: false,
      title: "Shortest Distance to Target String in a Circular Array",
      titleSlug: "shortest-distance-to-target-string-in-a-circular-array",
    },
    {
      acRate: 51.613333523893914,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2516",
      paidOnly: false,
      title: "Take K of Each Character From Left and Right",
      titleSlug: "take-k-of-each-character-from-left-and-right",
    },
    {
      acRate: 65.78524006978904,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2517",
      paidOnly: false,
      title: "Maximum Tastiness of Candy Basket",
      titleSlug: "maximum-tastiness-of-candy-basket",
    },
    {
      acRate: 32.235199586765,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2518",
      paidOnly: false,
      title: "Number of Great Partitions",
      titleSlug: "number-of-great-partitions",
    },
    {
      acRate: 53.07063025694204,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2519",
      paidOnly: true,
      title: "Count the Number of K-Big Indices",
      titleSlug: "count-the-number-of-k-big-indices",
    },
    {
      acRate: 85.6923054052447,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2520",
      paidOnly: false,
      title: "Count the Digits That Divide a Number",
      titleSlug: "count-the-digits-that-divide-a-number",
    },
    {
      acRate: 52.759592276456445,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2521",
      paidOnly: false,
      title: "Distinct Prime Factors of Product of Array",
      titleSlug: "distinct-prime-factors-of-product-of-array",
    },
    {
      acRate: 46.50840675618483,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2522",
      paidOnly: false,
      title: "Partition String Into Substrings With Values at Most K",
      titleSlug: "partition-string-into-substrings-with-values-at-most-k",
    },
    {
      acRate: 51.53405970001773,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2523",
      paidOnly: false,
      title: "Closest Prime Numbers in Range",
      titleSlug: "closest-prime-numbers-in-range",
    },
    {
      acRate: 35.03039513677811,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2524",
      paidOnly: true,
      title: "Maximum Frequency Score of a Subarray",
      titleSlug: "maximum-frequency-score-of-a-subarray",
    },
    {
      acRate: 37.49054303032461,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2525",
      paidOnly: false,
      title: "Categorize Box According to Criteria",
      titleSlug: "categorize-box-according-to-criteria",
    },
    {
      acRate: 49.18638705736794,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2526",
      paidOnly: false,
      title: "Find Consecutive Integers from a Data Stream",
      titleSlug: "find-consecutive-integers-from-a-data-stream",
    },
    {
      acRate: 69.08912950388451,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2527",
      paidOnly: false,
      title: "Find Xor-Beauty of Array",
      titleSlug: "find-xor-beauty-of-array",
    },
    {
      acRate: 32.95155548676675,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2528",
      paidOnly: false,
      title: "Maximize the Minimum Powered City",
      titleSlug: "maximize-the-minimum-powered-city",
    },
    {
      acRate: 74.49430219943743,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2529",
      paidOnly: false,
      title: "Maximum Count of Positive Integer and Negative Integer",
      titleSlug: "maximum-count-of-positive-integer-and-negative-integer",
    },
    {
      acRate: 63.765612109033576,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2530",
      paidOnly: false,
      title: "Maximal Score After Applying K Operations",
      titleSlug: "maximal-score-after-applying-k-operations",
    },
    {
      acRate: 26.879787207841787,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2531",
      paidOnly: false,
      title: "Make Number of Distinct Characters Equal",
      titleSlug: "make-number-of-distinct-characters-equal",
    },
    {
      acRate: 43.44904815229563,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2532",
      paidOnly: false,
      title: "Time to Cross a Bridge",
      titleSlug: "time-to-cross-a-bridge",
    },
    {
      acRate: 52.48610485203545,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2533",
      paidOnly: true,
      title: "Number of Good Binary Strings",
      titleSlug: "number-of-good-binary-strings",
    },
    {
      acRate: 49.149285399735774,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2534",
      paidOnly: true,
      title: "Time Taken to Cross the Door",
      titleSlug: "time-taken-to-cross-the-door",
    },
    {
      acRate: 84.78485497084655,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2535",
      paidOnly: false,
      title: "Difference Between Element Sum and Digit Sum of an Array",
      titleSlug: "difference-between-element-sum-and-digit-sum-of-an-array",
    },
    {
      acRate: 51.489610642861784,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2536",
      paidOnly: false,
      title: "Increment Submatrices by One",
      titleSlug: "increment-submatrices-by-one",
    },
    {
      acRate: 66.05474382116867,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2537",
      paidOnly: false,
      title: "Count the Number of Good Subarrays",
      titleSlug: "count-the-number-of-good-subarrays",
    },
    {
      acRate: 31.652964841700193,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2538",
      paidOnly: false,
      title: "Difference Between Maximum and Minimum Price Sum",
      titleSlug: "difference-between-maximum-and-minimum-price-sum",
    },
    {
      acRate: 50.93638755610586,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2539",
      paidOnly: true,
      title: "Count the Number of Good Subsequences",
      titleSlug: "count-the-number-of-good-subsequences",
    },
    {
      acRate: 58.22196984036848,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2540",
      paidOnly: false,
      title: "Minimum Common Value",
      titleSlug: "minimum-common-value",
    },
    {
      acRate: 32.30861274472364,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2541",
      paidOnly: false,
      title: "Minimum Operations to Make Array Equal II",
      titleSlug: "minimum-operations-to-make-array-equal-ii",
    },
    {
      acRate: 54.22901461822984,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2542",
      paidOnly: false,
      title: "Maximum Subsequence Score",
      titleSlug: "maximum-subsequence-score",
    },
    {
      acRate: 43.18519895872072,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2543",
      paidOnly: false,
      title: "Check if Point Is Reachable",
      titleSlug: "check-if-point-is-reachable",
    },
    {
      acRate: 68.3825573314802,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2544",
      paidOnly: false,
      title: "Alternating Digit Sum",
      titleSlug: "alternating-digit-sum",
    },
    {
      acRate: 85.58224677964579,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2545",
      paidOnly: false,
      title: "Sort the Students by Their Kth Score",
      titleSlug: "sort-the-students-by-their-kth-score",
    },
    {
      acRate: 41.57155136226437,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2546",
      paidOnly: false,
      title: "Apply Bitwise Operations to Make Strings Equal",
      titleSlug: "apply-bitwise-operations-to-make-strings-equal",
    },
    {
      acRate: 41.92932467761361,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2547",
      paidOnly: false,
      title: "Minimum Cost to Split an Array",
      titleSlug: "minimum-cost-to-split-an-array",
    },
    {
      acRate: 63.51047904191617,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2548",
      paidOnly: true,
      title: "Maximum Price to Fill a Bag",
      titleSlug: "maximum-price-to-fill-a-bag",
    },
    {
      acRate: 61.16447068983627,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2549",
      paidOnly: false,
      title: "Count Distinct Numbers on Board",
      titleSlug: "count-distinct-numbers-on-board",
    },
    {
      acRate: 28.725554662575192,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2550",
      paidOnly: false,
      title: "Count Collisions of Monkeys on a Polygon",
      titleSlug: "count-collisions-of-monkeys-on-a-polygon",
    },
    {
      acRate: 72.50255566359986,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2551",
      paidOnly: false,
      title: "Put Marbles in Bags",
      titleSlug: "put-marbles-in-bags",
    },
    {
      acRate: 34.00030974136596,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2552",
      paidOnly: false,
      title: "Count Increasing Quadruplets",
      titleSlug: "count-increasing-quadruplets",
    },
    {
      acRate: 80.12675623383903,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2553",
      paidOnly: false,
      title: "Separate the Digits in an Array",
      titleSlug: "separate-the-digits-in-an-array",
    },
    {
      acRate: 67.88679877665591,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2554",
      paidOnly: false,
      title: "Maximum Number of Integers to Choose From a Range I",
      titleSlug: "maximum-number-of-integers-to-choose-from-a-range-i",
    },
    {
      acRate: 35.13683806810399,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2555",
      paidOnly: false,
      title: "Maximize Win From Two Segments",
      titleSlug: "maximize-win-from-two-segments",
    },
    {
      acRate: 27.230966807165437,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2556",
      paidOnly: false,
      title: "Disconnect Path in a Binary Matrix by at Most One Flip",
      titleSlug: "disconnect-path-in-a-binary-matrix-by-at-most-one-flip",
    },
    {
      acRate: 35.144524735964424,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2557",
      paidOnly: true,
      title: "Maximum Number of Integers to Choose From a Range II",
      titleSlug: "maximum-number-of-integers-to-choose-from-a-range-ii",
    },
    {
      acRate: 75.66041599625545,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2558",
      paidOnly: false,
      title: "Take Gifts From the Richest Pile",
      titleSlug: "take-gifts-from-the-richest-pile",
    },
    {
      acRate: 67.89662395089383,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2559",
      paidOnly: false,
      title: "Count Vowel Strings in Ranges",
      titleSlug: "count-vowel-strings-in-ranges",
    },
    {
      acRate: 65.17806495529038,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2560",
      paidOnly: false,
      title: "House Robber IV",
      titleSlug: "house-robber-iv",
    },
    {
      acRate: 35.0569984722059,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2561",
      paidOnly: false,
      title: "Rearranging Fruits",
      titleSlug: "rearranging-fruits",
    },
    {
      acRate: 70.87423862414906,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2562",
      paidOnly: false,
      title: "Find the Array Concatenation Value",
      titleSlug: "find-the-array-concatenation-value",
    },
    {
      acRate: 52.90716608534358,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2563",
      paidOnly: false,
      title: "Count the Number of Fair Pairs",
      titleSlug: "count-the-number-of-fair-pairs",
    },
    {
      acRate: 34.40323070099676,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2564",
      paidOnly: false,
      title: "Substring XOR Queries",
      titleSlug: "substring-xor-queries",
    },
    {
      acRate: 32.54412242393619,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2565",
      paidOnly: false,
      title: "Subsequence With the Minimum Score",
      titleSlug: "subsequence-with-the-minimum-score",
    },
    {
      acRate: 60.43768920282543,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2566",
      paidOnly: false,
      title: "Maximum Difference by Remapping a Digit",
      titleSlug: "maximum-difference-by-remapping-a-digit",
    },
    {
      acRate: 48.78442073927065,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2567",
      paidOnly: false,
      title: "Minimum Score by Changing Two Elements",
      titleSlug: "minimum-score-by-changing-two-elements",
    },
    {
      acRate: 57.58457856264959,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2568",
      paidOnly: false,
      title: "Minimum Impossible OR",
      titleSlug: "minimum-impossible-or",
    },
    {
      acRate: 29.218125082406715,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2569",
      paidOnly: false,
      title: "Handling Sum Queries After Update",
      titleSlug: "handling-sum-queries-after-update",
    },
    {
      acRate: 82.0704866448374,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2570",
      paidOnly: false,
      title: "Merge Two 2D Arrays by Summing Values",
      titleSlug: "merge-two-2d-arrays-by-summing-values",
    },
    {
      acRate: 56.92844564356916,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2571",
      paidOnly: false,
      title: "Minimum Operations to Reduce an Integer to 0",
      titleSlug: "minimum-operations-to-reduce-an-integer-to-0",
    },
    {
      acRate: 24.946151111482884,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2572",
      paidOnly: false,
      title: "Count the Number of Square-Free Subsets",
      titleSlug: "count-the-number-of-square-free-subsets",
    },
    {
      acRate: 31.48710166919575,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2573",
      paidOnly: false,
      title: "Find the String with LCP",
      titleSlug: "find-the-string-with-lcp",
    },
    {
      acRate: 87.38817994009904,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2574",
      paidOnly: false,
      title: "Left and Right Sum Differences",
      titleSlug: "left-and-right-sum-differences",
    },
    {
      acRate: 34.53456811458662,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2575",
      paidOnly: false,
      title: "Find the Divisibility Array of a String",
      titleSlug: "find-the-divisibility-array-of-a-string",
    },
    {
      acRate: 39.83488308491727,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2576",
      paidOnly: false,
      title: "Find the Maximum Number of Marked Indices",
      titleSlug: "find-the-maximum-number-of-marked-indices",
    },
    {
      acRate: 56.884894459102895,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2577",
      paidOnly: false,
      title: "Minimum Time to Visit a Cell In a Grid",
      titleSlug: "minimum-time-to-visit-a-cell-in-a-grid",
    },
    {
      acRate: 72.00757081320977,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2578",
      paidOnly: false,
      title: "Split With Minimum Sum",
      titleSlug: "split-with-minimum-sum",
    },
    {
      acRate: 66.21543437733666,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2579",
      paidOnly: false,
      title: "Count Total Number of Colored Cells",
      titleSlug: "count-total-number-of-colored-cells",
    },
    {
      acRate: 37.94025186830563,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2580",
      paidOnly: false,
      title: "Count Ways to Group Overlapping Ranges",
      titleSlug: "count-ways-to-group-overlapping-ranges",
    },
    {
      acRate: 46.1780167985981,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2581",
      paidOnly: false,
      title: "Count Number of Possible Root Nodes",
      titleSlug: "count-number-of-possible-root-nodes",
    },
    {
      acRate: 56.53643814375899,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2582",
      paidOnly: false,
      title: "Pass the Pillow",
      titleSlug: "pass-the-pillow",
    },
    {
      acRate: 59.274323945585074,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2583",
      paidOnly: false,
      title: "Kth Largest Sum in a Binary Tree",
      titleSlug: "kth-largest-sum-in-a-binary-tree",
    },
    {
      acRate: 27.949276290508518,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2584",
      paidOnly: false,
      title: "Split the Array to Make Coprime Products",
      titleSlug: "split-the-array-to-make-coprime-products",
    },
    {
      acRate: 58.42883814447796,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2585",
      paidOnly: false,
      title: "Number of Ways to Earn Points",
      titleSlug: "number-of-ways-to-earn-points",
    },
    {
      acRate: 73.44952293013235,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2586",
      paidOnly: false,
      title: "Count the Number of Vowel Strings in Range",
      titleSlug: "count-the-number-of-vowel-strings-in-range",
    },
    {
      acRate: 41.29087048832272,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2587",
      paidOnly: false,
      title: "Rearrange Array to Maximize Prefix Score",
      titleSlug: "rearrange-array-to-maximize-prefix-score",
    },
    {
      acRate: 51.61736311410932,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2588",
      paidOnly: false,
      title: "Count the Number of Beautiful Subarrays",
      titleSlug: "count-the-number-of-beautiful-subarrays",
    },
    {
      acRate: 37.22242897903486,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2589",
      paidOnly: false,
      title: "Minimum Time to Complete All Tasks",
      titleSlug: "minimum-time-to-complete-all-tasks",
    },
    {
      acRate: 58.85703785373024,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2590",
      paidOnly: true,
      title: "Design a Todo List",
      titleSlug: "design-a-todo-list",
    },
    {
      acRate: 19.37237114226054,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2591",
      paidOnly: false,
      title: "Distribute Money to Maximum Children",
      titleSlug: "distribute-money-to-maximum-children",
    },
    {
      acRate: 58.10766182298547,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2592",
      paidOnly: false,
      title: "Maximize Greatness of an Array",
      titleSlug: "maximize-greatness-of-an-array",
    },
    {
      acRate: 64.69105548748469,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2593",
      paidOnly: false,
      title: "Find Score of an Array After Marking All Elements",
      titleSlug: "find-score-of-an-array-after-marking-all-elements",
    },
    {
      acRate: 59.955948806280034,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2594",
      paidOnly: false,
      title: "Minimum Time to Repair Cars",
      titleSlug: "minimum-time-to-repair-cars",
    },
    {
      acRate: 72.50113071008593,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2595",
      paidOnly: false,
      title: "Number of Even and Odd Bits",
      titleSlug: "number-of-even-and-odd-bits",
    },
    {
      acRate: 57.409251380465285,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2596",
      paidOnly: false,
      title: "Check Knight Tour Configuration",
      titleSlug: "check-knight-tour-configuration",
    },
    {
      acRate: 50.73556884949066,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2597",
      paidOnly: false,
      title: "The Number of Beautiful Subsets",
      titleSlug: "the-number-of-beautiful-subsets",
    },
    {
      acRate: 39.70936693996519,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2598",
      paidOnly: false,
      title: "Smallest Missing Non-negative Integer After Operations",
      titleSlug: "smallest-missing-non-negative-integer-after-operations",
    },
    {
      acRate: 51.64303913242308,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2599",
      paidOnly: true,
      title: "Make the Prefix Sum Non-negative",
      titleSlug: "make-the-prefix-sum-non-negative",
    },
    {
      acRate: 60.254752061343744,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2600",
      paidOnly: false,
      title: "K Items With the Maximum Sum",
      titleSlug: "k-items-with-the-maximum-sum",
    },
    {
      acRate: 55.58557785783725,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2601",
      paidOnly: false,
      title: "Prime Subtraction Operation",
      titleSlug: "prime-subtraction-operation",
    },
    {
      acRate: 36.73782075120863,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2602",
      paidOnly: false,
      title: "Minimum Operations to Make All Array Elements Equal",
      titleSlug: "minimum-operations-to-make-all-array-elements-equal",
    },
    {
      acRate: 35.67115652577799,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2603",
      paidOnly: false,
      title: "Collect Coins in a Tree",
      titleSlug: "collect-coins-in-a-tree",
    },
    {
      acRate: 39.224526600541026,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2604",
      paidOnly: true,
      title: "Minimum Time to Eat All Grains",
      titleSlug: "minimum-time-to-eat-all-grains",
    },
    {
      acRate: 54.201020569716604,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2605",
      paidOnly: false,
      title: "Form Smallest Number From Two Digit Arrays",
      titleSlug: "form-smallest-number-from-two-digit-arrays",
    },
    {
      acRate: 56.6705880007178,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2606",
      paidOnly: false,
      title: "Find the Substring With Maximum Cost",
      titleSlug: "find-the-substring-with-maximum-cost",
    },
    {
      acRate: 36.27826295011365,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2607",
      paidOnly: false,
      title: "Make K-Subarray Sums Equal",
      titleSlug: "make-k-subarray-sums-equal",
    },
    {
      acRate: 37.17511074416906,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2608",
      paidOnly: false,
      title: "Shortest Cycle in a Graph",
      titleSlug: "shortest-cycle-in-a-graph",
    },
    {
      acRate: 45.30859425331787,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2609",
      paidOnly: false,
      title: "Find the Longest Balanced Substring of a Binary String",
      titleSlug: "find-the-longest-balanced-substring-of-a-binary-string",
    },
    {
      acRate: 86.29338235591855,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2610",
      paidOnly: false,
      title: "Convert an Array Into a 2D Array With Conditions",
      titleSlug: "convert-an-array-into-a-2d-array-with-conditions",
    },
    {
      acRate: 47.03862786348761,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2611",
      paidOnly: false,
      title: "Mice and Cheese",
      titleSlug: "mice-and-cheese",
    },
    {
      acRate: 15.111858269753006,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2612",
      paidOnly: false,
      title: "Minimum Reverse Operations",
      titleSlug: "minimum-reverse-operations",
    },
    {
      acRate: 42.82380396732789,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2613",
      paidOnly: true,
      title: "Beautiful Pairs",
      titleSlug: "beautiful-pairs",
    },
    {
      acRate: 36.04085967762089,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2614",
      paidOnly: false,
      title: "Prime In Diagonal",
      titleSlug: "prime-in-diagonal",
    },
    {
      acRate: 31.091128498579156,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2615",
      paidOnly: false,
      title: "Sum of Distances",
      titleSlug: "sum-of-distances",
    },
    {
      acRate: 43.70991558242554,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2616",
      paidOnly: false,
      title: "Minimize the Maximum Difference of Pairs",
      titleSlug: "minimize-the-maximum-difference-of-pairs",
    },
    {
      acRate: 22.699919764642953,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2617",
      paidOnly: false,
      title: "Minimum Number of Visited Cells in a Grid",
      titleSlug: "minimum-number-of-visited-cells-in-a-grid",
    },
    {
      acRate: 28.054001598355978,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2618",
      paidOnly: false,
      title: "Check if Object Instance of Class",
      titleSlug: "check-if-object-instance-of-class",
    },
    {
      acRate: 74.53587415064568,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2619",
      paidOnly: false,
      title: "Array Prototype Last",
      titleSlug: "array-prototype-last",
    },
    {
      acRate: 82.20939179583699,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2620",
      paidOnly: false,
      title: "Counter",
      titleSlug: "counter",
    },
    {
      acRate: 87.75870873204413,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2621",
      paidOnly: false,
      title: "Sleep",
      titleSlug: "sleep",
    },
    {
      acRate: 75.69826233509617,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2622",
      paidOnly: false,
      title: "Cache With Time Limit",
      titleSlug: "cache-with-time-limit",
    },
    {
      acRate: 63.34234940433633,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2623",
      paidOnly: false,
      title: "Memoize",
      titleSlug: "memoize",
    },
    {
      acRate: 67.03701952626353,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2624",
      paidOnly: false,
      title: "Snail Traversal",
      titleSlug: "snail-traversal",
    },
    {
      acRate: 64.27805849027713,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2625",
      paidOnly: false,
      title: "Flatten Deeply Nested Array",
      titleSlug: "flatten-deeply-nested-array",
    },
    {
      acRate: 85.4229773591309,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2626",
      paidOnly: false,
      title: "Array Reduce Transformation",
      titleSlug: "array-reduce-transformation",
    },
    {
      acRate: 91.79062587706989,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2627",
      paidOnly: false,
      title: "Debounce",
      titleSlug: "debounce",
    },
    {
      acRate: 39.10942257731095,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2628",
      paidOnly: true,
      title: "JSON Deep Equal",
      titleSlug: "json-deep-equal",
    },
    {
      acRate: 87.00311760770613,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2629",
      paidOnly: false,
      title: "Function Composition",
      titleSlug: "function-composition",
    },
    {
      acRate: 32.41847826086956,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2630",
      paidOnly: false,
      title: "Memoize II",
      titleSlug: "memoize-ii",
    },
    {
      acRate: 81.05302522308764,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2631",
      paidOnly: false,
      title: "Group By",
      titleSlug: "group-by",
    },
    {
      acRate: 89.40165817600639,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2632",
      paidOnly: true,
      title: "Curry",
      titleSlug: "curry",
    },
    {
      acRate: 77.91641791044776,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2633",
      paidOnly: true,
      title: "Convert Object to JSON String",
      titleSlug: "convert-object-to-json-string",
    },
    {
      acRate: 85.46438463848207,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2634",
      paidOnly: false,
      title: "Filter Elements from Array",
      titleSlug: "filter-elements-from-array",
    },
    {
      acRate: 86.1365270344175,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2635",
      paidOnly: false,
      title: "Apply Transform Over Each Element in Array",
      titleSlug: "apply-transform-over-each-element-in-array",
    },
    {
      acRate: 79.8843334860284,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2636",
      paidOnly: true,
      title: "Promise Pool",
      titleSlug: "promise-pool",
    },
    {
      acRate: 82.75793422114187,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2637",
      paidOnly: false,
      title: "Promise Time Limit",
      titleSlug: "promise-time-limit",
    },
    {
      acRate: 46.681857020791796,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2638",
      paidOnly: true,
      title: "Count the Number of K-Free Subsets",
      titleSlug: "count-the-number-of-k-free-subsets",
    },
    {
      acRate: 69.15383199361845,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2639",
      paidOnly: false,
      title: "Find the Width of Columns of a Grid",
      titleSlug: "find-the-width-of-columns-of-a-grid",
    },
    {
      acRate: 71.90364607742058,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2640",
      paidOnly: false,
      title: "Find the Score of All Prefixes of an Array",
      titleSlug: "find-the-score-of-all-prefixes-of-an-array",
    },
    {
      acRate: 75.39921445404556,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2641",
      paidOnly: false,
      title: "Cousins in Binary Tree II",
      titleSlug: "cousins-in-binary-tree-ii",
    },
    {
      acRate: 64.02847756594736,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2642",
      paidOnly: false,
      title: "Design Graph With Shortest Path Calculator",
      titleSlug: "design-graph-with-shortest-path-calculator",
    },
    {
      acRate: 74.72937467157121,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2643",
      paidOnly: false,
      title: "Row With Maximum Ones",
      titleSlug: "row-with-maximum-ones",
    },
    {
      acRate: 50.29989544929291,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2644",
      paidOnly: false,
      title: "Find the Maximum Divisibility Score",
      titleSlug: "find-the-maximum-divisibility-score",
    },
    {
      acRate: 50.134452291598954,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2645",
      paidOnly: false,
      title: "Minimum Additions to Make Valid String",
      titleSlug: "minimum-additions-to-make-valid-string",
    },
    {
      acRate: 45.773171407096804,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2646",
      paidOnly: false,
      title: "Minimize the Total Price of the Trips",
      titleSlug: "minimize-the-total-price-of-the-trips",
    },
    {
      acRate: 59.08419497784343,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2647",
      paidOnly: true,
      title: "Color the Triangle Red",
      titleSlug: "color-the-triangle-red",
    },
    {
      acRate: 83.64367282928015,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2648",
      paidOnly: false,
      title: "Generate Fibonacci Sequence",
      titleSlug: "generate-fibonacci-sequence",
    },
    {
      acRate: 79.73808657693708,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2649",
      paidOnly: false,
      title: "Nested Array Generator",
      titleSlug: "nested-array-generator",
    },
    {
      acRate: 51.8487535552953,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2650",
      paidOnly: false,
      title: "Design Cancellable Function",
      titleSlug: "design-cancellable-function",
    },
    {
      acRate: 76.53425372577844,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2651",
      paidOnly: false,
      title: "Calculate Delayed Arrival Time",
      titleSlug: "calculate-delayed-arrival-time",
    },
    {
      acRate: 85.10556531096094,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2652",
      paidOnly: false,
      title: "Sum Multiples",
      titleSlug: "sum-multiples",
    },
    {
      acRate: 33.70806773549675,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2653",
      paidOnly: false,
      title: "Sliding Subarray Beauty",
      titleSlug: "sliding-subarray-beauty",
    },
    {
      acRate: 33.56180628023907,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2654",
      paidOnly: false,
      title:
        "Minimum Number of Operations to Make All Array Elements Equal to 1",
      titleSlug:
        "minimum-number-of-operations-to-make-all-array-elements-equal-to-1",
    },
    {
      acRate: 48.588654425870104,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2655",
      paidOnly: true,
      title: "Find Maximal Uncovered Ranges",
      titleSlug: "find-maximal-uncovered-ranges",
    },
    {
      acRate: 79.64570447647615,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2656",
      paidOnly: false,
      title: "Maximum Sum With Exactly K Elements ",
      titleSlug: "maximum-sum-with-exactly-k-elements",
    },
    {
      acRate: 87.06793802145411,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2657",
      paidOnly: false,
      title: "Find the Prefix Common Array of Two Arrays",
      titleSlug: "find-the-prefix-common-array-of-two-arrays",
    },
    {
      acRate: 70.30235226076816,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2658",
      paidOnly: false,
      title: "Maximum Number of Fish in a Grid",
      titleSlug: "maximum-number-of-fish-in-a-grid",
    },
    {
      acRate: 25.371513603732225,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2659",
      paidOnly: false,
      title: "Make Array Empty",
      titleSlug: "make-array-empty",
    },
    {
      acRate: 35.51518278957623,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2660",
      paidOnly: false,
      title: "Determine the Winner of a Bowling Game",
      titleSlug: "determine-the-winner-of-a-bowling-game",
    },
    {
      acRate: 63.95815126261254,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2661",
      paidOnly: false,
      title: "First Completely Painted Row or Column",
      titleSlug: "first-completely-painted-row-or-column",
    },
    {
      acRate: 40.01777470560644,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2662",
      paidOnly: false,
      title: "Minimum Cost of a Path With Special Roads",
      titleSlug: "minimum-cost-of-a-path-with-special-roads",
    },
    {
      acRate: 36.70186593997199,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2663",
      paidOnly: false,
      title: "Lexicographically Smallest Beautiful String",
      titleSlug: "lexicographically-smallest-beautiful-string",
    },
    {
      acRate: 72.76923076923076,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2664",
      paidOnly: true,
      title: "The Knight’s Tour",
      titleSlug: "the-knights-tour",
    },
    {
      acRate: 81.08374384236453,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2665",
      paidOnly: false,
      title: "Counter II",
      titleSlug: "counter-ii",
    },
    {
      acRate: 86.69932157246491,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2666",
      paidOnly: false,
      title: "Allow One Function Call",
      titleSlug: "allow-one-function-call",
    },
    {
      acRate: 82.12450035296979,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2667",
      paidOnly: false,
      title: "Create Hello World Function",
      titleSlug: "create-hello-world-function",
    },
    {
      acRate: 74.71055935276887,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2668",
      paidOnly: true,
      title: "Find Latest Salaries",
      titleSlug: "find-latest-salaries",
    },
    {
      acRate: 74.27475057559478,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2669",
      paidOnly: true,
      title: "Count Artist Occurrences On Spotify Ranking List",
      titleSlug: "count-artist-occurrences-on-spotify-ranking-list",
    },
    {
      acRate: 75.92051919451443,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2670",
      paidOnly: false,
      title: "Find the Distinct Difference Array",
      titleSlug: "find-the-distinct-difference-array",
    },
    {
      acRate: 29.754914026512886,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2671",
      paidOnly: false,
      title: "Frequency Tracker",
      titleSlug: "frequency-tracker",
    },
    {
      acRate: 55.09660035544345,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2672",
      paidOnly: false,
      title: "Number of Adjacent Elements With the Same Color",
      titleSlug: "number-of-adjacent-elements-with-the-same-color",
    },
    {
      acRate: 56.443434651298105,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2673",
      paidOnly: false,
      title: "Make Costs of Paths Equal in a Binary Tree",
      titleSlug: "make-costs-of-paths-equal-in-a-binary-tree",
    },
    {
      acRate: 76.6294227188082,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2674",
      paidOnly: true,
      title: "Split a Circular Linked List",
      titleSlug: "split-a-circular-linked-list",
    },
    {
      acRate: 68.68206521739131,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2675",
      paidOnly: true,
      title: "Array of Objects to Matrix",
      titleSlug: "array-of-objects-to-matrix",
    },
    {
      acRate: 83.1559025313461,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2676",
      paidOnly: true,
      title: "Throttle",
      titleSlug: "throttle",
    },
    {
      acRate: 84.55664842478923,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2677",
      paidOnly: false,
      title: "Chunk Array",
      titleSlug: "chunk-array",
    },
    {
      acRate: 81.31853958110426,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2678",
      paidOnly: false,
      title: "Number of Senior Citizens",
      titleSlug: "number-of-senior-citizens",
    },
    {
      acRate: 58.91983627832684,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2679",
      paidOnly: false,
      title: "Sum in a Matrix",
      titleSlug: "sum-in-a-matrix",
    },
    {
      acRate: 41.063575586568035,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2680",
      paidOnly: false,
      title: "Maximum OR",
      titleSlug: "maximum-or",
    },
    {
      acRate: 29.497811250985617,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2681",
      paidOnly: false,
      title: "Power of Heroes",
      titleSlug: "power-of-heroes",
    },
    {
      acRate: 48.76537384794439,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2682",
      paidOnly: false,
      title: "Find the Losers of the Circular Game",
      titleSlug: "find-the-losers-of-the-circular-game",
    },
    {
      acRate: 79.75940945958261,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2683",
      paidOnly: false,
      title: "Neighboring Bitwise XOR",
      titleSlug: "neighboring-bitwise-xor",
    },
    {
      acRate: 58.85494190439988,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2684",
      paidOnly: false,
      title: "Maximum Number of Moves in a Grid",
      titleSlug: "maximum-number-of-moves-in-a-grid",
    },
    {
      acRate: 77.67751571348559,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2685",
      paidOnly: false,
      title: "Count the Number of Complete Components",
      titleSlug: "count-the-number-of-complete-components",
    },
    {
      acRate: 69.20175041496907,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2686",
      paidOnly: true,
      title: "Immediate Food Delivery III",
      titleSlug: "immediate-food-delivery-iii",
    },
    {
      acRate: 81.38314785373609,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2687",
      paidOnly: true,
      title: "Bikes Last Time Used ",
      titleSlug: "bikes-last-time-used",
    },
    {
      acRate: 44.34504190601752,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2688",
      paidOnly: true,
      title: "Find Active Users",
      titleSlug: "find-active-users",
    },
    {
      acRate: 74.07267934475617,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2689",
      paidOnly: true,
      title: "Extract Kth Character From The Rope Tree",
      titleSlug: "extract-kth-character-from-the-rope-tree",
    },
    {
      acRate: 93.06451612903226,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2690",
      paidOnly: true,
      title: "Infinite Method Object",
      titleSlug: "infinite-method-object",
    },
    {
      acRate: 40.95477386934673,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2691",
      paidOnly: true,
      title: "Immutability Helper",
      titleSlug: "immutability-helper",
    },
    {
      acRate: 64.14087513340448,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2692",
      paidOnly: true,
      title: "Make Object Immutable",
      titleSlug: "make-object-immutable",
    },
    {
      acRate: 78.70334744132359,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2693",
      paidOnly: false,
      title: "Call Function with Custom Context",
      titleSlug: "call-function-with-custom-context",
    },
    {
      acRate: 74.45570079152485,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2694",
      paidOnly: false,
      title: "Event Emitter",
      titleSlug: "event-emitter",
    },
    {
      acRate: 89.18038858624362,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2695",
      paidOnly: false,
      title: "Array Wrapper",
      titleSlug: "array-wrapper",
    },
    {
      acRate: 77.06363762256517,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2696",
      paidOnly: false,
      title: "Minimum String Length After Removing Substrings",
      titleSlug: "minimum-string-length-after-removing-substrings",
    },
    {
      acRate: 79.0364537354191,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2697",
      paidOnly: false,
      title: "Lexicographically Smallest Palindrome",
      titleSlug: "lexicographically-smallest-palindrome",
    },
    {
      acRate: 81.8087418911286,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2698",
      paidOnly: false,
      title: "Find the Punishment Number of an Integer",
      titleSlug: "find-the-punishment-number-of-an-integer",
    },
    {
      acRate: 56.10389389270086,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2699",
      paidOnly: false,
      title: "Modify Graph Edge Weights",
      titleSlug: "modify-graph-edge-weights",
    },
    {
      acRate: 75.22872602065912,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2700",
      paidOnly: true,
      title: "Differences Between Two Objects",
      titleSlug: "differences-between-two-objects",
    },
    {
      acRate: 34.20781485297614,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2701",
      paidOnly: true,
      title: "Consecutive Transactions with Increasing Amounts",
      titleSlug: "consecutive-transactions-with-increasing-amounts",
    },
    {
      acRate: 41.989047871400814,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2702",
      paidOnly: true,
      title: "Minimum Operations to Make Numbers Non-positive",
      titleSlug: "minimum-operations-to-make-numbers-non-positive",
    },
    {
      acRate: 94.49070028955072,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2703",
      paidOnly: false,
      title: "Return Length of Arguments Passed",
      titleSlug: "return-length-of-arguments-passed",
    },
    {
      acRate: 62.90641817775773,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2704",
      paidOnly: false,
      title: "To Be Or Not To Be",
      titleSlug: "to-be-or-not-to-be",
    },
    {
      acRate: 66.77763830522659,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2705",
      paidOnly: false,
      title: "Compact Object",
      titleSlug: "compact-object",
    },
    {
      acRate: 68.26158118568803,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2706",
      paidOnly: false,
      title: "Buy Two Chocolates",
      titleSlug: "buy-two-chocolates",
    },
    {
      acRate: 57.02059211824155,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2707",
      paidOnly: false,
      title: "Extra Characters in a String",
      titleSlug: "extra-characters-in-a-string",
    },
    {
      acRate: 24.62236547001946,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2708",
      paidOnly: false,
      title: "Maximum Strength of a Group",
      titleSlug: "maximum-strength-of-a-group",
    },
    {
      acRate: 41.77160847166571,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2709",
      paidOnly: false,
      title: "Greatest Common Divisor Traversal",
      titleSlug: "greatest-common-divisor-traversal",
    },
    {
      acRate: 78.50848118541626,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2710",
      paidOnly: false,
      title: "Remove Trailing Zeros From a String",
      titleSlug: "remove-trailing-zeros-from-a-string",
    },
    {
      acRate: 67.65314240254574,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2711",
      paidOnly: false,
      title: "Difference of Number of Distinct Values on Diagonals",
      titleSlug: "difference-of-number-of-distinct-values-on-diagonals",
    },
    {
      acRate: 53.17497043549797,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2712",
      paidOnly: false,
      title: "Minimum Cost to Make All Characters Equal",
      titleSlug: "minimum-cost-to-make-all-characters-equal",
    },
    {
      acRate: 30.546643259277197,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2713",
      paidOnly: false,
      title: "Maximum Strictly Increasing Cells in a Matrix",
      titleSlug: "maximum-strictly-increasing-cells-in-a-matrix",
    },
    {
      acRate: 62.8369970966404,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2714",
      paidOnly: true,
      title: "Find Shortest Path with K Hops",
      titleSlug: "find-shortest-path-with-k-hops",
    },
    {
      acRate: 89.62220647613907,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2715",
      paidOnly: false,
      title: "Timeout Cancellation",
      titleSlug: "timeout-cancellation",
    },
    {
      acRate: 76.98254990635421,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2716",
      paidOnly: false,
      title: "Minimize String Length",
      titleSlug: "minimize-string-length",
    },
    {
      acRate: 63.1599819738621,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2717",
      paidOnly: false,
      title: "Semi-Ordered Permutation",
      titleSlug: "semi-ordered-permutation",
    },
    {
      acRate: 31.118714303240143,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2718",
      paidOnly: false,
      title: "Sum of Matrix After Queries",
      titleSlug: "sum-of-matrix-after-queries",
    },
    {
      acRate: 36.927211544976174,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2719",
      paidOnly: false,
      title: "Count of Integers",
      titleSlug: "count-of-integers",
    },
    {
      acRate: 54.92793143747565,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2720",
      paidOnly: true,
      title: "Popularity Percentage",
      titleSlug: "popularity-percentage",
    },
    {
      acRate: 77.47673632059087,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2721",
      paidOnly: false,
      title: "Execute Asynchronous Functions in Parallel",
      titleSlug: "execute-asynchronous-functions-in-parallel",
    },
    {
      acRate: 55.98441138951631,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2722",
      paidOnly: false,
      title: "Join Two Arrays by ID",
      titleSlug: "join-two-arrays-by-id",
    },
    {
      acRate: 91.8223893190391,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2723",
      paidOnly: false,
      title: "Add Two Promises",
      titleSlug: "add-two-promises",
    },
    {
      acRate: 83.13206645787993,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2724",
      paidOnly: false,
      title: "Sort By",
      titleSlug: "sort-by",
    },
    {
      acRate: 83.82326604753499,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2725",
      paidOnly: false,
      title: "Interval Cancellation",
      titleSlug: "interval-cancellation",
    },
    {
      acRate: 77.34639422646443,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2726",
      paidOnly: false,
      title: "Calculator with Method Chaining",
      titleSlug: "calculator-with-method-chaining",
    },
    {
      acRate: 81.37824926471838,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2727",
      paidOnly: false,
      title: "Is Object Empty",
      titleSlug: "is-object-empty",
    },
    {
      acRate: 85.19900497512438,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2728",
      paidOnly: true,
      title: "Count Houses in a Circular Street",
      titleSlug: "count-houses-in-a-circular-street",
    },
    {
      acRate: 52.23072615269741,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2729",
      paidOnly: false,
      title: "Check if The Number is Fascinating",
      titleSlug: "check-if-the-number-is-fascinating",
    },
    {
      acRate: 36.88206995189182,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2730",
      paidOnly: false,
      title: "Find the Longest Semi-Repetitive Substring",
      titleSlug: "find-the-longest-semi-repetitive-substring",
    },
    {
      acRate: 27.044662328073215,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2731",
      paidOnly: false,
      title: "Movement of Robots",
      titleSlug: "movement-of-robots",
    },
    {
      acRate: 45.86642599277979,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2732",
      paidOnly: false,
      title: "Find a Good Subset of the Matrix",
      titleSlug: "find-a-good-subset-of-the-matrix",
    },
    {
      acRate: 75.89137176091673,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2733",
      paidOnly: false,
      title: "Neither Minimum nor Maximum",
      titleSlug: "neither-minimum-nor-maximum",
    },
    {
      acRate: 32.08652685654161,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2734",
      paidOnly: false,
      title: "Lexicographically Smallest String After Substring Operation",
      titleSlug: "lexicographically-smallest-string-after-substring-operation",
    },
    {
      acRate: 33.48418515421319,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2735",
      paidOnly: false,
      title: "Collecting Chocolates",
      titleSlug: "collecting-chocolates",
    },
    {
      acRate: 27.867065094492006,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2736",
      paidOnly: false,
      title: "Maximum Sum Queries",
      titleSlug: "maximum-sum-queries",
    },
    {
      acRate: 64.68138679062561,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2737",
      paidOnly: true,
      title: "Find the Closest Marked Node",
      titleSlug: "find-the-closest-marked-node",
    },
    {
      acRate: 55.324405148875314,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2738",
      paidOnly: true,
      title: "Count Occurrences in Text",
      titleSlug: "count-occurrences-in-text",
    },
    {
      acRate: 40.076856800835664,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2739",
      paidOnly: false,
      title: "Total Distance Traveled",
      titleSlug: "total-distance-traveled",
    },
    {
      acRate: 64.20126430890141,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2740",
      paidOnly: false,
      title: "Find the Value of the Partition",
      titleSlug: "find-the-value-of-the-partition",
    },
    {
      acRate: 28.410561969108546,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2741",
      paidOnly: false,
      title: "Special Permutations",
      titleSlug: "special-permutations",
    },
    {
      acRate: 48.35525863609496,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2742",
      paidOnly: false,
      title: "Painting the Walls",
      titleSlug: "painting-the-walls",
    },
    {
      acRate: 76.117292098812,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2743",
      paidOnly: true,
      title: "Count Substrings Without Repeating Character",
      titleSlug: "count-substrings-without-repeating-character",
    },
    {
      acRate: 81.43354816234105,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2744",
      paidOnly: false,
      title: "Find Maximum Number of String Pairs",
      titleSlug: "find-maximum-number-of-string-pairs",
    },
    {
      acRate: 53.65898155116189,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2745",
      paidOnly: false,
      title: "Construct the Longest New String",
      titleSlug: "construct-the-longest-new-string",
    },
    {
      acRate: 26.05924765736815,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2746",
      paidOnly: false,
      title: "Decremental String Concatenation",
      titleSlug: "decremental-string-concatenation",
    },
    {
      acRate: 32.89881357213028,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2747",
      paidOnly: false,
      title: "Count Zero Request Servers",
      titleSlug: "count-zero-request-servers",
    },
    {
      acRate: 50.69982720315971,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2748",
      paidOnly: false,
      title: "Number of Beautiful Pairs",
      titleSlug: "number-of-beautiful-pairs",
    },
    {
      acRate: 30.024219739087354,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2749",
      paidOnly: false,
      title: "Minimum Operations to Make the Integer Zero",
      titleSlug: "minimum-operations-to-make-the-integer-zero",
    },
    {
      acRate: 33.70209023321011,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2750",
      paidOnly: false,
      title: "Ways to Split Array Into Good Subarrays",
      titleSlug: "ways-to-split-array-into-good-subarrays",
    },
    {
      acRate: 56.08745228298052,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2751",
      paidOnly: false,
      title: "Robot Collisions",
      titleSlug: "robot-collisions",
    },
    {
      acRate: 40.90520922288643,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2752",
      paidOnly: true,
      title:
        "Customers with Maximum Number of Transactions on Consecutive Days",
      titleSlug:
        "customers-with-maximum-number-of-transactions-on-consecutive-days",
    },
    {
      acRate: 60.98654708520179,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2753",
      paidOnly: true,
      title: "Count Houses in a Circular Street II",
      titleSlug: "count-houses-in-a-circular-street-ii",
    },
    {
      acRate: 86.82692307692308,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2754",
      paidOnly: true,
      title: "Bind Function to Context",
      titleSlug: "bind-function-to-context",
    },
    {
      acRate: 64.61937716262976,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2755",
      paidOnly: true,
      title: "Deep Merge of Two Objects",
      titleSlug: "deep-merge-of-two-objects",
    },
    {
      acRate: 66.4179104477612,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2756",
      paidOnly: true,
      title: "Query Batching",
      titleSlug: "query-batching",
    },
    {
      acRate: 73.35958005249343,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2757",
      paidOnly: true,
      title: "Generate Circular Array Values",
      titleSlug: "generate-circular-array-values",
    },
    {
      acRate: 84.9609375,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2758",
      paidOnly: true,
      title: "Next Day",
      titleSlug: "next-day",
    },
    {
      acRate: 62.31617647058824,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2759",
      paidOnly: true,
      title: "Convert JSON String to Object",
      titleSlug: "convert-json-string-to-object",
    },
    {
      acRate: 30.098897875371915,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2760",
      paidOnly: false,
      title: "Longest Even Odd Subarray With Threshold",
      titleSlug: "longest-even-odd-subarray-with-threshold",
    },
    {
      acRate: 35.321356955326316,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2761",
      paidOnly: false,
      title: "Prime Pairs With Target Sum",
      titleSlug: "prime-pairs-with-target-sum",
    },
    {
      acRate: 58.03196318111765,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2762",
      paidOnly: false,
      title: "Continuous Subarrays",
      titleSlug: "continuous-subarrays",
    },
    {
      acRate: 41.96330712413629,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2763",
      paidOnly: false,
      title: "Sum of Imbalance Numbers of All Subarrays",
      titleSlug: "sum-of-imbalance-numbers-of-all-subarrays",
    },
    {
      acRate: 65.7700650759219,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2764",
      paidOnly: true,
      title: "Is Array a Preorder of Some ‌Binary Tree",
      titleSlug: "is-array-a-preorder-of-some-binary-tree",
    },
    {
      acRate: 34.305051912923304,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2765",
      paidOnly: false,
      title: "Longest Alternating Subarray",
      titleSlug: "longest-alternating-subarray",
    },
    {
      acRate: 50.03512623490669,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2766",
      paidOnly: false,
      title: "Relocate Marbles",
      titleSlug: "relocate-marbles",
    },
    {
      acRate: 52.40912933220625,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2767",
      paidOnly: false,
      title: "Partition String Into Minimum Beautiful Substrings",
      titleSlug: "partition-string-into-minimum-beautiful-substrings",
    },
    {
      acRate: 37.96361766407405,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2768",
      paidOnly: false,
      title: "Number of Black Blocks",
      titleSlug: "number-of-black-blocks",
    },
    {
      acRate: 90.76937549239797,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2769",
      paidOnly: false,
      title: "Find the Maximum Achievable Number",
      titleSlug: "find-the-maximum-achievable-number",
    },
    {
      acRate: 31.130350450059098,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2770",
      paidOnly: false,
      title: "Maximum Number of Jumps to Reach the Last Index",
      titleSlug: "maximum-number-of-jumps-to-reach-the-last-index",
    },
    {
      acRate: 29.717926115874672,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2771",
      paidOnly: false,
      title: "Longest Non-decreasing Subarray From Two Arrays",
      titleSlug: "longest-non-decreasing-subarray-from-two-arrays",
    },
    {
      acRate: 32.59976769269062,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2772",
      paidOnly: false,
      title: "Apply Operations to Make All Array Elements Equal to Zero",
      titleSlug: "apply-operations-to-make-all-array-elements-equal-to-zero",
    },
    {
      acRate: 73.18932655654383,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2773",
      paidOnly: true,
      title: "Height of Special Binary Tree",
      titleSlug: "height-of-special-binary-tree",
    },
    {
      acRate: 82.83712784588442,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2774",
      paidOnly: true,
      title: "Array Upper Bound",
      titleSlug: "array-upper-bound",
    },
    {
      acRate: 70.90592334494772,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2775",
      paidOnly: true,
      title: "Undefined to Null",
      titleSlug: "undefined-to-null",
    },
    {
      acRate: 92.5476603119584,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2776",
      paidOnly: true,
      title: "Convert Callback Based Function to Promise Based Function",
      titleSlug: "convert-callback-based-function-to-promise-based-function",
    },
    {
      acRate: 82.35294117647058,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2777",
      paidOnly: true,
      title: "Date Range Generator",
      titleSlug: "date-range-generator",
    },
    {
      acRate: 81.00970021842183,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2778",
      paidOnly: false,
      title: "Sum of Squares of Special Elements ",
      titleSlug: "sum-of-squares-of-special-elements",
    },
    {
      acRate: 58.04234322637981,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2779",
      paidOnly: false,
      title: "Maximum Beauty of an Array After Applying Operation",
      titleSlug: "maximum-beauty-of-an-array-after-applying-operation",
    },
    {
      acRate: 75.57791532132629,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2780",
      paidOnly: false,
      title: "Minimum Index of a Valid Split",
      titleSlug: "minimum-index-of-a-valid-split",
    },
    {
      acRate: 37.606230040423114,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2781",
      paidOnly: false,
      title: "Length of the Longest Valid Substring",
      titleSlug: "length-of-the-longest-valid-substring",
    },
    {
      acRate: 82.5935596170583,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2782",
      paidOnly: true,
      title: "Number of Unique Categories",
      titleSlug: "number-of-unique-categories",
    },
    {
      acRate: 38.28667857851896,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2783",
      paidOnly: true,
      title: "Flight Occupancy and Waitlist Analysis",
      titleSlug: "flight-occupancy-and-waitlist-analysis",
    },
    {
      acRate: 48.360745199774996,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2784",
      paidOnly: false,
      title: "Check if Array is Good",
      titleSlug: "check-if-array-is-good",
    },
    {
      acRate: 79.35526162759963,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2785",
      paidOnly: false,
      title: "Sort Vowels in a String",
      titleSlug: "sort-vowels-in-a-string",
    },
    {
      acRate: 36.40111254594219,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2786",
      paidOnly: false,
      title: "Visit Array Positions to Maximize Score",
      titleSlug: "visit-array-positions-to-maximize-score",
    },
    {
      acRate: 33.56758439710003,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2787",
      paidOnly: false,
      title: "Ways to Express an Integer as Sum of Powers",
      titleSlug: "ways-to-express-an-integer-as-sum-of-powers",
    },
    {
      acRate: 74.690861843047,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2788",
      paidOnly: false,
      title: "Split Strings by Separator",
      titleSlug: "split-strings-by-separator",
    },
    {
      acRate: 46.545449494388265,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2789",
      paidOnly: false,
      title: "Largest Element in an Array after Merge Operations",
      titleSlug: "largest-element-in-an-array-after-merge-operations",
    },
    {
      acRate: 21.927788871498734,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2790",
      paidOnly: false,
      title: "Maximum Number of Groups With Increasing Length",
      titleSlug: "maximum-number-of-groups-with-increasing-length",
    },
    {
      acRate: 45.26426826560071,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2791",
      paidOnly: false,
      title: "Count Paths That Can Form a Palindrome in a Tree",
      titleSlug: "count-paths-that-can-form-a-palindrome-in-a-tree",
    },
    {
      acRate: 57.47067822539521,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2792",
      paidOnly: true,
      title: "Count Nodes That Are Great Enough",
      titleSlug: "count-nodes-that-are-great-enough",
    },
    {
      acRate: 79.10798122065728,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2793",
      paidOnly: true,
      title: "Status of Flight Tickets",
      titleSlug: "status-of-flight-tickets",
    },
    {
      acRate: 64.07239819004525,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2794",
      paidOnly: true,
      title: "Create Object from Two Arrays",
      titleSlug: "create-object-from-two-arrays",
    },
    {
      acRate: 89.98935037273695,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2795",
      paidOnly: true,
      title: "Parallel Execution of Promises for Individual Results Retrieval",
      titleSlug:
        "parallel-execution-of-promises-for-individual-results-retrieval",
    },
    {
      acRate: 93.05354558610709,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2796",
      paidOnly: true,
      title: "Repeat String",
      titleSlug: "repeat-string",
    },
    {
      acRate: 89.5819508958195,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2797",
      paidOnly: true,
      title: "Partial Function with Placeholders",
      titleSlug: "partial-function-with-placeholders",
    },
    {
      acRate: 87.59511374314373,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2798",
      paidOnly: false,
      title: "Number of Employees Who Met the Target",
      titleSlug: "number-of-employees-who-met-the-target",
    },
    {
      acRate: 75.78827264609585,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2799",
      paidOnly: false,
      title: "Count Complete Subarrays in an Array",
      titleSlug: "count-complete-subarrays-in-an-array",
    },
    {
      acRate: 30.59501893084164,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2800",
      paidOnly: false,
      title: "Shortest String That Contains Three Strings",
      titleSlug: "shortest-string-that-contains-three-strings",
    },
    {
      acRate: 25.807905784239143,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2801",
      paidOnly: false,
      title: "Count Stepping Numbers in Range",
      titleSlug: "count-stepping-numbers-in-range",
    },
    {
      acRate: 75.95192915876028,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2802",
      paidOnly: true,
      title: "Find The K-th Lucky Number",
      titleSlug: "find-the-k-th-lucky-number",
    },
    {
      acRate: 87.13007570543702,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2803",
      paidOnly: true,
      title: "Factorial Generator",
      titleSlug: "factorial-generator",
    },
    {
      acRate: 89.55223880597015,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2804",
      paidOnly: true,
      title: "Array Prototype ForEach",
      titleSlug: "array-prototype-foreach",
    },
    {
      acRate: 82.55977496483825,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2805",
      paidOnly: true,
      title: "Custom Interval",
      titleSlug: "custom-interval",
    },
    {
      acRate: 55.000985978349995,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2806",
      paidOnly: false,
      title: "Account Balance After Rounded Purchase",
      titleSlug: "account-balance-after-rounded-purchase",
    },
    {
      acRate: 91.53235152366902,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2807",
      paidOnly: false,
      title: "Insert Greatest Common Divisors in Linked List",
      titleSlug: "insert-greatest-common-divisors-in-linked-list",
    },
    {
      acRate: 27.28475538918291,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2808",
      paidOnly: false,
      title: "Minimum Seconds to Equalize a Circular Array",
      titleSlug: "minimum-seconds-to-equalize-a-circular-array",
    },
    {
      acRate: 25.140313528159474,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2809",
      paidOnly: false,
      title: "Minimum Time to Make Array Sum At Most x",
      titleSlug: "minimum-time-to-make-array-sum-at-most-x",
    },
    {
      acRate: 78.4216170185924,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2810",
      paidOnly: false,
      title: "Faulty Keyboard",
      titleSlug: "faulty-keyboard",
    },
    {
      acRate: 33.87503230808995,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2811",
      paidOnly: false,
      title: "Check if it is Possible to Split Array",
      titleSlug: "check-if-it-is-possible-to-split-array",
    },
    {
      acRate: 48.33234081861364,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2812",
      paidOnly: false,
      title: "Find the Safest Path in a Grid",
      titleSlug: "find-the-safest-path-in-a-grid",
    },
    {
      acRate: 27.70267781502081,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2813",
      paidOnly: false,
      title: "Maximum Elegance of a K-Length Subsequence",
      titleSlug: "maximum-elegance-of-a-k-length-subsequence",
    },
    {
      acRate: 53.233830845771145,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2814",
      paidOnly: true,
      title: "Minimum Time Takes to Reach Destination Without Drowning",
      titleSlug: "minimum-time-takes-to-reach-destination-without-drowning",
    },
    {
      acRate: 58.92851163569396,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2815",
      paidOnly: false,
      title: "Max Pair Sum in an Array",
      titleSlug: "max-pair-sum-in-an-array",
    },
    {
      acRate: 61.20930697024166,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2816",
      paidOnly: false,
      title: "Double a Number Represented as a Linked List",
      titleSlug: "double-a-number-represented-as-a-linked-list",
    },
    {
      acRate: 33.86403616201652,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2817",
      paidOnly: false,
      title: "Minimum Absolute Difference Between Elements With Constraint",
      titleSlug: "minimum-absolute-difference-between-elements-with-constraint",
    },
    {
      acRate: 54.228069530704495,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2818",
      paidOnly: false,
      title: "Apply Operations to Maximize Score",
      titleSlug: "apply-operations-to-maximize-score",
    },
    {
      acRate: 41.71475680131904,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2819",
      paidOnly: true,
      title: "Minimum Relative Loss After Buying Chocolates",
      titleSlug: "minimum-relative-loss-after-buying-chocolates",
    },
    {
      acRate: 68.39092210181967,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2820",
      paidOnly: true,
      title: "Election Results",
      titleSlug: "election-results",
    },
    {
      acRate: 71.94055944055944,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2821",
      paidOnly: true,
      title: "Delay the Resolution of Each Promise",
      titleSlug: "delay-the-resolution-of-each-promise",
    },
    {
      acRate: 59.523809523809526,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2822",
      paidOnly: true,
      title: "Inversion of Object",
      titleSlug: "inversion-of-object",
    },
    {
      acRate: 55.70264765784114,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2823",
      paidOnly: true,
      title: "Deep Object Filter",
      titleSlug: "deep-object-filter",
    },
    {
      acRate: 87.48014021114638,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2824",
      paidOnly: false,
      title: "Count Pairs Whose Sum is Less than Target",
      titleSlug: "count-pairs-whose-sum-is-less-than-target",
    },
    {
      acRate: 65.60590610258579,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2825",
      paidOnly: false,
      title: "Make String a Subsequence Using Cyclic Increments",
      titleSlug: "make-string-a-subsequence-using-cyclic-increments",
    },
    {
      acRate: 41.70729932319336,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2826",
      paidOnly: false,
      title: "Sorting Three Groups",
      titleSlug: "sorting-three-groups",
    },
    {
      acRate: 19.382567220504217,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2827",
      paidOnly: false,
      title: "Number of Beautiful Integers in the Range",
      titleSlug: "number-of-beautiful-integers-in-the-range",
    },
    {
      acRate: 82.55532892492397,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2828",
      paidOnly: false,
      title: "Check if a String Is an Acronym of Words",
      titleSlug: "check-if-a-string-is-an-acronym-of-words",
    },
    {
      acRate: 59.76528957160576,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2829",
      paidOnly: false,
      title: "Determine the Minimum Sum of a k-avoiding Array",
      titleSlug: "determine-the-minimum-sum-of-a-k-avoiding-array",
    },
    {
      acRate: 37.05857346734279,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2830",
      paidOnly: false,
      title: "Maximize the Profit as the Salesman",
      titleSlug: "maximize-the-profit-as-the-salesman",
    },
    {
      acRate: 35.997705599770555,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2831",
      paidOnly: false,
      title: "Find the Longest Equal Subarray",
      titleSlug: "find-the-longest-equal-subarray",
    },
    {
      acRate: 75.29128672745694,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2832",
      paidOnly: true,
      title: "Maximal Range That Each Element Is Maximum in It",
      titleSlug: "maximal-range-that-each-element-is-maximum-in-it",
    },
    {
      acRate: 64.3032245898548,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2833",
      paidOnly: false,
      title: "Furthest Point From Origin",
      titleSlug: "furthest-point-from-origin",
    },
    {
      acRate: 36.027194661958426,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2834",
      paidOnly: false,
      title: "Find the Minimum Possible Sum of a Beautiful Array",
      titleSlug: "find-the-minimum-possible-sum-of-a-beautiful-array",
    },
    {
      acRate: 31.195356342879165,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2835",
      paidOnly: false,
      title: "Minimum Operations to Form Subsequence With Target Sum",
      titleSlug: "minimum-operations-to-form-subsequence-with-target-sum",
    },
    {
      acRate: 28.34464805267725,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2836",
      paidOnly: false,
      title: "Maximize Value of Function in a Ball Passing Game",
      titleSlug: "maximize-value-of-function-in-a-ball-passing-game",
    },
    {
      acRate: 77.54095472961072,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2837",
      paidOnly: true,
      title: "Total Traveled Distance",
      titleSlug: "total-traveled-distance",
    },
    {
      acRate: 68.5758354755784,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2838",
      paidOnly: true,
      title: "Maximum Coins Heroes Can Collect",
      titleSlug: "maximum-coins-heroes-can-collect",
    },
    {
      acRate: 46.973177488007565,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2839",
      paidOnly: false,
      title: "Check if Strings Can be Made Equal With Operations I",
      titleSlug: "check-if-strings-can-be-made-equal-with-operations-i",
    },
    {
      acRate: 55.08987701040681,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2840",
      paidOnly: false,
      title: "Check if Strings Can be Made Equal With Operations II",
      titleSlug: "check-if-strings-can-be-made-equal-with-operations-ii",
    },
    {
      acRate: 39.11643618705796,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2841",
      paidOnly: false,
      title: "Maximum Sum of Almost Unique Subarray",
      titleSlug: "maximum-sum-of-almost-unique-subarray",
    },
    {
      acRate: 29.497558468260088,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2842",
      paidOnly: false,
      title: "Count K-Subsequences of a String With Maximum Beauty",
      titleSlug: "count-k-subsequences-of-a-string-with-maximum-beauty",
    },
    {
      acRate: 83.15438209463704,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2843",
      paidOnly: false,
      title: "  Count Symmetric Integers",
      titleSlug: "count-symmetric-integers",
    },
    {
      acRate: 37.98428387591381,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2844",
      paidOnly: false,
      title: "Minimum Operations to Make a Special Number",
      titleSlug: "minimum-operations-to-make-a-special-number",
    },
    {
      acRate: 58.06824446850485,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2845",
      paidOnly: false,
      title: "Count of Interesting Subarrays",
      titleSlug: "count-of-interesting-subarrays",
    },
    {
      acRate: 42.30437532340597,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2846",
      paidOnly: false,
      title: "Minimum Edge Weight Equilibrium Queries in a Tree",
      titleSlug: "minimum-edge-weight-equilibrium-queries-in-a-tree",
    },
    {
      acRate: 43.104693140794225,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2847",
      paidOnly: true,
      title: "Smallest Number With Given Digit Product",
      titleSlug: "smallest-number-with-given-digit-product",
    },
    {
      acRate: 72.76043404715602,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2848",
      paidOnly: false,
      title: "Points That Intersect With Cars",
      titleSlug: "points-that-intersect-with-cars",
    },
    {
      acRate: 37.13761505786455,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2849",
      paidOnly: false,
      title: "Determine if a Cell Is Reachable at a Given Time",
      titleSlug: "determine-if-a-cell-is-reachable-at-a-given-time",
    },
    {
      acRate: 44.15407829936823,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2850",
      paidOnly: false,
      title: "Minimum Moves to Spread Stones Over Grid",
      titleSlug: "minimum-moves-to-spread-stones-over-grid",
    },
    {
      acRate: 24.882381392076685,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2851",
      paidOnly: false,
      title: "String Transformation",
      titleSlug: "string-transformation",
    },
    {
      acRate: 70.76547231270358,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2852",
      paidOnly: true,
      title: "Sum of Remoteness of All Cells",
      titleSlug: "sum-of-remoteness-of-all-cells",
    },
    {
      acRate: 74.31385211494995,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2853",
      paidOnly: true,
      title: "Highest Salaries Difference",
      titleSlug: "highest-salaries-difference",
    },
    {
      acRate: 69.70816401920946,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2854",
      paidOnly: true,
      title: "Rolling Average Steps",
      titleSlug: "rolling-average-steps",
    },
    {
      acRate: 56.546594720723355,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2855",
      paidOnly: false,
      title: "Minimum Right Shifts to Sort the Array",
      titleSlug: "minimum-right-shifts-to-sort-the-array",
    },
    {
      acRate: 24.877335093760593,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2856",
      paidOnly: false,
      title: "Minimum Array Length After Pair Removals",
      titleSlug: "minimum-array-length-after-pair-removals",
    },
    {
      acRate: 31.963027938519545,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2857",
      paidOnly: false,
      title: "Count Pairs of Points With Distance k",
      titleSlug: "count-pairs-of-points-with-distance-k",
    },
    {
      acRate: 55.39233435059225,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2858",
      paidOnly: false,
      title: "Minimum Edge Reversals So Every Node Is Reachable",
      titleSlug: "minimum-edge-reversals-so-every-node-is-reachable",
    },
    {
      acRate: 85.66929615361096,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2859",
      paidOnly: false,
      title: "Sum of Values at Indices With K Set Bits",
      titleSlug: "sum-of-values-at-indices-with-k-set-bits",
    },
    {
      acRate: 49.95153813737885,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2860",
      paidOnly: false,
      title: "Happy Students",
      titleSlug: "happy-students",
    },
    {
      acRate: 38.662193133757064,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2861",
      paidOnly: false,
      title: "Maximum Number of Alloys",
      titleSlug: "maximum-number-of-alloys",
    },
    {
      acRate: 41.392331525948876,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2862",
      paidOnly: false,
      title: "Maximum Element-Sum of a Complete Subset of Indices",
      titleSlug: "maximum-element-sum-of-a-complete-subset-of-indices",
    },
    {
      acRate: 70.07953797051523,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2863",
      paidOnly: true,
      title: "Maximum Length of Semi-Decreasing Subarrays",
      titleSlug: "maximum-length-of-semi-decreasing-subarrays",
    },
    {
      acRate: 82.69077684004814,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2864",
      paidOnly: false,
      title: "Maximum Odd Binary Number",
      titleSlug: "maximum-odd-binary-number",
    },
    {
      acRate: 43.21909587945059,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2865",
      paidOnly: false,
      title: "Beautiful Towers I",
      titleSlug: "beautiful-towers-i",
    },
    {
      acRate: 34.30399929137694,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2866",
      paidOnly: false,
      title: "Beautiful Towers II",
      titleSlug: "beautiful-towers-ii",
    },
    {
      acRate: 34.269090291344604,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2867",
      paidOnly: false,
      title: "Count Valid Paths in a Tree",
      titleSlug: "count-valid-paths-in-a-tree",
    },
    {
      acRate: 53.71589840075258,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2868",
      paidOnly: true,
      title: "The Wording Game",
      titleSlug: "the-wording-game",
    },
    {
      acRate: 60.934763105054046,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2869",
      paidOnly: false,
      title: "Minimum Operations to Collect Elements",
      titleSlug: "minimum-operations-to-collect-elements",
    },
    {
      acRate: 61.812952256045506,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2870",
      paidOnly: false,
      title: "Minimum Number of Operations to Make Array Empty",
      titleSlug: "minimum-number-of-operations-to-make-array-empty",
    },
    {
      acRate: 41.438074418823305,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2871",
      paidOnly: false,
      title: "Split Array Into Maximum Number of Subarrays",
      titleSlug: "split-array-into-maximum-number-of-subarrays",
    },
    {
      acRate: 69.78704977329461,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2872",
      paidOnly: false,
      title: "Maximum Number of K-Divisible Components",
      titleSlug: "maximum-number-of-k-divisible-components",
    },
    {
      acRate: 58.30407557550311,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2873",
      paidOnly: false,
      title: "Maximum Value of an Ordered Triplet I",
      titleSlug: "maximum-value-of-an-ordered-triplet-i",
    },
    {
      acRate: 56.72067672973874,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2874",
      paidOnly: false,
      title: "Maximum Value of an Ordered Triplet II",
      titleSlug: "maximum-value-of-an-ordered-triplet-ii",
    },
    {
      acRate: 31.049497162761952,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2875",
      paidOnly: false,
      title: "Minimum Size Subarray in Infinite Array",
      titleSlug: "minimum-size-subarray-in-infinite-array",
    },
    {
      acRate: 28.703221838482285,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2876",
      paidOnly: false,
      title: "Count Visited Nodes in a Directed Graph",
      titleSlug: "count-visited-nodes-in-a-directed-graph",
    },
    {
      acRate: 81.4846957638497,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2877",
      paidOnly: false,
      title: "Create a DataFrame from List",
      titleSlug: "create-a-dataframe-from-list",
    },
    {
      acRate: 85.17166540281882,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2878",
      paidOnly: false,
      title: "Get the Size of a DataFrame",
      titleSlug: "get-the-size-of-a-dataframe",
    },
    {
      acRate: 93.09130539551798,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2879",
      paidOnly: false,
      title: "Display the First Three Rows",
      titleSlug: "display-the-first-three-rows",
    },
    {
      acRate: 79.2825248038427,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2880",
      paidOnly: false,
      title: "Select Data",
      titleSlug: "select-data",
    },
    {
      acRate: 90.29818895733452,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2881",
      paidOnly: false,
      title: "Create a New Column",
      titleSlug: "create-a-new-column",
    },
    {
      acRate: 85.57420567159059,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2882",
      paidOnly: false,
      title: "Drop Duplicate Rows",
      titleSlug: "drop-duplicate-rows",
    },
    {
      acRate: 64.36095209400422,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2883",
      paidOnly: false,
      title: "Drop Missing Data",
      titleSlug: "drop-missing-data",
    },
    {
      acRate: 92.52261947467018,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2884",
      paidOnly: false,
      title: "Modify Columns",
      titleSlug: "modify-columns",
    },
    {
      acRate: 85.59934958247938,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2885",
      paidOnly: false,
      title: "Rename Columns",
      titleSlug: "rename-columns",
    },
    {
      acRate: 87.48859014010864,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2886",
      paidOnly: false,
      title: "Change Data Type",
      titleSlug: "change-data-type",
    },
    {
      acRate: 72.25835508939068,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2887",
      paidOnly: false,
      title: "Fill Missing Data",
      titleSlug: "fill-missing-data",
    },
    {
      acRate: 90.75805253066429,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2888",
      paidOnly: false,
      title: "Reshape Data: Concatenate",
      titleSlug: "reshape-data-concatenate",
    },
    {
      acRate: 83.57786460409856,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2889",
      paidOnly: false,
      title: "Reshape Data: Pivot",
      titleSlug: "reshape-data-pivot",
    },
    {
      acRate: 86.21678497050583,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2890",
      paidOnly: false,
      title: "Reshape Data: Melt",
      titleSlug: "reshape-data-melt",
    },
    {
      acRate: 76.6713776288573,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2891",
      paidOnly: false,
      title: "Method Chaining",
      titleSlug: "method-chaining",
    },
    {
      acRate: 39.60033774275261,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2892",
      paidOnly: true,
      title: "Minimizing Array After Replacing Pairs With Their Product",
      titleSlug: "minimizing-array-after-replacing-pairs-with-their-product",
    },
    {
      acRate: 67.65760067467848,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2893",
      paidOnly: true,
      title: "Calculate Orders Within Each Interval",
      titleSlug: "calculate-orders-within-each-interval",
    },
    {
      acRate: 88.37180305264008,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2894",
      paidOnly: false,
      title: "Divisible and Non-divisible Sums Difference",
      titleSlug: "divisible-and-non-divisible-sums-difference",
    },
    {
      acRate: 69.0136660724896,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2895",
      paidOnly: false,
      title: "Minimum Processing Time",
      titleSlug: "minimum-processing-time",
    },
    {
      acRate: 27.10361781614758,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2896",
      paidOnly: false,
      title: "Apply Operations to Make Two Strings Equal",
      titleSlug: "apply-operations-to-make-two-strings-equal",
    },
    {
      acRate: 42.991921360375116,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2897",
      paidOnly: false,
      title: "Apply Operations on Array to Maximize Sum of Squares",
      titleSlug: "apply-operations-on-array-to-maximize-sum-of-squares",
    },
    {
      acRate: 58.503026967528896,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2898",
      paidOnly: true,
      title: "Maximum Linear Stock Score",
      titleSlug: "maximum-linear-stock-score",
    },
    {
      acRate: 60.82904493699096,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2899",
      paidOnly: false,
      title: "Last Visited Integers",
      titleSlug: "last-visited-integers",
    },
    {
      acRate: 59.693846058885256,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2900",
      paidOnly: false,
      title: "Longest Unequal Adjacent Groups Subsequence I",
      titleSlug: "longest-unequal-adjacent-groups-subsequence-i",
    },
    {
      acRate: 27.60249079839811,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2901",
      paidOnly: false,
      title: "Longest Unequal Adjacent Groups Subsequence II",
      titleSlug: "longest-unequal-adjacent-groups-subsequence-ii",
    },
    {
      acRate: 20.33891367524866,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2902",
      paidOnly: false,
      title: "Count of Sub-Multisets With Bounded Sum",
      titleSlug: "count-of-sub-multisets-with-bounded-sum",
    },
    {
      acRate: 60.288063204606956,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2903",
      paidOnly: false,
      title: "Find Indices With Index and Value Difference I",
      titleSlug: "find-indices-with-index-and-value-difference-i",
    },
    {
      acRate: 39.44227430555556,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2904",
      paidOnly: false,
      title: "Shortest and Lexicographically Smallest Beautiful String",
      titleSlug: "shortest-and-lexicographically-smallest-beautiful-string",
    },
    {
      acRate: 31.641248864810695,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2905",
      paidOnly: false,
      title: "Find Indices With Index and Value Difference II",
      titleSlug: "find-indices-with-index-and-value-difference-ii",
    },
    {
      acRate: 30.743112562857267,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2906",
      paidOnly: false,
      title: "Construct Product Matrix",
      titleSlug: "construct-product-matrix",
    },
    {
      acRate: 54.438280166435504,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2907",
      paidOnly: true,
      title: "Maximum Profitable Triplets With Increasing Prices I",
      titleSlug: "maximum-profitable-triplets-with-increasing-prices-i",
    },
    {
      acRate: 65.812744435893,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2908",
      paidOnly: false,
      title: "Minimum Sum of Mountain Triplets I",
      titleSlug: "minimum-sum-of-mountain-triplets-i",
    },
    {
      acRate: 53.50577089364263,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2909",
      paidOnly: false,
      title: "Minimum Sum of Mountain Triplets II",
      titleSlug: "minimum-sum-of-mountain-triplets-ii",
    },
    {
      acRate: 23.92189190581689,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2910",
      paidOnly: false,
      title: "Minimum Number of Groups to Create a Valid Assignment",
      titleSlug: "minimum-number-of-groups-to-create-a-valid-assignment",
    },
    {
      acRate: 34.70323122756092,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2911",
      paidOnly: false,
      title: "Minimum Changes to Make K Semi-palindromes",
      titleSlug: "minimum-changes-to-make-k-semi-palindromes",
    },
    {
      acRate: 58.71508379888268,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2912",
      paidOnly: true,
      title: "Number of Ways to Reach Destination in the Grid",
      titleSlug: "number-of-ways-to-reach-destination-in-the-grid",
    },
    {
      acRate: 79.47435794863588,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2913",
      paidOnly: false,
      title: "Subarrays Distinct Element Sum of Squares I",
      titleSlug: "subarrays-distinct-element-sum-of-squares-i",
    },
    {
      acRate: 76.50800026779139,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2914",
      paidOnly: false,
      title: "Minimum Number of Changes to Make Binary String Beautiful",
      titleSlug: "minimum-number-of-changes-to-make-binary-string-beautiful",
    },
    {
      acRate: 36.957262716308335,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2915",
      paidOnly: false,
      title: "Length of the Longest Subsequence That Sums to Target",
      titleSlug: "length-of-the-longest-subsequence-that-sums-to-target",
    },
    {
      acRate: 20.584560221654804,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2916",
      paidOnly: false,
      title: "Subarrays Distinct Element Sum of Squares II",
      titleSlug: "subarrays-distinct-element-sum-of-squares-ii",
    },
    {
      acRate: 71.98023724626536,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2917",
      paidOnly: false,
      title: "Find the K-or of an Array",
      titleSlug: "find-the-k-or-of-an-array",
    },
    {
      acRate: 36.41936236132858,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2918",
      paidOnly: false,
      title: "Minimum Equal Sum of Two Arrays After Replacing Zeros",
      titleSlug: "minimum-equal-sum-of-two-arrays-after-replacing-zeros",
    },
    {
      acRate: 33.77730304747787,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2919",
      paidOnly: false,
      title: "Minimum Increment Operations to Make Array Beautiful",
      titleSlug: "minimum-increment-operations-to-make-array-beautiful",
    },
    {
      acRate: 35.59600704638873,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2920",
      paidOnly: false,
      title: "Maximum Points After Collecting Coins From All Nodes",
      titleSlug: "maximum-points-after-collecting-coins-from-all-nodes",
    },
    {
      acRate: 45.52845528455284,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2921",
      paidOnly: true,
      title: "Maximum Profitable Triplets With Increasing Prices II",
      titleSlug: "maximum-profitable-triplets-with-increasing-prices-ii",
    },
    {
      acRate: 41.48096885813149,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2922",
      paidOnly: true,
      title: "Market Analysis III",
      titleSlug: "market-analysis-iii",
    },
    {
      acRate: 72.26093242889884,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2923",
      paidOnly: false,
      title: "Find Champion I",
      titleSlug: "find-champion-i",
    },
    {
      acRate: 69.98570721479776,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2924",
      paidOnly: false,
      title: "Find Champion II",
      titleSlug: "find-champion-ii",
    },
    {
      acRate: 45.80559254327563,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2925",
      paidOnly: false,
      title: "Maximum Score After Applying Operations on a Tree",
      titleSlug: "maximum-score-after-applying-operations-on-a-tree",
    },
    {
      acRate: 24.812394876439384,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2926",
      paidOnly: false,
      title: "Maximum Balanced Subsequence Sum",
      titleSlug: "maximum-balanced-subsequence-sum",
    },
    {
      acRate: 44.01658767772511,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2927",
      paidOnly: true,
      title: "Distribute Candies Among Children III",
      titleSlug: "distribute-candies-among-children-iii",
    },
    {
      acRate: 73.1604846571654,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2928",
      paidOnly: false,
      title: "Distribute Candies Among Children I",
      titleSlug: "distribute-candies-among-children-i",
    },
    {
      acRate: 34.96167179336946,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2929",
      paidOnly: false,
      title: "Distribute Candies Among Children II",
      titleSlug: "distribute-candies-among-children-ii",
    },
    {
      acRate: 54.987494482860086,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2930",
      paidOnly: false,
      title: "Number of Strings Which Can Be Rearranged to Contain Substring",
      titleSlug:
        "number-of-strings-which-can-be-rearranged-to-contain-substring",
    },
    {
      acRate: 59.76495918184265,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2931",
      paidOnly: false,
      title: "Maximum Spending After Buying Items",
      titleSlug: "maximum-spending-after-buying-items",
    },
    {
      acRate: 74.60195934438525,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2932",
      paidOnly: false,
      title: "Maximum Strong Pair XOR I",
      titleSlug: "maximum-strong-pair-xor-i",
    },
    {
      acRate: 45.870308288963386,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2933",
      paidOnly: false,
      title: "High-Access Employees",
      titleSlug: "high-access-employees",
    },
    {
      acRate: 43.07940423109762,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2934",
      paidOnly: false,
      title: "Minimum Operations to Maximize Last Elements in Arrays",
      titleSlug: "minimum-operations-to-maximize-last-elements-in-arrays",
    },
    {
      acRate: 30.516121021480895,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2935",
      paidOnly: false,
      title: "Maximum Strong Pair XOR II",
      titleSlug: "maximum-strong-pair-xor-ii",
    },
    {
      acRate: 62.62536873156343,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2936",
      paidOnly: true,
      title: "Number of Equal Numbers Blocks",
      titleSlug: "number-of-equal-numbers-blocks",
    },
    {
      acRate: 43.00205876848213,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2937",
      paidOnly: false,
      title: "Make Three Strings Equal",
      titleSlug: "make-three-strings-equal",
    },
    {
      acRate: 64.08839571328153,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2938",
      paidOnly: false,
      title: "Separate Black and White Balls",
      titleSlug: "separate-black-and-white-balls",
    },
    {
      acRate: 26.75019127773527,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2939",
      paidOnly: false,
      title: "Maximum Xor Product",
      titleSlug: "maximum-xor-product",
    },
    {
      acRate: 52.35457481812419,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2940",
      paidOnly: false,
      title: "Find Building Where Alice and Bob Can Meet",
      titleSlug: "find-building-where-alice-and-bob-can-meet",
    },
    {
      acRate: 36.3573883161512,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2941",
      paidOnly: true,
      title: "Maximum GCD-Sum of a Subarray",
      titleSlug: "maximum-gcd-sum-of-a-subarray",
    },
    {
      acRate: 88.42959470486899,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2942",
      paidOnly: false,
      title: "Find Words Containing Character",
      titleSlug: "find-words-containing-character",
    },
    {
      acRate: 36.71851089285217,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2943",
      paidOnly: false,
      title: "Maximize Area of Square Hole in Grid",
      titleSlug: "maximize-area-of-square-hole-in-grid",
    },
    {
      acRate: 46.40081994565477,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2944",
      paidOnly: false,
      title: "Minimum Number of Coins for Fruits",
      titleSlug: "minimum-number-of-coins-for-fruits",
    },
    {
      acRate: 16.91865591222284,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2945",
      paidOnly: false,
      title: "Find Maximum Non-decreasing Array Length",
      titleSlug: "find-maximum-non-decreasing-array-length",
    },
    {
      acRate: 58.02872899833269,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2946",
      paidOnly: false,
      title: "Matrix Similarity After Cyclic Shifts",
      titleSlug: "matrix-similarity-after-cyclic-shifts",
    },
    {
      acRate: 59.40364735712893,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2947",
      paidOnly: false,
      title: "Count Beautiful Substrings I",
      titleSlug: "count-beautiful-substrings-i",
    },
    {
      acRate: 60.26327807744054,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2948",
      paidOnly: false,
      title: "Make Lexicographically Smallest Array by Swapping Elements",
      titleSlug: "make-lexicographically-smallest-array-by-swapping-elements",
    },
    {
      acRate: 24.681411473060386,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2949",
      paidOnly: false,
      title: "Count Beautiful Substrings II",
      titleSlug: "count-beautiful-substrings-ii",
    },
    {
      acRate: 73.1813524590164,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2950",
      paidOnly: true,
      title: "Number of Divisible Substrings",
      titleSlug: "number-of-divisible-substrings",
    },
    {
      acRate: 73.99325553637027,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2951",
      paidOnly: false,
      title: "Find the Peaks",
      titleSlug: "find-the-peaks",
    },
    {
      acRate: 56.499855505249975,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2952",
      paidOnly: false,
      title: "Minimum Number of Coins to be Added",
      titleSlug: "minimum-number-of-coins-to-be-added",
    },
    {
      acRate: 28.284879249346258,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2953",
      paidOnly: false,
      title: "Count Complete Substrings",
      titleSlug: "count-complete-substrings",
    },
    {
      acRate: 33.158900240883796,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2954",
      paidOnly: false,
      title: "Count the Number of Infection Sequences",
      titleSlug: "count-the-number-of-infection-sequences",
    },
    {
      acRate: 61.29192019244375,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2955",
      paidOnly: true,
      title: "Number of Same-End Substrings",
      titleSlug: "number-of-same-end-substrings",
    },
    {
      acRate: 83.53890618957482,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2956",
      paidOnly: false,
      title: "Find Common Elements Between Two Arrays",
      titleSlug: "find-common-elements-between-two-arrays",
    },
    {
      acRate: 51.541005021022976,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2957",
      paidOnly: false,
      title: "Remove Adjacent Almost-Equal Characters",
      titleSlug: "remove-adjacent-almost-equal-characters",
    },
    {
      acRate: 55.65853819719799,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2958",
      paidOnly: false,
      title: "Length of Longest Subarray With at Most K Frequency",
      titleSlug: "length-of-longest-subarray-with-at-most-k-frequency",
    },
    {
      acRate: 48.03883278469006,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2959",
      paidOnly: false,
      title: "Number of Possible Sets of Closing Branches",
      titleSlug: "number-of-possible-sets-of-closing-branches",
    },
    {
      acRate: 78.35361395870225,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2960",
      paidOnly: false,
      title: "Count Tested Devices After Test Operations",
      titleSlug: "count-tested-devices-after-test-operations",
    },
    {
      acRate: 46.95033459646859,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2961",
      paidOnly: false,
      title: "Double Modular Exponentiation",
      titleSlug: "double-modular-exponentiation",
    },
    {
      acRate: 62.49938179215201,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2962",
      paidOnly: false,
      title: "Count Subarrays Where Max Element Appears at Least K Times",
      titleSlug: "count-subarrays-where-max-element-appears-at-least-k-times",
    },
    {
      acRate: 46.62463591785569,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2963",
      paidOnly: false,
      title: "Count the Number of Good Partitions",
      titleSlug: "count-the-number-of-good-partitions",
    },
    {
      acRate: 67.58676679521007,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2964",
      paidOnly: true,
      title: "Number of Divisible Triplet Sums",
      titleSlug: "number-of-divisible-triplet-sums",
    },
    {
      acRate: 83.67351809110156,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2965",
      paidOnly: false,
      title: "Find Missing and Repeated Values",
      titleSlug: "find-missing-and-repeated-values",
    },
    {
      acRate: 71.68642022185458,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2966",
      paidOnly: false,
      title: "Divide Array Into Arrays With Max Difference",
      titleSlug: "divide-array-into-arrays-with-max-difference",
    },
    {
      acRate: 22.385532897268178,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2967",
      paidOnly: false,
      title: "Minimum Cost to Make Array Equalindromic",
      titleSlug: "minimum-cost-to-make-array-equalindromic",
    },
    {
      acRate: 36.11861071706402,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2968",
      paidOnly: false,
      title: "Apply Operations to Maximize Frequency Score",
      titleSlug: "apply-operations-to-maximize-frequency-score",
    },
    {
      acRate: 44.90846681922197,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2969",
      paidOnly: true,
      title: "Minimum Number of Coins for Fruits II",
      titleSlug: "minimum-number-of-coins-for-fruits-ii",
    },
    {
      acRate: 54.49281399708394,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2970",
      paidOnly: false,
      title: "Count the Number of Incremovable Subarrays I",
      titleSlug: "count-the-number-of-incremovable-subarrays-i",
    },
    {
      acRate: 65.33896562681072,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2971",
      paidOnly: false,
      title: "Find Polygon With the Largest Perimeter",
      titleSlug: "find-polygon-with-the-largest-perimeter",
    },
    {
      acRate: 38.700688666852436,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2972",
      paidOnly: false,
      title: "Count the Number of Incremovable Subarrays II",
      titleSlug: "count-the-number-of-incremovable-subarrays-ii",
    },
    {
      acRate: 36.02102437933348,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2973",
      paidOnly: false,
      title: "Find Number of Coins to Place in Tree Nodes",
      titleSlug: "find-number-of-coins-to-place-in-tree-nodes",
    },
    {
      acRate: 84.80087189500931,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2974",
      paidOnly: false,
      title: "Minimum Number Game",
      titleSlug: "minimum-number-game",
    },
    {
      acRate: 23.936558982604883,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2975",
      paidOnly: false,
      title: "Maximum Square Area by Removing Fences From a Field",
      titleSlug: "maximum-square-area-by-removing-fences-from-a-field",
    },
    {
      acRate: 57.66073280331836,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2976",
      paidOnly: false,
      title: "Minimum Cost to Convert String I",
      titleSlug: "minimum-cost-to-convert-string-i",
    },
    {
      acRate: 25.387319359458406,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2977",
      paidOnly: false,
      title: "Minimum Cost to Convert String II",
      titleSlug: "minimum-cost-to-convert-string-ii",
    },
    {
      acRate: 40.513094601817215,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2978",
      paidOnly: true,
      title: "Symmetric Coordinates",
      titleSlug: "symmetric-coordinates",
    },
    {
      acRate: 80.25916735594156,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2979",
      paidOnly: true,
      title: "Most Expensive Item That Can Not Be Bought",
      titleSlug: "most-expensive-item-that-can-not-be-bought",
    },
    {
      acRate: 69.65286706094112,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2980",
      paidOnly: false,
      title: "Check if Bitwise OR Has Trailing Zeros",
      titleSlug: "check-if-bitwise-or-has-trailing-zeros",
    },
    {
      acRate: 61.90257352941176,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2981",
      paidOnly: false,
      title: "Find Longest Special Substring That Occurs Thrice I",
      titleSlug: "find-longest-special-substring-that-occurs-thrice-i",
    },
    {
      acRate: 38.29992788232573,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2982",
      paidOnly: false,
      title: "Find Longest Special Substring That Occurs Thrice II",
      titleSlug: "find-longest-special-substring-that-occurs-thrice-ii",
    },
    {
      acRate: 22.955425146709953,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2983",
      paidOnly: false,
      title: "Palindrome Rearrangement Queries",
      titleSlug: "palindrome-rearrangement-queries",
    },
    {
      acRate: 61.7786391042205,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2984",
      paidOnly: true,
      title: "Find Peak Calling Hours for Each City",
      titleSlug: "find-peak-calling-hours-for-each-city",
    },
    {
      acRate: 87.94222315260623,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2985",
      paidOnly: true,
      title: "Calculate Compressed Mean",
      titleSlug: "calculate-compressed-mean",
    },
    {
      acRate: 53.62098138747885,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2986",
      paidOnly: true,
      title: "Find Third Transaction",
      titleSlug: "find-third-transaction",
    },
    {
      acRate: 79.93323442136499,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2987",
      paidOnly: true,
      title: "Find Expensive Cities",
      titleSlug: "find-expensive-cities",
    },
    {
      acRate: 81.06888361045131,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2988",
      paidOnly: true,
      title: "Manager of the Largest Department",
      titleSlug: "manager-of-the-largest-department",
    },
    {
      acRate: 89.38997382725992,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2989",
      paidOnly: true,
      title: "Class Performance",
      titleSlug: "class-performance",
    },
    {
      acRate: 63.60304482661404,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2990",
      paidOnly: true,
      title: "Loan Types",
      titleSlug: "loan-types",
    },
    {
      acRate: 57.285714285714285,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2991",
      paidOnly: true,
      title: "Top Three Wineries ",
      titleSlug: "top-three-wineries",
    },
    {
      acRate: 71.69811320754717,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2992",
      paidOnly: true,
      title: "Number of Self-Divisible Permutations",
      titleSlug: "number-of-self-divisible-permutations",
    },
    {
      acRate: 81.513281459619,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2993",
      paidOnly: true,
      title: "Friday Purchases I",
      titleSlug: "friday-purchases-i",
    },
    {
      acRate: 77.08990536277602,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2994",
      paidOnly: true,
      title: "Friday Purchases II ",
      titleSlug: "friday-purchases-ii",
    },
    {
      acRate: 43.04792810783824,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2995",
      paidOnly: true,
      title: "Viewers Turned Streamers",
      titleSlug: "viewers-turned-streamers",
    },
    {
      acRate: 33.45984502317994,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "2996",
      paidOnly: false,
      title: "Smallest Missing Integer Greater Than Sequential Prefix Sum",
      titleSlug: "smallest-missing-integer-greater-than-sequential-prefix-sum",
    },
    {
      acRate: 85.31395382859817,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2997",
      paidOnly: false,
      title: "Minimum Number of Operations to Make Array XOR Equal to K",
      titleSlug: "minimum-number-of-operations-to-make-array-xor-equal-to-k",
    },
    {
      acRate: 47.151886463220755,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "2998",
      paidOnly: false,
      title: "Minimum Number of Operations to Make X and Y Equal",
      titleSlug: "minimum-number-of-operations-to-make-x-and-y-equal",
    },
    {
      acRate: 46.54961870109156,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "2999",
      paidOnly: false,
      title: "Count the Number of Powerful Integers",
      titleSlug: "count-the-number-of-powerful-integers",
    },
    {
      acRate: 36.41084874117432,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3000",
      paidOnly: false,
      title: "Maximum Area of Longest Diagonal Rectangle",
      titleSlug: "maximum-area-of-longest-diagonal-rectangle",
    },
    {
      acRate: 21.353375471397463,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3001",
      paidOnly: false,
      title: "Minimum Moves to Capture The Queen",
      titleSlug: "minimum-moves-to-capture-the-queen",
    },
    {
      acRate: 44.66675003126172,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3002",
      paidOnly: false,
      title: "Maximum Size of a Set After Removals",
      titleSlug: "maximum-size-of-a-set-after-removals",
    },
    {
      acRate: 27.255473463024472,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3003",
      paidOnly: false,
      title: "Maximize the Number of Partitions After Operations",
      titleSlug: "maximize-the-number-of-partitions-after-operations",
    },
    {
      acRate: 56.727828746177366,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3004",
      paidOnly: true,
      title: "Maximum Subtree of the Same Color",
      titleSlug: "maximum-subtree-of-the-same-color",
    },
    {
      acRate: 77.90653320530863,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3005",
      paidOnly: false,
      title: "Count Elements With Maximum Frequency",
      titleSlug: "count-elements-with-maximum-frequency",
    },
    {
      acRate: 38.11182525057306,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3006",
      paidOnly: false,
      title: "Find Beautiful Indices in the Given Array I",
      titleSlug: "find-beautiful-indices-in-the-given-array-i",
    },
    {
      acRate: 36.675666554168075,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3007",
      paidOnly: false,
      title: "Maximum Number That Sum of the Prices Is Less Than or Equal to K",
      titleSlug:
        "maximum-number-that-sum-of-the-prices-is-less-than-or-equal-to-k",
    },
    {
      acRate: 26.195690178686444,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3008",
      paidOnly: false,
      title: "Find Beautiful Indices in the Given Array II",
      titleSlug: "find-beautiful-indices-in-the-given-array-ii",
    },
    {
      acRate: 45.196387770645195,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3009",
      paidOnly: true,
      title: "Maximum Number of Intersections on the Chart",
      titleSlug: "maximum-number-of-intersections-on-the-chart",
    },
    {
      acRate: 65.62569138344763,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3010",
      paidOnly: false,
      title: "Divide an Array Into Subarrays With Minimum Cost I",
      titleSlug: "divide-an-array-into-subarrays-with-minimum-cost-i",
    },
    {
      acRate: 66.54323188823209,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3011",
      paidOnly: false,
      title: "Find if Array Can Be Sorted",
      titleSlug: "find-if-array-can-be-sorted",
    },
    {
      acRate: 34.698629529427414,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3012",
      paidOnly: false,
      title: "Minimize Length of Array Using Operations",
      titleSlug: "minimize-length-of-array-using-operations",
    },
    {
      acRate: 29.8777271637497,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3013",
      paidOnly: false,
      title: "Divide an Array Into Subarrays With Minimum Cost II",
      titleSlug: "divide-an-array-into-subarrays-with-minimum-cost-ii",
    },
    {
      acRate: 66.1019150563549,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3014",
      paidOnly: false,
      title: "Minimum Number of Pushes to Type Word I",
      titleSlug: "minimum-number-of-pushes-to-type-word-i",
    },
    {
      acRate: 54.730650598952735,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3015",
      paidOnly: false,
      title: "Count the Number of Houses at a Certain Distance I",
      titleSlug: "count-the-number-of-houses-at-a-certain-distance-i",
    },
    {
      acRate: 79.90135635018495,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3016",
      paidOnly: false,
      title: "Minimum Number of Pushes to Type Word II",
      titleSlug: "minimum-number-of-pushes-to-type-word-ii",
    },
    {
      acRate: 21.51990349819059,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3017",
      paidOnly: false,
      title: "Count the Number of Houses at a Certain Distance II",
      titleSlug: "count-the-number-of-houses-at-a-certain-distance-ii",
    },
    {
      acRate: 43.162719633307866,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3018",
      paidOnly: true,
      title: "Maximum Number of Removal Queries That Can Be Processed I",
      titleSlug: "maximum-number-of-removal-queries-that-can-be-processed-i",
    },
    {
      acRate: 79.60088968860899,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3019",
      paidOnly: false,
      title: "Number of Changing Keys",
      titleSlug: "number-of-changing-keys",
    },
    {
      acRate: 26.310576582950123,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3020",
      paidOnly: false,
      title: "Find the Maximum Number of Elements in Subset",
      titleSlug: "find-the-maximum-number-of-elements-in-subset",
    },
    {
      acRate: 45.5330259196092,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3021",
      paidOnly: false,
      title: "Alice and Bob Playing Flower Game",
      titleSlug: "alice-and-bob-playing-flower-game",
    },
    {
      acRate: 28.680263471153083,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3022",
      paidOnly: false,
      title: "Minimize OR of Remaining Elements Using Operations",
      titleSlug: "minimize-or-of-remaining-elements-using-operations",
    },
    {
      acRate: 56.80029973772949,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3023",
      paidOnly: true,
      title: "Find Pattern in Infinite Stream I",
      titleSlug: "find-pattern-in-infinite-stream-i",
    },
    {
      acRate: 38.02849706236862,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3024",
      paidOnly: false,
      title: "Type of Triangle",
      titleSlug: "type-of-triangle",
    },
    {
      acRate: 40.616906051330346,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3025",
      paidOnly: false,
      title: "Find the Number of Ways to Place People I",
      titleSlug: "find-the-number-of-ways-to-place-people-i",
    },
    {
      acRate: 20.102625316828536,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3026",
      paidOnly: false,
      title: "Maximum Good Subarray Sum",
      titleSlug: "maximum-good-subarray-sum",
    },
    {
      acRate: 45.74841599741717,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3027",
      paidOnly: false,
      title: "Find the Number of Ways to Place People II",
      titleSlug: "find-the-number-of-ways-to-place-people-ii",
    },
    {
      acRate: 73.5757300578311,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3028",
      paidOnly: false,
      title: "Ant on the Boundary",
      titleSlug: "ant-on-the-boundary",
    },
    {
      acRate: 41.14366197183099,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3029",
      paidOnly: false,
      title: "Minimum Time to Revert Word to Initial State I",
      titleSlug: "minimum-time-to-revert-word-to-initial-state-i",
    },
    {
      acRate: 42.07483910748005,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3030",
      paidOnly: false,
      title: "Find the Grid of Region Average",
      titleSlug: "find-the-grid-of-region-average",
    },
    {
      acRate: 34.27441964786363,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3031",
      paidOnly: false,
      title: "Minimum Time to Revert Word to Initial State II",
      titleSlug: "minimum-time-to-revert-word-to-initial-state-ii",
    },
    {
      acRate: 87.63231944258341,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3032",
      paidOnly: true,
      title: "Count Numbers With Unique Digits II",
      titleSlug: "count-numbers-with-unique-digits-ii",
    },
    {
      acRate: 68.19734029262334,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3033",
      paidOnly: false,
      title: "Modify the Matrix",
      titleSlug: "modify-the-matrix",
    },
    {
      acRate: 66.47024815440719,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3034",
      paidOnly: false,
      title: "Number of Subarrays That Match a Pattern I",
      titleSlug: "number-of-subarrays-that-match-a-pattern-i",
    },
    {
      acRate: 42.916475564388726,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3035",
      paidOnly: false,
      title: "Maximum Palindromes After Operations",
      titleSlug: "maximum-palindromes-after-operations",
    },
    {
      acRate: 31.910025706940875,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3036",
      paidOnly: false,
      title: "Number of Subarrays That Match a Pattern II",
      titleSlug: "number-of-subarrays-that-match-a-pattern-ii",
    },
    {
      acRate: 68.43971631205675,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3037",
      paidOnly: true,
      title: "Find Pattern in Infinite Stream II",
      titleSlug: "find-pattern-in-infinite-stream-ii",
    },
    {
      acRate: 51.788672425831365,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3038",
      paidOnly: false,
      title: "Maximum Number of Operations With the Same Score I",
      titleSlug: "maximum-number-of-operations-with-the-same-score-i",
    },
    {
      acRate: 56.017753525727244,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3039",
      paidOnly: false,
      title: "Apply Operations to Make String Empty",
      titleSlug: "apply-operations-to-make-string-empty",
    },
    {
      acRate: 32.963049238563904,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3040",
      paidOnly: false,
      title: "Maximum Number of Operations With the Same Score II",
      titleSlug: "maximum-number-of-operations-with-the-same-score-ii",
    },
    {
      acRate: 32.17224627383589,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3041",
      paidOnly: false,
      title: "Maximize Consecutive Elements in an Array After Modification",
      titleSlug: "maximize-consecutive-elements-in-an-array-after-modification",
    },
    {
      acRate: 77.66750841420263,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3042",
      paidOnly: false,
      title: "Count Prefix and Suffix Pairs I",
      titleSlug: "count-prefix-and-suffix-pairs-i",
    },
    {
      acRate: 56.341571324623665,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3043",
      paidOnly: false,
      title: "Find the Length of the Longest Common Prefix",
      titleSlug: "find-the-length-of-the-longest-common-prefix",
    },
    {
      acRate: 44.76434989913809,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3044",
      paidOnly: false,
      title: "Most Frequent Prime",
      titleSlug: "most-frequent-prime",
    },
    {
      acRate: 26.987758378486852,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3045",
      paidOnly: false,
      title: "Count Prefix and Suffix Pairs II",
      titleSlug: "count-prefix-and-suffix-pairs-ii",
    },
    {
      acRate: 59.009427224682184,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3046",
      paidOnly: false,
      title: "Split the Array",
      titleSlug: "split-the-array",
    },
    {
      acRate: 44.93709565254041,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3047",
      paidOnly: false,
      title: "Find the Largest Area of Square Inside Two Rectangles",
      titleSlug: "find-the-largest-area-of-square-inside-two-rectangles",
    },
    {
      acRate: 34.34861600940472,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3048",
      paidOnly: false,
      title: "Earliest Second to Mark Indices I",
      titleSlug: "earliest-second-to-mark-indices-i",
    },
    {
      acRate: 20.10350853609356,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3049",
      paidOnly: false,
      title: "Earliest Second to Mark Indices II",
      titleSlug: "earliest-second-to-mark-indices-ii",
    },
    {
      acRate: 67.82464846980976,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3050",
      paidOnly: true,
      title: "Pizza Toppings Cost Analysis",
      titleSlug: "pizza-toppings-cost-analysis",
    },
    {
      acRate: 76.24499141385232,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3051",
      paidOnly: true,
      title: "Find Candidates for Data Scientist Position",
      titleSlug: "find-candidates-for-data-scientist-position",
    },
    {
      acRate: 75.0,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3052",
      paidOnly: true,
      title: "Maximize Items",
      titleSlug: "maximize-items",
    },
    {
      acRate: 50.523800771916925,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3053",
      paidOnly: true,
      title: "Classifying Triangles by Lengths",
      titleSlug: "classifying-triangles-by-lengths",
    },
    {
      acRate: 78.8809654415798,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3054",
      paidOnly: true,
      title: "Binary Tree Nodes",
      titleSlug: "binary-tree-nodes",
    },
    {
      acRate: 58.530447911424254,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3055",
      paidOnly: true,
      title: "Top Percentile Fraud",
      titleSlug: "top-percentile-fraud",
    },
    {
      acRate: 58.35700757575758,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3056",
      paidOnly: true,
      title: "Snaps Analysis",
      titleSlug: "snaps-analysis",
    },
    {
      acRate: 68.55177684371418,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3057",
      paidOnly: true,
      title: "Employees Project Allocation",
      titleSlug: "employees-project-allocation",
    },
    {
      acRate: 48.2514386896857,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3058",
      paidOnly: true,
      title: "Friends With No Mutual Friends",
      titleSlug: "friends-with-no-mutual-friends",
    },
    {
      acRate: 70.32122905027933,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3059",
      paidOnly: true,
      title: "Find All Unique Email Domains",
      titleSlug: "find-all-unique-email-domains",
    },
    {
      acRate: 39.73572439830109,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3060",
      paidOnly: true,
      title: "User Activities within Time Bounds",
      titleSlug: "user-activities-within-time-bounds",
    },
    {
      acRate: 81.70894526034714,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3061",
      paidOnly: true,
      title: "Calculate Trapping Rain Water",
      titleSlug: "calculate-trapping-rain-water",
    },
    {
      acRate: 78.63656749887875,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3062",
      paidOnly: true,
      title: "Winner of the Linked List Game",
      titleSlug: "winner-of-the-linked-list-game",
    },
    {
      acRate: 85.73063973063974,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3063",
      paidOnly: true,
      title: "Linked List Frequency",
      titleSlug: "linked-list-frequency",
    },
    {
      acRate: 90.22482893450635,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3064",
      paidOnly: true,
      title: "Guess the Number Using Bitwise Questions I",
      titleSlug: "guess-the-number-using-bitwise-questions-i",
    },
    {
      acRate: 85.91683876336961,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3065",
      paidOnly: false,
      title: "Minimum Operations to Exceed Threshold Value I",
      titleSlug: "minimum-operations-to-exceed-threshold-value-i",
    },
    {
      acRate: 45.716749760163836,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3066",
      paidOnly: false,
      title: "Minimum Operations to Exceed Threshold Value II",
      titleSlug: "minimum-operations-to-exceed-threshold-value-ii",
    },
    {
      acRate: 53.91458404010705,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3067",
      paidOnly: false,
      title: "Count Pairs of Connectable Servers in a Weighted Tree Network",
      titleSlug:
        "count-pairs-of-connectable-servers-in-a-weighted-tree-network",
    },
    {
      acRate: 65.19744024425962,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3068",
      paidOnly: false,
      title: "Find the Maximum Sum of Node Values",
      titleSlug: "find-the-maximum-sum-of-node-values",
    },
    {
      acRate: 72.83331486201928,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3069",
      paidOnly: false,
      title: "Distribute Elements Into Two Arrays I",
      titleSlug: "distribute-elements-into-two-arrays-i",
    },
    {
      acRate: 57.03606952677585,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3070",
      paidOnly: false,
      title: "Count Submatrices with Top-Left Element and Sum Less Than k",
      titleSlug: "count-submatrices-with-top-left-element-and-sum-less-than-k",
    },
    {
      acRate: 61.45921862525432,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3071",
      paidOnly: false,
      title: "Minimum Operations to Write the Letter Y on a Grid",
      titleSlug: "minimum-operations-to-write-the-letter-y-on-a-grid",
    },
    {
      acRate: 29.1610315720748,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3072",
      paidOnly: false,
      title: "Distribute Elements Into Two Arrays II",
      titleSlug: "distribute-elements-into-two-arrays-ii",
    },
    {
      acRate: 35.44179980436909,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3073",
      paidOnly: true,
      title: "Maximum Increasing Triplet Value",
      titleSlug: "maximum-increasing-triplet-value",
    },
    {
      acRate: 68.00307201228804,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3074",
      paidOnly: false,
      title: "Apple Redistribution into Boxes",
      titleSlug: "apple-redistribution-into-boxes",
    },
    {
      acRate: 54.82431763908314,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3075",
      paidOnly: false,
      title: "Maximize Happiness of Selected Children",
      titleSlug: "maximize-happiness-of-selected-children",
    },
    {
      acRate: 47.790622028724414,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3076",
      paidOnly: false,
      title: "Shortest Uncommon Substring in an Array",
      titleSlug: "shortest-uncommon-substring-in-an-array",
    },
    {
      acRate: 26.708188312877816,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3077",
      paidOnly: false,
      title: "Maximum Strength of K Disjoint Subarrays",
      titleSlug: "maximum-strength-of-k-disjoint-subarrays",
    },
    {
      acRate: 63.63061353573688,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3078",
      paidOnly: true,
      title: "Match Alphanumerical Pattern in Matrix I",
      titleSlug: "match-alphanumerical-pattern-in-matrix-i",
    },
    {
      acRate: 73.43779884696303,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3079",
      paidOnly: false,
      title: "Find the Sum of Encrypted Integers",
      titleSlug: "find-the-sum-of-encrypted-integers",
    },
    {
      acRate: 47.51021179137251,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3080",
      paidOnly: false,
      title: "Mark Elements on Array by Performing Queries",
      titleSlug: "mark-elements-on-array-by-performing-queries",
    },
    {
      acRate: 27.727484166457938,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3081",
      paidOnly: false,
      title: "Replace Question Marks in String to Minimize Its Value",
      titleSlug: "replace-question-marks-in-string-to-minimize-its-value",
    },
    {
      acRate: 36.341156565875664,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3082",
      paidOnly: false,
      title: "Find the Sum of the Power of All Subsequences",
      titleSlug: "find-the-sum-of-the-power-of-all-subsequences",
    },
    {
      acRate: 65.5474055258929,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3083",
      paidOnly: false,
      title: "Existence of a Substring in a String and Its Reverse",
      titleSlug: "existence-of-a-substring-in-a-string-and-its-reverse",
    },
    {
      acRate: 48.80424209352535,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3084",
      paidOnly: false,
      title: "Count Substrings Starting and Ending with Given Character",
      titleSlug: "count-substrings-starting-and-ending-with-given-character",
    },
    {
      acRate: 44.354982647496286,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3085",
      paidOnly: false,
      title: "Minimum Deletions to Make String K-Special",
      titleSlug: "minimum-deletions-to-make-string-k-special",
    },
    {
      acRate: 20.675321717344268,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3086",
      paidOnly: false,
      title: "Minimum Moves to Pick K Ones",
      titleSlug: "minimum-moves-to-pick-k-ones",
    },
    {
      acRate: 61.41183918961697,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3087",
      paidOnly: true,
      title: "Find Trending Hashtags",
      titleSlug: "find-trending-hashtags",
    },
    {
      acRate: 42.361574382921944,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3088",
      paidOnly: true,
      title: "Make String Anti-palindrome",
      titleSlug: "make-string-anti-palindrome",
    },
    {
      acRate: 38.71273071462375,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3089",
      paidOnly: true,
      title: "Find Bursty Behavior",
      titleSlug: "find-bursty-behavior",
    },
    {
      acRate: 63.27679375562894,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3090",
      paidOnly: false,
      title: "Maximum Length Substring With Two Occurrences",
      titleSlug: "maximum-length-substring-with-two-occurrences",
    },
    {
      acRate: 43.279562107214225,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3091",
      paidOnly: false,
      title: "Apply Operations to Make Sum of Array Greater Than or Equal to k",
      titleSlug:
        "apply-operations-to-make-sum-of-array-greater-than-or-equal-to-k",
    },
    {
      acRate: 41.47013610288328,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3092",
      paidOnly: false,
      title: "Most Frequent IDs",
      titleSlug: "most-frequent-ids",
    },
    {
      acRate: 36.851789383299085,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3093",
      paidOnly: false,
      title: "Longest Common Suffix Queries",
      titleSlug: "longest-common-suffix-queries",
    },
    {
      acRate: 82.87179487179486,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3094",
      paidOnly: true,
      title: "Guess the Number Using Bitwise Questions II",
      titleSlug: "guess-the-number-using-bitwise-questions-ii",
    },
    {
      acRate: 42.54281800932384,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3095",
      paidOnly: false,
      title: "Shortest Subarray With OR at Least K I",
      titleSlug: "shortest-subarray-with-or-at-least-k-i",
    },
    {
      acRate: 38.95830030125257,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3096",
      paidOnly: false,
      title: "Minimum Levels to Gain More Points",
      titleSlug: "minimum-levels-to-gain-more-points",
    },
    {
      acRate: 50.247713613796705,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3097",
      paidOnly: false,
      title: "Shortest Subarray With OR at Least K II",
      titleSlug: "shortest-subarray-with-or-at-least-k-ii",
    },
    {
      acRate: 23.270691723310676,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3098",
      paidOnly: false,
      title: "Find the Sum of Subsequence Powers",
      titleSlug: "find-the-sum-of-subsequence-powers",
    },
    {
      acRate: 83.0607152758525,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3099",
      paidOnly: false,
      title: "Harshad Number",
      titleSlug: "harshad-number",
    },
    {
      acRate: 62.12756856357863,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3100",
      paidOnly: false,
      title: "Water Bottles II",
      titleSlug: "water-bottles-ii",
    },
    {
      acRate: 56.17498487385498,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3101",
      paidOnly: false,
      title: "Count Alternating Subarrays",
      titleSlug: "count-alternating-subarrays",
    },
    {
      acRate: 31.282202750155886,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3102",
      paidOnly: false,
      title: "Minimize Manhattan Distances",
      titleSlug: "minimize-manhattan-distances",
    },
    {
      acRate: 66.27497062279672,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3103",
      paidOnly: true,
      title: "Find Trending Hashtags II ",
      titleSlug: "find-trending-hashtags-ii",
    },
    {
      acRate: 58.50453893932155,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3104",
      paidOnly: true,
      title: "Find Longest Self-Contained Substring",
      titleSlug: "find-longest-self-contained-substring",
    },
    {
      acRate: 65.08581319741187,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3105",
      paidOnly: false,
      title: "Longest Strictly Increasing or Strictly Decreasing Subarray",
      titleSlug: "longest-strictly-increasing-or-strictly-decreasing-subarray",
    },
    {
      acRate: 62.15823086888338,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3106",
      paidOnly: false,
      title:
        "Lexicographically Smallest String After Operations With Constraint",
      titleSlug:
        "lexicographically-smallest-string-after-operations-with-constraint",
    },
    {
      acRate: 46.55291715187417,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3107",
      paidOnly: false,
      title: "Minimum Operations to Make Median of Array Equal to K",
      titleSlug: "minimum-operations-to-make-median-of-array-equal-to-k",
    },
    {
      acRate: 68.5481678808307,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3108",
      paidOnly: false,
      title: "Minimum Cost Walk in Weighted Graph",
      titleSlug: "minimum-cost-walk-in-weighted-graph",
    },
    {
      acRate: 36.74418604651163,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3109",
      paidOnly: true,
      title: "Find the Index of Permutation",
      titleSlug: "find-the-index-of-permutation",
    },
    {
      acRate: 91.94118048376009,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3110",
      paidOnly: false,
      title: "Score of a String",
      titleSlug: "score-of-a-string",
    },
    {
      acRate: 62.206864583552814,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3111",
      paidOnly: false,
      title: "Minimum Rectangles to Cover Points",
      titleSlug: "minimum-rectangles-to-cover-points",
    },
    {
      acRate: 35.439837436207675,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3112",
      paidOnly: false,
      title: "Minimum Time to Visit Disappearing Nodes",
      titleSlug: "minimum-time-to-visit-disappearing-nodes",
    },
    {
      acRate: 30.671296296296298,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3113",
      paidOnly: false,
      title: "Find the Number of Subarrays Where Boundary Elements Are Maximum",
      titleSlug:
        "find-the-number-of-subarrays-where-boundary-elements-are-maximum",
    },
    {
      acRate: 34.27369530455008,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3114",
      paidOnly: false,
      title: "Latest Time You Can Obtain After Replacing Characters",
      titleSlug: "latest-time-you-can-obtain-after-replacing-characters",
    },
    {
      acRate: 57.27478723684557,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3115",
      paidOnly: false,
      title: "Maximum Prime Difference",
      titleSlug: "maximum-prime-difference",
    },
    {
      acRate: 18.282528549590864,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3116",
      paidOnly: false,
      title: "Kth Smallest Amount With Single Denomination Combination",
      titleSlug: "kth-smallest-amount-with-single-denomination-combination",
    },
    {
      acRate: 26.944850255661066,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3117",
      paidOnly: false,
      title: "Minimum Sum of Values by Dividing Array",
      titleSlug: "minimum-sum-of-values-by-dividing-array",
    },
    {
      acRate: 56.803907885554786,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3118",
      paidOnly: true,
      title: "Friday Purchase III ",
      titleSlug: "friday-purchase-iii",
    },
    {
      acRate: 53.604963112005365,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3119",
      paidOnly: true,
      title: "Maximum Number of Potholes That Can Be Fixed",
      titleSlug: "maximum-number-of-potholes-that-can-be-fixed",
    },
    {
      acRate: 65.17751619155675,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3120",
      paidOnly: false,
      title: "Count the Number of Special Characters I",
      titleSlug: "count-the-number-of-special-characters-i",
    },
    {
      acRate: 41.88284322906912,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3121",
      paidOnly: false,
      title: "Count the Number of Special Characters II",
      titleSlug: "count-the-number-of-special-characters-ii",
    },
    {
      acRate: 40.19173860940595,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3122",
      paidOnly: false,
      title: "Minimum Number of Operations to Satisfy Conditions",
      titleSlug: "minimum-number-of-operations-to-satisfy-conditions",
    },
    {
      acRate: 45.39045553145336,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3123",
      paidOnly: false,
      title: "Find Edges in Shortest Paths",
      titleSlug: "find-edges-in-shortest-paths",
    },
    {
      acRate: 61.82233834095362,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3124",
      paidOnly: true,
      title: "Find Longest Calls",
      titleSlug: "find-longest-calls",
    },
    {
      acRate: 68.01675977653632,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3125",
      paidOnly: true,
      title: "Maximum Number That Makes Result of Bitwise AND Zero",
      titleSlug: "maximum-number-that-makes-result-of-bitwise-and-zero",
    },
    {
      acRate: 61.45999362448199,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3126",
      paidOnly: true,
      title: "Server Utilization Time",
      titleSlug: "server-utilization-time",
    },
    {
      acRate: 51.71144142915587,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3127",
      paidOnly: false,
      title: "Make a Square with the Same Color",
      titleSlug: "make-a-square-with-the-same-color",
    },
    {
      acRate: 46.80945708502925,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3128",
      paidOnly: false,
      title: "Right Triangles",
      titleSlug: "right-triangles",
    },
    {
      acRate: 26.09459143057832,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3129",
      paidOnly: false,
      title: "Find All Possible Stable Binary Arrays I",
      titleSlug: "find-all-possible-stable-binary-arrays-i",
    },
    {
      acRate: 25.67501908794336,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3130",
      paidOnly: false,
      title: "Find All Possible Stable Binary Arrays II",
      titleSlug: "find-all-possible-stable-binary-arrays-ii",
    },
    {
      acRate: 81.93985828270603,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3131",
      paidOnly: false,
      title: "Find the Integer Added to Array I",
      titleSlug: "find-the-integer-added-to-array-i",
    },
    {
      acRate: 31.712869961162447,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3132",
      paidOnly: false,
      title: "Find the Integer Added to Array II",
      titleSlug: "find-the-integer-added-to-array-ii",
    },
    {
      acRate: 55.51615652521596,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3133",
      paidOnly: false,
      title: "Minimum Array End",
      titleSlug: "minimum-array-end",
    },
    {
      acRate: 27.811655731377847,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3134",
      paidOnly: false,
      title: "Find the Median of the Uniqueness Array",
      titleSlug: "find-the-median-of-the-uniqueness-array",
    },
    {
      acRate: 55.00505561172901,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3135",
      paidOnly: true,
      title: "Equalize Strings by Adding or Removing Characters at Ends",
      titleSlug: "equalize-strings-by-adding-or-removing-characters-at-ends",
    },
    {
      acRate: 38.568732871070644,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3136",
      paidOnly: false,
      title: "Valid Word",
      titleSlug: "valid-word",
    },
    {
      acRate: 59.590600664875446,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3137",
      paidOnly: false,
      title: "Minimum Number of Operations to Make Word K-Periodic",
      titleSlug: "minimum-number-of-operations-to-make-word-k-periodic",
    },
    {
      acRate: 39.65286702756033,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3138",
      paidOnly: false,
      title: "Minimum Length of Anagram Concatenation",
      titleSlug: "minimum-length-of-anagram-concatenation",
    },
    {
      acRate: 17.66654756877903,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3139",
      paidOnly: false,
      title: "Minimum Cost to Equalize Array",
      titleSlug: "minimum-cost-to-equalize-array",
    },
    {
      acRate: 57.10357470210816,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3140",
      paidOnly: true,
      title: "Consecutive Available Seats II",
      titleSlug: "consecutive-available-seats-ii",
    },
    {
      acRate: 46.66073018699911,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3141",
      paidOnly: true,
      title: "Maximum Hamming Distances",
      titleSlug: "maximum-hamming-distances",
    },
    {
      acRate: 43.40771021404644,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3142",
      paidOnly: false,
      title: "Check if Grid Satisfies Conditions",
      titleSlug: "check-if-grid-satisfies-conditions",
    },
    {
      acRate: 38.04765108639728,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3143",
      paidOnly: false,
      title: "Maximum Points Inside the Square",
      titleSlug: "maximum-points-inside-the-square",
    },
    {
      acRate: 38.81778042367416,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3144",
      paidOnly: false,
      title: "Minimum Substring Partition of Equal Character Frequency",
      titleSlug: "minimum-substring-partition-of-equal-character-frequency",
    },
    {
      acRate: 21.550127854686536,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3145",
      paidOnly: false,
      title: "Find Products of Elements of Big Array",
      titleSlug: "find-products-of-elements-of-big-array",
    },
    {
      acRate: 87.13001196310732,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3146",
      paidOnly: false,
      title: "Permutation Difference between Two Strings",
      titleSlug: "permutation-difference-between-two-strings",
    },
    {
      acRate: 40.95776743231632,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3147",
      paidOnly: false,
      title: "Taking Maximum Energy From the Mystic Dungeon",
      titleSlug: "taking-maximum-energy-from-the-mystic-dungeon",
    },
    {
      acRate: 46.592158299743495,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3148",
      paidOnly: false,
      title: "Maximum Difference Score in a Grid",
      titleSlug: "maximum-difference-score-in-a-grid",
    },
    {
      acRate: 23.49385118628628,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3149",
      paidOnly: false,
      title: "Find the Minimum Cost Array Permutation",
      titleSlug: "find-the-minimum-cost-array-permutation",
    },
    {
      acRate: 86.3722998729352,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3150",
      paidOnly: true,
      title: "Invalid Tweets II",
      titleSlug: "invalid-tweets-ii",
    },
    {
      acRate: 81.83951844488624,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3151",
      paidOnly: false,
      title: "Special Array I",
      titleSlug: "special-array-i",
    },
    {
      acRate: 45.663624315129326,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3152",
      paidOnly: false,
      title: "Special Array II",
      titleSlug: "special-array-ii",
    },
    {
      acRate: 42.34954152137414,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3153",
      paidOnly: false,
      title: "Sum of Digit Differences of All Pairs",
      titleSlug: "sum-of-digit-differences-of-all-pairs",
    },
    {
      acRate: 35.94855651518821,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3154",
      paidOnly: false,
      title: "Find Number of Ways to Reach the K-th Stair",
      titleSlug: "find-number-of-ways-to-reach-the-k-th-stair",
    },
    {
      acRate: 40.61387146006444,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3155",
      paidOnly: true,
      title: "Maximum Number of Upgradable Servers",
      titleSlug: "maximum-number-of-upgradable-servers",
    },
    {
      acRate: 44.25619834710744,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3156",
      paidOnly: true,
      title: "Employee Task Duration and Concurrent Tasks",
      titleSlug: "employee-task-duration-and-concurrent-tasks",
    },
    {
      acRate: 68.45168800931314,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3157",
      paidOnly: true,
      title: "Find the Level of Tree with Minimum Sum",
      titleSlug: "find-the-level-of-tree-with-minimum-sum",
    },
    {
      acRate: 77.49890427204991,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3158",
      paidOnly: false,
      title: "Find the XOR of Numbers Which Appear Twice",
      titleSlug: "find-the-xor-of-numbers-which-appear-twice",
    },
    {
      acRate: 72.38704300299723,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3159",
      paidOnly: false,
      title: "Find Occurrences of an Element in an Array",
      titleSlug: "find-occurrences-of-an-element-in-an-array",
    },
    {
      acRate: 54.20842047530785,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3160",
      paidOnly: false,
      title: "Find the Number of Distinct Colors Among the Balls",
      titleSlug: "find-the-number-of-distinct-colors-among-the-balls",
    },
    {
      acRate: 16.44332363877333,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3161",
      paidOnly: false,
      title: "Block Placement Queries",
      titleSlug: "block-placement-queries",
    },
    {
      acRate: 85.5349135169763,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3162",
      paidOnly: false,
      title: "Find the Number of Good Pairs I",
      titleSlug: "find-the-number-of-good-pairs-i",
    },
    {
      acRate: 66.778969859685,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3163",
      paidOnly: false,
      title: "String Compression III",
      titleSlug: "string-compression-iii",
    },
    {
      acRate: 26.012397671887573,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3164",
      paidOnly: false,
      title: "Find the Number of Good Pairs II",
      titleSlug: "find-the-number-of-good-pairs-ii",
    },
    {
      acRate: 15.820032384917882,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3165",
      paidOnly: false,
      title: "Maximum Sum of Subsequence With Non-adjacent Elements",
      titleSlug: "maximum-sum-of-subsequence-with-non-adjacent-elements",
    },
    {
      acRate: 52.29247827389871,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3166",
      paidOnly: true,
      title: "Calculate Parking Fees and Duration",
      titleSlug: "calculate-parking-fees-and-duration",
    },
    {
      acRate: 75.68696770046601,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3167",
      paidOnly: true,
      title: "Better Compression of String",
      titleSlug: "better-compression-of-string",
    },
    {
      acRate: 78.25047500408944,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3168",
      paidOnly: false,
      title: "Minimum Number of Chairs in a Waiting Room",
      titleSlug: "minimum-number-of-chairs-in-a-waiting-room",
    },
    {
      acRate: 47.894067060215164,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3169",
      paidOnly: false,
      title: "Count Days Without Meetings",
      titleSlug: "count-days-without-meetings",
    },
    {
      acRate: 35.18887640585173,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3170",
      paidOnly: false,
      title: "Lexicographically Minimum String After Removing Stars",
      titleSlug: "lexicographically-minimum-string-after-removing-stars",
    },
    {
      acRate: 29.500844923956844,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3171",
      paidOnly: false,
      title: "Find Subarray With Bitwise OR Closest to K",
      titleSlug: "find-subarray-with-bitwise-or-closest-to-k",
    },
    {
      acRate: 68.34726341331896,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3172",
      paidOnly: true,
      title: "Second Day Verification",
      titleSlug: "second-day-verification",
    },
    {
      acRate: 95.24570515381542,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3173",
      paidOnly: true,
      title: "Bitwise OR of Adjacent Elements",
      titleSlug: "bitwise-or-of-adjacent-elements",
    },
    {
      acRate: 82.56304452184216,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3174",
      paidOnly: false,
      title: "Clear Digits",
      titleSlug: "clear-digits",
    },
    {
      acRate: 39.339417132764204,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3175",
      paidOnly: false,
      title: "Find The First Player to win K Games in a Row",
      titleSlug: "find-the-first-player-to-win-k-games-in-a-row",
    },
    {
      acRate: 31.388601980679265,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3176",
      paidOnly: false,
      title: "Find the Maximum Length of a Good Subsequence I",
      titleSlug: "find-the-maximum-length-of-a-good-subsequence-i",
    },
    {
      acRate: 23.826949182553268,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3177",
      paidOnly: false,
      title: "Find the Maximum Length of a Good Subsequence II",
      titleSlug: "find-the-maximum-length-of-a-good-subsequence-ii",
    },
    {
      acRate: 61.479984382536,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3178",
      paidOnly: false,
      title: "Find the Child Who Has the Ball After K Seconds",
      titleSlug: "find-the-child-who-has-the-ball-after-k-seconds",
    },
    {
      acRate: 53.62401271991624,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3179",
      paidOnly: false,
      title: "Find the N-th Value After K Seconds",
      titleSlug: "find-the-n-th-value-after-k-seconds",
    },
    {
      acRate: 29.809204823918417,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3180",
      paidOnly: false,
      title: "Maximum Total Reward Using Operations I",
      titleSlug: "maximum-total-reward-using-operations-i",
    },
    {
      acRate: 20.5401159326074,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3181",
      paidOnly: false,
      title: "Maximum Total Reward Using Operations II",
      titleSlug: "maximum-total-reward-using-operations-ii",
    },
    {
      acRate: 49.18114143920596,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3182",
      paidOnly: true,
      title: "Find Top Scoring Students",
      titleSlug: "find-top-scoring-students",
    },
    {
      acRate: 51.89675400860383,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3183",
      paidOnly: true,
      title: "The Number of Ways to Make the Sum",
      titleSlug: "the-number-of-ways-to-make-the-sum",
    },
    {
      acRate: 77.4350425385146,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3184",
      paidOnly: false,
      title: "Count Pairs That Form a Complete Day I",
      titleSlug: "count-pairs-that-form-a-complete-day-i",
    },
    {
      acRate: 42.91427796715215,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3185",
      paidOnly: false,
      title: "Count Pairs That Form a Complete Day II",
      titleSlug: "count-pairs-that-form-a-complete-day-ii",
    },
    {
      acRate: 27.528775059074622,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3186",
      paidOnly: false,
      title: "Maximum Total Damage With Spell Casting",
      titleSlug: "maximum-total-damage-with-spell-casting",
    },
    {
      acRate: 25.638059795317965,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3187",
      paidOnly: false,
      title: "Peaks in Array",
      titleSlug: "peaks-in-array",
    },
    {
      acRate: 38.9344262295082,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3188",
      paidOnly: true,
      title: "Find Top Scoring Students II",
      titleSlug: "find-top-scoring-students-ii",
    },
    {
      acRate: 76.0284408329101,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3189",
      paidOnly: true,
      title: "Minimum Moves to Get a Peaceful Board",
      titleSlug: "minimum-moves-to-get-a-peaceful-board",
    },
    {
      acRate: 88.72421695951108,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3190",
      paidOnly: false,
      title: "Find Minimum Operations to Make All Elements Divisible by Three",
      titleSlug:
        "find-minimum-operations-to-make-all-elements-divisible-by-three",
    },
    {
      acRate: 80.54516033266572,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3191",
      paidOnly: false,
      title: "Minimum Operations to Make Binary Array Elements Equal to One I",
      titleSlug:
        "minimum-operations-to-make-binary-array-elements-equal-to-one-i",
    },
    {
      acRate: 63.85645299352358,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3192",
      paidOnly: false,
      title: "Minimum Operations to Make Binary Array Elements Equal to One II",
      titleSlug:
        "minimum-operations-to-make-binary-array-elements-equal-to-one-ii",
    },
    {
      acRate: 27.624054274855254,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3193",
      paidOnly: false,
      title: "Count the Number of Inversions",
      titleSlug: "count-the-number-of-inversions",
    },
    {
      acRate: 84.73263996288277,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3194",
      paidOnly: false,
      title: "Minimum Average of Smallest and Largest Elements",
      titleSlug: "minimum-average-of-smallest-and-largest-elements",
    },
    {
      acRate: 68.86381693945654,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3195",
      paidOnly: false,
      title: "Find the Minimum Area to Cover All Ones I",
      titleSlug: "find-the-minimum-area-to-cover-all-ones-i",
    },
    {
      acRate: 28.543660835442108,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3196",
      paidOnly: false,
      title: "Maximize Total Cost of Alternating Subarrays",
      titleSlug: "maximize-total-cost-of-alternating-subarrays",
    },
    {
      acRate: 28.495063546609938,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3197",
      paidOnly: false,
      title: "Find the Minimum Area to Cover All Ones II",
      titleSlug: "find-the-minimum-area-to-cover-all-ones-ii",
    },
    {
      acRate: 82.86377195889956,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3198",
      paidOnly: true,
      title: "Find Cities in Each State",
      titleSlug: "find-cities-in-each-state",
    },
    {
      acRate: 83.05304010349288,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3199",
      paidOnly: true,
      title: "Count Triplets with Even XOR Set Bits I",
      titleSlug: "count-triplets-with-even-xor-set-bits-i",
    },
    {
      acRate: 43.129022339557025,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3200",
      paidOnly: false,
      title: "Maximum Height of a Triangle",
      titleSlug: "maximum-height-of-a-triangle",
    },
    {
      acRate: 37.563833577451405,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3201",
      paidOnly: false,
      title: "Find the Maximum Length of Valid Subsequence I",
      titleSlug: "find-the-maximum-length-of-valid-subsequence-i",
    },
    {
      acRate: 39.40067271430028,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3202",
      paidOnly: false,
      title: "Find the Maximum Length of Valid Subsequence II",
      titleSlug: "find-the-maximum-length-of-valid-subsequence-ii",
    },
    {
      acRate: 57.53124537069524,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3203",
      paidOnly: false,
      title: "Find Minimum Diameter After Merging Two Trees",
      titleSlug: "find-minimum-diameter-after-merging-two-trees",
    },
    {
      acRate: 93.41275402943238,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3204",
      paidOnly: true,
      title: "Bitwise User Permissions Analysis",
      titleSlug: "bitwise-user-permissions-analysis",
    },
    {
      acRate: 77.60162601626016,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3205",
      paidOnly: true,
      title: "Maximum Array Hopping Score I",
      titleSlug: "maximum-array-hopping-score-i",
    },
    {
      acRate: 67.49577318246847,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3206",
      paidOnly: false,
      title: "Alternating Groups I",
      titleSlug: "alternating-groups-i",
    },
    {
      acRate: 32.436867957237794,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3207",
      paidOnly: false,
      title: "Maximum Points After Enemy Battles",
      titleSlug: "maximum-points-after-enemy-battles",
    },
    {
      acRate: 59.869181067106446,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3208",
      paidOnly: false,
      title: "Alternating Groups II",
      titleSlug: "alternating-groups-ii",
    },
    {
      acRate: 33.673163418290855,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3209",
      paidOnly: false,
      title: "Number of Subarrays With AND Value of K",
      titleSlug: "number-of-subarrays-with-and-value-of-k",
    },
    {
      acRate: 67.84029519316813,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3210",
      paidOnly: false,
      title: "Find the Encrypted String",
      titleSlug: "find-the-encrypted-string",
    },
    {
      acRate: 87.00737780510298,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3211",
      paidOnly: false,
      title: "Generate Binary Strings Without Adjacent Zeros",
      titleSlug: "generate-binary-strings-without-adjacent-zeros",
    },
    {
      acRate: 50.37357855412784,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3212",
      paidOnly: false,
      title: "Count Submatrices With Equal Frequency of X and Y",
      titleSlug: "count-submatrices-with-equal-frequency-of-x-and-y",
    },
    {
      acRate: 19.19639399618953,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3213",
      paidOnly: false,
      title: "Construct String with Minimum Cost",
      titleSlug: "construct-string-with-minimum-cost",
    },
    {
      acRate: 53.00185136207352,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3214",
      paidOnly: true,
      title: "Year on Year Growth Rate",
      titleSlug: "year-on-year-growth-rate",
    },
    {
      acRate: 59.72222222222222,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3215",
      paidOnly: true,
      title: "Count Triplets with Even XOR Set Bits II",
      titleSlug: "count-triplets-with-even-xor-set-bits-ii",
    },
    {
      acRate: 53.49827166816029,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3216",
      paidOnly: false,
      title: "Lexicographically Smallest String After a Swap",
      titleSlug: "lexicographically-smallest-string-after-a-swap",
    },
    {
      acRate: 67.82953981422392,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3217",
      paidOnly: false,
      title: "Delete Nodes From Linked List Present in Array",
      titleSlug: "delete-nodes-from-linked-list-present-in-array",
    },
    {
      acRate: 57.517070395057715,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3218",
      paidOnly: false,
      title: "Minimum Cost for Cutting Cake I",
      titleSlug: "minimum-cost-for-cutting-cake-i",
    },
    {
      acRate: 54.56937034396283,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3219",
      paidOnly: false,
      title: "Minimum Cost for Cutting Cake II",
      titleSlug: "minimum-cost-for-cutting-cake-ii",
    },
    {
      acRate: 69.50421354322624,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3220",
      paidOnly: false,
      title: "Odd and Even Transactions",
      titleSlug: "odd-and-even-transactions",
    },
    {
      acRate: 56.771545827633375,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3221",
      paidOnly: true,
      title: "Maximum Array Hopping Score II",
      titleSlug: "maximum-array-hopping-score-ii",
    },
    {
      acRate: 51.65344709078412,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3222",
      paidOnly: false,
      title: "Find the Winning Player in Coin Game",
      titleSlug: "find-the-winning-player-in-coin-game",
    },
    {
      acRate: 74.928814750622,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3223",
      paidOnly: false,
      title: "Minimum Length of String After Operations",
      titleSlug: "minimum-length-of-string-after-operations",
    },
    {
      acRate: 23.19183700690253,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3224",
      paidOnly: false,
      title: "Minimum Array Changes to Make Differences Equal",
      titleSlug: "minimum-array-changes-to-make-differences-equal",
    },
    {
      acRate: 23.963179253687024,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3225",
      paidOnly: false,
      title: "Maximum Score From Grid Operations",
      titleSlug: "maximum-score-from-grid-operations",
    },
    {
      acRate: 62.53005538295285,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3226",
      paidOnly: false,
      title: "Number of Bit Changes to Make Two Integers Equal",
      titleSlug: "number-of-bit-changes-to-make-two-integers-equal",
    },
    {
      acRate: 61.96473923572145,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3227",
      paidOnly: false,
      title: "Vowels Game in a String",
      titleSlug: "vowels-game-in-a-string",
    },
    {
      acRate: 53.058173888576256,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3228",
      paidOnly: false,
      title: "Maximum Number of Operations to Move Ones to the End",
      titleSlug: "maximum-number-of-operations-to-move-ones-to-the-end",
    },
    {
      acRate: 38.76679807461939,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3229",
      paidOnly: false,
      title: "Minimum Operations to Make Array Equal to Target",
      titleSlug: "minimum-operations-to-make-array-equal-to-target",
    },
    {
      acRate: 37.07339878447873,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3230",
      paidOnly: true,
      title: "Customer Purchasing Behavior Analysis",
      titleSlug: "customer-purchasing-behavior-analysis",
    },
    {
      acRate: 42.561983471074385,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3231",
      paidOnly: true,
      title: "Minimum Number of Increasing Subsequence to Be Removed",
      titleSlug: "minimum-number-of-increasing-subsequence-to-be-removed",
    },
    {
      acRate: 81.27032321253674,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3232",
      paidOnly: false,
      title: "Find if Digit Game Can Be Won",
      titleSlug: "find-if-digit-game-can-be-won",
    },
    {
      acRate: 26.873182216887493,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3233",
      paidOnly: false,
      title: "Find the Count of Numbers Which Are Not Special",
      titleSlug: "find-the-count-of-numbers-which-are-not-special",
    },
    {
      acRate: 16.683176971038986,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3234",
      paidOnly: false,
      title: "Count the Number of Substrings With Dominant Ones",
      titleSlug: "count-the-number-of-substrings-with-dominant-ones",
    },
    {
      acRate: 25.96395490773318,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3235",
      paidOnly: false,
      title: "Check if the Rectangle Corner Is Reachable",
      titleSlug: "check-if-the-rectangle-corner-is-reachable",
    },
    {
      acRate: 72.38095238095238,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3236",
      paidOnly: true,
      title: "CEO Subordinate Hierarchy",
      titleSlug: "ceo-subordinate-hierarchy",
    },
    {
      acRate: 48.58027878162106,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3237",
      paidOnly: true,
      title: "Alt and Tab Simulation",
      titleSlug: "alt-and-tab-simulation",
    },
    {
      acRate: 59.641732500966796,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3238",
      paidOnly: false,
      title: "Find the Number of Winning Players",
      titleSlug: "find-the-number-of-winning-players",
    },
    {
      acRate: 74.20563081340907,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3239",
      paidOnly: false,
      title: "Minimum Number of Flips to Make Binary Grid Palindromic I",
      titleSlug: "minimum-number-of-flips-to-make-binary-grid-palindromic-i",
    },
    {
      acRate: 24.27069418709872,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3240",
      paidOnly: false,
      title: "Minimum Number of Flips to Make Binary Grid Palindromic II",
      titleSlug: "minimum-number-of-flips-to-make-binary-grid-palindromic-ii",
    },
    {
      acRate: 23.91200153374233,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3241",
      paidOnly: false,
      title: "Time Taken to Mark All Nodes",
      titleSlug: "time-taken-to-mark-all-nodes",
    },
    {
      acRate: 75.51476753936458,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3242",
      paidOnly: false,
      title: "Design Neighbor Sum Service",
      titleSlug: "design-neighbor-sum-service",
    },
    {
      acRate: 61.84711885556398,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3243",
      paidOnly: false,
      title: "Shortest Distance After Road Addition Queries I",
      titleSlug: "shortest-distance-after-road-addition-queries-i",
    },
    {
      acRate: 25.588872965126964,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3244",
      paidOnly: false,
      title: "Shortest Distance After Road Addition Queries II",
      titleSlug: "shortest-distance-after-road-addition-queries-ii",
    },
    {
      acRate: 14.865987164967912,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3245",
      paidOnly: false,
      title: "Alternating Groups III",
      titleSlug: "alternating-groups-iii",
    },
    {
      acRate: 81.66371681415929,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3246",
      paidOnly: true,
      title: "Premier League Table Ranking",
      titleSlug: "premier-league-table-ranking",
    },
    {
      acRate: 47.290053603335316,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3247",
      paidOnly: true,
      title: "Number of Subsequences with Odd Sum",
      titleSlug: "number-of-subsequences-with-odd-sum",
    },
    {
      acRate: 81.44817734241472,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3248",
      paidOnly: false,
      title: "Snake in Matrix",
      titleSlug: "snake-in-matrix",
    },
    {
      acRate: 54.53287197231834,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3249",
      paidOnly: false,
      title: "Count the Number of Good Nodes",
      titleSlug: "count-the-number-of-good-nodes",
    },
    {
      acRate: 45.9076195858809,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3250",
      paidOnly: false,
      title: "Find the Count of Monotonic Pairs I",
      titleSlug: "find-the-count-of-monotonic-pairs-i",
    },
    {
      acRate: 22.76360741649806,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3251",
      paidOnly: false,
      title: "Find the Count of Monotonic Pairs II",
      titleSlug: "find-the-count-of-monotonic-pairs-ii",
    },
    {
      acRate: 58.49232201023732,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3252",
      paidOnly: true,
      title: "Premier League Table Ranking II",
      titleSlug: "premier-league-table-ranking-ii",
    },
    {
      acRate: 57.95880149812734,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3253",
      paidOnly: true,
      title: "Construct String with Minimum Cost (Easy)",
      titleSlug: "construct-string-with-minimum-cost-easy",
    },
    {
      acRate: 62.50936313371638,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3254",
      paidOnly: false,
      title: "Find the Power of K-Size Subarrays I",
      titleSlug: "find-the-power-of-k-size-subarrays-i",
    },
    {
      acRate: 30.311211891195946,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3255",
      paidOnly: false,
      title: "Find the Power of K-Size Subarrays II",
      titleSlug: "find-the-power-of-k-size-subarrays-ii",
    },
    {
      acRate: 15.030439362290895,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3256",
      paidOnly: false,
      title: "Maximum Value Sum by Placing Three Rooks I",
      titleSlug: "maximum-value-sum-by-placing-three-rooks-i",
    },
    {
      acRate: 26.263547590943237,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3257",
      paidOnly: false,
      title: "Maximum Value Sum by Placing Three Rooks II",
      titleSlug: "maximum-value-sum-by-placing-three-rooks-ii",
    },
    {
      acRate: 77.7648504711184,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3258",
      paidOnly: false,
      title: "Count Substrings That Satisfy K-Constraint I",
      titleSlug: "count-substrings-that-satisfy-k-constraint-i",
    },
    {
      acRate: 49.258249619711734,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3259",
      paidOnly: false,
      title: "Maximum Energy Boost From Two Drinks",
      titleSlug: "maximum-energy-boost-from-two-drinks",
    },
    {
      acRate: 15.251653268918544,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3260",
      paidOnly: false,
      title: "Find the Largest Palindrome Divisible by K",
      titleSlug: "find-the-largest-palindrome-divisible-by-k",
    },
    {
      acRate: 21.251965752227854,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3261",
      paidOnly: false,
      title: "Count Substrings That Satisfy K-Constraint II",
      titleSlug: "count-substrings-that-satisfy-k-constraint-ii",
    },
    {
      acRate: 61.28755364806867,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3262",
      paidOnly: true,
      title: "Find Overlapping Shifts",
      titleSlug: "find-overlapping-shifts",
    },
    {
      acRate: 94.92471663001184,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3263",
      paidOnly: true,
      title: "Convert Doubly Linked List to Array I",
      titleSlug: "convert-doubly-linked-list-to-array-i",
    },
    {
      acRate: 87.09905985629163,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3264",
      paidOnly: false,
      title: "Final Array State After K Multiplication Operations I",
      titleSlug: "final-array-state-after-k-multiplication-operations-i",
    },
    {
      acRate: 37.430745059125115,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3265",
      paidOnly: false,
      title: "Count Almost Equal Pairs I",
      titleSlug: "count-almost-equal-pairs-i",
    },
    {
      acRate: 11.69475341939164,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3266",
      paidOnly: false,
      title: "Final Array State After K Multiplication Operations II",
      titleSlug: "final-array-state-after-k-multiplication-operations-ii",
    },
    {
      acRate: 26.770101421168093,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3267",
      paidOnly: false,
      title: "Count Almost Equal Pairs II",
      titleSlug: "count-almost-equal-pairs-ii",
    },
    {
      acRate: 59.057437407952875,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3268",
      paidOnly: true,
      title: "Find Overlapping Shifts II",
      titleSlug: "find-overlapping-shifts-ii",
    },
    {
      acRate: 62.45954692556634,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3269",
      paidOnly: true,
      title: "Constructing Two Increasing Arrays",
      titleSlug: "constructing-two-increasing-arrays",
    },
    {
      acRate: 75.93363051015353,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3270",
      paidOnly: false,
      title: "Find the Key of the Numbers",
      titleSlug: "find-the-key-of-the-numbers",
    },
    {
      acRate: 82.93653831432289,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3271",
      paidOnly: false,
      title: "Hash Divided String",
      titleSlug: "hash-divided-string",
    },
    {
      acRate: 69.7542701249407,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3272",
      paidOnly: false,
      title: "Find the Count of Good Integers",
      titleSlug: "find-the-count-of-good-integers",
    },
    {
      acRate: 37.72763262074426,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3273",
      paidOnly: false,
      title: "Minimum Amount of Damage Dealt to Bob",
      titleSlug: "minimum-amount-of-damage-dealt-to-bob",
    },
    {
      acRate: 71.78274190329738,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3274",
      paidOnly: false,
      title: "Check if Two Chessboard Squares Have the Same Color",
      titleSlug: "check-if-two-chessboard-squares-have-the-same-color",
    },
    {
      acRate: 47.98092209856916,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3275",
      paidOnly: false,
      title: "K-th Nearest Obstacle Queries",
      titleSlug: "k-th-nearest-obstacle-queries",
    },
    {
      acRate: 14.297328997174388,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3276",
      paidOnly: false,
      title: "Select Cells in Grid With Maximum Score",
      titleSlug: "select-cells-in-grid-with-maximum-score",
    },
    {
      acRate: 41.850609217729115,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3277",
      paidOnly: false,
      title: "Maximum XOR Score Subarray Queries",
      titleSlug: "maximum-xor-score-subarray-queries",
    },
    {
      acRate: 42.84280936454849,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3278",
      paidOnly: true,
      title: "Find Candidates for Data Scientist Position II",
      titleSlug: "find-candidates-for-data-scientist-position-ii",
    },
    {
      acRate: 55.19379844961241,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3279",
      paidOnly: true,
      title: "Maximum Total Area Occupied by Pistons",
      titleSlug: "maximum-total-area-occupied-by-pistons",
    },
    {
      acRate: 88.23410967179005,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3280",
      paidOnly: false,
      title: "Convert Date to Binary",
      titleSlug: "convert-date-to-binary",
    },
    {
      acRate: 34.475777061500835,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3281",
      paidOnly: false,
      title: "Maximize Score of Numbers in Ranges",
      titleSlug: "maximize-score-of-numbers-in-ranges",
    },
    {
      acRate: 32.317732658178066,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3282",
      paidOnly: false,
      title: "Reach End of Array With Max Score",
      titleSlug: "reach-end-of-array-with-max-score",
    },
    {
      acRate: 31.981471950591867,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3283",
      paidOnly: false,
      title: "Maximum Number of Moves to Kill All Pawns",
      titleSlug: "maximum-number-of-moves-to-kill-all-pawns",
    },
    {
      acRate: 41.53116531165312,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3284",
      paidOnly: true,
      title: "Sum of Consecutive Subarrays",
      titleSlug: "sum-of-consecutive-subarrays",
    },
    {
      acRate: 85.96339391608167,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3285",
      paidOnly: false,
      title: "Find Indices of Stable Mountains",
      titleSlug: "find-indices-of-stable-mountains",
    },
    {
      acRate: 30.205281649759684,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3286",
      paidOnly: false,
      title: "Find a Safe Walk Through a Grid",
      titleSlug: "find-a-safe-walk-through-a-grid",
    },
    {
      acRate: 18.40066738171851,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3287",
      paidOnly: false,
      title: "Find the Maximum Sequence Value of Array",
      titleSlug: "find-the-maximum-sequence-value-of-array",
    },
    {
      acRate: 16.884508249410757,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3288",
      paidOnly: false,
      title: "Length of the Longest Increasing Path",
      titleSlug: "length-of-the-longest-increasing-path",
    },
    {
      acRate: 88.26541883397265,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3289",
      paidOnly: false,
      title: "The Two Sneaky Numbers of Digitville",
      titleSlug: "the-two-sneaky-numbers-of-digitville",
    },
    {
      acRate: 40.92714109300467,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3290",
      paidOnly: false,
      title: "Maximum Multiplication Score",
      titleSlug: "maximum-multiplication-score",
    },
    {
      acRate: 19.893603259815016,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3291",
      paidOnly: false,
      title: "Minimum Number of Valid Strings to Form Target I",
      titleSlug: "minimum-number-of-valid-strings-to-form-target-i",
    },
    {
      acRate: 18.076617788361116,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3292",
      paidOnly: false,
      title: "Minimum Number of Valid Strings to Form Target II",
      titleSlug: "minimum-number-of-valid-strings-to-form-target-ii",
    },
    {
      acRate: 80.4736587723538,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3293",
      paidOnly: true,
      title: "Calculate Product Final Price",
      titleSlug: "calculate-product-final-price",
    },
    {
      acRate: 81.51162790697674,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3294",
      paidOnly: true,
      title: "Convert Doubly Linked List to Array II",
      titleSlug: "convert-doubly-linked-list-to-array-ii",
    },
    {
      acRate: 47.41788397425778,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3295",
      paidOnly: false,
      title: "Report Spam Message",
      titleSlug: "report-spam-message",
    },
    {
      acRate: 35.799032794787664,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3296",
      paidOnly: false,
      title: "Minimum Number of Seconds to Make Mountain Height Zero",
      titleSlug: "minimum-number-of-seconds-to-make-mountain-height-zero",
    },
    {
      acRate: 41.26261294729526,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3297",
      paidOnly: false,
      title: "Count Substrings That Can Be Rearranged to Contain a String I",
      titleSlug:
        "count-substrings-that-can-be-rearranged-to-contain-a-string-i",
    },
    {
      acRate: 55.350838481906436,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3298",
      paidOnly: false,
      title: "Count Substrings That Can Be Rearranged to Contain a String II",
      titleSlug:
        "count-substrings-that-can-be-rearranged-to-contain-a-string-ii",
    },
    {
      acRate: 39.97772828507795,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3299",
      paidOnly: true,
      title: "Sum of Consecutive Subsequences",
      titleSlug: "sum-of-consecutive-subsequences",
    },
    {
      acRate: 83.35161779955216,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3300",
      paidOnly: false,
      title: "Minimum Element After Replacement With Digit Sum",
      titleSlug: "minimum-element-after-replacement-with-digit-sum",
    },
    {
      acRate: 36.20835718374356,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3301",
      paidOnly: false,
      title: "Maximize the Total Height of Unique Towers",
      titleSlug: "maximize-the-total-height-of-unique-towers",
    },
    {
      acRate: 20.297376464595008,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3302",
      paidOnly: false,
      title: "Find the Lexicographically Smallest Valid Sequence",
      titleSlug: "find-the-lexicographically-smallest-valid-sequence",
    },
    {
      acRate: 13.638753982738889,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3303",
      paidOnly: false,
      title: "Find the Occurrence of First Almost Equal Substring",
      titleSlug: "find-the-occurrence-of-first-almost-equal-substring",
    },
    {
      acRate: 72.96055249611688,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3304",
      paidOnly: false,
      title: "Find the K-th Character in String Game I",
      titleSlug: "find-the-k-th-character-in-string-game-i",
    },
    {
      acRate: 41.04506658511496,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3305",
      paidOnly: false,
      title: "Count of Substrings Containing Every Vowel and K Consonants I",
      titleSlug:
        "count-of-substrings-containing-every-vowel-and-k-consonants-i",
    },
    {
      acRate: 40.727949586239376,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3306",
      paidOnly: false,
      title: "Count of Substrings Containing Every Vowel and K Consonants II",
      titleSlug:
        "count-of-substrings-containing-every-vowel-and-k-consonants-ii",
    },
    {
      acRate: 26.945984196249555,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3307",
      paidOnly: false,
      title: "Find the K-th Character in String Game II",
      titleSlug: "find-the-k-th-character-in-string-game-ii",
    },
    {
      acRate: 49.3781512605042,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3308",
      paidOnly: true,
      title: "Find Top Performing Driver",
      titleSlug: "find-top-performing-driver",
    },
    {
      acRate: 64.95474035254884,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3309",
      paidOnly: false,
      title: "Maximum Possible Number by Binary Concatenation",
      titleSlug: "maximum-possible-number-by-binary-concatenation",
    },
    {
      acRate: 49.171040573190034,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3310",
      paidOnly: false,
      title: "Remove Methods From Project",
      titleSlug: "remove-methods-from-project",
    },
    {
      acRate: 27.376563290681705,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3311",
      paidOnly: false,
      title: "Construct 2D Grid Matching Graph Layout",
      titleSlug: "construct-2d-grid-matching-graph-layout",
    },
    {
      acRate: 19.515764823952498,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3312",
      paidOnly: false,
      title: "Sorted GCD Pair Queries",
      titleSlug: "sorted-gcd-pair-queries",
    },
    {
      acRate: 51.45089285714286,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3313",
      paidOnly: true,
      title: "Find the Last Marked Nodes in Tree",
      titleSlug: "find-the-last-marked-nodes-in-tree",
    },
    {
      acRate: 73.82751022977652,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3314",
      paidOnly: false,
      title: "Construct the Minimum Bitwise Array I",
      titleSlug: "construct-the-minimum-bitwise-array-i",
    },
    {
      acRate: 34.62811592244815,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3315",
      paidOnly: false,
      title: "Construct the Minimum Bitwise Array II",
      titleSlug: "construct-the-minimum-bitwise-array-ii",
    },
    {
      acRate: 37.75363653102559,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3316",
      paidOnly: false,
      title: "Find Maximum Removals From Source String",
      titleSlug: "find-maximum-removals-from-source-string",
    },
    {
      acRate: 32.868396328683964,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3317",
      paidOnly: false,
      title: "Find the Number of Possible Ways for an Event",
      titleSlug: "find-the-number-of-possible-ways-for-an-event",
    },
    {
      acRate: 63.472913616398245,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3318",
      paidOnly: false,
      title: "Find X-Sum of All K-Long Subarrays I",
      titleSlug: "find-x-sum-of-all-k-long-subarrays-i",
    },
    {
      acRate: 60.82095267269108,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3319",
      paidOnly: false,
      title: "K-th Largest Perfect Subtree Size in Binary Tree",
      titleSlug: "k-th-largest-perfect-subtree-size-in-binary-tree",
    },
    {
      acRate: 30.979238188654566,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3320",
      paidOnly: false,
      title: "Count The Number of Winning Sequences",
      titleSlug: "count-the-number-of-winning-sequences",
    },
    {
      acRate: 15.75402747484024,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3321",
      paidOnly: false,
      title: "Find X-Sum of All K-Long Subarrays II",
      titleSlug: "find-x-sum-of-all-k-long-subarrays-ii",
    },
    {
      acRate: 71.52480097979179,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3322",
      paidOnly: true,
      title: "Premier League Table Ranking III",
      titleSlug: "premier-league-table-ranking-iii",
    },
    {
      acRate: 50.080688542227,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3323",
      paidOnly: true,
      title: "Minimize Connected Groups by Inserting Interval",
      titleSlug: "minimize-connected-groups-by-inserting-interval",
    },
    {
      acRate: 79.0897571277719,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3324",
      paidOnly: false,
      title: "Find the Sequence of Strings Appeared on the Screen",
      titleSlug: "find-the-sequence-of-strings-appeared-on-the-screen",
    },
    {
      acRate: 54.363683617777006,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3325",
      paidOnly: false,
      title: "Count Substrings With K-Frequency Characters I",
      titleSlug: "count-substrings-with-k-frequency-characters-i",
    },
    {
      acRate: 28.440548118311415,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3326",
      paidOnly: false,
      title: "Minimum Division Operations to Make Array Non Decreasing",
      titleSlug: "minimum-division-operations-to-make-array-non-decreasing",
    },
    {
      acRate: 17.800977930487644,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3327",
      paidOnly: false,
      title: "Check if DFS Strings Are Palindromes",
      titleSlug: "check-if-dfs-strings-are-palindromes",
    },
    {
      acRate: 69.61069145845438,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3328",
      paidOnly: true,
      title: "Find Cities in Each State II",
      titleSlug: "find-cities-in-each-state-ii",
    },
    {
      acRate: 70.40816326530613,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3329",
      paidOnly: true,
      title: "Count Substrings With K-Frequency Characters II",
      titleSlug: "count-substrings-with-k-frequency-characters-ii",
    },
    {
      acRate: 56.53671157105897,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3330",
      paidOnly: false,
      title: "Find the Original Typed String I",
      titleSlug: "find-the-original-typed-string-i",
    },
    {
      acRate: 54.37789687137891,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3331",
      paidOnly: false,
      title: "Find Subtree Sizes After Changes",
      titleSlug: "find-subtree-sizes-after-changes",
    },
    {
      acRate: 45.810518731988466,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3332",
      paidOnly: false,
      title: "Maximum Points Tourist Can Earn",
      titleSlug: "maximum-points-tourist-can-earn",
    },
    {
      acRate: 14.560601988712712,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3333",
      paidOnly: false,
      title: "Find the Original Typed String II",
      titleSlug: "find-the-original-typed-string-ii",
    },
    {
      acRate: 40.24117582377305,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3334",
      paidOnly: false,
      title: "Find the Maximum Factor Score of Array",
      titleSlug: "find-the-maximum-factor-score-of-array",
    },
    {
      acRate: 26.439955432834374,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3335",
      paidOnly: false,
      title: "Total Characters in String After Transformations I",
      titleSlug: "total-characters-in-string-after-transformations-i",
    },
    {
      acRate: 28.409142752862813,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3336",
      paidOnly: false,
      title: "Find the Number of Subsequences With Equal GCD",
      titleSlug: "find-the-number-of-subsequences-with-equal-gcd",
    },
    {
      acRate: 31.572501632919657,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3337",
      paidOnly: false,
      title: "Total Characters in String After Transformations II",
      titleSlug: "total-characters-in-string-after-transformations-ii",
    },
    {
      acRate: 89.83413590155163,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3338",
      paidOnly: true,
      title: "Second Highest Salary II",
      titleSlug: "second-highest-salary-ii",
    },
    {
      acRate: 56.618610747051115,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3339",
      paidOnly: true,
      title: "Find the Number of K-Even Arrays",
      titleSlug: "find-the-number-of-k-even-arrays",
    },
    {
      acRate: 80.50322636525054,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3340",
      paidOnly: false,
      title: "Check Balanced String",
      titleSlug: "check-balanced-string",
    },
    {
      acRate: 55.937886689057805,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3341",
      paidOnly: false,
      title: "Find Minimum Time to Reach Last Room I",
      titleSlug: "find-minimum-time-to-reach-last-room-i",
    },
    {
      acRate: 69.00079451538656,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3342",
      paidOnly: false,
      title: "Find Minimum Time to Reach Last Room II",
      titleSlug: "find-minimum-time-to-reach-last-room-ii",
    },
    {
      acRate: 40.99480560365182,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3343",
      paidOnly: false,
      title: "Count Number of Balanced Permutations",
      titleSlug: "count-number-of-balanced-permutations",
    },
    {
      acRate: 51.36417556346382,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3344",
      paidOnly: true,
      title: "Maximum Sized Array",
      titleSlug: "maximum-sized-array",
    },
    {
      acRate: 63.761324586066856,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3345",
      paidOnly: false,
      title: "Smallest Divisible Digit Product I",
      titleSlug: "smallest-divisible-digit-product-i",
    },
    {
      acRate: 20.840544978476014,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3346",
      paidOnly: false,
      title: "Maximum Frequency of an Element After Performing Operations I",
      titleSlug:
        "maximum-frequency-of-an-element-after-performing-operations-i",
    },
    {
      acRate: 37.27064715278677,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3347",
      paidOnly: false,
      title: "Maximum Frequency of an Element After Performing Operations II",
      titleSlug:
        "maximum-frequency-of-an-element-after-performing-operations-ii",
    },
    {
      acRate: 10.134900081171969,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3348",
      paidOnly: false,
      title: "Smallest Divisible Digit Product II",
      titleSlug: "smallest-divisible-digit-product-ii",
    },
    {
      acRate: 42.821068202229384,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3349",
      paidOnly: false,
      title: "Adjacent Increasing Subarrays Detection I",
      titleSlug: "adjacent-increasing-subarrays-detection-i",
    },
    {
      acRate: 40.80282234001474,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3350",
      paidOnly: false,
      title: "Adjacent Increasing Subarrays Detection II",
      titleSlug: "adjacent-increasing-subarrays-detection-ii",
    },
    {
      acRate: 29.54065395555806,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3351",
      paidOnly: false,
      title: "Sum of Good Subsequences",
      titleSlug: "sum-of-good-subsequences",
    },
    {
      acRate: 24.68294657312466,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3352",
      paidOnly: false,
      title: "Count K-Reducible Numbers Less Than N",
      titleSlug: "count-k-reducible-numbers-less-than-n",
    },
    {
      acRate: 63.598901098901095,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3353",
      paidOnly: true,
      title: "Minimum Total Operations",
      titleSlug: "minimum-total-operations",
    },
    {
      acRate: 55.45536890645586,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3354",
      paidOnly: false,
      title: "Make Array Elements Equal to Zero",
      titleSlug: "make-array-elements-equal-to-zero",
    },
    {
      acRate: 46.21453609666727,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3355",
      paidOnly: false,
      title: "Zero Array Transformation I",
      titleSlug: "zero-array-transformation-i",
    },
    {
      acRate: 43.689798163278596,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3356",
      paidOnly: false,
      title: "Zero Array Transformation II",
      titleSlug: "zero-array-transformation-ii",
    },
    {
      acRate: 15.155996901190225,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3357",
      paidOnly: false,
      title: "Minimize the Maximum Adjacent Element Difference",
      titleSlug: "minimize-the-maximum-adjacent-element-difference",
    },
    {
      acRate: 90.69969578444154,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3358",
      paidOnly: true,
      title: "Books with NULL Ratings",
      titleSlug: "books-with-null-ratings",
    },
    {
      acRate: 49.62264150943396,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3359",
      paidOnly: true,
      title: "Find Sorted Submatrices With Maximum Element at Most K",
      titleSlug: "find-sorted-submatrices-with-maximum-element-at-most-k",
    },
    {
      acRate: 41.44315178761277,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3360",
      paidOnly: false,
      title: "Stone Removal Game",
      titleSlug: "stone-removal-game",
    },
    {
      acRate: 52.506304625695236,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3361",
      paidOnly: false,
      title: "Shift Distance Between Two Strings",
      titleSlug: "shift-distance-between-two-strings",
    },
    {
      acRate: 26.23991004377334,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3362",
      paidOnly: false,
      title: "Zero Array Transformation III",
      titleSlug: "zero-array-transformation-iii",
    },
    {
      acRate: 39.42481884057971,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3363",
      paidOnly: false,
      title: "Find the Maximum Number of Fruits Collected",
      titleSlug: "find-the-maximum-number-of-fruits-collected",
    },
    {
      acRate: 44.76112993144656,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3364",
      paidOnly: false,
      title: "Minimum Positive Sum Subarray ",
      titleSlug: "minimum-positive-sum-subarray",
    },
    {
      acRate: 55.94970512963169,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3365",
      paidOnly: false,
      title: "Rearrange K Substrings to Form Target String",
      titleSlug: "rearrange-k-substrings-to-form-target-string",
    },
    {
      acRate: 29.30220122983691,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3366",
      paidOnly: false,
      title: "Minimum Array Sum",
      titleSlug: "minimum-array-sum",
    },
    {
      acRate: 28.694084313557138,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3367",
      paidOnly: false,
      title: "Maximize Sum of Weights after Edge Removals",
      titleSlug: "maximize-sum-of-weights-after-edge-removals",
    },
    {
      acRate: 88.53092783505154,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3368",
      paidOnly: true,
      title: "First Letter Capitalization",
      titleSlug: "first-letter-capitalization",
    },
    {
      acRate: 34.215046375815874,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3369",
      paidOnly: true,
      title: "Design an Array Statistics Tracker ",
      titleSlug: "design-an-array-statistics-tracker",
    },
    {
      acRate: 75.75230042278041,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3370",
      paidOnly: false,
      title: "Smallest Number With All Set Bits",
      titleSlug: "smallest-number-with-all-set-bits",
    },
    {
      acRate: 35.21228784845818,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3371",
      paidOnly: false,
      title: "Identify the Largest Outlier in an Array",
      titleSlug: "identify-the-largest-outlier-in-an-array",
    },
    {
      acRate: 47.98320587794272,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3372",
      paidOnly: false,
      title: "Maximize the Number of Target Nodes After Connecting Trees I",
      titleSlug: "maximize-the-number-of-target-nodes-after-connecting-trees-i",
    },
    {
      acRate: 53.82465944813133,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3373",
      paidOnly: false,
      title: "Maximize the Number of Target Nodes After Connecting Trees II",
      titleSlug:
        "maximize-the-number-of-target-nodes-after-connecting-trees-ii",
    },
    {
      acRate: 76.3724434876211,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3374",
      paidOnly: false,
      title: "First Letter Capitalization II",
      titleSlug: "first-letter-capitalization-ii",
    },
    {
      acRate: 73.46465550887343,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3375",
      paidOnly: false,
      title: "Minimum Operations to Make Array Values Equal to K",
      titleSlug: "minimum-operations-to-make-array-values-equal-to-k",
    },
    {
      acRate: 29.97291525600292,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3376",
      paidOnly: false,
      title: "Minimum Time to Break Locks I",
      titleSlug: "minimum-time-to-break-locks-i",
    },
    {
      acRate: 26.455900712344864,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3377",
      paidOnly: false,
      title: "Digit Operations to Make Two Integers Equal",
      titleSlug: "digit-operations-to-make-two-integers-equal",
    },
    {
      acRate: 27.874301253965854,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3378",
      paidOnly: false,
      title: "Count Connected Components in LCM Graph",
      titleSlug: "count-connected-components-in-lcm-graph",
    },
    {
      acRate: 56.376448367295055,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3379",
      paidOnly: false,
      title: "Transformed Array",
      titleSlug: "transformed-array",
    },
    {
      acRate: 49.348982903724945,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3380",
      paidOnly: false,
      title: "Maximum Area Rectangle With Point Constraints I",
      titleSlug: "maximum-area-rectangle-with-point-constraints-i",
    },
    {
      acRate: 26.71860994277046,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3381",
      paidOnly: false,
      title: "Maximum Subarray Sum With Length Divisible by K",
      titleSlug: "maximum-subarray-sum-with-length-divisible-by-k",
    },
    {
      acRate: 20.38149737720553,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3382",
      paidOnly: false,
      title: "Maximum Area Rectangle With Point Constraints II",
      titleSlug: "maximum-area-rectangle-with-point-constraints-ii",
    },
    {
      acRate: 45.00941619585687,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3383",
      paidOnly: true,
      title: "Minimum Runes to Add to Cast Spell",
      titleSlug: "minimum-runes-to-add-to-cast-spell",
    },
    {
      acRate: 77.4,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3384",
      paidOnly: true,
      title: "Team Dominance by Pass Success",
      titleSlug: "team-dominance-by-pass-success",
    },
    {
      acRate: 45.53014553014553,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3385",
      paidOnly: true,
      title: "Minimum Time to Break Locks II",
      titleSlug: "minimum-time-to-break-locks-ii",
    },
    {
      acRate: 40.46338010039902,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3386",
      paidOnly: false,
      title: "Button with Longest Push Time",
      titleSlug: "button-with-longest-push-time",
    },
    {
      acRate: 58.30937799441737,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3387",
      paidOnly: false,
      title: "Maximize Amount After Two Days of Conversions",
      titleSlug: "maximize-amount-after-two-days-of-conversions",
    },
    {
      acRate: 15.2014945289565,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3388",
      paidOnly: false,
      title: "Count Beautiful Splits in an Array",
      titleSlug: "count-beautiful-splits-in-an-array",
    },
    {
      acRate: 24.58603066439523,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3389",
      paidOnly: false,
      title: "Minimum Operations to Make Character Frequencies Equal",
      titleSlug: "minimum-operations-to-make-character-frequencies-equal",
    },
    {
      acRate: 43.46978557504873,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3390",
      paidOnly: true,
      title: "Longest Team Pass Streak",
      titleSlug: "longest-team-pass-streak",
    },
    {
      acRate: 66.41604010025063,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3391",
      paidOnly: true,
      title: "Design a 3D Binary Matrix with Efficient Layer Tracking",
      titleSlug: "design-a-3d-binary-matrix-with-efficient-layer-tracking",
    },
    {
      acRate: 62.02449328549275,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3392",
      paidOnly: false,
      title: "Count Subarrays of Length Three With a Condition",
      titleSlug: "count-subarrays-of-length-three-with-a-condition",
    },
    {
      acRate: 39.45639187574672,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3393",
      paidOnly: false,
      title: "Count Paths With the Given XOR Value",
      titleSlug: "count-paths-with-the-given-xor-value",
    },
    {
      acRate: 68.45308826132025,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3394",
      paidOnly: false,
      title: "Check if Grid can be Cut into Sections",
      titleSlug: "check-if-grid-can-be-cut-into-sections",
    },
    {
      acRate: 16.73411930318494,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3395",
      paidOnly: false,
      title: "Subsequences with a Unique Middle Mode I",
      titleSlug: "subsequences-with-a-unique-middle-mode-i",
    },
    {
      acRate: 71.56375085832957,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3396",
      paidOnly: false,
      title: "Minimum Number of Operations to Make Elements in Array Distinct",
      titleSlug:
        "minimum-number-of-operations-to-make-elements-in-array-distinct",
    },
    {
      acRate: 30.84110684330172,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3397",
      paidOnly: false,
      title: "Maximum Number of Distinct Elements After Operations",
      titleSlug: "maximum-number-of-distinct-elements-after-operations",
    },
    {
      acRate: 18.971746178786475,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3398",
      paidOnly: false,
      title: "Smallest Substring With Identical Characters I",
      titleSlug: "smallest-substring-with-identical-characters-i",
    },
    {
      acRate: 40.28802497162315,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3399",
      paidOnly: false,
      title: "Smallest Substring With Identical Characters II",
      titleSlug: "smallest-substring-with-identical-characters-ii",
    },
    {
      acRate: 84.46909667194929,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3400",
      paidOnly: true,
      title: "Maximum Number of Matching Indices After Right Shifts",
      titleSlug: "maximum-number-of-matching-indices-after-right-shifts",
    },
    {
      acRate: 55.125,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3401",
      paidOnly: true,
      title: "Find Circular Gift Exchange Chains",
      titleSlug: "find-circular-gift-exchange-chains",
    },
    {
      acRate: 71.95022991614822,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3402",
      paidOnly: false,
      title: "Minimum Operations to Make Columns Strictly Increasing",
      titleSlug: "minimum-operations-to-make-columns-strictly-increasing",
    },
    {
      acRate: 23.516809723175154,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3403",
      paidOnly: false,
      title: "Find the Lexicographically Largest String From the Box I",
      titleSlug: "find-the-lexicographically-largest-string-from-the-box-i",
    },
    {
      acRate: 28.528371877354665,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3404",
      paidOnly: false,
      title: "Count Special Subsequences",
      titleSlug: "count-special-subsequences",
    },
    {
      acRate: 31.215724936841454,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3405",
      paidOnly: false,
      title: "Count the Number of Arrays with K Matching Adjacent Elements",
      titleSlug: "count-the-number-of-arrays-with-k-matching-adjacent-elements",
    },
    {
      acRate: 50.56022408963585,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3406",
      paidOnly: true,
      title: "Find the Lexicographically Largest String From the Box II",
      titleSlug: "find-the-lexicographically-largest-string-from-the-box-ii",
    },
    {
      acRate: 26.209046935435204,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3407",
      paidOnly: false,
      title: "Substring Matching Pattern",
      titleSlug: "substring-matching-pattern",
    },
    {
      acRate: 33.98634609676462,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3408",
      paidOnly: false,
      title: "Design Task Manager",
      titleSlug: "design-task-manager",
    },
    {
      acRate: 14.27534208321698,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3409",
      paidOnly: false,
      title: "Longest Subsequence With Decreasing Adjacent Difference",
      titleSlug: "longest-subsequence-with-decreasing-adjacent-difference",
    },
    {
      acRate: 19.289056498358825,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3410",
      paidOnly: false,
      title:
        "Maximize Subarray Sum After Removing All Occurrences of One Element",
      titleSlug:
        "maximize-subarray-sum-after-removing-all-occurrences-of-one-element",
    },
    {
      acRate: 44.84274602637809,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3411",
      paidOnly: false,
      title: "Maximum Subarray With Equal Products",
      titleSlug: "maximum-subarray-with-equal-products",
    },
    {
      acRate: 33.64720453498896,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3412",
      paidOnly: false,
      title: "Find Mirror Score of a String",
      titleSlug: "find-mirror-score-of-a-string",
    },
    {
      acRate: 23.27194370559914,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3413",
      paidOnly: false,
      title: "Maximum Coins From K Consecutive Bags",
      titleSlug: "maximum-coins-from-k-consecutive-bags",
    },
    {
      acRate: 30.60114503816794,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3414",
      paidOnly: false,
      title: "Maximum Score of Non-overlapping Intervals",
      titleSlug: "maximum-score-of-non-overlapping-intervals",
    },
    {
      acRate: 81.08340498710233,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3415",
      paidOnly: true,
      title: "Find Products with Three Consecutive Digits ",
      titleSlug: "find-products-with-three-consecutive-digits",
    },
    {
      acRate: 43.986254295532646,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3416",
      paidOnly: true,
      title: "Subsequences with a Unique Middle Mode II",
      titleSlug: "subsequences-with-a-unique-middle-mode-ii",
    },
    {
      acRate: 63.201850690087824,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3417",
      paidOnly: false,
      title: "Zigzag Grid Traversal With Skip",
      titleSlug: "zigzag-grid-traversal-with-skip",
    },
    {
      acRate: 28.51007047245736,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3418",
      paidOnly: false,
      title: "Maximum Amount of Money Robot Can Earn",
      titleSlug: "maximum-amount-of-money-robot-can-earn",
    },
    {
      acRate: 42.36287550440891,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3419",
      paidOnly: false,
      title: "Minimize the Maximum Edge Weight of Graph",
      titleSlug: "minimize-the-maximum-edge-weight-of-graph",
    },
    {
      acRate: 20.32804886418228,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3420",
      paidOnly: false,
      title: "Count Non-Decreasing Subarrays After K Operations",
      titleSlug: "count-non-decreasing-subarrays-after-k-operations",
    },
    {
      acRate: 47.5107652791418,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3421",
      paidOnly: false,
      title: "Find Students Who Improved",
      titleSlug: "find-students-who-improved",
    },
    {
      acRate: 49.717514124293785,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3422",
      paidOnly: true,
      title: "Minimum Operations to Make Subarray Elements Equal",
      titleSlug: "minimum-operations-to-make-subarray-elements-equal",
    },
    {
      acRate: 66.51945023495742,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3423",
      paidOnly: false,
      title: "Maximum Difference Between Adjacent Elements in a Circular Array",
      titleSlug:
        "maximum-difference-between-adjacent-elements-in-a-circular-array",
    },
    {
      acRate: 36.31019886590528,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3424",
      paidOnly: false,
      title: "Minimum Cost to Make Arrays Identical",
      titleSlug: "minimum-cost-to-make-arrays-identical",
    },
    {
      acRate: 19.820408874940064,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3425",
      paidOnly: false,
      title: "Longest Special Path",
      titleSlug: "longest-special-path",
    },
    {
      acRate: 32.76056049913061,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3426",
      paidOnly: false,
      title: "Manhattan Distances of All Arrangements of Pieces",
      titleSlug: "manhattan-distances-of-all-arrangements-of-pieces",
    },
    {
      acRate: 84.97028079524492,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3427",
      paidOnly: false,
      title: "Sum of Variable Length Subarrays",
      titleSlug: "sum-of-variable-length-subarrays",
    },
    {
      acRate: 20.065801772161365,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3428",
      paidOnly: false,
      title: "Maximum and Minimum Sums of at Most Size K Subsequences",
      titleSlug: "maximum-and-minimum-sums-of-at-most-size-k-subsequences",
    },
    {
      acRate: 43.342233865685934,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3429",
      paidOnly: false,
      title: "Paint House IV",
      titleSlug: "paint-house-iv",
    },
    {
      acRate: 22.35302773894489,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3430",
      paidOnly: false,
      title: "Maximum and Minimum Sums of at Most Size K Subarrays",
      titleSlug: "maximum-and-minimum-sums-of-at-most-size-k-subarrays",
    },
    {
      acRate: 60.726643598615915,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3431",
      paidOnly: true,
      title: "Minimum Unlocked Indices to Sort Nums",
      titleSlug: "minimum-unlocked-indices-to-sort-nums",
    },
    {
      acRate: 72.25820064598855,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3432",
      paidOnly: false,
      title: "Count Partitions with Even Sum Difference",
      titleSlug: "count-partitions-with-even-sum-difference",
    },
    {
      acRate: 29.855066716894346,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3433",
      paidOnly: false,
      title: "Count Mentions Per User",
      titleSlug: "count-mentions-per-user",
    },
    {
      acRate: 23.653996210010032,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3434",
      paidOnly: false,
      title: "Maximum Frequency After Subarray Operation",
      titleSlug: "maximum-frequency-after-subarray-operation",
    },
    {
      acRate: 15.205855443732846,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3435",
      paidOnly: false,
      title: "Frequencies of Shortest Supersequences",
      titleSlug: "frequencies-of-shortest-supersequences",
    },
    {
      acRate: 56.1374425438927,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3436",
      paidOnly: false,
      title: "Find Valid Emails",
      titleSlug: "find-valid-emails",
    },
    {
      acRate: 85.42952064546749,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3437",
      paidOnly: true,
      title: "Permutations III",
      titleSlug: "permutations-iii",
    },
    {
      acRate: 59.30488008120843,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3438",
      paidOnly: false,
      title: "Find Valid Pair of Adjacent Digits in String",
      titleSlug: "find-valid-pair-of-adjacent-digits-in-string",
    },
    {
      acRate: 31.423090338332756,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3439",
      paidOnly: false,
      title: "Reschedule Meetings for Maximum Free Time I",
      titleSlug: "reschedule-meetings-for-maximum-free-time-i",
    },
    {
      acRate: 39.524309199020635,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3440",
      paidOnly: false,
      title: "Reschedule Meetings for Maximum Free Time II",
      titleSlug: "reschedule-meetings-for-maximum-free-time-ii",
    },
    {
      acRate: 18.698029814967413,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3441",
      paidOnly: false,
      title: "Minimum Cost Good Caption",
      titleSlug: "minimum-cost-good-caption",
    },
    {
      acRate: 48.75367536753675,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3442",
      paidOnly: false,
      title: "Maximum Difference Between Even and Odd Frequency I",
      titleSlug: "maximum-difference-between-even-and-odd-frequency-i",
    },
    {
      acRate: 30.712869747735844,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3443",
      paidOnly: false,
      title: "Maximum Manhattan Distance After K Changes",
      titleSlug: "maximum-manhattan-distance-after-k-changes",
    },
    {
      acRate: 25.054934779559584,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3444",
      paidOnly: false,
      title: "Minimum Increments for Target Multiples in an Array",
      titleSlug: "minimum-increments-for-target-multiples-in-an-array",
    },
    {
      acRate: 18.38962811327192,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3445",
      paidOnly: false,
      title: "Maximum Difference Between Even and Odd Frequency II",
      titleSlug: "maximum-difference-between-even-and-odd-frequency-ii",
    },
    {
      acRate: 70.32882682117565,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3446",
      paidOnly: false,
      title: "Sort Matrix by Diagonals",
      titleSlug: "sort-matrix-by-diagonals",
    },
    {
      acRate: 25.580616813826,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3447",
      paidOnly: false,
      title: "Assign Elements to Groups with Constraints",
      titleSlug: "assign-elements-to-groups-with-constraints",
    },
    {
      acRate: 20.576494810706333,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3448",
      paidOnly: false,
      title: "Count Substrings Divisible By Last Digit",
      titleSlug: "count-substrings-divisible-by-last-digit",
    },
    {
      acRate: 24.499792444997926,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3449",
      paidOnly: false,
      title: "Maximize the Minimum Game Score",
      titleSlug: "maximize-the-minimum-game-score",
    },
    {
      acRate: 85.71428571428571,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3450",
      paidOnly: true,
      title: "Maximum Students on a Single Bench",
      titleSlug: "maximum-students-on-a-single-bench",
    },
    {
      acRate: 56.41368763142802,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3451",
      paidOnly: false,
      title: "Find Invalid IP Addresses",
      titleSlug: "find-invalid-ip-addresses",
    },
    {
      acRate: 69.04004567327297,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3452",
      paidOnly: false,
      title: "Sum of Good Numbers",
      titleSlug: "sum-of-good-numbers",
    },
    {
      acRate: 37.036539269214614,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3453",
      paidOnly: false,
      title: "Separate Squares I",
      titleSlug: "separate-squares-i",
    },
    {
      acRate: 18.65148861646235,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3454",
      paidOnly: false,
      title: "Separate Squares II",
      titleSlug: "separate-squares-ii",
    },
    {
      acRate: 21.618428824571765,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3455",
      paidOnly: false,
      title: "Shortest Matching Substring",
      titleSlug: "shortest-matching-substring",
    },
    {
      acRate: 35.06052807168049,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3456",
      paidOnly: false,
      title: "Find Special Substring of Length K",
      titleSlug: "find-special-substring-of-length-k",
    },
    {
      acRate: 32.249582003343974,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3457",
      paidOnly: false,
      title: "Eat Pizzas!",
      titleSlug: "eat-pizzas",
    },
    {
      acRate: 17.73042694162387,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3458",
      paidOnly: false,
      title: "Select K Disjoint Special Substrings",
      titleSlug: "select-k-disjoint-special-substrings",
    },
    {
      acRate: 33.50121938288623,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3459",
      paidOnly: false,
      title: "Length of Longest V-Shaped Diagonal Segment",
      titleSlug: "length-of-longest-v-shaped-diagonal-segment",
    },
    {
      acRate: 68.71686108165429,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3460",
      paidOnly: true,
      title: "Longest Common Prefix After at Most One Removal",
      titleSlug: "longest-common-prefix-after-at-most-one-removal",
    },
    {
      acRate: 77.28911783644558,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3461",
      paidOnly: false,
      title: "Check If Digits Are Equal in String After Operations I",
      titleSlug: "check-if-digits-are-equal-in-string-after-operations-i",
    },
    {
      acRate: 59.78560223113125,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3462",
      paidOnly: false,
      title: "Maximum Sum With at Most K Elements",
      titleSlug: "maximum-sum-with-at-most-k-elements",
    },
    {
      acRate: 9.452438049560353,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3463",
      paidOnly: false,
      title: "Check If Digits Are Equal in String After Operations II",
      titleSlug: "check-if-digits-are-equal-in-string-after-operations-ii",
    },
    {
      acRate: 18.879486431281002,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3464",
      paidOnly: false,
      title: "Maximize the Distance Between Points on a Square",
      titleSlug: "maximize-the-distance-between-points-on-a-square",
    },
    {
      acRate: 70.90955284552845,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3465",
      paidOnly: false,
      title: "Find Products with Valid Serial Numbers",
      titleSlug: "find-products-with-valid-serial-numbers",
    },
    {
      acRate: 53.05269922879178,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3466",
      paidOnly: true,
      title: "Maximum Coin Collection ",
      titleSlug: "maximum-coin-collection",
    },
    {
      acRate: 89.25059342149882,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3467",
      paidOnly: false,
      title: "Transform Array by Parity",
      titleSlug: "transform-array-by-parity",
    },
    {
      acRate: 45.69620862201694,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3468",
      paidOnly: false,
      title: "Find the Number of Copy Arrays",
      titleSlug: "find-the-number-of-copy-arrays",
    },
    {
      acRate: 17.898478835978835,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3469",
      paidOnly: false,
      title: "Find Minimum Cost to Remove Array Elements",
      titleSlug: "find-minimum-cost-to-remove-array-elements",
    },
    {
      acRate: 26.740171511304155,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3470",
      paidOnly: false,
      title: "Permutations IV",
      titleSlug: "permutations-iv",
    },
    {
      acRate: 36.56281239586804,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3471",
      paidOnly: false,
      title: "Find the Largest Almost Missing Integer",
      titleSlug: "find-the-largest-almost-missing-integer",
    },
    {
      acRate: 36.095462744553906,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3472",
      paidOnly: false,
      title: "Longest Palindromic Subsequence After at Most K Operations",
      titleSlug: "longest-palindromic-subsequence-after-at-most-k-operations",
    },
    {
      acRate: 24.687017001545595,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3473",
      paidOnly: false,
      title: "Sum of K Subarrays With Length at Least M",
      titleSlug: "sum-of-k-subarrays-with-length-at-least-m",
    },
    {
      acRate: 29.324274697025338,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3474",
      paidOnly: false,
      title: "Lexicographically Smallest Generated String",
      titleSlug: "lexicographically-smallest-generated-string",
    },
    {
      acRate: 86.19113848599244,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3475",
      paidOnly: false,
      title: "DNA Pattern Recognition ",
      titleSlug: "dna-pattern-recognition",
    },
    {
      acRate: 62.95302013422819,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3476",
      paidOnly: true,
      title: "Maximize Profit from Task Assignment",
      titleSlug: "maximize-profit-from-task-assignment",
    },
    {
      acRate: 51.97383754807132,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3477",
      paidOnly: false,
      title: "Fruits Into Baskets II",
      titleSlug: "fruits-into-baskets-ii",
    },
    {
      acRate: 30.87747066090179,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3478",
      paidOnly: false,
      title: "Choose K Elements With Maximum Sum",
      titleSlug: "choose-k-elements-with-maximum-sum",
    },
    {
      acRate: 21.405882352941177,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3479",
      paidOnly: false,
      title: "Fruits Into Baskets III",
      titleSlug: "fruits-into-baskets-iii",
    },
    {
      acRate: 32.58769027134348,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3480",
      paidOnly: false,
      title: "Maximize Subarrays After Removing One Conflicting Pair",
      titleSlug: "maximize-subarrays-after-removing-one-conflicting-pair",
    },
    {
      acRate: 78.19863850584744,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3481",
      paidOnly: true,
      title: "Apply Substitutions",
      titleSlug: "apply-substitutions",
    },
    {
      acRate: 57.14781401804303,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3482",
      paidOnly: false,
      title: "Analyze Organization Hierarchy",
      titleSlug: "analyze-organization-hierarchy",
    },
    {
      acRate: 66.10887328806537,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3483",
      paidOnly: false,
      title: "Unique 3-Digit Even Numbers",
      titleSlug: "unique-3-digit-even-numbers",
    },
    {
      acRate: 67.83066924292991,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3484",
      paidOnly: false,
      title: "Design Spreadsheet",
      titleSlug: "design-spreadsheet",
    },
    {
      acRate: 19.99110715873722,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3485",
      paidOnly: false,
      title: "Longest Common Prefix of K Strings After Removal",
      titleSlug: "longest-common-prefix-of-k-strings-after-removal",
    },
    {
      acRate: 16.411615857332208,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3486",
      paidOnly: false,
      title: "Longest Special Path II",
      titleSlug: "longest-special-path-ii",
    },
    {
      acRate: 27.15522753429913,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3487",
      paidOnly: false,
      title: "Maximum Unique Subarray Sum After Deletion",
      titleSlug: "maximum-unique-subarray-sum-after-deletion",
    },
    {
      acRate: 30.73735656608585,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3488",
      paidOnly: false,
      title: "Closest Equal Element Queries",
      titleSlug: "closest-equal-element-queries",
    },
    {
      acRate: 29.20885413029816,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3489",
      paidOnly: false,
      title: "Zero Array Transformation IV",
      titleSlug: "zero-array-transformation-iv",
    },
    {
      acRate: 20.791687842340053,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3490",
      paidOnly: false,
      title: "Count Beautiful Numbers",
      titleSlug: "count-beautiful-numbers",
    },
    {
      acRate: 74.15929203539822,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3491",
      paidOnly: true,
      title: "Phone Number Prefix",
      titleSlug: "phone-number-prefix",
    },
    {
      acRate: 74.44658413571756,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3492",
      paidOnly: false,
      title: "Maximum Containers on a Ship",
      titleSlug: "maximum-containers-on-a-ship",
    },
    {
      acRate: 46.599653379549395,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3493",
      paidOnly: false,
      title: "Properties Graph",
      titleSlug: "properties-graph",
    },
    {
      acRate: 34.335713567333805,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3494",
      paidOnly: false,
      title: "Find the Minimum Amount of Time to Brew Potions",
      titleSlug: "find-the-minimum-amount-of-time-to-brew-potions",
    },
    {
      acRate: 30.815692590888172,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3495",
      paidOnly: false,
      title: "Minimum Operations to Make Array Elements Zero",
      titleSlug: "minimum-operations-to-make-array-elements-zero",
    },
    {
      acRate: 60.84905660377359,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3496",
      paidOnly: true,
      title: "Maximize Score After Pair Deletions",
      titleSlug: "maximize-score-after-pair-deletions",
    },
    {
      acRate: 77.32077205882352,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3497",
      paidOnly: false,
      title: "Analyze Subscription Conversion ",
      titleSlug: "analyze-subscription-conversion",
    },
    {
      acRate: 86.73191825727106,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3498",
      paidOnly: false,
      title: "Reverse Degree of a String",
      titleSlug: "reverse-degree-of-a-string",
    },
    {
      acRate: 29.531412189214574,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3499",
      paidOnly: false,
      title: "Maximize Active Section with Trade I",
      titleSlug: "maximize-active-section-with-trade-i",
    },
    {
      acRate: 22.441200324412,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3500",
      paidOnly: false,
      title: "Minimum Cost to Divide Array Into Subarrays",
      titleSlug: "minimum-cost-to-divide-array-into-subarrays",
    },
    {
      acRate: 18.978705809385982,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3501",
      paidOnly: false,
      title: "Maximize Active Section with Trade II",
      titleSlug: "maximize-active-section-with-trade-ii",
    },
    {
      acRate: 81.73218888416206,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3502",
      paidOnly: false,
      title: "Minimum Cost to Reach Every Position",
      titleSlug: "minimum-cost-to-reach-every-position",
    },
    {
      acRate: 43.03129347850091,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3503",
      paidOnly: false,
      title: "Longest Palindrome After Substring Concatenation I",
      titleSlug: "longest-palindrome-after-substring-concatenation-i",
    },
    {
      acRate: 15.47924307832127,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3504",
      paidOnly: false,
      title: "Longest Palindrome After Substring Concatenation II",
      titleSlug: "longest-palindrome-after-substring-concatenation-ii",
    },
    {
      acRate: 27.158799853640687,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3505",
      paidOnly: false,
      title: "Minimum Operations to Make Elements Within K Subarrays Equal",
      titleSlug: "minimum-operations-to-make-elements-within-k-subarrays-equal",
    },
    {
      acRate: 55.524079320113316,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3506",
      paidOnly: true,
      title: "Find Time Required to Eliminate Bacterial Strains",
      titleSlug: "find-time-required-to-eliminate-bacterial-strains",
    },
    {
      acRate: 55.94543373426154,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3507",
      paidOnly: false,
      title: "Minimum Pair Removal to Sort Array I",
      titleSlug: "minimum-pair-removal-to-sort-array-i",
    },
    {
      acRate: 21.411150717172923,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3508",
      paidOnly: false,
      title: "Implement Router",
      titleSlug: "implement-router",
    },
    {
      acRate: 10.405397372644593,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3509",
      paidOnly: false,
      title:
        "Maximum Product of Subsequences With an Alternating Sum Equal to K",
      titleSlug:
        "maximum-product-of-subsequences-with-an-alternating-sum-equal-to-k",
    },
    {
      acRate: 12.852713992958856,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3510",
      paidOnly: false,
      title: "Minimum Pair Removal to Sort Array II",
      titleSlug: "minimum-pair-removal-to-sort-array-ii",
    },
    {
      acRate: 38.00959232613909,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3511",
      paidOnly: true,
      title: "Make a Positive Array",
      titleSlug: "make-a-positive-array",
    },
    {
      acRate: 86.21799241907775,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3512",
      paidOnly: false,
      title: "Minimum Operations to Make Array Sum Divisible by K",
      titleSlug: "minimum-operations-to-make-array-sum-divisible-by-k",
    },
    {
      acRate: 24.403630232808407,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3513",
      paidOnly: false,
      title: "Number of Unique XOR Triplets I",
      titleSlug: "number-of-unique-xor-triplets-i",
    },
    {
      acRate: 28.94627928151643,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3514",
      paidOnly: false,
      title: "Number of Unique XOR Triplets II",
      titleSlug: "number-of-unique-xor-triplets-ii",
    },
    {
      acRate: 30.648526077097504,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3515",
      paidOnly: false,
      title: "Shortest Path in a Weighted Tree",
      titleSlug: "shortest-path-in-a-weighted-tree",
    },
    {
      acRate: 82.32629012596504,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3516",
      paidOnly: false,
      title: "Find Closest Person",
      titleSlug: "find-closest-person",
    },
    {
      acRate: 62.67379214459506,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3517",
      paidOnly: false,
      title: "Smallest Palindromic Rearrangement I",
      titleSlug: "smallest-palindromic-rearrangement-i",
    },
    {
      acRate: 11.763044153789656,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3518",
      paidOnly: false,
      title: "Smallest Palindromic Rearrangement II",
      titleSlug: "smallest-palindromic-rearrangement-ii",
    },
    {
      acRate: 33.123102078953515,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3519",
      paidOnly: false,
      title: "Count Numbers with Non-Decreasing Digits ",
      titleSlug: "count-numbers-with-non-decreasing-digits",
    },
    {
      acRate: 55.59502664298401,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3520",
      paidOnly: true,
      title: "Minimum Threshold for Inversion Pairs Count",
      titleSlug: "minimum-threshold-for-inversion-pairs-count",
    },
    {
      acRate: 66.45911166459112,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3521",
      paidOnly: false,
      title: "Find Product Recommendation Pairs",
      titleSlug: "find-product-recommendation-pairs",
    },
    {
      acRate: 55.03984199414289,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3522",
      paidOnly: false,
      title: "Calculate Score After Performing Instructions",
      titleSlug: "calculate-score-after-performing-instructions",
    },
    {
      acRate: 53.716864318102544,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3523",
      paidOnly: false,
      title: "Make Array Non-decreasing",
      titleSlug: "make-array-non-decreasing",
    },
    {
      acRate: 31.76359299169203,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3524",
      paidOnly: false,
      title: "Find X Value of Array I",
      titleSlug: "find-x-value-of-array-i",
    },
    {
      acRate: 26.285414480587615,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3525",
      paidOnly: false,
      title: "Find X Value of Array II",
      titleSlug: "find-x-value-of-array-ii",
    },
    {
      acRate: 66.58227848101265,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3526",
      paidOnly: true,
      title: "Range XOR Queries with Subarray Reversals",
      titleSlug: "range-xor-queries-with-subarray-reversals",
    },
    {
      acRate: 73.99340344763209,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3527",
      paidOnly: false,
      title: "Find the Most Common Response",
      titleSlug: "find-the-most-common-response",
    },
    {
      acRate: 57.6869376357431,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3528",
      paidOnly: false,
      title: "Unit Conversion I",
      titleSlug: "unit-conversion-i",
    },
    {
      acRate: 20.832084706822496,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3529",
      paidOnly: false,
      title: "Count Cells in Overlapping Horizontal and Vertical Substrings",
      titleSlug:
        "count-cells-in-overlapping-horizontal-and-vertical-substrings",
    },
    {
      acRate: 25.822951901658282,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3530",
      paidOnly: false,
      title: "Maximum Profit from Valid Topological Order in DAG",
      titleSlug: "maximum-profit-from-valid-topological-order-in-dag",
    },
    {
      acRate: 36.429990588727385,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3531",
      paidOnly: false,
      title: "Count Covered Buildings",
      titleSlug: "count-covered-buildings",
    },
    {
      acRate: 54.40367335629182,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3532",
      paidOnly: false,
      title: "Path Existence Queries in a Graph I",
      titleSlug: "path-existence-queries-in-a-graph-i",
    },
    {
      acRate: 24.603825136612024,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3533",
      paidOnly: false,
      title: "Concatenated Divisibility",
      titleSlug: "concatenated-divisibility",
    },
    {
      acRate: 20.61359534790455,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3534",
      paidOnly: false,
      title: "Path Existence Queries in a Graph II",
      titleSlug: "path-existence-queries-in-a-graph-ii",
    },
    {
      acRate: 71.68141592920354,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3535",
      paidOnly: true,
      title: "Unit Conversion II",
      titleSlug: "unit-conversion-ii",
    },
    {
      acRate: 69.32961635470596,
      difficulty: "Easy",
      freqBar: null,
      frontendQuestionId: "3536",
      paidOnly: false,
      title: "Maximum Product of Two Digits",
      titleSlug: "maximum-product-of-two-digits",
    },
    {
      acRate: 67.5173343605547,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3537",
      paidOnly: false,
      title: "Fill a Special Grid",
      titleSlug: "fill-a-special-grid",
    },
    {
      acRate: 24.40531356194007,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3538",
      paidOnly: false,
      title: "Merge Operations for Minimum Travel Time",
      titleSlug: "merge-operations-for-minimum-travel-time",
    },
    {
      acRate: 18.510838831291235,
      difficulty: "Hard",
      freqBar: null,
      frontendQuestionId: "3539",
      paidOnly: false,
      title: "Find Sum of Array Product of Magical Sequences",
      titleSlug: "find-sum-of-array-product-of-magical-sequences",
    },
    {
      acRate: 86.82926829268293,
      difficulty: "Medium",
      freqBar: null,
      frontendQuestionId: "3540",
      paidOnly: true,
      title: "Minimum Time to Visit All Houses",
      titleSlug: "minimum-time-to-visit-all-houses",
    },
  ],
  updatedDate: "2025-05-09",
};
